var BlurRadius = /* @__PURE__ */ ((BlurRadius2) => {
  BlurRadius2["Low"] = "Low";
  BlurRadius2["High"] = "High";
  return BlurRadius2;
})(BlurRadius || {});
const simd = async () => WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
function isSupported$1() {
  return new Promise((resolve, reject) => {
    if (typeof MediaStreamTrackProcessor === "undefined" || typeof MediaStreamTrackGenerator === "undefined") {
      reject("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.");
    } else {
      resolve();
    }
  });
}
var axios$2 = { exports: {} };
var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$e = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$d = utils$e;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config, code, request2, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request2;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request2, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request2, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$a.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$a.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$a.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$9 = utils$e;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$9.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional2 = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
      request2 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request2) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request2.abort();
        request2 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request2.send(requestData);
  });
};
var utils$6 = utils$e;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional2 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError2(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$e;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$5.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$e;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$4.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$4.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$e;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.25.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional2 = config.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l = token._listeners.length;
    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var utils$1 = utils$e;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$e;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
function getVonageMetadata() {
  return globalThis._vonageMediaProcessorMetadata;
}
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).substr(1));
}
const anyMap$1 = /* @__PURE__ */ new WeakMap();
const eventsMap$1 = /* @__PURE__ */ new WeakMap();
const producersMap$1 = /* @__PURE__ */ new WeakMap();
const anyProducer$1 = Symbol("anyProducer");
const resolvedPromise$1 = Promise.resolve();
const listenerAdded$1 = Symbol("listenerAdded");
const listenerRemoved$1 = Symbol("listenerRemoved");
let isGlobalDebugEnabled$1 = false;
function assertEventName$1(eventName) {
  if (typeof eventName !== "string" && typeof eventName !== "symbol") {
    throw new TypeError("eventName must be a string or a symbol");
  }
}
function assertListener$1(listener) {
  if (typeof listener !== "function") {
    throw new TypeError("listener must be a function");
  }
}
function getListeners$1(instance, eventName) {
  const events = eventsMap$1.get(instance);
  if (!events.has(eventName)) {
    events.set(eventName, /* @__PURE__ */ new Set());
  }
  return events.get(eventName);
}
function getEventProducers$1(instance, eventName) {
  const key = typeof eventName === "string" || typeof eventName === "symbol" ? eventName : anyProducer$1;
  const producers = producersMap$1.get(instance);
  if (!producers.has(key)) {
    producers.set(key, /* @__PURE__ */ new Set());
  }
  return producers.get(key);
}
function enqueueProducers$1(instance, eventName, eventData) {
  const producers = producersMap$1.get(instance);
  if (producers.has(eventName)) {
    for (const producer of producers.get(eventName)) {
      producer.enqueue(eventData);
    }
  }
  if (producers.has(anyProducer$1)) {
    const item = Promise.all([eventName, eventData]);
    for (const producer of producers.get(anyProducer$1)) {
      producer.enqueue(item);
    }
  }
}
function iterator$1(instance, eventNames) {
  eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
  let isFinished = false;
  let flush = () => {
  };
  let queue = [];
  const producer = {
    enqueue(item) {
      queue.push(item);
      flush();
    },
    finish() {
      isFinished = true;
      flush();
    }
  };
  for (const eventName of eventNames) {
    getEventProducers$1(instance, eventName).add(producer);
  }
  return {
    async next() {
      if (!queue) {
        return { done: true };
      }
      if (queue.length === 0) {
        if (isFinished) {
          queue = void 0;
          return this.next();
        }
        await new Promise((resolve) => {
          flush = resolve;
        });
        return this.next();
      }
      return {
        done: false,
        value: await queue.shift()
      };
    },
    async return(value) {
      queue = void 0;
      for (const eventName of eventNames) {
        getEventProducers$1(instance, eventName).delete(producer);
      }
      flush();
      return arguments.length > 0 ? { done: true, value: await value } : { done: true };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function defaultMethodNamesOrAssert$1(methodNames) {
  if (methodNames === void 0) {
    return allEmitteryMethods$1;
  }
  if (!Array.isArray(methodNames)) {
    throw new TypeError("`methodNames` must be an array of strings");
  }
  for (const methodName of methodNames) {
    if (!allEmitteryMethods$1.includes(methodName)) {
      if (typeof methodName !== "string") {
        throw new TypeError("`methodNames` element must be a string");
      }
      throw new Error(`${methodName} is not Emittery method`);
    }
  }
  return methodNames;
}
const isListenerSymbol$1 = (symbol) => symbol === listenerAdded$1 || symbol === listenerRemoved$1;
class Emittery$1 {
  static mixin(emitteryPropertyName, methodNames) {
    methodNames = defaultMethodNamesOrAssert$1(methodNames);
    return (target) => {
      if (typeof target !== "function") {
        throw new TypeError("`target` must be function");
      }
      for (const methodName of methodNames) {
        if (target.prototype[methodName] !== void 0) {
          throw new Error(`The property \`${methodName}\` already exists on \`target\``);
        }
      }
      function getEmitteryProperty() {
        Object.defineProperty(this, emitteryPropertyName, {
          enumerable: false,
          value: new Emittery$1()
        });
        return this[emitteryPropertyName];
      }
      Object.defineProperty(target.prototype, emitteryPropertyName, {
        enumerable: false,
        get: getEmitteryProperty
      });
      const emitteryMethodCaller = (methodName) => function(...args) {
        return this[emitteryPropertyName][methodName](...args);
      };
      for (const methodName of methodNames) {
        Object.defineProperty(target.prototype, methodName, {
          enumerable: false,
          value: emitteryMethodCaller(methodName)
        });
      }
      return target;
    };
  }
  static get isDebugEnabled() {
    if (typeof process !== "object") {
      return isGlobalDebugEnabled$1;
    }
    const { env } = process || { env: {} };
    return env.DEBUG === "emittery" || env.DEBUG === "*" || isGlobalDebugEnabled$1;
  }
  static set isDebugEnabled(newValue) {
    isGlobalDebugEnabled$1 = newValue;
  }
  constructor(options = {}) {
    anyMap$1.set(this, /* @__PURE__ */ new Set());
    eventsMap$1.set(this, /* @__PURE__ */ new Map());
    producersMap$1.set(this, /* @__PURE__ */ new Map());
    this.debug = options.debug || {};
    if (this.debug.enabled === void 0) {
      this.debug.enabled = false;
    }
    if (!this.debug.logger) {
      this.debug.logger = (type, debugName, eventName, eventData) => {
        eventData = JSON.stringify(eventData);
        if (typeof eventName === "symbol") {
          eventName = eventName.toString();
        }
        const currentTime = new Date();
        const logTime = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;
        console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);
      };
    }
  }
  logIfDebugEnabled(type, eventName, eventData) {
    if (Emittery$1.isDebugEnabled || this.debug.enabled) {
      this.debug.logger(type, this.debug.name, eventName, eventData);
    }
  }
  on(eventNames, listener) {
    assertListener$1(listener);
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName$1(eventName);
      getListeners$1(this, eventName).add(listener);
      this.logIfDebugEnabled("subscribe", eventName, void 0);
      if (!isListenerSymbol$1(eventName)) {
        this.emit(listenerAdded$1, { eventName, listener });
      }
    }
    return this.off.bind(this, eventNames, listener);
  }
  off(eventNames, listener) {
    assertListener$1(listener);
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName$1(eventName);
      getListeners$1(this, eventName).delete(listener);
      this.logIfDebugEnabled("unsubscribe", eventName, void 0);
      if (!isListenerSymbol$1(eventName)) {
        this.emit(listenerRemoved$1, { eventName, listener });
      }
    }
  }
  once(eventNames) {
    return new Promise((resolve) => {
      const off = this.on(eventNames, (data2) => {
        off();
        resolve(data2);
      });
    });
  }
  events(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName$1(eventName);
    }
    return iterator$1(this, eventNames);
  }
  async emit(eventName, eventData) {
    assertEventName$1(eventName);
    this.logIfDebugEnabled("emit", eventName, eventData);
    enqueueProducers$1(this, eventName, eventData);
    const listeners = getListeners$1(this, eventName);
    const anyListeners = anyMap$1.get(this);
    const staticListeners = [...listeners];
    const staticAnyListeners = isListenerSymbol$1(eventName) ? [] : [...anyListeners];
    await resolvedPromise$1;
    await Promise.all([
      ...staticListeners.map(async (listener) => {
        if (listeners.has(listener)) {
          return listener(eventData);
        }
      }),
      ...staticAnyListeners.map(async (listener) => {
        if (anyListeners.has(listener)) {
          return listener(eventName, eventData);
        }
      })
    ]);
  }
  async emitSerial(eventName, eventData) {
    assertEventName$1(eventName);
    this.logIfDebugEnabled("emitSerial", eventName, eventData);
    const listeners = getListeners$1(this, eventName);
    const anyListeners = anyMap$1.get(this);
    const staticListeners = [...listeners];
    const staticAnyListeners = [...anyListeners];
    await resolvedPromise$1;
    for (const listener of staticListeners) {
      if (listeners.has(listener)) {
        await listener(eventData);
      }
    }
    for (const listener of staticAnyListeners) {
      if (anyListeners.has(listener)) {
        await listener(eventName, eventData);
      }
    }
  }
  onAny(listener) {
    assertListener$1(listener);
    this.logIfDebugEnabled("subscribeAny", void 0, void 0);
    anyMap$1.get(this).add(listener);
    this.emit(listenerAdded$1, { listener });
    return this.offAny.bind(this, listener);
  }
  anyEvent() {
    return iterator$1(this);
  }
  offAny(listener) {
    assertListener$1(listener);
    this.logIfDebugEnabled("unsubscribeAny", void 0, void 0);
    this.emit(listenerRemoved$1, { listener });
    anyMap$1.get(this).delete(listener);
  }
  clearListeners(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      this.logIfDebugEnabled("clear", eventName, void 0);
      if (typeof eventName === "string" || typeof eventName === "symbol") {
        getListeners$1(this, eventName).clear();
        const producers = getEventProducers$1(this, eventName);
        for (const producer of producers) {
          producer.finish();
        }
        producers.clear();
      } else {
        anyMap$1.get(this).clear();
        for (const listeners of eventsMap$1.get(this).values()) {
          listeners.clear();
        }
        for (const producers of producersMap$1.get(this).values()) {
          for (const producer of producers) {
            producer.finish();
          }
          producers.clear();
        }
      }
    }
  }
  listenerCount(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    let count = 0;
    for (const eventName of eventNames) {
      if (typeof eventName === "string") {
        count += anyMap$1.get(this).size + getListeners$1(this, eventName).size + getEventProducers$1(this, eventName).size + getEventProducers$1(this).size;
        continue;
      }
      if (typeof eventName !== "undefined") {
        assertEventName$1(eventName);
      }
      count += anyMap$1.get(this).size;
      for (const value of eventsMap$1.get(this).values()) {
        count += value.size;
      }
      for (const value of producersMap$1.get(this).values()) {
        count += value.size;
      }
    }
    return count;
  }
  bindMethods(target, methodNames) {
    if (typeof target !== "object" || target === null) {
      throw new TypeError("`target` must be an object");
    }
    methodNames = defaultMethodNamesOrAssert$1(methodNames);
    for (const methodName of methodNames) {
      if (target[methodName] !== void 0) {
        throw new Error(`The property \`${methodName}\` already exists on \`target\``);
      }
      Object.defineProperty(target, methodName, {
        enumerable: false,
        value: this[methodName].bind(this)
      });
    }
  }
}
const allEmitteryMethods$1 = Object.getOwnPropertyNames(Emittery$1.prototype).filter((v) => v !== "constructor");
Object.defineProperty(Emittery$1, "listenerAdded", {
  value: listenerAdded$1,
  writable: false,
  enumerable: true,
  configurable: false
});
Object.defineProperty(Emittery$1, "listenerRemoved", {
  value: listenerRemoved$1,
  writable: false,
  enumerable: true,
  configurable: false
});
var WarningType;
(function(WarningType2) {
  WarningType2["FPS_DROP"] = "fps_drop";
})(WarningType || (WarningType = {}));
class InsertableStreamHelper {
  constructor() {
    this.processor_ = null;
    this.generator_ = null;
  }
  init(track) {
    return new Promise((resolve, reject) => {
      try {
        this.processor_ = new MediaStreamTrackProcessor(track);
      } catch (e) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${e}`);
        reject(e);
      }
      try {
        if (track.kind === "audio") {
          this.generator_ = new MediaStreamTrackGenerator({ kind: "audio" });
        } else if (track.kind === "video") {
          this.generator_ = new MediaStreamTrackGenerator({ kind: "video" });
        } else {
          reject("kind not supported");
        }
      } catch (e) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${e}`);
        reject(e);
      }
      resolve();
    });
  }
  getReadable() {
    return this.processor_.readable;
  }
  getWriteable() {
    return this.generator_.writable;
  }
  getProccesorTrack() {
    return this.generator_;
  }
}
class MediaProcessorConnector {
  constructor(vonageMediaProcessor2) {
    this.insertableStreamHelper_ = new InsertableStreamHelper();
    this.mediaProcessor_ = vonageMediaProcessor2;
  }
  setTrack(track) {
    return new Promise((resolve, reject) => {
      this.insertableStreamHelper_.init(track).then(() => {
        this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
          resolve(this.insertableStreamHelper_.getProccesorTrack());
        }).catch((e) => {
          reject(e);
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }
  destroy() {
    return new Promise((resolve, reject) => {
      if (this.mediaProcessor_) {
        this.mediaProcessor_.destroy().then(() => {
          resolve();
        }).catch((e) => {
          reject(e);
        });
      } else {
        reject("no processor");
      }
    });
  }
}
function isSupported() {
  return new Promise(async (resolve, reject) => {
    try {
      await isSupported$1();
    } catch (e) {
      reject(e);
      return;
    }
    simd().then((isSIMDSupported) => {
      if (isSIMDSupported === false) {
        reject("Your browser does not support WebAssembly features.");
        return;
      }
      resolve();
    }).catch((e) => {
      reject(e);
    });
  });
}
const VonageSelfiesegmentation = {};
(function() {
  var D;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var H = ca(this);
  function J(a, b) {
    if (b)
      a: {
        var c = H;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var f = a[d];
          if (!(f in c))
            break a;
          c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  J("Symbol", function(a) {
    function b(h) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (h || "") + "_" + f++, h);
    }
    function c(h, e) {
      this.g = h;
      ba(this, "description", { configurable: true, writable: true, value: e });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", f = 0;
    return b;
  });
  J("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = H[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function M(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function ea(a) {
    if (!(a instanceof Array)) {
      a = M(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var fa = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, ha;
  if (typeof Object.setPrototypeOf == "function")
    ha = Object.setPrototypeOf;
  else {
    var ia;
    a: {
      var ja = { a: true }, ka = {};
      try {
        ka.__proto__ = ja;
        ia = ka.a;
        break a;
      } catch (a) {
      }
      ia = false;
    }
    ha = ia ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var la = ha;
  function ma(a, b) {
    a.prototype = fa(b.prototype);
    a.prototype.constructor = a;
    if (la)
      la(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.ea = b.prototype;
  }
  function na() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.s = this.m = 0;
    this.j = null;
  }
  function oa(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  na.prototype.o = function(a) {
    this.h = a;
  };
  function pa(a, b) {
    a.j = { U: b, V: true };
    a.g = a.m || a.s;
  }
  na.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.s;
  };
  function N(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function qa(a) {
    this.g = new na();
    this.h = a;
  }
  function ra(a, b) {
    oa(a.g);
    var c = a.g.i;
    if (c)
      return sa(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return ta(a);
  }
  function sa(a, b, c, d) {
    try {
      var f = b.call(a.g.i, c);
      if (!(f instanceof Object))
        throw new TypeError("Iterator result " + f + " is not an object");
      if (!f.done)
        return a.g.l = false, f;
      var h = f.value;
    } catch (e) {
      return a.g.i = null, pa(a.g, e), ta(a);
    }
    a.g.i = null;
    d.call(a.g, h);
    return ta(a);
  }
  function ta(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, pa(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.V)
        throw b.U;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function ua(a) {
    this.next = function(b) {
      oa(a.g);
      a.g.i ? b = sa(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = ta(a));
      return b;
    };
    this.throw = function(b) {
      oa(a.g);
      a.g.i ? b = sa(a, a.g.i["throw"], b, a.g.o) : (pa(a.g, b), b = ta(a));
      return b;
    };
    this.return = function(b) {
      return ra(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function O(a, b) {
    b = new ua(new qa(b));
    la && a.prototype && la(b, a.prototype);
    return b;
  }
  function va(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, f = { next: function() {
      if (!d && c < a.length) {
        var h = c++;
        return { value: b(h, a[h]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    f[Symbol.iterator] = function() {
      return f;
    };
    return f;
  }
  var wa = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var f in d)
          Object.prototype.hasOwnProperty.call(d, f) && (a[f] = d[f]);
    }
    return a;
  };
  J("Object.assign", function(a) {
    return a || wa;
  });
  J("Promise", function(a) {
    function b(e) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.o = false;
      var g = this.j();
      try {
        e(g.resolve, g.reject);
      } catch (k) {
        g.reject(k);
      }
    }
    function c() {
      this.g = null;
    }
    function d(e) {
      return e instanceof b ? e : new b(function(g) {
        g(e);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(e) {
      if (this.g == null) {
        this.g = [];
        var g = this;
        this.i(function() {
          g.l();
        });
      }
      this.g.push(e);
    };
    var f = H.setTimeout;
    c.prototype.i = function(e) {
      f(e, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var e = this.g;
        this.g = [];
        for (var g = 0; g < e.length; ++g) {
          var k = e[g];
          e[g] = null;
          try {
            k();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(e) {
      this.i(function() {
        throw e;
      });
    };
    b.prototype.j = function() {
      function e(l) {
        return function(q) {
          k || (k = true, l.call(g, q));
        };
      }
      var g = this, k = false;
      return { resolve: e(this.C), reject: e(this.l) };
    };
    b.prototype.C = function(e) {
      if (e === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (e instanceof b)
        this.F(e);
      else {
        a:
          switch (typeof e) {
            case "object":
              var g = e != null;
              break a;
            case "function":
              g = true;
              break a;
            default:
              g = false;
          }
        g ? this.u(e) : this.m(e);
      }
    };
    b.prototype.u = function(e) {
      var g = void 0;
      try {
        g = e.then;
      } catch (k) {
        this.l(k);
        return;
      }
      typeof g == "function" ? this.G(g, e) : this.m(e);
    };
    b.prototype.l = function(e) {
      this.s(2, e);
    };
    b.prototype.m = function(e) {
      this.s(1, e);
    };
    b.prototype.s = function(e, g) {
      if (this.h != 0)
        throw Error("Cannot settle(" + e + ", " + g + "): Promise already settled in state" + this.h);
      this.h = e;
      this.i = g;
      this.h === 2 && this.D();
      this.A();
    };
    b.prototype.D = function() {
      var e = this;
      f(function() {
        if (e.B()) {
          var g = H.console;
          typeof g !== "undefined" && g.error(e.i);
        }
      }, 1);
    };
    b.prototype.B = function() {
      if (this.o)
        return false;
      var e = H.CustomEvent, g = H.Event, k = H.dispatchEvent;
      if (typeof k === "undefined")
        return true;
      typeof e === "function" ? e = new e("unhandledrejection", { cancelable: true }) : typeof g === "function" ? e = new g("unhandledrejection", { cancelable: true }) : (e = H.document.createEvent("CustomEvent"), e.initCustomEvent("unhandledrejection", false, true, e));
      e.promise = this;
      e.reason = this.i;
      return k(e);
    };
    b.prototype.A = function() {
      if (this.g != null) {
        for (var e = 0; e < this.g.length; ++e)
          h.h(this.g[e]);
        this.g = null;
      }
    };
    var h = new c();
    b.prototype.F = function(e) {
      var g = this.j();
      e.J(g.resolve, g.reject);
    };
    b.prototype.G = function(e, g) {
      var k = this.j();
      try {
        e.call(g, k.resolve, k.reject);
      } catch (l) {
        k.reject(l);
      }
    };
    b.prototype.then = function(e, g) {
      function k(w, t) {
        return typeof w == "function" ? function(y) {
          try {
            l(w(y));
          } catch (m) {
            q(m);
          }
        } : t;
      }
      var l, q, v = new b(function(w, t) {
        l = w;
        q = t;
      });
      this.J(k(e, l), k(g, q));
      return v;
    };
    b.prototype.catch = function(e) {
      return this.then(void 0, e);
    };
    b.prototype.J = function(e, g) {
      function k() {
        switch (l.h) {
          case 1:
            e(l.i);
            break;
          case 2:
            g(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? h.h(k) : this.g.push(k);
      this.o = true;
    };
    b.resolve = d;
    b.reject = function(e) {
      return new b(function(g, k) {
        k(e);
      });
    };
    b.race = function(e) {
      return new b(function(g, k) {
        for (var l = M(e), q = l.next(); !q.done; q = l.next())
          d(q.value).J(g, k);
      });
    };
    b.all = function(e) {
      var g = M(e), k = g.next();
      return k.done ? d([]) : new b(function(l, q) {
        function v(y) {
          return function(m) {
            w[y] = m;
            t--;
            t == 0 && l(w);
          };
        }
        var w = [], t = 0;
        do
          w.push(void 0), t++, d(k.value).J(v(w.length - 1), q), k = g.next();
        while (!k.done);
      });
    };
    return b;
  });
  J("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  J("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var f = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + f, 0)); c < f; c++) {
        var h = d[c];
        if (h === b || Object.is(h, b))
          return true;
      }
      return false;
    };
  });
  J("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  J("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return va(this, function(b) {
        return b;
      });
    };
  });
  var xa = this || self;
  function ya(a, b) {
    a = a.split(".");
    var c = xa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function za(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var Aa, Ba = typeof TextDecoder !== "undefined", Ca, Da = typeof TextEncoder !== "undefined";
  function Ea(a) {
    if (Da)
      a = (Ca || (Ca = new TextEncoder())).encode(a);
    else {
      var b = void 0;
      b = b === void 0 ? false : b;
      for (var c = 0, d = new Uint8Array(3 * a.length), f = 0; f < a.length; f++) {
        var h = a.charCodeAt(f);
        if (128 > h)
          d[c++] = h;
        else {
          if (2048 > h)
            d[c++] = h >> 6 | 192;
          else {
            if (55296 <= h && 57343 >= h) {
              if (56319 >= h && f < a.length) {
                var e = a.charCodeAt(++f);
                if (56320 <= e && 57343 >= e) {
                  h = 1024 * (h - 55296) + e - 56320 + 65536;
                  d[c++] = h >> 18 | 240;
                  d[c++] = h >> 12 & 63 | 128;
                  d[c++] = h >> 6 & 63 | 128;
                  d[c++] = h & 63 | 128;
                  continue;
                } else
                  f--;
              }
              if (b)
                throw Error("Found an unpaired surrogate");
              h = 65533;
            }
            d[c++] = h >> 12 | 224;
            d[c++] = h >> 6 & 63 | 128;
          }
          d[c++] = h & 63 | 128;
        }
      }
      a = d.subarray(0, c);
    }
    return a;
  }
  var Fa = {}, Ga = null;
  function Ha(a, b) {
    b === void 0 && (b = 0);
    Ja();
    b = Fa[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", f = 0, h = 0; f < a.length - 2; f += 3) {
      var e = a[f], g = a[f + 1], k = a[f + 2], l = b[e >> 2];
      e = b[(e & 3) << 4 | g >> 4];
      g = b[(g & 15) << 2 | k >> 6];
      k = b[k & 63];
      c[h++] = l + e + g + k;
    }
    l = 0;
    k = d;
    switch (a.length - f) {
      case 2:
        l = a[f + 1], k = b[(l & 15) << 2] || d;
      case 1:
        a = a[f], c[h] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
    }
    return c.join("");
  }
  function Ka(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    La(a, function(h) {
      d[f++] = h;
    });
    return d.subarray(0, f);
  }
  function La(a, b) {
    function c(k) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), q = Ga[l];
        if (q != null)
          return q;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return k;
    }
    Ja();
    for (var d = 0; ; ) {
      var f = c(-1), h = c(0), e = c(64), g = c(64);
      if (g === 64 && f === -1)
        break;
      b(f << 2 | h >> 4);
      e != 64 && (b(h << 4 & 240 | e >> 2), g != 64 && b(e << 6 & 192 | g));
    }
  }
  function Ja() {
    if (!Ga) {
      Ga = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Fa[c] = d;
        for (var f = 0; f < d.length; f++) {
          var h = d[f];
          Ga[h] === void 0 && (Ga[h] = f);
        }
      }
    }
  }
  var Ma = typeof Uint8Array.prototype.slice === "function", Na;
  function Oa(a, b, c) {
    return b === c ? Na || (Na = new Uint8Array(0)) : Ma ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
  }
  var P = 0, Q = 0;
  function Pa(a, b) {
    b = b === void 0 ? {} : b;
    b = b.v === void 0 ? false : b.v;
    this.h = null;
    this.g = this.i = this.j = 0;
    this.l = false;
    this.v = b;
    a && Qa(this, a);
  }
  function Qa(a, b) {
    b = b.constructor === Uint8Array ? b : b.constructor === ArrayBuffer ? new Uint8Array(b) : b.constructor === Array ? new Uint8Array(b) : b.constructor === String ? Ka(b) : b instanceof Uint8Array ? new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : new Uint8Array(0);
    a.h = b;
    a.j = 0;
    a.i = a.h.length;
    a.g = a.j;
  }
  Pa.prototype.reset = function() {
    this.g = this.j;
  };
  function Ra(a) {
    var b = a.h, c = b[a.g], d = c & 127;
    if (128 > c)
      return a.g += 1, d;
    c = b[a.g + 1];
    d |= (c & 127) << 7;
    if (128 > c)
      return a.g += 2, d;
    c = b[a.g + 2];
    d |= (c & 127) << 14;
    if (128 > c)
      return a.g += 3, d;
    c = b[a.g + 3];
    d |= (c & 127) << 21;
    if (128 > c)
      return a.g += 4, d;
    c = b[a.g + 4];
    d |= (c & 15) << 28;
    if (128 > c)
      return a.g += 5, d >>> 0;
    a.g += 5;
    128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && a.g++;
    return d;
  }
  function R(a) {
    var b = a.h[a.g];
    var c = a.h[a.g + 1];
    var d = a.h[a.g + 2], f = a.h[a.g + 3];
    a.g += 4;
    c = (b << 0 | c << 8 | d << 16 | f << 24) >>> 0;
    a = 2 * (c >> 31) + 1;
    b = c >>> 23 & 255;
    c &= 8388607;
    return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
  }
  var Sa = [];
  function Ta() {
    this.g = new Uint8Array(64);
    this.h = 0;
  }
  Ta.prototype.push = function(a) {
    if (!(this.h + 1 < this.g.length)) {
      var b = this.g;
      this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length));
      this.g.set(b);
    }
    this.g[this.h++] = a;
  };
  Ta.prototype.length = function() {
    return this.h;
  };
  Ta.prototype.end = function() {
    var a = this.g, b = this.h;
    this.h = 0;
    return Oa(a, 0, b);
  };
  function S(a, b) {
    for (; 127 < b; )
      a.push(b & 127 | 128), b >>>= 7;
    a.push(b);
  }
  function Ua(a) {
    var b = {}, c = b.N === void 0 ? false : b.N;
    this.o = { v: b.v === void 0 ? false : b.v };
    this.N = c;
    b = this.o;
    Sa.length ? (c = Sa.pop(), b && (c.v = b.v), a && Qa(c, a), a = c) : a = new Pa(a, b);
    this.g = a;
    this.m = this.g.g;
    this.h = this.i = this.l = -1;
    this.j = false;
  }
  Ua.prototype.reset = function() {
    this.g.reset();
    this.h = this.l = -1;
  };
  function Va(a) {
    var b = a.g;
    (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.l || 0 > b.g || b.g > b.i);
    if (b)
      return false;
    a.m = a.g.g;
    b = Ra(a.g);
    var c = b & 7;
    if (c != 0 && c != 5 && c != 1 && c != 2 && c != 3 && c != 4)
      return a.j = true, false;
    a.i = b;
    a.l = b >>> 3;
    a.h = c;
    return true;
  }
  function Wa(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Wa(a);
        else {
          for (a = a.g; a.h[a.g] & 128; )
            a.g++;
          a.g++;
        }
        break;
      case 1:
        a.h != 1 ? Wa(a) : (a = a.g, a.g += 8);
        break;
      case 2:
        if (a.h != 2)
          Wa(a);
        else {
          var b = Ra(a.g);
          a = a.g;
          a.g += b;
        }
        break;
      case 5:
        a.h != 5 ? Wa(a) : (a = a.g, a.g += 4);
        break;
      case 3:
        b = a.l;
        do {
          if (!Va(a)) {
            a.j = true;
            break;
          }
          if (a.h == 4) {
            a.l != b && (a.j = true);
            break;
          }
          Wa(a);
        } while (1);
        break;
      default:
        a.j = true;
    }
  }
  function Xa(a, b, c) {
    var d = a.g.i, f = Ra(a.g);
    f = a.g.g + f;
    a.g.i = f;
    c(b, a);
    a.g.g = f;
    a.g.i = d;
    return b;
  }
  function Ya(a) {
    var b = Ra(a.g);
    a = a.g;
    var c = a.g;
    a.g += b;
    a = a.h;
    var d;
    if (Ba)
      (d = Aa) || (d = Aa = new TextDecoder("utf-8", { fatal: false })), d = d.decode(a.subarray(c, c + b));
    else {
      b = c + b;
      for (var f = [], h = null, e, g, k; c < b; )
        e = a[c++], 128 > e ? f.push(e) : 224 > e ? c >= b ? f.push(65533) : (g = a[c++], 194 > e || (g & 192) !== 128 ? (c--, f.push(65533)) : f.push((e & 31) << 6 | g & 63)) : 240 > e ? c >= b - 1 ? f.push(65533) : (g = a[c++], (g & 192) !== 128 || e === 224 && 160 > g || e === 237 && 160 <= g || ((d = a[c++]) & 192) !== 128 ? (c--, f.push(65533)) : f.push((e & 15) << 12 | (g & 63) << 6 | d & 63)) : 244 >= e ? c >= b - 2 ? f.push(65533) : (g = a[c++], (g & 192) !== 128 || (e << 28) + (g - 144) >> 30 !== 0 || ((d = a[c++]) & 192) !== 128 || ((k = a[c++]) & 192) !== 128 ? (c--, f.push(65533)) : (e = (e & 7) << 18 | (g & 63) << 12 | (d & 63) << 6 | k & 63, e -= 65536, f.push((e >> 10 & 1023) + 55296, (e & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (h = za(h, f), f.length = 0);
      d = za(h, f);
    }
    return d;
  }
  function Za() {
    this.h = [];
    this.i = 0;
    this.g = new Ta();
  }
  function $a(a, b) {
    b.length !== 0 && (a.h.push(b), a.i += b.length);
  }
  function ab(a) {
    var b = a.i + a.g.length();
    if (b === 0)
      return new Uint8Array(0);
    b = new Uint8Array(b);
    for (var c = a.h, d = c.length, f = 0, h = 0; h < d; h++) {
      var e = c[h];
      e.length !== 0 && (b.set(e, f), f += e.length);
    }
    c = a.g;
    d = c.h;
    d !== 0 && (b.set(c.g.subarray(0, d), f), c.h = 0);
    a.h = [b];
    return b;
  }
  function T(a, b, c) {
    if (c != null) {
      S(a.g, 8 * b + 5);
      a = a.g;
      var d = c;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? P = Q = 0 : (Q = 0, P = 2147483648) : isNaN(d) ? (Q = 0, P = 2147483647) : 34028234663852886e22 < d ? (Q = 0, P = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), Q = 0, P = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d) & 8388607, Q = 0, P = (c << 31 | b + 127 << 23 | d) >>> 0);
      c = P;
      a.push(c >>> 0 & 255);
      a.push(c >>> 8 & 255);
      a.push(c >>> 16 & 255);
      a.push(c >>> 24 & 255);
    }
  }
  var bb = typeof Uint8Array === "function";
  function cb(a, b, c) {
    if (a != null)
      return typeof a === "object" ? bb && a instanceof Uint8Array ? c(a) : db(a, b, c) : b(a);
  }
  function db(a, b, c) {
    if (Array.isArray(a)) {
      for (var d = Array(a.length), f = 0; f < a.length; f++)
        d[f] = cb(a[f], b, c);
      Array.isArray(a) && a.W && eb(d);
      return d;
    }
    d = {};
    for (f in a)
      d[f] = cb(a[f], b, c);
    return d;
  }
  function fb(a) {
    return typeof a === "number" ? isFinite(a) ? a : String(a) : a;
  }
  var gb = { W: { value: true, configurable: true } };
  function eb(a) {
    Array.isArray(a) && !Object.isFrozen(a) && Object.defineProperties(a, gb);
    return a;
  }
  var hb;
  function U(a, b, c) {
    var d = hb;
    hb = null;
    a || (a = d);
    d = this.constructor.ca;
    a || (a = d ? [d] : []);
    this.j = d ? 0 : -1;
    this.i = null;
    this.g = a;
    a: {
      d = this.g.length;
      a = d - 1;
      if (d && (d = this.g[a], d !== null && typeof d === "object" && d.constructor === Object)) {
        this.l = a - this.j;
        this.h = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        a = c[b], a < this.l ? (a += this.j, (d = this.g[a]) ? eb(d) : this.g[a] = ib) : (jb(this), (d = this.h[a]) ? eb(d) : this.h[a] = ib);
  }
  var ib = Object.freeze(eb([]));
  function jb(a) {
    var b = a.l + a.j;
    a.g[b] || (a.h = a.g[b] = {});
  }
  function V(a, b, c) {
    return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.h ? a.h[b] : void 0 : a.g[b + a.j];
  }
  function kb(a) {
    var b = b === void 0 ? false : b;
    var c = V(a, 1, b);
    c == null && (c = ib);
    c === ib && (c = eb([]), W(a, 1, c, b));
    return c;
  }
  function X(a, b, c) {
    a = V(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function W(a, b, c, d) {
    (d === void 0 ? 0 : d) || b >= a.l ? (jb(a), a.h[b] = c) : a.g[b + a.j] = c;
  }
  function lb(a, b) {
    a.i || (a.i = {});
    var c = a.i[1];
    if (!c) {
      var d = kb(a);
      c = [];
      for (var f = 0; f < d.length; f++)
        c[f] = new b(d[f]);
      a.i[1] = c;
    }
    return c;
  }
  function mb(a, b, c, d) {
    var f = lb(a, c);
    b = b ? b : new c();
    a = kb(a);
    d != void 0 ? (f.splice(d, 0, b), a.splice(d, 0, nb(b))) : (f.push(b), a.push(nb(b)));
  }
  U.prototype.toJSON = function() {
    var a = nb(this);
    return db(a, fb, Ha);
  };
  function nb(a, b) {
    if (a.i)
      for (var c in a.i) {
        var d = a.i[c];
        if (Array.isArray(d))
          for (var f = 0; f < d.length; f++)
            d[f] && nb(d[f]);
        else
          d && nb(d);
      }
    return a.g;
  }
  U.prototype.toString = function() {
    return nb(this).toString();
  };
  function ob(a, b) {
    a = V(a, b);
    return a == null ? 0 : a;
  }
  function pb(a, b) {
    a = V(a, b);
    return a == null ? "" : a;
  }
  function qb(a, b) {
    if (a = a.m) {
      $a(b, b.g.end());
      for (var c = 0; c < a.length; c++)
        $a(b, a[c]);
    }
  }
  function rb(a, b) {
    if (b.h == 4)
      return false;
    var c = b.m;
    Wa(b);
    b.N || (b = Oa(b.g.h, c, b.g.g), (c = a.m) ? c.push(b) : a.m = [b]);
    return true;
  }
  function Y(a, b) {
    var c = void 0;
    return new (c || (c = Promise))(function(d, f) {
      function h(k) {
        try {
          g(b.next(k));
        } catch (l) {
          f(l);
        }
      }
      function e(k) {
        try {
          g(b["throw"](k));
        } catch (l) {
          f(l);
        }
      }
      function g(k) {
        k.done ? d(k.value) : new c(function(l) {
          l(k.value);
        }).then(h, e);
      }
      g((b = b.apply(a, void 0)).next());
    });
  }
  function sb(a) {
    U.call(this, a);
  }
  ma(sb, U);
  function tb(a, b) {
    for (; Va(b); )
      switch (b.i) {
        case 8:
          var c = Ra(b.g);
          W(a, 1, c);
          break;
        case 21:
          c = R(b.g);
          W(a, 2, c);
          break;
        case 26:
          c = Ya(b);
          W(a, 3, c);
          break;
        case 34:
          c = Ya(b);
          W(a, 4, c);
          break;
        default:
          if (!rb(a, b))
            return a;
      }
    return a;
  }
  function ub(a) {
    U.call(this, a, -1, vb);
  }
  ma(ub, U);
  ub.prototype.addClassification = function(a, b) {
    mb(this, a, sb, b);
  };
  var vb = [1];
  function wb(a) {
    U.call(this, a);
  }
  ma(wb, U);
  function xb(a, b) {
    for (; Va(b); )
      switch (b.i) {
        case 13:
          var c = R(b.g);
          W(a, 1, c);
          break;
        case 21:
          c = R(b.g);
          W(a, 2, c);
          break;
        case 29:
          c = R(b.g);
          W(a, 3, c);
          break;
        case 37:
          c = R(b.g);
          W(a, 4, c);
          break;
        case 45:
          c = R(b.g);
          W(a, 5, c);
          break;
        default:
          if (!rb(a, b))
            return a;
      }
    return a;
  }
  function yb(a) {
    U.call(this, a, -1, zb);
  }
  ma(yb, U);
  var zb = [1];
  function Ab(a) {
    U.call(this, a);
  }
  ma(Ab, U);
  function Bb(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function Cb(a) {
    return lb(a, sb).map(function(b) {
      return { index: ob(b, 1), Y: X(b, 2), label: V(b, 3) != null ? pb(b, 3) : void 0, displayName: V(b, 4) != null ? pb(b, 4) : void 0 };
    });
  }
  function Db(a) {
    return { x: X(a, 1), y: X(a, 2), z: X(a, 3), visibility: V(a, 4) != null ? X(a, 4) : void 0 };
  }
  function Eb(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function Fb(a, b, c) {
    Gb(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function Gb(a, b) {
    var c = a.g;
    if (a.m === void 0) {
      var d = Bb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), f = Bb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), h = c.createProgram();
      c.attachShader(h, d);
      c.attachShader(h, f);
      c.linkProgram(h);
      if (!c.getProgramParameter(h, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(h));
      d = a.m = h;
      c.useProgram(d);
      f = c.getUniformLocation(d, "sampler0");
      a.j = { I: c.getAttribLocation(d, "aVertex"), H: c.getAttribLocation(d, "aTex"), da: f };
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.I);
      c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.o = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.o);
      c.enableVertexAttribArray(a.j.H);
      c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(f, 0);
    }
    d = a.j;
    c.useProgram(a.m);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, a.o);
    c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.I);
    c.disableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function Hb(a) {
    this.g = a;
  }
  var Ib = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Jb(a, b) {
    return b + a;
  }
  function Kb(a, b) {
    window[a] = b;
  }
  function Lb(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Mb() {
    return Y(this, function b() {
      return O(b, function(c) {
        switch (c.g) {
          case 1:
            return c.m = 2, N(c, WebAssembly.instantiate(Ib), 4);
          case 4:
            c.g = 3;
            c.m = 0;
            break;
          case 2:
            return c.m = 0, c.j = null, c.return(false);
          case 3:
            return c.return(true);
        }
      });
    });
  }
  function Nb(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.F = {};
    this.m = {};
    this.s = {};
    this.G = this.o = this.R = true;
    this.C = Promise.resolve();
    this.P = "";
    this.B = {};
    this.locateFile = a && a.locateFile || Jb;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.S = b;
    if (a.options) {
      b = M(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  D = Nb.prototype;
  D.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Ob(a, b) {
    return a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(b) : a.g.files;
  }
  function Pb(a) {
    return Y(a, function c() {
      var d = this, f, h, e, g, k, l, q, v, w, t, y;
      return O(c, function(m) {
        switch (m.g) {
          case 1:
            f = d;
            if (!d.R)
              return m.return();
            h = Ob(d, d.j);
            return N(m, Mb(), 2);
          case 2:
            e = m.h;
            if (typeof window === "object")
              return Kb("createMediapipeSolutionsWasm", { locateFile: d.locateFile }), Kb("createMediapipeSolutionsPackedAssets", { locateFile: d.locateFile }), l = h.filter(function(u) {
                return u.data !== void 0;
              }), q = h.filter(function(u) {
                return u.data === void 0;
              }), v = Promise.all(l.map(function(u) {
                var x = Qb(f, u.url);
                if (u.path !== void 0) {
                  var z = u.path;
                  x = x.then(function(E) {
                    f.overrideFile(z, E);
                    return Promise.resolve(E);
                  });
                }
                return x;
              })), w = Promise.all(q.map(function(u) {
                return u.simd === void 0 || u.simd && e || !u.simd && !e ? Lb(f.locateFile(u.url, f.S)) : Promise.resolve();
              })).then(function() {
                return Y(f, function x() {
                  var z, E, F = this;
                  return O(x, function(K) {
                    if (K.g == 1)
                      return z = window.createMediapipeSolutionsWasm, E = window.createMediapipeSolutionsPackedAssets, N(K, z(E), 2);
                    F.h = K.h;
                    K.g = 0;
                  });
                });
              }), t = function() {
                return Y(f, function x() {
                  var z = this;
                  return O(x, function(E) {
                    z.g.graph && z.g.graph.url ? E = N(E, Qb(z, z.g.graph.url), 0) : (E.g = 0, E = void 0);
                    return E;
                  });
                });
              }(), N(m, Promise.all([w, v, t]), 7);
            if (typeof importScripts !== "function")
              throw Error("solutions can only be loaded on a web page or in a web worker");
            g = h.filter(function(u) {
              return u.simd === void 0 || u.simd && e || !u.simd && !e;
            }).map(function(u) {
              return f.locateFile(u.url, f.S);
            });
            importScripts.apply(null, ea(g));
            return N(m, createMediapipeSolutionsWasm(Module), 6);
          case 6:
            d.h = m.h;
            d.l = new OffscreenCanvas(1, 1);
            d.h.canvas = d.l;
            k = d.h.GL.createContext(d.l, { antialias: false, alpha: false, ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1 });
            d.h.GL.makeContextCurrent(k);
            m.g = 4;
            break;
          case 7:
            d.l = document.createElement("canvas");
            y = d.l.getContext("webgl2", {});
            if (!y && (y = d.l.getContext("webgl", {}), !y))
              return alert("Failed to create WebGL canvas context when passing video frame."), m.return();
            d.D = y;
            d.h.canvas = d.l;
            d.h.createContext(d.l, true, true, {});
          case 4:
            d.i = new d.h.SolutionWasm(), d.R = false, m.g = 0;
        }
      });
    });
  }
  function Rb(a) {
    return Y(a, function c() {
      var d = this, f, h, e, g, k, l, q, v;
      return O(c, function(w) {
        if (w.g == 1) {
          if (d.g.graph && d.g.graph.url && d.P === d.g.graph.url)
            return w.return();
          d.o = true;
          if (!d.g.graph || !d.g.graph.url) {
            w.g = 2;
            return;
          }
          d.P = d.g.graph.url;
          return N(w, Qb(d, d.g.graph.url), 3);
        }
        w.g != 2 && (f = w.h, d.i.loadGraph(f));
        h = M(Object.keys(d.B));
        for (e = h.next(); !e.done; e = h.next())
          g = e.value, d.i.overrideFile(g, d.B[g]);
        d.B = {};
        if (d.g.listeners)
          for (k = M(d.g.listeners), l = k.next(); !l.done; l = k.next())
            q = l.value, Sb(d, q);
        v = d.j;
        d.j = {};
        d.setOptions(v);
        w.g = 0;
      });
    });
  }
  D.reset = function() {
    return Y(this, function b() {
      var c = this;
      return O(b, function(d) {
        c.i && (c.i.reset(), c.m = {}, c.s = {});
        d.g = 0;
      });
    });
  };
  D.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], f = [], h = {}, e = M(Object.keys(a)), g = e.next(); !g.done; h = { K: h.K, L: h.L }, g = e.next()) {
        var k = g.value;
        k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], g = b[k], g !== void 0 && (g.onChange && (h.K = g.onChange, h.L = a[k], d.push(function(l) {
          return function() {
            return Y(c, function v() {
              var w, t = this;
              return O(v, function(y) {
                if (y.g == 1)
                  return N(y, l.K(l.L), 2);
                w = y.h;
                w === true && (t.o = true);
                y.g = 0;
              });
            });
          };
        }(h))), g.graphOptionXref && (k = { valueNumber: g.type === 1 ? a[k] : 0, valueBoolean: g.type === 0 ? a[k] : false, valueString: g.type === 2 ? a[k] : "" }, g = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), g.graphOptionXref), k), f.push(g))));
      }
      if (d.length !== 0 || f.length !== 0)
        this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(f), this.u = (this.u === void 0 ? [] : this.u).concat(d);
    }
  };
  function Tb(a) {
    return Y(a, function c() {
      var d = this, f, h, e, g, k, l, q;
      return O(c, function(v) {
        switch (v.g) {
          case 1:
            if (!d.o)
              return v.return();
            if (!d.u) {
              v.g = 2;
              break;
            }
            f = M(d.u);
            h = f.next();
          case 3:
            if (h.done) {
              v.g = 5;
              break;
            }
            e = h.value;
            return N(v, e(), 4);
          case 4:
            h = f.next();
            v.g = 3;
            break;
          case 5:
            d.u = void 0;
          case 2:
            if (d.A) {
              g = new d.h.GraphOptionChangeRequestList();
              k = M(d.A);
              for (l = k.next(); !l.done; l = k.next())
                q = l.value, g.push_back(q);
              d.i.changeOptions(g);
              g.delete();
              d.A = void 0;
            }
            d.o = false;
            v.g = 0;
        }
      });
    });
  }
  D.initialize = function() {
    return Y(this, function b() {
      var c = this;
      return O(b, function(d) {
        return d.g == 1 ? N(d, Pb(c), 2) : d.g != 3 ? N(d, Rb(c), 3) : N(d, Tb(c), 0);
      });
    });
  };
  function Qb(a, b) {
    return Y(a, function d() {
      var f = this, h, e;
      return O(d, function(g) {
        if (b in f.F)
          return g.return(f.F[b]);
        h = f.locateFile(b, "");
        e = fetch(h).then(function(k) {
          return k.arrayBuffer();
        });
        f.F[b] = e;
        return g.return(e);
      });
    });
  }
  D.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
  };
  D.clearOverriddenFiles = function() {
    this.B = {};
    this.i && this.i.clearOverriddenFiles();
  };
  D.send = function(a, b) {
    return Y(this, function d() {
      var f = this, h, e, g, k, l, q, v, w, t;
      return O(d, function(y) {
        switch (y.g) {
          case 1:
            if (!f.g.inputs)
              return y.return();
            h = 1e3 * (b === void 0 || b === null ? performance.now() : b);
            return N(y, f.C, 2);
          case 2:
            return N(y, f.initialize(), 3);
          case 3:
            e = new f.h.PacketDataList();
            g = M(Object.keys(a));
            for (k = g.next(); !k.done; k = g.next())
              if (l = k.value, q = f.g.inputs[l]) {
                a: {
                  var m = f;
                  var u = a[l];
                  switch (q.type) {
                    case "video":
                      var x = m.m[q.stream];
                      x || (x = new Eb(m.h, m.D), m.m[q.stream] = x);
                      m = x;
                      m.l === 0 && (m.l = m.h.createTexture());
                      if (typeof HTMLVideoElement !== "undefined" && u instanceof HTMLVideoElement) {
                        var z = u.videoWidth;
                        x = u.videoHeight;
                      } else
                        typeof HTMLImageElement !== "undefined" && u instanceof HTMLImageElement ? (z = u.naturalWidth, x = u.naturalHeight) : (z = u.width, x = u.height);
                      x = { glName: m.l, width: z, height: x };
                      z = m.g;
                      z.canvas.width = x.width;
                      z.canvas.height = x.height;
                      z.activeTexture(z.TEXTURE0);
                      m.h.bindTexture2d(m.l);
                      z.texImage2D(z.TEXTURE_2D, 0, z.RGBA, z.RGBA, z.UNSIGNED_BYTE, u);
                      m.h.bindTexture2d(0);
                      m = x;
                      break a;
                    case "detections":
                      x = m.m[q.stream];
                      x || (x = new Hb(m.h), m.m[q.stream] = x);
                      m = x;
                      m.data || (m.data = new m.g.DetectionListData());
                      m.data.reset(u.length);
                      for (x = 0; x < u.length; ++x) {
                        z = u[x];
                        var E = m.data, F = E.setBoundingBox, K = x;
                        var I = z.T;
                        var r = new Ab();
                        W(r, 1, I.Z);
                        W(r, 2, I.$);
                        W(r, 3, I.height);
                        W(r, 4, I.width);
                        W(r, 5, I.rotation);
                        W(r, 6, I.X);
                        var A = I = new Za();
                        T(A, 1, V(r, 1));
                        T(A, 2, V(r, 2));
                        T(A, 3, V(r, 3));
                        T(A, 4, V(r, 4));
                        T(A, 5, V(r, 5));
                        var C = V(r, 6);
                        if (C != null && C != null) {
                          S(A.g, 48);
                          var p = A.g, B = C;
                          C = 0 > B;
                          B = Math.abs(B);
                          var n = B >>> 0;
                          B = Math.floor((B - n) / 4294967296);
                          B >>>= 0;
                          C && (B = ~B >>> 0, n = (~n >>> 0) + 1, 4294967295 < n && (n = 0, B++, 4294967295 < B && (B = 0)));
                          P = n;
                          Q = B;
                          C = P;
                          for (n = Q; 0 < n || 127 < C; )
                            p.push(C & 127 | 128), C = (C >>> 7 | n << 25) >>> 0, n >>>= 7;
                          p.push(C);
                        }
                        qb(r, A);
                        I = ab(I);
                        F.call(E, K, I);
                        if (z.O)
                          for (E = 0; E < z.O.length; ++E)
                            r = z.O[E], A = r.visibility ? true : false, F = m.data, K = F.addNormalizedLandmark, I = x, r = Object.assign(Object.assign({}, r), { visibility: A ? r.visibility : 0 }), A = new wb(), W(A, 1, r.x), W(A, 2, r.y), W(A, 3, r.z), r.visibility && W(A, 4, r.visibility), p = r = new Za(), T(p, 1, V(A, 1)), T(p, 2, V(A, 2)), T(p, 3, V(A, 3)), T(p, 4, V(A, 4)), T(p, 5, V(A, 5)), qb(A, p), r = ab(r), K.call(F, I, r);
                        if (z.M)
                          for (E = 0; E < z.M.length; ++E) {
                            F = m.data;
                            K = F.addClassification;
                            I = x;
                            r = z.M[E];
                            A = new sb();
                            W(A, 2, r.Y);
                            r.index && W(A, 1, r.index);
                            r.label && W(A, 3, r.label);
                            r.displayName && W(A, 4, r.displayName);
                            p = r = new Za();
                            n = V(A, 1);
                            if (n != null && n != null)
                              if (S(p.g, 8), C = p.g, 0 <= n)
                                S(C, n);
                              else {
                                for (B = 0; 9 > B; B++)
                                  C.push(n & 127 | 128), n >>= 7;
                                C.push(1);
                              }
                            T(p, 2, V(A, 2));
                            C = V(A, 3);
                            C != null && (C = Ea(C), S(p.g, 26), S(p.g, C.length), $a(p, p.g.end()), $a(p, C));
                            C = V(A, 4);
                            C != null && (C = Ea(C), S(p.g, 34), S(p.g, C.length), $a(p, p.g.end()), $a(p, C));
                            qb(A, p);
                            r = ab(r);
                            K.call(F, I, r);
                          }
                      }
                      m = m.data;
                      break a;
                    default:
                      m = {};
                  }
                }
                v = m;
                w = q.stream;
                switch (q.type) {
                  case "video":
                    e.pushTexture2d(Object.assign(Object.assign({}, v), { stream: w, timestamp: h }));
                    break;
                  case "detections":
                    t = v;
                    t.stream = w;
                    t.timestamp = h;
                    e.pushDetectionList(t);
                    break;
                  default:
                    throw Error("Unknown input config type: '" + q.type + "'");
                }
              }
            f.i.send(e);
            return N(y, f.C, 4);
          case 4:
            e.delete(), y.g = 0;
        }
      });
    });
  };
  function Ub(a, b, c) {
    return Y(a, function f() {
      var h, e, g, k, l, q, v = this, w, t, y, m, u, x, z, E;
      return O(f, function(F) {
        switch (F.g) {
          case 1:
            if (!c)
              return F.return(b);
            h = {};
            e = 0;
            g = M(Object.keys(c));
            for (k = g.next(); !k.done; k = g.next())
              l = k.value, q = c[l], typeof q !== "string" && q.type === "texture" && b[q.stream] !== void 0 && ++e;
            1 < e && (v.G = false);
            w = M(Object.keys(c));
            k = w.next();
          case 2:
            if (k.done) {
              F.g = 4;
              break;
            }
            t = k.value;
            y = c[t];
            if (typeof y === "string")
              return z = h, E = t, N(F, Vb(v, t, b[y]), 14);
            m = b[y.stream];
            if (y.type === "detection_list") {
              if (m) {
                var K = m.getRectList();
                for (var I = m.getLandmarksList(), r = m.getClassificationsList(), A = [], C = 0; C < K.size(); ++C) {
                  var p = K.get(C);
                  a: {
                    var B = new Ab();
                    for (p = new Ua(p); Va(p); )
                      switch (p.i) {
                        case 13:
                          var n = R(p.g);
                          W(B, 1, n);
                          break;
                        case 21:
                          n = R(p.g);
                          W(B, 2, n);
                          break;
                        case 29:
                          n = R(p.g);
                          W(B, 3, n);
                          break;
                        case 37:
                          n = R(p.g);
                          W(B, 4, n);
                          break;
                        case 45:
                          n = R(p.g);
                          W(B, 5, n);
                          break;
                        case 48:
                          for (var G = p.g, L = 128, Ia = 0, Z = n = 0; 4 > Z && 128 <= L; Z++)
                            L = G.h[G.g++], Ia |= (L & 127) << 7 * Z;
                          128 <= L && (L = G.h[G.g++], Ia |= (L & 127) << 28, n |= (L & 127) >> 4);
                          if (128 <= L)
                            for (Z = 0; 5 > Z && 128 <= L; Z++)
                              L = G.h[G.g++], n |= (L & 127) << 7 * Z + 3;
                          if (128 > L) {
                            G = Ia >>> 0;
                            L = n >>> 0;
                            if (n = L & 2147483648)
                              G = ~G + 1 >>> 0, L = ~L >>> 0, G == 0 && (L = L + 1 >>> 0);
                            G = 4294967296 * L + (G >>> 0);
                            n = n ? -G : G;
                          } else
                            G.l = true, n = void 0;
                          W(B, 6, n);
                          break;
                        default:
                          if (!rb(B, p))
                            break a;
                      }
                  }
                  B = { Z: X(B, 1), $: X(B, 2), height: X(B, 3), width: X(B, 4), rotation: X(B, 5, 0), X: ob(B, 6) };
                  n = I.get(C);
                  a:
                    for (p = new yb(), n = new Ua(n); Va(n); )
                      switch (n.i) {
                        case 10:
                          G = Xa(n, new wb(), xb);
                          mb(p, G, wb, void 0);
                          break;
                        default:
                          if (!rb(p, n))
                            break a;
                      }
                  p = lb(p, wb).map(Db);
                  G = r.get(C);
                  a:
                    for (n = new ub(), G = new Ua(G); Va(G); )
                      switch (G.i) {
                        case 10:
                          n.addClassification(Xa(G, new sb(), tb));
                          break;
                        default:
                          if (!rb(n, G))
                            break a;
                      }
                  B = { T: B, O: p, M: Cb(n) };
                  A.push(B);
                }
                K = A;
              } else
                K = [];
              h[t] = K;
              F.g = 7;
              break;
            }
            if (y.type === "proto_list") {
              if (m) {
                K = Array(m.size());
                for (I = 0; I < m.size(); I++)
                  K[I] = m.get(I);
                m.delete();
              } else
                K = [];
              h[t] = K;
              F.g = 7;
              break;
            }
            if (m === void 0) {
              F.g = 3;
              break;
            }
            if (y.type === "float_list") {
              h[t] = m;
              F.g = 7;
              break;
            }
            if (y.type === "proto") {
              h[t] = m;
              F.g = 7;
              break;
            }
            if (y.type !== "texture")
              throw Error("Unknown output config type: '" + y.type + "'");
            u = v.s[t];
            u || (u = new Eb(v.h, v.D), v.s[t] = u);
            return N(F, Fb(u, m, v.G), 13);
          case 13:
            x = F.h, h[t] = x;
          case 7:
            y.transform && h[t] && (h[t] = y.transform(h[t]));
            F.g = 3;
            break;
          case 14:
            z[E] = F.h;
          case 3:
            k = w.next();
            F.g = 2;
            break;
          case 4:
            return F.return(h);
        }
      });
    });
  }
  function Vb(a, b, c) {
    return Y(a, function f() {
      var h = this, e;
      return O(f, function(g) {
        return typeof c === "number" || c instanceof Uint8Array || c instanceof h.h.Uint8BlobList ? g.return(c) : c instanceof h.h.Texture2dDataOut ? (e = h.s[b], e || (e = new Eb(h.h, h.D), h.s[b] = e), g.return(Fb(e, c, h.G))) : g.return(void 0);
      });
    });
  }
  function Sb(a, b) {
    for (var c = b.name || "$", d = [].concat(ea(b.wants)), f = new a.h.StringList(), h = M(b.wants), e = h.next(); !e.done; e = h.next())
      f.push_back(e.value);
    h = a.h.PacketListener.implement({ onResults: function(g) {
      for (var k = {}, l = 0; l < b.wants.length; ++l)
        k[d[l]] = g.get(l);
      var q = a.listeners[c];
      q && (a.C = Ub(a, k, b.outs).then(function(v) {
        v = q(v);
        for (var w = 0; w < b.wants.length; ++w) {
          var t = k[d[w]];
          typeof t === "object" && t.hasOwnProperty && t.hasOwnProperty("delete") && t.delete();
        }
        v && (a.C = v);
      }));
    } });
    a.i.attachMultiListener(f, h);
    f.delete();
  }
  D.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  ya("Solution", Nb);
  ya("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Wb(a) {
    a === void 0 && (a = 0);
    switch (a) {
      case 1:
        return "selfie_segmentation_landscape.tflite";
      default:
        return "selfie_segmentation.tflite";
    }
  }
  function Xb(a) {
    var b = this;
    a = a || {};
    this.g = new Nb({ locateFile: a.locateFile, files: function(c) {
      return [{ simd: true, url: "selfie_segmentation_solution_simd_wasm_bin.js" }, { simd: false, url: "selfie_segmentation_solution_wasm_bin.js" }, { data: true, url: Wb(c.modelSelection) }];
    }, graph: { url: "selfie_segmentation.binarypb" }, listeners: [{ wants: ["segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: {
      type: "video",
      stream: "input_frames_gpu"
    } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, modelSelection: { type: 1, graphOptionXref: {
      calculatorType: "ConstantSidePacketCalculator",
      calculatorName: "ConstantSidePacketCalculatorModelSelection",
      fieldName: "int_value"
    }, onChange: function(c) {
      return Y(b, function f() {
        var h, e, g = this, k;
        return O(f, function(l) {
          if (l.g == 1)
            return h = Wb(c), e = "third_party/mediapipe/modules/selfie_segmentation/" + h, N(l, Qb(g.g, h), 2);
          k = l.h;
          g.g.overrideFile(e, k);
          return l.return(true);
        });
      });
    } } } });
  }
  D = Xb.prototype;
  D.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  D.onResults = function(a) {
    this.g.onResults(a);
  };
  D.initialize = function() {
    return Y(this, function b() {
      var c = this;
      return O(b, function(d) {
        return N(d, c.g.initialize(), 0);
      });
    });
  };
  D.reset = function() {
    this.g.reset();
  };
  D.send = function(a) {
    return Y(this, function c() {
      var d = this;
      return O(c, function(f) {
        return N(f, d.g.send(a), 0);
      });
    });
  };
  D.setOptions = function(a) {
    this.g.setOptions(a);
  };
  ya("SelfieSegmentation", Xb);
  ya("VERSION", "0.1.1632777926");
}).call(VonageSelfiesegmentation);
const VonageHands = {};
(function() {
  var x;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function B(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  B("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  B("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function C(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function ea(a) {
    if (!(a instanceof Array)) {
      a = C(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var fa = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, ha;
  if (typeof Object.setPrototypeOf == "function")
    ha = Object.setPrototypeOf;
  else {
    var ia;
    a: {
      var ja = { a: true }, ka = {};
      try {
        ka.__proto__ = ja;
        ia = ka.a;
        break a;
      } catch (a) {
      }
      ia = false;
    }
    ha = ia ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var la = ha;
  function D(a, b) {
    a.prototype = fa(b.prototype);
    a.prototype.constructor = a;
    if (la)
      la(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.ra = b.prototype;
  }
  function ma() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.u = this.o = 0;
    this.j = null;
  }
  function na(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  ma.prototype.s = function(a) {
    this.h = a;
  };
  function oa(a, b) {
    a.j = { fa: b, ga: true };
    a.g = a.o || a.u;
  }
  ma.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.u;
  };
  function F(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function pa(a) {
    this.g = new ma();
    this.h = a;
  }
  function qa(a, b) {
    na(a.g);
    var c = a.g.i;
    if (c)
      return ra(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return G(a);
  }
  function ra(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, oa(a.g, f), G(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return G(a);
  }
  function G(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, oa(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.ga)
        throw b.fa;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function sa(a) {
    this.next = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i.next, b, a.g.s) : (a.g.s(b), b = G(a));
      return b;
    };
    this.throw = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.s) : (oa(a.g, b), b = G(a));
      return b;
    };
    this.return = function(b) {
      return qa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ta(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, e) {
      function g(f) {
        f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
      }
      g(a.next());
    });
  }
  function I(a) {
    return ta(new sa(new pa(a)));
  }
  B("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.s = false;
      var h = this.j();
      try {
        f(h.resolve, h.reject);
      } catch (k) {
        h.reject(k);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(h) {
        h(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var h = this;
        this.i(function() {
          h.l();
        });
      }
      this.g.push(f);
    };
    var e = y.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var h = 0; h < f.length; ++h) {
          var k = f[h];
          f[h] = null;
          try {
            k();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(m) {
          k || (k = true, l.call(h, m));
        };
      }
      var h = this, k = false;
      return { resolve: f(this.D), reject: f(this.l) };
    };
    b.prototype.D = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.H(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var h = f != null;
              break a;
            case "function":
              h = true;
              break a;
            default:
              h = false;
          }
        h ? this.A(f) : this.o(f);
      }
    };
    b.prototype.A = function(f) {
      var h = void 0;
      try {
        h = f.then;
      } catch (k) {
        this.l(k);
        return;
      }
      typeof h == "function" ? this.I(h, f) : this.o(f);
    };
    b.prototype.l = function(f) {
      this.u(2, f);
    };
    b.prototype.o = function(f) {
      this.u(1, f);
    };
    b.prototype.u = function(f, h) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = h;
      this.h === 2 && this.G();
      this.B();
    };
    b.prototype.G = function() {
      var f = this;
      e(function() {
        if (f.C()) {
          var h = y.console;
          typeof h !== "undefined" && h.error(f.i);
        }
      }, 1);
    };
    b.prototype.C = function() {
      if (this.s)
        return false;
      var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
      if (typeof k === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof h === "function" ? f = new h("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return k(f);
    };
    b.prototype.B = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.H = function(f) {
      var h = this.j();
      f.M(h.resolve, h.reject);
    };
    b.prototype.I = function(f, h) {
      var k = this.j();
      try {
        f.call(h, k.resolve, k.reject);
      } catch (l) {
        k.reject(l);
      }
    };
    b.prototype.then = function(f, h) {
      function k(p, n) {
        return typeof p == "function" ? function(q) {
          try {
            l(p(q));
          } catch (t) {
            m(t);
          }
        } : n;
      }
      var l, m, r = new b(function(p, n) {
        l = p;
        m = n;
      });
      this.M(k(f, l), k(h, m));
      return r;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.M = function(f, h) {
      function k() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            h(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(k) : this.g.push(k);
      this.s = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(h, k) {
        k(f);
      });
    };
    b.race = function(f) {
      return new b(function(h, k) {
        for (var l = C(f), m = l.next(); !m.done; m = l.next())
          d(m.value).M(h, k);
      });
    };
    b.all = function(f) {
      var h = C(f), k = h.next();
      return k.done ? d([]) : new b(function(l, m) {
        function r(q) {
          return function(t) {
            p[q] = t;
            n--;
            n == 0 && l(p);
          };
        }
        var p = [], n = 0;
        do
          p.push(void 0), n++, d(k.value).M(r(p.length - 1), m), k = h.next();
        while (!k.done);
      });
    };
    return b;
  });
  function ua(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  B("Object.assign", function(a) {
    return a || va;
  });
  B("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  B("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  B("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  B("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ua(this, function(b) {
        return b;
      });
    };
  });
  var wa = this || self;
  function J(a, b) {
    a = a.split(".");
    var c = wa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function K() {
    throw Error("Invalid UTF8");
  }
  function xa(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var ya, za = typeof TextDecoder !== "undefined", Aa, Ba = typeof TextEncoder !== "undefined";
  var Ca = {}, L = null;
  function Da(a) {
    var b;
    b === void 0 && (b = 0);
    Ea();
    b = Ca[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | h >> 4];
      h = b[(h & 15) << 2 | k >> 6];
      k = b[k & 63];
      c[g++] = l + f + h + k;
    }
    l = 0;
    k = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], k = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
    }
    return c.join("");
  }
  function Fa(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Ga(a, function(g) {
      d[e++] = g;
    });
    return e !== c ? d.subarray(0, e) : d;
  }
  function Ga(a, b) {
    function c(k) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), m = L[l];
        if (m != null)
          return m;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return k;
    }
    Ea();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), h = c(64);
      if (h === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
    }
  }
  function Ea() {
    if (!L) {
      L = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Ca[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          L[g] === void 0 && (L[g] = e);
        }
      }
    }
  }
  var Ha = typeof Uint8Array === "function";
  function Ia(a) {
    return Ha && a != null && a instanceof Uint8Array;
  }
  var Ja;
  function Ka(a) {
    this.L = a;
    if (a !== null && a.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var La = typeof Uint8Array.prototype.slice === "function", M = 0, N = 0;
  function Ma(a, b) {
    if (a.constructor === Uint8Array)
      return a;
    if (a.constructor === ArrayBuffer)
      return new Uint8Array(a);
    if (a.constructor === Array)
      return new Uint8Array(a);
    if (a.constructor === String)
      return Fa(a);
    if (a.constructor === Ka) {
      if (!b && (b = a.L) && b.constructor === Uint8Array)
        return b;
      b = a.L;
      b = b == null || Ia(b) ? b : typeof b === "string" ? Fa(b) : null;
      return (a = a.L = b) ? new Uint8Array(a) : Ja || (Ja = new Uint8Array(0));
    }
    if (a instanceof Uint8Array)
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Na(a, b) {
    return Error("Invalid wire type: " + a + " (at position " + b + ")");
  }
  function Oa() {
    return Error("Failed to read varint, encoding is invalid.");
  }
  function Pa(a, b) {
    b = b === void 0 ? {} : b;
    b = b.v === void 0 ? false : b.v;
    this.h = null;
    this.g = this.i = this.j = 0;
    this.v = b;
    a && Qa(this, a);
  }
  function Qa(a, b) {
    a.h = Ma(b, a.v);
    a.j = 0;
    a.i = a.h.length;
    a.g = a.j;
  }
  Pa.prototype.reset = function() {
    this.g = this.j;
  };
  function O(a) {
    if (a.g > a.i)
      throw Error("Tried to read past the end of the data " + a.g + " > " + a.i);
  }
  function Q(a) {
    var b = a.h, c = b[a.g], d = c & 127;
    if (128 > c)
      return a.g += 1, O(a), d;
    c = b[a.g + 1];
    d |= (c & 127) << 7;
    if (128 > c)
      return a.g += 2, O(a), d;
    c = b[a.g + 2];
    d |= (c & 127) << 14;
    if (128 > c)
      return a.g += 3, O(a), d;
    c = b[a.g + 3];
    d |= (c & 127) << 21;
    if (128 > c)
      return a.g += 4, O(a), d;
    c = b[a.g + 4];
    a.g += 5;
    d |= (c & 15) << 28;
    if (128 > c)
      return O(a), d;
    if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++])
      throw Oa();
    O(a);
    return d;
  }
  var Ra = [];
  function Sa() {
    this.g = [];
  }
  Sa.prototype.length = function() {
    return this.g.length;
  };
  Sa.prototype.end = function() {
    var a = this.g;
    this.g = [];
    return a;
  };
  function R(a, b) {
    for (; 127 < b; )
      a.g.push(b & 127 | 128), b >>>= 7;
    a.g.push(b);
  }
  function Ta(a) {
    var b = {}, c = b.W === void 0 ? false : b.W;
    this.l = { v: b.v === void 0 ? false : b.v };
    this.W = c;
    b = this.l;
    Ra.length ? (c = Ra.pop(), b && (c.v = b.v), a && Qa(c, a), a = c) : a = new Pa(a, b);
    this.g = a;
    this.j = this.g.g;
    this.h = this.i = -1;
  }
  Ta.prototype.reset = function() {
    this.g.reset();
    this.j = this.g.g;
    this.h = this.i = -1;
  };
  function Ua(a) {
    var b = a.g;
    if (b.g == b.i)
      return false;
    a.j = a.g.g;
    var c = Q(a.g) >>> 0;
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      throw Na(c, a.j);
    if (1 > b)
      throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
    a.i = b;
    a.h = c;
    return true;
  }
  function Va(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Va(a);
        else
          a: {
            a = a.g;
            for (var b = a.g, c = b + 10; b < c; )
              if ((a.h[b++] & 128) === 0) {
                a.g = b;
                O(a);
                break a;
              }
            throw Oa();
          }
        break;
      case 1:
        a = a.g;
        a.g += 8;
        O(a);
        break;
      case 2:
        a.h != 2 ? Va(a) : (b = Q(a.g) >>> 0, a = a.g, a.g += b, O(a));
        break;
      case 5:
        a = a.g;
        a.g += 4;
        O(a);
        break;
      case 3:
        b = a.i;
        do {
          if (!Ua(a))
            throw Error("Unmatched start-group tag: stream EOF");
          if (a.h == 4) {
            if (a.i != b)
              throw Error("Unmatched end-group tag");
            break;
          }
          Va(a);
        } while (1);
        break;
      default:
        throw Na(a.h, a.j);
    }
  }
  var Wa = [];
  function Xa() {
    this.i = [];
    this.h = 0;
    this.g = new Sa();
  }
  function S(a, b) {
    b.length !== 0 && (a.i.push(b), a.h += b.length);
  }
  function Ya(a, b) {
    if (b = b.ca) {
      S(a, a.g.end());
      for (var c = 0; c < b.length; c++)
        S(a, b[c]);
    }
  }
  var T = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
  function Za(a, b) {
    Object.isFrozen(a) || (T ? a[T] |= b : a.N !== void 0 ? a.N |= b : Object.defineProperties(a, { N: { value: b, configurable: true, writable: true, enumerable: false } }));
  }
  function $a(a) {
    var b;
    T ? b = a[T] : b = a.N;
    return b == null ? 0 : b;
  }
  function U(a) {
    Za(a, 1);
    return a;
  }
  function ab(a) {
    return Array.isArray(a) ? !!($a(a) & 2) : false;
  }
  function bb(a) {
    if (!Array.isArray(a))
      throw Error("cannot mark non-array as immutable");
    Za(a, 2);
  }
  function cb(a) {
    return a !== null && typeof a === "object" && !Array.isArray(a) && a.constructor === Object;
  }
  var db = Object.freeze(U([]));
  function eb(a) {
    if (ab(a.m))
      throw Error("Cannot mutate an immutable Message");
  }
  var fb = typeof Symbol != "undefined" && typeof Symbol.hasInstance != "undefined";
  function gb(a) {
    return { value: a, configurable: false, writable: false, enumerable: false };
  }
  function V(a, b, c) {
    return b === -1 ? null : b >= a.i ? a.g ? a.g[b] : void 0 : (c === void 0 ? 0 : c) && a.g && (c = a.g[b], c != null) ? c : a.m[b + a.h];
  }
  function W(a, b, c, d) {
    d = d === void 0 ? false : d;
    eb(a);
    b < a.i && !d ? a.m[b + a.h] = c : (a.g || (a.g = a.m[a.i + a.h] = {}))[b] = c;
  }
  function hb(a, b, c, d) {
    c = c === void 0 ? true : c;
    d = d === void 0 ? false : d;
    var e = V(a, b, d);
    e == null && (e = db);
    if (ab(a.m))
      c && (bb(e), Object.freeze(e));
    else if (e === db || ab(e))
      e = U(e.slice()), W(a, b, e, d);
    return e;
  }
  function X(a, b, c) {
    a = V(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function ib(a, b, c, d) {
    a.j || (a.j = {});
    var e = ab(a.m), g = a.j[c];
    if (!g) {
      d = hb(a, c, true, d === void 0 ? false : d);
      g = [];
      e = e || ab(d);
      for (var f = 0; f < d.length; f++)
        g[f] = new b(d[f]), e && bb(g[f].m);
      e && (bb(g), Object.freeze(g));
      a.j[c] = g;
    }
    return g;
  }
  function jb(a, b, c, d, e) {
    var g = g === void 0 ? false : g;
    eb(a);
    g = ib(a, c, b, g);
    c = d ? d : new c();
    a = hb(a, b);
    e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.m)) : (g.push(c), a.push(c.m));
    return c;
  }
  function kb(a, b) {
    a = V(a, b);
    return a == null ? 0 : a;
  }
  function lb(a, b) {
    a = V(a, b);
    return a == null ? "" : a;
  }
  function mb(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        if (a && !Array.isArray(a)) {
          if (Ia(a))
            return Da(a);
          if (a instanceof Ka) {
            var b = a.L;
            b = b == null || typeof b === "string" ? b : Ha && b instanceof Uint8Array ? Da(b) : null;
            return (a.L = b) || "";
          }
        }
    }
    return a;
  }
  function nb(a) {
    var b = ob;
    b = b === void 0 ? pb : b;
    return qb(a, b);
  }
  function rb(a, b) {
    if (a != null) {
      if (Array.isArray(a))
        a = qb(a, b);
      else if (cb(a)) {
        var c = {}, d;
        for (d in a)
          c[d] = rb(a[d], b);
        a = c;
      } else
        a = b(a);
      return a;
    }
  }
  function qb(a, b) {
    for (var c = a.slice(), d = 0; d < c.length; d++)
      c[d] = rb(c[d], b);
    Array.isArray(a) && $a(a) & 1 && U(c);
    return c;
  }
  function ob(a) {
    if (a && typeof a == "object" && a.toJSON)
      return a.toJSON();
    a = mb(a);
    return Array.isArray(a) ? nb(a) : a;
  }
  function pb(a) {
    return Ia(a) ? new Uint8Array(a) : a;
  }
  function sb(a, b, c) {
    a || (a = tb);
    tb = null;
    var d = this.constructor.h;
    a || (a = d ? [d] : []);
    this.h = (d ? 0 : -1) - (this.constructor.g || 0);
    this.j = void 0;
    this.m = a;
    a: {
      d = this.m.length;
      a = d - 1;
      if (d && (d = this.m[a], cb(d))) {
        this.i = a - this.h;
        this.g = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.i = Math.max(b, a + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        if (a = c[b], a < this.i)
          a += this.h, (d = this.m[a]) ? Array.isArray(d) && U(d) : this.m[a] = db;
        else {
          d = this.g || (this.g = this.m[this.i + this.h] = {});
          var e = d[a];
          e ? Array.isArray(e) && U(e) : d[a] = db;
        }
  }
  sb.prototype.toJSON = function() {
    return nb(this.m);
  };
  sb.prototype.toString = function() {
    return this.m.toString();
  };
  var tb;
  function ub() {
    sb.apply(this, arguments);
  }
  D(ub, sb);
  if (fb) {
    var vb = {};
    Object.defineProperties(ub, (vb[Symbol.hasInstance] = gb(function() {
      throw Error("Cannot perform instanceof checks for MutableMessage");
    }), vb));
  }
  function wb(a, b, c) {
    if (c) {
      var d = {}, e;
      for (e in c) {
        var g = c[e], f = g.ja;
        f || (d.F = g.pa || g.ha.P, g.ba ? (d.U = xb(g.ba), f = function(h) {
          return function(k, l, m) {
            return h.F(k, l, m, h.U);
          };
        }(d)) : g.da ? (d.T = yb(g.X.g, g.da), f = function(h) {
          return function(k, l, m) {
            return h.F(k, l, m, h.T);
          };
        }(d)) : f = d.F, g.ja = f);
        f(b, a, g.X);
        d = { F: d.F, U: d.U, T: d.T };
      }
    }
    Ya(b, a);
  }
  var zb = Symbol();
  function Ab(a, b, c) {
    return a[zb] || (a[zb] = function(d, e) {
      return b(d, e, c);
    });
  }
  function Bb(a) {
    var b = a[zb];
    if (!b) {
      var c = Cb(a);
      b = function(d, e) {
        return Db(d, e, c);
      };
      a[zb] = b;
    }
    return b;
  }
  function Eb(a) {
    var b = a.ba;
    if (b)
      return Bb(b);
    if (b = a.oa)
      return Ab(a.X.g, b, a.da);
  }
  function Fb(a) {
    var b = Eb(a), c = a.X, d = a.ha.O;
    return b ? function(e, g) {
      return d(e, g, c, b);
    } : function(e, g) {
      return d(e, g, c);
    };
  }
  function Gb(a, b, c, d, e, g) {
    a = a();
    var f = 0;
    a.length && typeof a[0] !== "number" && (c(b, a[0]), f++);
    for (; f < a.length; ) {
      c = a[f++];
      for (var h = f + 1; h < a.length && typeof a[h] !== "number"; )
        h++;
      var k = a[f++];
      h -= f;
      switch (h) {
        case 0:
          d(b, c, k);
          break;
        case 1:
          d(b, c, k, a[f++]);
          break;
        case 2:
          e(b, c, k, a[f++], a[f++]);
          break;
        case 3:
          h = a[f++];
          var l = a[f++], m = a[f++];
          Array.isArray(m) ? e(b, c, k, h, l, m) : g(b, c, k, h, l, m);
          break;
        case 4:
          g(b, c, k, a[f++], a[f++], a[f++], a[f++]);
          break;
        default:
          throw Error("unexpected number of binary field arguments: " + h);
      }
    }
    return b;
  }
  var Hb = Symbol();
  function xb(a) {
    var b = a[Hb];
    if (!b) {
      var c = Ib(a);
      b = function(d, e) {
        return Jb(d, e, c);
      };
      a[Hb] = b;
    }
    return b;
  }
  function yb(a, b) {
    var c = a[Hb];
    c || (c = function(d, e) {
      return wb(d, e, b);
    }, a[Hb] = c);
    return c;
  }
  var Kb = Symbol();
  function Lb(a, b) {
    a.push(b);
  }
  function Mb(a, b, c) {
    a.push(b, c.P);
  }
  function Nb(a, b, c, d, e) {
    var g = xb(e), f = c.P;
    a.push(b, function(h, k, l) {
      return f(h, k, l, d, g);
    });
  }
  function Ob(a, b, c, d, e, g) {
    var f = yb(d, g), h = c.P;
    a.push(b, function(k, l, m) {
      return h(k, l, m, d, f);
    });
  }
  function Ib(a) {
    var b = a[Kb];
    return b ? b : Gb(a, a[Kb] = [], Lb, Mb, Nb, Ob);
  }
  var Pb = Symbol();
  function Qb(a, b) {
    a[0] = b;
  }
  function Rb(a, b, c, d) {
    var e = c.O;
    a[b] = d ? function(g, f, h) {
      return e(g, f, h, d);
    } : e;
  }
  function Sb(a, b, c, d, e, g) {
    var f = c.O, h = Bb(e);
    a[b] = function(k, l, m) {
      return f(k, l, m, d, h, g);
    };
  }
  function Tb(a, b, c, d, e, g, f) {
    var h = c.O, k = Ab(d, e, g);
    a[b] = function(l, m, r) {
      return h(l, m, r, d, k, f);
    };
  }
  function Cb(a) {
    var b = a[Pb];
    return b ? b : Gb(a, a[Pb] = {}, Qb, Rb, Sb, Tb);
  }
  function Db(a, b, c) {
    for (; Ua(b) && b.h != 4; ) {
      var d = b.i, e = c[d];
      if (!e) {
        var g = c[0];
        g && (g = g[d]) && (e = c[d] = Fb(g));
      }
      if (!e || !e(b, a, d)) {
        if (e = b, d = a, g = e.j, Va(e), !e.W) {
          var f = e.g.h;
          e = e.g.g;
          e = g === e ? Ja || (Ja = new Uint8Array(0)) : La ? f.slice(g, e) : new Uint8Array(f.subarray(g, e));
          (g = d.ca) ? g.push(e) : d.ca = [e];
        }
      }
    }
    return a;
  }
  function Ub(a, b, c) {
    if (Wa.length) {
      var d = Wa.pop();
      a && (Qa(d.g, a), d.i = -1, d.h = -1);
      a = d;
    } else
      a = new Ta(a);
    try {
      return Db(new b(), a, Cb(c));
    } finally {
      b = a.g, b.h = null, b.j = 0, b.i = 0, b.g = 0, b.v = false, a.i = -1, a.h = -1, 100 > Wa.length && Wa.push(a);
    }
  }
  function Jb(a, b, c) {
    for (var d = c.length, e = d % 2 == 1, g = e ? 1 : 0; g < d; g += 2)
      (0, c[g + 1])(b, a, c[g]);
    wb(a, b, e ? c[0] : void 0);
  }
  function Vb(a, b) {
    var c = new Xa();
    Jb(a, c, Ib(b));
    S(c, c.g.end());
    a = new Uint8Array(c.h);
    b = c.i;
    for (var d = b.length, e = 0, g = 0; g < d; g++) {
      var f = b[g];
      a.set(f, e);
      e += f.length;
    }
    c.i = [a];
    return a;
  }
  function Wb(a, b) {
    return { O: a, P: b };
  }
  var Y = Wb(function(a, b, c) {
    if (a.h !== 5)
      return false;
    a = a.g;
    var d = a.h[a.g];
    var e = a.h[a.g + 1];
    var g = a.h[a.g + 2], f = a.h[a.g + 3];
    a.g += 4;
    O(a);
    e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
    a = 2 * (e >> 31) + 1;
    d = e >>> 23 & 255;
    e &= 8388607;
    W(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null) {
      R(a.g, 8 * c + 5);
      a = a.g;
      var d = b;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? M = N = 0 : (N = 0, M = 2147483648) : isNaN(d) ? (N = 0, M = 2147483647) : 34028234663852886e22 < d ? (N = 0, M = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), N = 0, M = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, N = 0, M = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = M;
      a.g.push(c >>> 0 & 255);
      a.g.push(c >>> 8 & 255);
      a.g.push(c >>> 16 & 255);
      a.g.push(c >>> 24 & 255);
    }
  }), Xb = Wb(function(a, b, c) {
    if (a.h !== 0)
      return false;
    for (var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)
      e = d.h[d.g++], O(d), g |= (e & 127) << 7 * f;
    128 <= e && (e = d.h[d.g++], O(d), g |= (e & 127) << 28, a |= (e & 127) >> 4);
    if (128 <= e)
      for (f = 0; 5 > f && 128 <= e; f++)
        e = d.h[d.g++], O(d), a |= (e & 127) << 7 * f + 3;
    if (128 > e) {
      d = g >>> 0;
      e = a >>> 0;
      if (a = e & 2147483648)
        d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
      d = 4294967296 * e + (d >>> 0);
    } else
      throw Oa();
    W(b, c, a ? -d : d);
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null && b != null) {
      R(a.g, 8 * c);
      a = a.g;
      var d = b;
      c = 0 > d;
      d = Math.abs(d);
      b = d >>> 0;
      d = Math.floor((d - b) / 4294967296);
      d >>>= 0;
      c && (d = ~d >>> 0, b = (~b >>> 0) + 1, 4294967295 < b && (b = 0, d++, 4294967295 < d && (d = 0)));
      M = b;
      N = d;
      c = M;
      for (b = N; 0 < b || 127 < c; )
        a.g.push(c & 127 | 128), c = (c >>> 7 | b << 25) >>> 0, b >>>= 7;
      a.g.push(c);
    }
  }), Yb = Wb(function(a, b, c) {
    if (a.h !== 0)
      return false;
    W(b, c, Q(a.g));
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null && b != null)
      if (R(a.g, 8 * c), a = a.g, c = b, 0 <= c)
        R(a, c);
      else {
        for (b = 0; 9 > b; b++)
          a.g.push(c & 127 | 128), c >>= 7;
        a.g.push(1);
      }
  }), Zb = Wb(function(a, b, c) {
    if (a.h !== 2)
      return false;
    var d = Q(a.g) >>> 0;
    a = a.g;
    var e = a.g;
    a.g += d;
    O(a);
    a = a.h;
    var g;
    if (za)
      (g = ya) || (g = ya = new TextDecoder("utf-8", { fatal: true })), g = g.decode(a.subarray(e, e + d));
    else {
      d = e + d;
      for (var f = [], h = null, k, l, m; e < d; )
        k = a[e++], 128 > k ? f.push(k) : 224 > k ? e >= d ? K() : (l = a[e++], 194 > k || (l & 192) !== 128 ? (e--, K()) : f.push((k & 31) << 6 | l & 63)) : 240 > k ? e >= d - 1 ? K() : (l = a[e++], (l & 192) !== 128 || k === 224 && 160 > l || k === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, K()) : f.push((k & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= k ? e >= d - 2 ? K() : (l = a[e++], (l & 192) !== 128 || (k << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((m = a[e++]) & 192) !== 128 ? (e--, K()) : (k = (k & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | m & 63, k -= 65536, f.push((k >> 10 & 1023) + 55296, (k & 1023) + 56320))) : K(), 8192 <= f.length && (h = xa(h, f), f.length = 0);
      g = xa(h, f);
    }
    W(b, c, g);
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null) {
      var d = false;
      d = d === void 0 ? false : d;
      if (Ba) {
        if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b))
          throw Error("Found an unpaired surrogate");
        b = (Aa || (Aa = new TextEncoder())).encode(b);
      } else {
        for (var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++) {
          var h = b.charCodeAt(f);
          if (128 > h)
            g[e++] = h;
          else {
            if (2048 > h)
              g[e++] = h >> 6 | 192;
            else {
              if (55296 <= h && 57343 >= h) {
                if (56319 >= h && f < b.length) {
                  var k = b.charCodeAt(++f);
                  if (56320 <= k && 57343 >= k) {
                    h = 1024 * (h - 55296) + k - 56320 + 65536;
                    g[e++] = h >> 18 | 240;
                    g[e++] = h >> 12 & 63 | 128;
                    g[e++] = h >> 6 & 63 | 128;
                    g[e++] = h & 63 | 128;
                    continue;
                  } else
                    f--;
                }
                if (d)
                  throw Error("Found an unpaired surrogate");
                h = 65533;
              }
              g[e++] = h >> 12 | 224;
              g[e++] = h >> 6 & 63 | 128;
            }
            g[e++] = h & 63 | 128;
          }
        }
        b = g.subarray(0, e);
      }
      R(a.g, 8 * c + 2);
      R(a.g, b.length);
      S(a, a.g.end());
      S(a, b);
    }
  }), $b = Wb(function(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    b = jb(b, c, d);
    c = a.g.i;
    d = Q(a.g) >>> 0;
    var g = a.g.g + d, f = g - c;
    0 >= f && (a.g.i = g, e(b, a), f = g - a.g.g);
    if (f)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.g.g = g;
    a.g.i = c;
    return true;
  }, function(a, b, c, d, e) {
    b = ib(b, d, c);
    if (b != null)
      for (d = 0; d < b.length; d++) {
        var g = a;
        R(g.g, 8 * c + 2);
        var f = g.g.end();
        S(g, f);
        f.push(g.h);
        g = f;
        e(b[d], a);
        f = a;
        var h = g.pop();
        for (h = f.h + f.g.length() - h; 127 < h; )
          g.push(h & 127 | 128), h >>>= 7, f.h++;
        g.push(h);
        f.h++;
      }
  });
  function Z() {
    ub.apply(this, arguments);
  }
  D(Z, ub);
  if (fb) {
    var ac = {};
    Object.defineProperties(Z, (ac[Symbol.hasInstance] = gb(Object[Symbol.hasInstance]), ac));
  }
  function bc(a) {
    Z.call(this, a);
  }
  D(bc, Z);
  function cc() {
    return [1, Yb, 2, Y, 3, Zb, 4, Zb];
  }
  function dc(a) {
    Z.call(this, a, -1, ec);
  }
  D(dc, Z);
  dc.prototype.addClassification = function(a, b) {
    jb(this, 1, bc, a, b);
    return this;
  };
  function fc() {
    return [1, $b, bc, cc];
  }
  var ec = [1];
  function gc(a) {
    Z.call(this, a);
  }
  D(gc, Z);
  function hc() {
    return [1, Y, 2, Y, 3, Y, 4, Y, 5, Y];
  }
  function ic(a) {
    Z.call(this, a, -1, jc);
  }
  D(ic, Z);
  function kc() {
    return [1, $b, gc, hc];
  }
  var jc = [1];
  function lc(a) {
    Z.call(this, a);
  }
  D(lc, Z);
  function mc() {
    return [1, Y, 2, Y, 3, Y, 4, Y, 5, Y, 6, Xb];
  }
  function nc(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function oc(a) {
    return ib(a, bc, 1).map(function(b) {
      return { index: kb(b, 1), score: X(b, 2), label: V(b, 3) != null ? lb(b, 3) : void 0, displayName: V(b, 4) != null ? lb(b, 4) : void 0 };
    });
  }
  function pc(a) {
    return { x: X(a, 1), y: X(a, 2), z: X(a, 3), visibility: V(a, 4) != null ? X(a, 4) : void 0 };
  }
  function qc(a) {
    return a.map(function(b) {
      return ib(Ub(b, ic, kc), gc, 1).map(pc);
    });
  }
  function rc(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function sc(a, b, c) {
    tc(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function tc(a, b) {
    var c = a.g;
    if (a.o === void 0) {
      var d = nc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = nc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.o = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { K: c.getAttribLocation(d, "aVertex"), J: c.getAttribLocation(d, "aTex"), qa: e };
      a.u = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.u);
      c.enableVertexAttribArray(a.j.K);
      c.vertexAttribPointer(a.j.K, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.J);
      c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.o);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.K);
    c.bindBuffer(c.ARRAY_BUFFER, a.u);
    c.vertexAttribPointer(d.K, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.J);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.K);
    c.disableVertexAttribArray(d.J);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function uc(a) {
    this.g = a;
  }
  var vc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function wc(a, b) {
    return b + a;
  }
  function xc(a, b) {
    window[a] = b;
  }
  function yc(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function zc() {
    return I(function(a) {
      switch (a.g) {
        case 1:
          return a.o = 2, F(a, WebAssembly.instantiate(vc), 4);
        case 4:
          a.g = 3;
          a.o = 0;
          break;
        case 2:
          return a.o = 0, a.j = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function Ac(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.H = {};
    this.o = {};
    this.u = {};
    this.I = this.s = this.$ = true;
    this.D = Promise.resolve();
    this.Z = "";
    this.C = {};
    this.locateFile = a && a.locateFile || wc;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.aa = b;
    if (a.options) {
      b = C(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  x = Ac.prototype;
  x.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Bc(a) {
    var b, c, d, e, g, f, h, k, l, m, r;
    return I(function(p) {
      switch (p.g) {
        case 1:
          if (!a.$)
            return p.return();
          b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
          return F(p, zc(), 2);
        case 2:
          c = p.h;
          if (typeof window === "object")
            return xc("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), xc("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(n) {
              return n.data !== void 0;
            }), h = b.filter(function(n) {
              return n.data === void 0;
            }), k = Promise.all(f.map(function(n) {
              var q = Cc(a, n.url);
              if (n.path !== void 0) {
                var t = n.path;
                q = q.then(function(w) {
                  a.overrideFile(t, w);
                  return Promise.resolve(w);
                });
              }
              return q;
            })), l = Promise.all(h.map(function(n) {
              return n.simd === void 0 || n.simd && c || !n.simd && !c ? yc(a.locateFile(n.url, a.aa)) : Promise.resolve();
            })).then(function() {
              var n, q, t;
              return I(function(w) {
                if (w.g == 1)
                  return n = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, n(q), 2);
                t.h = w.h;
                w.g = 0;
              });
            }), m = function() {
              return I(function(n) {
                a.g.graph && a.g.graph.url ? n = F(n, Cc(a, a.g.graph.url), 0) : (n.g = 0, n = void 0);
                return n;
              });
            }(), F(p, Promise.all([l, k, m]), 7);
          if (typeof importScripts !== "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(n) {
            return n.simd === void 0 || n.simd && c || !n.simd && !c;
          }).map(function(n) {
            return a.locateFile(n.url, a.aa);
          });
          importScripts.apply(null, ea(d));
          e = a;
          return F(p, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          e.h = p.h;
          a.l = new OffscreenCanvas(1, 1);
          a.h.canvas = a.l;
          g = a.h.GL.createContext(a.l, {
            antialias: false,
            alpha: false,
            na: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
          });
          a.h.GL.makeContextCurrent(g);
          p.g = 4;
          break;
        case 7:
          a.l = document.createElement("canvas");
          r = a.l.getContext("webgl2", {});
          if (!r && (r = a.l.getContext("webgl", {}), !r))
            return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
          a.G = r;
          a.h.canvas = a.l;
          a.h.createContext(a.l, true, true, {});
        case 4:
          a.i = new a.h.SolutionWasm(), a.$ = false, p.g = 0;
      }
    });
  }
  function Dc(a) {
    var b, c, d, e, g, f, h, k;
    return I(function(l) {
      if (l.g == 1) {
        if (a.g.graph && a.g.graph.url && a.Z === a.g.graph.url)
          return l.return();
        a.s = true;
        if (!a.g.graph || !a.g.graph.url) {
          l.g = 2;
          return;
        }
        a.Z = a.g.graph.url;
        return F(l, Cc(a, a.g.graph.url), 3);
      }
      l.g != 2 && (b = l.h, a.i.loadGraph(b));
      c = C(Object.keys(a.C));
      for (d = c.next(); !d.done; d = c.next())
        e = d.value, a.i.overrideFile(e, a.C[e]);
      a.C = {};
      if (a.g.listeners)
        for (g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())
          h = f.value, Ec(a, h);
      k = a.j;
      a.j = {};
      a.setOptions(k);
      l.g = 0;
    });
  }
  x.reset = function() {
    var a = this;
    return I(function(b) {
      a.i && (a.i.reset(), a.o = {}, a.u = {});
      b.g = 0;
    });
  };
  x.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = C(Object.keys(a)), h = f.next(); !h.done; g = { R: g.R, S: g.S }, h = f.next()) {
        var k = h.value;
        k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.R = h.onChange, g.S = a[k], d.push(function(l) {
          return function() {
            var m;
            return I(function(r) {
              if (r.g == 1)
                return F(r, l.R(l.S), 2);
              m = r.h;
              m === true && (c.s = true);
              r.g = 0;
            });
          };
        }(g))), h.graphOptionXref && (k = { valueNumber: h.type === 1 ? a[k] : 0, valueBoolean: h.type === 0 ? a[k] : false, valueString: h.type === 2 ? a[k] : "" }, h = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), h.graphOptionXref), k), e.push(h))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.s = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
    }
  };
  function Fc(a) {
    var b, c, d, e, g, f, h;
    return I(function(k) {
      switch (k.g) {
        case 1:
          if (!a.s)
            return k.return();
          if (!a.A) {
            k.g = 2;
            break;
          }
          b = C(a.A);
          c = b.next();
        case 3:
          if (c.done) {
            k.g = 5;
            break;
          }
          d = c.value;
          return F(k, d(), 4);
        case 4:
          c = b.next();
          k.g = 3;
          break;
        case 5:
          a.A = void 0;
        case 2:
          if (a.B) {
            e = new a.h.GraphOptionChangeRequestList();
            g = C(a.B);
            for (f = g.next(); !f.done; f = g.next())
              h = f.value, e.push_back(h);
            a.i.changeOptions(e);
            e.delete();
            a.B = void 0;
          }
          a.s = false;
          k.g = 0;
      }
    });
  }
  x.initialize = function() {
    var a = this;
    return I(function(b) {
      return b.g == 1 ? F(b, Bc(a), 2) : b.g != 3 ? F(b, Dc(a), 3) : F(b, Fc(a), 0);
    });
  };
  function Cc(a, b) {
    var c, d;
    return I(function(e) {
      if (b in a.H)
        return e.return(a.H[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.H[b] = d;
      return e.return(d);
    });
  }
  x.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
  };
  x.clearOverriddenFiles = function() {
    this.C = {};
    this.i && this.i.clearOverriddenFiles();
  };
  x.send = function(a, b) {
    var c = this, d, e, g, f, h, k, l, m, r;
    return I(function(p) {
      switch (p.g) {
        case 1:
          if (!c.g.inputs)
            return p.return();
          d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
          return F(p, c.D, 2);
        case 2:
          return F(p, c.initialize(), 3);
        case 3:
          e = new c.h.PacketDataList();
          g = C(Object.keys(a));
          for (f = g.next(); !f.done; f = g.next())
            if (h = f.value, k = c.g.inputs[h]) {
              a: {
                var n = a[h];
                switch (k.type) {
                  case "video":
                    var q = c.o[k.stream];
                    q || (q = new rc(c.h, c.G), c.o[k.stream] = q);
                    q.l === 0 && (q.l = q.h.createTexture());
                    if (typeof HTMLVideoElement !== "undefined" && n instanceof HTMLVideoElement) {
                      var t = n.videoWidth;
                      var w = n.videoHeight;
                    } else
                      typeof HTMLImageElement !== "undefined" && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                    w = { glName: q.l, width: t, height: w };
                    t = q.g;
                    t.canvas.width = w.width;
                    t.canvas.height = w.height;
                    t.activeTexture(t.TEXTURE0);
                    q.h.bindTexture2d(q.l);
                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                    q.h.bindTexture2d(0);
                    q = w;
                    break a;
                  case "detections":
                    q = c.o[k.stream];
                    q || (q = new uc(c.h), c.o[k.stream] = q);
                    q.data || (q.data = new q.g.DetectionListData());
                    q.data.reset(n.length);
                    for (w = 0; w < n.length; ++w) {
                      t = n[w];
                      var v = q.data, A = v.setBoundingBox, H = w;
                      var E = t.ea;
                      var u = new lc();
                      W(u, 1, E.ka);
                      W(u, 2, E.la);
                      W(u, 3, E.height);
                      W(u, 4, E.width);
                      W(u, 5, E.rotation);
                      W(u, 6, E.ia);
                      E = Vb(u, mc);
                      A.call(v, H, E);
                      if (t.Y)
                        for (v = 0; v < t.Y.length; ++v) {
                          u = t.Y[v];
                          var z = u.visibility ? true : false;
                          A = q.data;
                          H = A.addNormalizedLandmark;
                          E = w;
                          u = Object.assign(Object.assign({}, u), { visibility: z ? u.visibility : 0 });
                          z = new gc();
                          W(z, 1, u.x);
                          W(z, 2, u.y);
                          W(z, 3, u.z);
                          u.visibility && W(z, 4, u.visibility);
                          u = Vb(z, hc);
                          H.call(A, E, u);
                        }
                      if (t.V)
                        for (v = 0; v < t.V.length; ++v)
                          A = q.data, H = A.addClassification, E = w, u = t.V[v], z = new bc(), W(z, 2, u.score), u.index && W(z, 1, u.index), u.label && W(z, 3, u.label), u.displayName && W(z, 4, u.displayName), u = Vb(z, cc), H.call(A, E, u);
                    }
                    q = q.data;
                    break a;
                  default:
                    q = {};
                }
              }
              l = q;
              m = k.stream;
              switch (k.type) {
                case "video":
                  e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: m, timestamp: d }));
                  break;
                case "detections":
                  r = l;
                  r.stream = m;
                  r.timestamp = d;
                  e.pushDetectionList(r);
                  break;
                default:
                  throw Error("Unknown input config type: '" + k.type + "'");
              }
            }
          c.i.send(e);
          return F(p, c.D, 4);
        case 4:
          e.delete(), p.g = 0;
      }
    });
  };
  function Gc(a, b, c) {
    var d, e, g, f, h, k, l, m, r, p, n, q, t, w;
    return I(function(v) {
      switch (v.g) {
        case 1:
          if (!c)
            return v.return(b);
          d = {};
          e = 0;
          g = C(Object.keys(c));
          for (f = g.next(); !f.done; f = g.next())
            h = f.value, k = c[h], typeof k !== "string" && k.type === "texture" && b[k.stream] !== void 0 && ++e;
          1 < e && (a.I = false);
          l = C(Object.keys(c));
          f = l.next();
        case 2:
          if (f.done) {
            v.g = 4;
            break;
          }
          m = f.value;
          r = c[m];
          if (typeof r === "string")
            return t = d, w = m, F(v, Hc(a, m, b[r]), 14);
          p = b[r.stream];
          if (r.type === "detection_list") {
            if (p) {
              var A = p.getRectList();
              for (var H = p.getLandmarksList(), E = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z) {
                var P = Ub(A.get(z), lc, mc);
                P = { ea: { ka: X(P, 1), la: X(P, 2), height: X(P, 3), width: X(P, 4), rotation: X(P, 5, 0), ia: kb(P, 6) }, Y: ib(Ub(H.get(z), ic, kc), gc, 1).map(pc), V: oc(Ub(E.get(z), dc, fc)) };
                u.push(P);
              }
              A = u;
            } else
              A = [];
            d[m] = A;
            v.g = 7;
            break;
          }
          if (r.type === "proto_list") {
            if (p) {
              A = Array(p.size());
              for (H = 0; H < p.size(); H++)
                A[H] = p.get(H);
              p.delete();
            } else
              A = [];
            d[m] = A;
            v.g = 7;
            break;
          }
          if (p === void 0) {
            v.g = 3;
            break;
          }
          if (r.type === "float_list") {
            d[m] = p;
            v.g = 7;
            break;
          }
          if (r.type === "proto") {
            d[m] = p;
            v.g = 7;
            break;
          }
          if (r.type !== "texture")
            throw Error("Unknown output config type: '" + r.type + "'");
          n = a.u[m];
          n || (n = new rc(a.h, a.G), a.u[m] = n);
          return F(v, sc(n, p, a.I), 13);
        case 13:
          q = v.h, d[m] = q;
        case 7:
          r.transform && d[m] && (d[m] = r.transform(d[m]));
          v.g = 3;
          break;
        case 14:
          t[w] = v.h;
        case 3:
          f = l.next();
          v.g = 2;
          break;
        case 4:
          return v.return(d);
      }
    });
  }
  function Hc(a, b, c) {
    var d;
    return I(function(e) {
      return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.u[b], d || (d = new rc(a.h, a.G), a.u[b] = d), e.return(sc(d, c, a.I))) : e.return(void 0);
    });
  }
  function Ec(a, b) {
    for (var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(h) {
      for (var k = {}, l = 0; l < b.wants.length; ++l)
        k[d[l]] = h.get(l);
      var m = a.listeners[c];
      m && (a.D = Gc(a, k, b.outs).then(function(r) {
        r = m(r);
        for (var p = 0; p < b.wants.length; ++p) {
          var n = k[d[p]];
          typeof n === "object" && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
        }
        r && (a.D = r);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  x.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  J("Solution", Ac);
  J("OptionType", { BOOL: 0, NUMBER: 1, ma: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Ic(a) {
    a === void 0 && (a = 0);
    return a === 1 ? "hand_landmark_full.tflite" : "hand_landmark_lite.tflite";
  }
  function Jc(a) {
    var b = this;
    a = a || {};
    this.g = new Ac({ locateFile: a.locateFile, files: function(c) {
      return [{ url: "hands_solution_packed_assets_loader.js" }, { simd: false, url: "hands_solution_wasm_bin.js" }, { simd: true, url: "hands_solution_simd_wasm_bin.js" }, { data: true, url: Ic(c.modelComplexity) }];
    }, graph: { url: "hands.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["multi_hand_landmarks", "multi_hand_world_landmarks", "image_transformed", "multi_handedness"], outs: {
      image: "image_transformed",
      multiHandLandmarks: { type: "proto_list", stream: "multi_hand_landmarks", transform: qc },
      multiHandWorldLandmarks: { type: "proto_list", stream: "multi_hand_world_landmarks", transform: qc },
      multiHandedness: { type: "proto_list", stream: "multi_handedness", transform: function(c) {
        return c.map(function(d) {
          return oc(Ub(d, dc, fc))[0];
        });
      } }
    } }], options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumHands: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculator", fieldName: "int_value" } }, modelComplexity: {
      type: 1,
      graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" },
      onChange: function(c) {
        var d, e, g;
        return I(function(f) {
          if (f.g == 1)
            return d = Ic(c), e = "third_party/mediapipe/modules/hand_landmark/" + d, F(f, Cc(b.g, d), 2);
          g = f.h;
          b.g.overrideFile(e, g);
          return f.return(true);
        });
      }
    }, minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "handlandmarktrackinggpu__palmdetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } }, minTrackingConfidence: { type: 1, graphOptionXref: {
      calculatorType: "ThresholdingCalculator",
      calculatorName: "handlandmarktrackinggpu__handlandmarkgpu__ThresholdingCalculator",
      fieldName: "threshold"
    } } } });
  }
  x = Jc.prototype;
  x.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  x.onResults = function(a) {
    this.g.onResults(a);
  };
  x.initialize = function() {
    var a = this;
    return I(function(b) {
      return F(b, a.g.initialize(), 0);
    });
  };
  x.reset = function() {
    this.g.reset();
  };
  x.send = function(a) {
    var b = this;
    return I(function(c) {
      return F(c, b.g.send(a), 0);
    });
  };
  x.setOptions = function(a) {
    this.g.setOptions(a);
  };
  J("Hands", Jc);
  J("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]);
  J("VERSION", "0.4.1646424915");
}).call(VonageHands);
var VonageHolistic = {};
(function() {
  var x;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function z(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  z("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  z("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function B(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function D(a) {
    if (!(a instanceof Array)) {
      a = B(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var ea = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, fa;
  if (typeof Object.setPrototypeOf == "function")
    fa = Object.setPrototypeOf;
  else {
    var ha;
    a: {
      var ia = { a: true }, ja = {};
      try {
        ja.__proto__ = ia;
        ha = ja.a;
        break a;
      } catch (a) {
      }
      ha = false;
    }
    fa = ha ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var ka = fa;
  function E(a, b) {
    a.prototype = ea(b.prototype);
    a.prototype.constructor = a;
    if (ka)
      ka(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.da = b.prototype;
  }
  function la() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.s = this.m = 0;
    this.j = null;
  }
  function ma(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  la.prototype.o = function(a) {
    this.h = a;
  };
  function na(a, b) {
    a.j = { U: b, V: true };
    a.g = a.m || a.s;
  }
  la.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.s;
  };
  function F(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function oa(a) {
    this.g = new la();
    this.h = a;
  }
  function pa(a, b) {
    ma(a.g);
    var c = a.g.i;
    if (c)
      return qa(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return ra(a);
  }
  function qa(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, na(a.g, f), ra(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return ra(a);
  }
  function ra(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, na(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.V)
        throw b.U;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function sa(a) {
    this.next = function(b) {
      ma(a.g);
      a.g.i ? b = qa(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = ra(a));
      return b;
    };
    this.throw = function(b) {
      ma(a.g);
      a.g.i ? b = qa(a, a.g.i["throw"], b, a.g.o) : (na(a.g, b), b = ra(a));
      return b;
    };
    this.return = function(b) {
      return pa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ta(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, e) {
      function g(f) {
        f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
      }
      g(a.next());
    });
  }
  function H(a) {
    return ta(new sa(new oa(a)));
  }
  z("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.o = false;
      var k = this.j();
      try {
        f(k.resolve, k.reject);
      } catch (h) {
        k.reject(h);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(k) {
        k(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var k = this;
        this.i(function() {
          k.l();
        });
      }
      this.g.push(f);
    };
    var e = y.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var k = 0; k < f.length; ++k) {
          var h = f[k];
          f[k] = null;
          try {
            h();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(n) {
          h || (h = true, l.call(k, n));
        };
      }
      var k = this, h = false;
      return { resolve: f(this.C), reject: f(this.l) };
    };
    b.prototype.C = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.F(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var k = f != null;
              break a;
            case "function":
              k = true;
              break a;
            default:
              k = false;
          }
        k ? this.v(f) : this.m(f);
      }
    };
    b.prototype.v = function(f) {
      var k = void 0;
      try {
        k = f.then;
      } catch (h) {
        this.l(h);
        return;
      }
      typeof k == "function" ? this.G(k, f) : this.m(f);
    };
    b.prototype.l = function(f) {
      this.s(2, f);
    };
    b.prototype.m = function(f) {
      this.s(1, f);
    };
    b.prototype.s = function(f, k) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = k;
      this.h === 2 && this.D();
      this.A();
    };
    b.prototype.D = function() {
      var f = this;
      e(function() {
        if (f.B()) {
          var k = y.console;
          typeof k !== "undefined" && k.error(f.i);
        }
      }, 1);
    };
    b.prototype.B = function() {
      if (this.o)
        return false;
      var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
      if (typeof h === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof k === "function" ? f = new k("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return h(f);
    };
    b.prototype.A = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.F = function(f) {
      var k = this.j();
      f.J(k.resolve, k.reject);
    };
    b.prototype.G = function(f, k) {
      var h = this.j();
      try {
        f.call(k, h.resolve, h.reject);
      } catch (l) {
        h.reject(l);
      }
    };
    b.prototype.then = function(f, k) {
      function h(p, m) {
        return typeof p == "function" ? function(q) {
          try {
            l(p(q));
          } catch (t) {
            n(t);
          }
        } : m;
      }
      var l, n, r = new b(function(p, m) {
        l = p;
        n = m;
      });
      this.J(h(f, l), h(k, n));
      return r;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.J = function(f, k) {
      function h() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            k(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(h) : this.g.push(h);
      this.o = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(k, h) {
        h(f);
      });
    };
    b.race = function(f) {
      return new b(function(k, h) {
        for (var l = B(f), n = l.next(); !n.done; n = l.next())
          d(n.value).J(k, h);
      });
    };
    b.all = function(f) {
      var k = B(f), h = k.next();
      return h.done ? d([]) : new b(function(l, n) {
        function r(q) {
          return function(t) {
            p[q] = t;
            m--;
            m == 0 && l(p);
          };
        }
        var p = [], m = 0;
        do
          p.push(void 0), m++, d(h.value).J(r(p.length - 1), n), h = k.next();
        while (!h.done);
      });
    };
    return b;
  });
  function ua(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  z("Object.assign", function(a) {
    return a || va;
  });
  z("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  z("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  z("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  z("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ua(this, function(b) {
        return b;
      });
    };
  });
  var wa = this || self;
  function I(a, b) {
    a = a.split(".");
    var c = wa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function xa(a) {
    wa.setTimeout(function() {
      throw a;
    }, 0);
  }
  function ya(a) {
    xa(a);
    return;
  }
  function za(a, b) {
    ya(Error("Invalid wire type: " + a + " (at position " + b + ")"));
  }
  function Aa() {
    ya(Error("Failed to read varint, encoding is invalid."));
  }
  function Ba(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var Ca, Da = typeof TextDecoder !== "undefined", Ea, Fa = typeof TextEncoder !== "undefined";
  function Ga(a) {
    if (Fa)
      a = (Ea || (Ea = new TextEncoder())).encode(a);
    else {
      var b = void 0;
      b = b === void 0 ? false : b;
      for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
        var g = a.charCodeAt(e);
        if (128 > g)
          d[c++] = g;
        else {
          if (2048 > g)
            d[c++] = g >> 6 | 192;
          else {
            if (55296 <= g && 57343 >= g) {
              if (56319 >= g && e < a.length) {
                var f = a.charCodeAt(++e);
                if (56320 <= f && 57343 >= f) {
                  g = 1024 * (g - 55296) + f - 56320 + 65536;
                  d[c++] = g >> 18 | 240;
                  d[c++] = g >> 12 & 63 | 128;
                  d[c++] = g >> 6 & 63 | 128;
                  d[c++] = g & 63 | 128;
                  continue;
                } else
                  e--;
              }
              if (b)
                throw Error("Found an unpaired surrogate");
              g = 65533;
            }
            d[c++] = g >> 12 | 224;
            d[c++] = g >> 6 & 63 | 128;
          }
          d[c++] = g & 63 | 128;
        }
      }
      a = d.subarray(0, c);
    }
    return a;
  }
  var Ha = {}, Ia = null;
  function Ja(a) {
    var b;
    b === void 0 && (b = 0);
    Ka();
    b = Ha[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | k >> 4];
      k = b[(k & 15) << 2 | h >> 6];
      h = b[h & 63];
      c[g++] = l + f + k + h;
    }
    l = 0;
    h = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], h = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
    }
    return c.join("");
  }
  function La(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Ma(a, function(g) {
      d[e++] = g;
    });
    return d.subarray(0, e);
  }
  function Ma(a, b) {
    function c(h) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), n = Ia[l];
        if (n != null)
          return n;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return h;
    }
    Ka();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), k = c(64);
      if (k === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
    }
  }
  function Ka() {
    if (!Ia) {
      Ia = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Ha[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          Ia[g] === void 0 && (Ia[g] = e);
        }
      }
    }
  }
  var Na = typeof Uint8Array === "function", Oa;
  function Pa(a) {
    this.g = a;
    if (a !== null && a.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  Pa.prototype.toJSON = function() {
    if (this.g == null)
      var a = "";
    else
      a = this.g, a = this.g = a == null || typeof a === "string" ? a : Na && a instanceof Uint8Array ? Ja(a) : null;
    return a;
  };
  var Qa = typeof Uint8Array.prototype.slice === "function";
  function Ra(a, b, c) {
    return b === c ? Oa || (Oa = new Uint8Array(0)) : Qa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
  }
  var K = 0, L = 0;
  function Sa(a) {
    if (a.constructor === Uint8Array)
      return a;
    if (a.constructor === ArrayBuffer)
      return new Uint8Array(a);
    if (a.constructor === Array)
      return new Uint8Array(a);
    if (a.constructor === String)
      return La(a);
    if (a.constructor === Pa) {
      if (a.g == null)
        var b = Oa || (Oa = new Uint8Array(0));
      else {
        b = Uint8Array;
        var c = a.g;
        c = c == null || Na && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? La(c) : null;
        a = a.g = c;
        b = new b(a);
      }
      return b;
    }
    if (a instanceof Uint8Array)
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ta(a, b) {
    b = b === void 0 ? {} : b;
    b = b.u === void 0 ? false : b.u;
    this.h = null;
    this.g = this.i = this.m = 0;
    this.l = false;
    this.u = b;
    a && Ua(this, a);
  }
  function Ua(a, b) {
    a.h = Sa(b);
    a.m = 0;
    a.i = a.h.length;
    a.g = a.m;
  }
  Ta.prototype.reset = function() {
    this.g = this.m;
  };
  function Va(a) {
    for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)
      b = a.h[a.g++], c |= (b & 127) << 7 * e;
    128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b)
      for (e = 0; 5 > e && 128 <= b; e++)
        b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
    if (128 > b) {
      a = c >>> 0;
      b = d >>> 0;
      if (d = b & 2147483648)
        a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
      a = 4294967296 * b + (a >>> 0);
      return d ? -a : a;
    }
    a.l = true;
    Aa();
  }
  function M(a) {
    a.g > a.i && (a.l = true, ya(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
  }
  Ta.prototype.j = function() {
    var a = this.h, b = a[this.g], c = b & 127;
    if (128 > b)
      return this.g += 1, M(this), c;
    b = a[this.g + 1];
    c |= (b & 127) << 7;
    if (128 > b)
      return this.g += 2, M(this), c;
    b = a[this.g + 2];
    c |= (b & 127) << 14;
    if (128 > b)
      return this.g += 3, M(this), c;
    b = a[this.g + 3];
    c |= (b & 127) << 21;
    if (128 > b)
      return this.g += 4, M(this), c;
    b = a[this.g + 4];
    c |= (b & 15) << 28;
    if (128 > b)
      return this.g += 5, M(this), c >>> 0;
    this.g += 5;
    if (128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++])
      return this.l = true, Aa(), c;
    M(this);
    return c;
  };
  Ta.prototype.o = function() {
    var a = this.h[this.g], b = this.h[this.g + 1];
    var c = this.h[this.g + 2];
    var d = this.h[this.g + 3];
    this.g += 4;
    M(this);
    c = (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
    a = 2 * (c >> 31) + 1;
    b = c >>> 23 & 255;
    c &= 8388607;
    return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
  };
  var Wa = [];
  function Xa() {
    this.g = new Uint8Array(64);
    this.h = 0;
  }
  function N(a, b) {
    if (!(a.h + 1 < a.g.length)) {
      var c = a.g;
      a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
      a.g.set(c);
    }
    a.g[a.h++] = b;
  }
  Xa.prototype.length = function() {
    return this.h;
  };
  Xa.prototype.end = function() {
    var a = this.g, b = this.h;
    this.h = 0;
    return Ra(a, 0, b);
  };
  function Ya(a, b) {
    for (; 127 < b; )
      N(a, b & 127 | 128), b >>>= 7;
    N(a, b);
  }
  function Za(a) {
    var b = {}, c = b.N === void 0 ? false : b.N;
    this.m = { u: b.u === void 0 ? false : b.u };
    this.N = c;
    b = this.m;
    Wa.length ? (c = Wa.pop(), b && (c.u = b.u), a && Ua(c, a), a = c) : a = new Ta(a, b);
    this.g = a;
    this.l = this.g.g;
    this.h = this.i = -1;
    this.j = false;
  }
  Za.prototype.reset = function() {
    this.g.reset();
    this.h = this.i = -1;
  };
  function $a(a) {
    var b = a.g;
    (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.l || 0 > b.g || b.g > b.i);
    if (b)
      return false;
    a.l = a.g.g;
    var c = a.g.j();
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      return a.j = true, za(c, a.l), false;
    a.i = b;
    a.h = c;
    return true;
  }
  function ab(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          ab(a);
        else
          a: {
            a = a.g;
            for (var b = a.g, c = 0; 10 > c; c++) {
              if ((a.h[b] & 128) === 0) {
                a.g = b + 1;
                M(a);
                break a;
              }
              b++;
            }
            a.l = true;
            Aa();
          }
        break;
      case 1:
        a = a.g;
        a.g += 8;
        M(a);
        break;
      case 2:
        a.h != 2 ? ab(a) : (b = a.g.j(), a = a.g, a.g += b, M(a));
        break;
      case 5:
        a = a.g;
        a.g += 4;
        M(a);
        break;
      case 3:
        b = a.i;
        do {
          if (!$a(a)) {
            a.j = true;
            ya(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (a.h == 4) {
            a.i != b && (a.j = true, ya(Error("Unmatched end-group tag")));
            break;
          }
          ab(a);
        } while (1);
        break;
      default:
        a.j = true, za(a.h, a.l);
    }
  }
  function bb(a, b, c) {
    a.N || (a = Ra(a.g.h, c, a.g.g), (c = b.o) ? c.push(a) : b.o = [a]);
  }
  function cb(a, b, c) {
    var d = a.g.i, e = a.g.j(), g = a.g.g + e;
    a.g.i = g;
    c(b, a);
    c = g - a.g.g;
    if (c !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.g.g = g;
    a.g.i = d;
    return b;
  }
  function db(a, b, c) {
    var d = a.g.j();
    for (d = a.g.g + d; a.g.g < d; )
      c.push(b.call(a.g));
  }
  var eb = [];
  function fb() {
    this.h = [];
    this.i = 0;
    this.g = new Xa();
  }
  function gb(a, b) {
    b.length !== 0 && (a.h.push(b), a.i += b.length);
  }
  function hb(a, b, c) {
    Ya(a.g, 8 * b + 2);
    Ya(a.g, c.length);
    gb(a, a.g.end());
    gb(a, c);
  }
  var ib = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
  function jb(a, b) {
    Object.isFrozen(a) || (ib ? a[ib] |= b : a.g !== void 0 ? a.g |= b : Object.defineProperties(a, { g: { value: b, configurable: true, writable: true, enumerable: false } }));
  }
  function kb(a) {
    if (!a)
      return 0;
    var b;
    ib ? b = a[ib] : b = a.g;
    return b == null ? 0 : b;
  }
  function lb(a) {
    if (!Array.isArray(a))
      return a;
    jb(a, 1);
    return a;
  }
  function mb(a) {
    if (!Array.isArray(a))
      throw Error("cannot mark non-array as immutable");
    jb(a, 2);
  }
  function nb(a) {
    return a !== null && typeof a === "object" && a.constructor === Object;
  }
  function ob(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        return Na && a != null && a instanceof Uint8Array ? Ja(a) : a;
      default:
        return a;
    }
  }
  function pb(a, b) {
    if (a != null)
      return Array.isArray(a) || nb(a) ? qb(a, b) : b(a);
  }
  function qb(a, b) {
    if (Array.isArray(a)) {
      for (var c = Array(a.length), d = 0; d < a.length; d++)
        c[d] = pb(a[d], b);
      kb(a) & 1 && lb(c);
      return c;
    }
    c = {};
    for (d in a)
      c[d] = pb(a[d], b);
    return c;
  }
  var rb;
  function O(a, b, c) {
    var d = rb;
    rb = null;
    a || (a = d);
    d = this.constructor.ba;
    a || (a = d ? [d] : []);
    this.j = (d ? 0 : -1) - (this.constructor.$ || 0);
    this.m = this.g = null;
    this.h = a;
    a: {
      d = this.h.length;
      a = d - 1;
      if (d && (d = this.h[a], nb(d))) {
        this.l = a - this.j;
        this.i = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        a = c[b], a < this.l ? (a += this.j, (d = this.h[a]) ? lb(d) : this.h[a] = sb) : (tb(this), (d = this.i[a]) ? lb(d) : this.i[a] = sb);
  }
  var sb = Object.freeze(lb([]));
  function tb(a) {
    var b = a.l + a.j;
    a.h[b] || (a.i = a.h[b] = {});
  }
  function P(a, b, c) {
    return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.i ? a.i[b] : void 0 : a.h[b + a.j];
  }
  function ub(a, b, c) {
    c = c === void 0 ? true : c;
    var d = d === void 0 ? false : d;
    var e = P(a, b, d);
    e == null && (e = sb);
    e === sb ? (e = lb([]), Q(a, b, e, d)) : c && Array.isArray(e) && kb(e) & 2 && (e = e.slice(), Q(a, b, e, d));
    return e;
  }
  function vb(a) {
    var b = ub(a, 3, false);
    a.m || (a.m = {});
    if (!a.m[3]) {
      for (var c = 0; c < b.length; c++)
        b[c] = +b[c];
      a.m[3] = true;
    }
    return b;
  }
  function R(a, b, c) {
    a = P(a, b);
    return a == null ? c : a;
  }
  function S(a, b, c) {
    a = P(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function Q(a, b, c, d) {
    (d === void 0 ? 0 : d) || b >= a.l ? (tb(a), a.i[b] = c) : a.h[b + a.j] = c;
  }
  function wb(a, b, c) {
    if (c === -1)
      return null;
    a.g || (a.g = {});
    var d = a.g[c];
    if (d)
      return d;
    var e = P(a, c, false);
    if (e == null)
      return d;
    b = new b(e);
    return a.g[c] = b;
  }
  function xb(a, b, c) {
    a.g || (a.g = {});
    var d = a.g[c];
    if (!d) {
      var e = ub(a, c, false);
      d = [];
      for (var g = Array.isArray(e) ? !!(kb(e) & 2) : false, f = 0; f < e.length; f++)
        d[f] = new b(e[f]), g && mb(d[f].h);
      g && (mb(d), Object.freeze(d));
      a.g[c] = d;
    }
    return d;
  }
  function yb(a, b, c, d, e) {
    var g = xb(a, d, b);
    c = c ? c : new d();
    a = ub(a, b);
    e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, T(c))) : (g.push(c), a.push(T(c)));
  }
  O.prototype.toJSON = function() {
    var a = T(this);
    return qb(a, ob);
  };
  function T(a) {
    if (a.g)
      for (var b in a.g) {
        var c = a.g[b];
        if (Array.isArray(c))
          for (var d = 0; d < c.length; d++)
            c[d] && T(c[d]);
        else
          c && T(c);
      }
    return a.h;
  }
  O.prototype.toString = function() {
    return T(this).toString();
  };
  function zb(a, b) {
    if (a = a.o) {
      gb(b, b.g.end());
      for (var c = 0; c < a.length; c++)
        gb(b, a[c]);
    }
  }
  function Ab(a) {
    var b = a[0];
    switch (a.length) {
      case 2:
        var c = a[1];
        return function(h, l, n) {
          return b(h, l, n, c);
        };
      case 3:
        var d = a[1], e = a[2];
        return function(h, l, n) {
          return b(h, l, n, d, e);
        };
      case 4:
        var g = a[1], f = a[2], k = a[3];
        return function(h, l, n) {
          return b(h, l, n, g, f, k);
        };
      default:
        throw Error("unsupported number of parameters, expected [2-4], got " + a.length);
    }
  }
  function U(a, b, c) {
    for (; $a(b) && b.h != 4; ) {
      var d = b.i, e = c[d];
      if (e) {
        if (Array.isArray(e) && (e = c[d] = Ab(e)), !e(b, a, d)) {
          d = b;
          e = a;
          var g = d.l;
          ab(d);
          bb(d, e, g);
        }
      } else
        d = b, e = a, g = d.l, ab(d), bb(d, e, g);
    }
    return a;
  }
  function Bb(a, b) {
    var c = new fb();
    b(a, c);
    a = c.i + c.g.length();
    if (a === 0)
      c = new Uint8Array(0);
    else {
      a = new Uint8Array(a);
      for (var d = c.h, e = d.length, g = b = 0; g < e; g++) {
        var f = d[g];
        f.length !== 0 && (a.set(f, b), b += f.length);
      }
      d = c.g;
      e = d.h;
      e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
      c.h = [a];
      c = a;
    }
    return c;
  }
  function Cb(a, b, c) {
    if (eb.length) {
      var d = eb.pop();
      a && (Ua(d.g, a), d.i = -1, d.h = -1);
      a = d;
    } else
      a = new Za(a);
    try {
      return c(new b(), a);
    } finally {
      b = a.g, b.h = null, b.m = 0, b.i = 0, b.g = 0, b.l = false, b.u = false, a.i = -1, a.h = -1, a.j = false, 100 > eb.length && eb.push(a);
    }
  }
  function W(a, b, c) {
    b = P(b, c);
    if (b != null) {
      Ya(a.g, 8 * c + 5);
      a = a.g;
      var d = b;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? K = L = 0 : (L = 0, K = 2147483648) : isNaN(d) ? (L = 0, K = 2147483647) : 34028234663852886e22 < d ? (L = 0, K = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), L = 0, K = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, L = 0, K = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = K;
      N(a, c >>> 0 & 255);
      N(a, c >>> 8 & 255);
      N(a, c >>> 16 & 255);
      N(a, c >>> 24 & 255);
    }
  }
  function X(a, b, c) {
    if (a.h !== 5)
      return false;
    Q(b, c, a.g.o());
    return true;
  }
  function Db(a, b, c) {
    if (a.h !== 5 && a.h !== 2)
      return false;
    b = ub(b, c);
    a.h == 2 ? db(a, Ta.prototype.o, b) : b.push(a.g.o());
    return true;
  }
  function Eb(a, b, c) {
    if (a.h !== 0)
      return false;
    Q(b, c, Va(a.g));
    return true;
  }
  function Fb(a, b, c) {
    if (a.h !== 0)
      return false;
    Q(b, c, a.g.j());
    return true;
  }
  function Gb(a, b, c) {
    if (a.h !== 2)
      return false;
    var d = a.g.j();
    a = a.g;
    var e = a.g;
    a.g += d;
    M(a);
    a = a.h;
    var g;
    if (Da)
      (g = Ca) || (g = Ca = new TextDecoder("utf-8", { fatal: false })), g = g.decode(a.subarray(e, e + d));
    else {
      d = e + d;
      for (var f = [], k = null, h, l, n; e < d; )
        h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((n = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | n & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = Ba(k, f), f.length = 0);
      g = Ba(k, f);
    }
    Q(b, c, g);
    return true;
  }
  function Hb(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    a = cb(a, new d(), e);
    var g = g === void 0 ? false : g;
    b.g || (b.g = {});
    d = a ? T(a) : a;
    b.g[c] = a;
    Q(b, c, d, g);
    return true;
  }
  function Ib(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    a = cb(a, new d(), e);
    yb(b, c, a, d, void 0);
    return true;
  }
  function Jb(a, b, c) {
    if (a.h !== 0 && a.h !== 2)
      return false;
    b = ub(b, c);
    a.h == 2 ? db(a, Ta.prototype.j, b) : b.push(a.g.j());
    return true;
  }
  function Kb(a, b, c) {
    if (a.h !== 0)
      return false;
    Q(b, c, Va(a.g));
    return true;
  }
  function Y(a) {
    O.call(this, a, -1, Lb);
  }
  var Mb;
  E(Y, O);
  Y.prototype.getRows = function() {
    return P(this, 1);
  };
  Y.prototype.getCols = function() {
    return P(this, 2);
  };
  Y.prototype.getPackedDataList = function() {
    return vb(this);
  };
  Y.prototype.getLayout = function() {
    return R(this, 4, 0);
  };
  function Nb(a, b) {
    return U(a, b, Mb || (Mb = { 1: Fb, 2: Fb, 3: Db, 4: Kb }));
  }
  var Lb = [3];
  function Ob(a) {
    O.call(this, a);
  }
  var Pb;
  E(Ob, O);
  function Qb(a, b) {
    var c = P(a, 1);
    if (c != null && c != null) {
      Ya(b.g, 8);
      var d = b.g;
      if (0 <= c)
        Ya(d, c);
      else {
        for (var e = 0; 9 > e; e++)
          N(d, c & 127 | 128), c >>= 7;
        N(d, 1);
      }
    }
    W(b, a, 2);
    d = P(a, 3);
    d != null && hb(b, 3, Ga(d));
    d = P(a, 4);
    d != null && hb(b, 4, Ga(d));
    zb(a, b);
  }
  function Rb(a, b) {
    return U(a, b, Pb || (Pb = { 1: Fb, 2: X, 3: Gb, 4: Gb }));
  }
  function Sb(a) {
    O.call(this, a, -1, Tb);
  }
  var Ub;
  E(Sb, O);
  Sb.prototype.addClassification = function(a, b) {
    yb(this, 1, a, Ob, b);
    return this;
  };
  function Vb(a, b) {
    return U(a, b, Ub || (Ub = { 1: [Ib, Ob, Rb] }));
  }
  var Tb = [1];
  function Wb(a) {
    O.call(this, a);
  }
  var Xb;
  E(Wb, O);
  function Yb(a, b) {
    W(b, a, 1);
    W(b, a, 2);
    W(b, a, 3);
    W(b, a, 4);
    W(b, a, 5);
    zb(a, b);
  }
  function Zb(a, b) {
    return U(a, b, Xb || (Xb = { 1: X, 2: X, 3: X, 4: X, 5: X }));
  }
  function $b(a) {
    O.call(this, a, -1, ac);
  }
  var bc;
  E($b, O);
  function cc(a, b) {
    return U(a, b, bc || (bc = { 1: [Ib, Wb, Zb] }));
  }
  var ac = [1];
  function dc(a) {
    O.call(this, a);
  }
  var ec;
  E(dc, O);
  function fc(a, b) {
    W(b, a, 1);
    W(b, a, 2);
    W(b, a, 3);
    W(b, a, 4);
    W(b, a, 5);
    var c = P(a, 6);
    if (c != null && c != null) {
      Ya(b.g, 48);
      var d = b.g, e = c;
      c = 0 > e;
      e = Math.abs(e);
      var g = e >>> 0;
      e = Math.floor((e - g) / 4294967296);
      e >>>= 0;
      c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
      K = g;
      L = e;
      c = K;
      for (g = L; 0 < g || 127 < c; )
        N(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
      N(d, c);
    }
    zb(a, b);
  }
  function gc(a, b) {
    return U(a, b, ec || (ec = { 1: X, 2: X, 3: X, 4: X, 5: X, 6: Eb }));
  }
  function Z(a) {
    O.call(this, a, -1, hc);
  }
  var ic;
  E(Z, O);
  Z.prototype.getVertexType = function() {
    return R(this, 1, 0);
  };
  Z.prototype.getPrimitiveType = function() {
    return R(this, 2, 0);
  };
  Z.prototype.getVertexBufferList = function() {
    return vb(this);
  };
  Z.prototype.getIndexBufferList = function() {
    return ub(this, 4);
  };
  function jc(a, b) {
    return U(a, b, ic || (ic = { 1: Kb, 2: Kb, 3: Db, 4: Jb }));
  }
  var hc = [3, 4];
  function kc(a) {
    O.call(this, a);
  }
  var lc;
  E(kc, O);
  kc.prototype.getMesh = function() {
    return wb(this, Z, 1);
  };
  kc.prototype.getPoseTransformMatrix = function() {
    return wb(this, Y, 2);
  };
  function mc(a, b) {
    return U(a, b, lc || (lc = { 1: [Hb, Z, jc], 2: [Hb, Y, Nb] }));
  }
  var nc = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], oc = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], pc = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], qc = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], rc = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], sc = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], tc = [].concat(D(nc), D(oc), D(pc), D(qc), D(rc), D(sc));
  function uc(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function vc(a) {
    return xb(a, Ob, 1).map(function(b) {
      return { index: R(b, 1, 0), score: S(b, 2), label: P(b, 3) != null ? R(b, 3, "") : void 0, displayName: P(b, 4) != null ? R(b, 4, "") : void 0 };
    });
  }
  function wc(a) {
    return { x: S(a, 1), y: S(a, 2), z: S(a, 3), visibility: P(a, 4) != null ? S(a, 4) : void 0 };
  }
  function xc(a) {
    return xb(Cb(a, $b, cc), Wb, 1).map(wc);
  }
  function yc(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function zc(a, b, c) {
    Ac(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function Ac(a, b) {
    var c = a.g;
    if (a.m === void 0) {
      var d = uc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = uc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.m = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { I: c.getAttribLocation(d, "aVertex"), H: c.getAttribLocation(d, "aTex"), ca: e };
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.I);
      c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.o = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.o);
      c.enableVertexAttribArray(a.j.H);
      c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.m);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, a.o);
    c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.I);
    c.disableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function Bc(a) {
    this.g = a;
  }
  var Cc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Dc(a, b) {
    return b + a;
  }
  function Ec(a, b) {
    window[a] = b;
  }
  function Fc(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Gc() {
    return H(function(a) {
      switch (a.g) {
        case 1:
          return a.m = 2, F(a, WebAssembly.instantiate(Cc), 4);
        case 4:
          a.g = 3;
          a.m = 0;
          break;
        case 2:
          return a.m = 0, a.j = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function Hc(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.F = {};
    this.m = {};
    this.s = {};
    this.G = this.o = this.R = true;
    this.C = Promise.resolve();
    this.P = "";
    this.B = {};
    this.locateFile = a && a.locateFile || Dc;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.S = b;
    if (a.options) {
      b = B(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  x = Hc.prototype;
  x.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Ic(a) {
    var b, c, d, e, g, f, k, h, l, n, r;
    return H(function(p) {
      switch (p.g) {
        case 1:
          if (!a.R)
            return p.return();
          b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
          return F(p, Gc(), 2);
        case 2:
          c = p.h;
          if (typeof window === "object")
            return Ec("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), Ec("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(m) {
              return m.data !== void 0;
            }), k = b.filter(function(m) {
              return m.data === void 0;
            }), h = Promise.all(f.map(function(m) {
              var q = Jc(a, m.url);
              if (m.path !== void 0) {
                var t = m.path;
                q = q.then(function(w) {
                  a.overrideFile(t, w);
                  return Promise.resolve(w);
                });
              }
              return q;
            })), l = Promise.all(k.map(function(m) {
              return m.simd === void 0 || m.simd && c || !m.simd && !c ? Fc(a.locateFile(m.url, a.S)) : Promise.resolve();
            })).then(function() {
              var m, q, t;
              return H(function(w) {
                if (w.g == 1)
                  return m = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, m(q), 2);
                t.h = w.h;
                w.g = 0;
              });
            }), n = function() {
              return H(function(m) {
                a.g.graph && a.g.graph.url ? m = F(m, Jc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                return m;
              });
            }(), F(p, Promise.all([l, h, n]), 7);
          if (typeof importScripts !== "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(m) {
            return m.simd === void 0 || m.simd && c || !m.simd && !c;
          }).map(function(m) {
            return a.locateFile(m.url, a.S);
          });
          importScripts.apply(null, D(d));
          e = a;
          return F(p, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          e.h = p.h;
          a.l = new OffscreenCanvas(1, 1);
          a.h.canvas = a.l;
          g = a.h.GL.createContext(a.l, {
            antialias: false,
            alpha: false,
            aa: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
          });
          a.h.GL.makeContextCurrent(g);
          p.g = 4;
          break;
        case 7:
          a.l = document.createElement("canvas");
          r = a.l.getContext("webgl2", {});
          if (!r && (r = a.l.getContext("webgl", {}), !r))
            return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
          a.D = r;
          a.h.canvas = a.l;
          a.h.createContext(a.l, true, true, {});
        case 4:
          a.i = new a.h.SolutionWasm(), a.R = false, p.g = 0;
      }
    });
  }
  function Kc(a) {
    var b, c, d, e, g, f, k, h;
    return H(function(l) {
      if (l.g == 1) {
        if (a.g.graph && a.g.graph.url && a.P === a.g.graph.url)
          return l.return();
        a.o = true;
        if (!a.g.graph || !a.g.graph.url) {
          l.g = 2;
          return;
        }
        a.P = a.g.graph.url;
        return F(l, Jc(a, a.g.graph.url), 3);
      }
      l.g != 2 && (b = l.h, a.i.loadGraph(b));
      c = B(Object.keys(a.B));
      for (d = c.next(); !d.done; d = c.next())
        e = d.value, a.i.overrideFile(e, a.B[e]);
      a.B = {};
      if (a.g.listeners)
        for (g = B(a.g.listeners), f = g.next(); !f.done; f = g.next())
          k = f.value, Lc(a, k);
      h = a.j;
      a.j = {};
      a.setOptions(h);
      l.g = 0;
    });
  }
  x.reset = function() {
    var a = this;
    return H(function(b) {
      a.i && (a.i.reset(), a.m = {}, a.s = {});
      b.g = 0;
    });
  };
  x.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = B(Object.keys(a)), k = f.next(); !k.done; g = { K: g.K, L: g.L }, k = f.next()) {
        var h = k.value;
        h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.K = k.onChange, g.L = a[h], d.push(function(l) {
          return function() {
            var n;
            return H(function(r) {
              if (r.g == 1)
                return F(r, l.K(l.L), 2);
              n = r.h;
              n === true && (c.o = true);
              r.g = 0;
            });
          };
        }(g))), k.graphOptionXref && (h = { valueNumber: k.type === 1 ? a[h] : 0, valueBoolean: k.type === 0 ? a[h] : false, valueString: k.type === 2 ? a[h] : "" }, k = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), k.graphOptionXref), h), e.push(k))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.v = (this.v === void 0 ? [] : this.v).concat(d);
    }
  };
  function Mc(a) {
    var b, c, d, e, g, f, k;
    return H(function(h) {
      switch (h.g) {
        case 1:
          if (!a.o)
            return h.return();
          if (!a.v) {
            h.g = 2;
            break;
          }
          b = B(a.v);
          c = b.next();
        case 3:
          if (c.done) {
            h.g = 5;
            break;
          }
          d = c.value;
          return F(h, d(), 4);
        case 4:
          c = b.next();
          h.g = 3;
          break;
        case 5:
          a.v = void 0;
        case 2:
          if (a.A) {
            e = new a.h.GraphOptionChangeRequestList();
            g = B(a.A);
            for (f = g.next(); !f.done; f = g.next())
              k = f.value, e.push_back(k);
            a.i.changeOptions(e);
            e.delete();
            a.A = void 0;
          }
          a.o = false;
          h.g = 0;
      }
    });
  }
  x.initialize = function() {
    var a = this;
    return H(function(b) {
      return b.g == 1 ? F(b, Ic(a), 2) : b.g != 3 ? F(b, Kc(a), 3) : F(b, Mc(a), 0);
    });
  };
  function Jc(a, b) {
    var c, d;
    return H(function(e) {
      if (b in a.F)
        return e.return(a.F[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.F[b] = d;
      return e.return(d);
    });
  }
  x.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
  };
  x.clearOverriddenFiles = function() {
    this.B = {};
    this.i && this.i.clearOverriddenFiles();
  };
  x.send = function(a, b) {
    var c = this, d, e, g, f, k, h, l, n, r;
    return H(function(p) {
      switch (p.g) {
        case 1:
          if (!c.g.inputs)
            return p.return();
          d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
          return F(p, c.C, 2);
        case 2:
          return F(p, c.initialize(), 3);
        case 3:
          e = new c.h.PacketDataList();
          g = B(Object.keys(a));
          for (f = g.next(); !f.done; f = g.next())
            if (k = f.value, h = c.g.inputs[k]) {
              a: {
                var m = a[k];
                switch (h.type) {
                  case "video":
                    var q = c.m[h.stream];
                    q || (q = new yc(c.h, c.D), c.m[h.stream] = q);
                    q.l === 0 && (q.l = q.h.createTexture());
                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                      var t = m.videoWidth;
                      var w = m.videoHeight;
                    } else
                      typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (t = m.naturalWidth, w = m.naturalHeight) : (t = m.width, w = m.height);
                    w = { glName: q.l, width: t, height: w };
                    t = q.g;
                    t.canvas.width = w.width;
                    t.canvas.height = w.height;
                    t.activeTexture(t.TEXTURE0);
                    q.h.bindTexture2d(q.l);
                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, m);
                    q.h.bindTexture2d(0);
                    q = w;
                    break a;
                  case "detections":
                    q = c.m[h.stream];
                    q || (q = new Bc(c.h), c.m[h.stream] = q);
                    q.data || (q.data = new q.g.DetectionListData());
                    q.data.reset(m.length);
                    for (w = 0; w < m.length; ++w) {
                      t = m[w];
                      var v = q.data, C = v.setBoundingBox, J = w;
                      var G = t.T;
                      var u = new dc();
                      Q(u, 1, G.X);
                      Q(u, 2, G.Y);
                      Q(u, 3, G.height);
                      Q(u, 4, G.width);
                      Q(u, 5, G.rotation);
                      Q(u, 6, G.W);
                      G = Bb(u, fc);
                      C.call(v, J, G);
                      if (t.O)
                        for (v = 0; v < t.O.length; ++v) {
                          u = t.O[v];
                          var A = u.visibility ? true : false;
                          C = q.data;
                          J = C.addNormalizedLandmark;
                          G = w;
                          u = Object.assign(Object.assign({}, u), { visibility: A ? u.visibility : 0 });
                          A = new Wb();
                          Q(A, 1, u.x);
                          Q(A, 2, u.y);
                          Q(A, 3, u.z);
                          u.visibility && Q(A, 4, u.visibility);
                          u = Bb(A, Yb);
                          J.call(C, G, u);
                        }
                      if (t.M)
                        for (v = 0; v < t.M.length; ++v)
                          C = q.data, J = C.addClassification, G = w, u = t.M[v], A = new Ob(), Q(A, 2, u.score), u.index && Q(A, 1, u.index), u.label && Q(A, 3, u.label), u.displayName && Q(A, 4, u.displayName), u = Bb(A, Qb), J.call(C, G, u);
                    }
                    q = q.data;
                    break a;
                  default:
                    q = {};
                }
              }
              l = q;
              n = h.stream;
              switch (h.type) {
                case "video":
                  e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: n, timestamp: d }));
                  break;
                case "detections":
                  r = l;
                  r.stream = n;
                  r.timestamp = d;
                  e.pushDetectionList(r);
                  break;
                default:
                  throw Error("Unknown input config type: '" + h.type + "'");
              }
            }
          c.i.send(e);
          return F(p, c.C, 4);
        case 4:
          e.delete(), p.g = 0;
      }
    });
  };
  function Nc(a, b, c) {
    var d, e, g, f, k, h, l, n, r, p, m, q, t, w;
    return H(function(v) {
      switch (v.g) {
        case 1:
          if (!c)
            return v.return(b);
          d = {};
          e = 0;
          g = B(Object.keys(c));
          for (f = g.next(); !f.done; f = g.next())
            k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
          1 < e && (a.G = false);
          l = B(Object.keys(c));
          f = l.next();
        case 2:
          if (f.done) {
            v.g = 4;
            break;
          }
          n = f.value;
          r = c[n];
          if (typeof r === "string")
            return t = d, w = n, F(v, Oc(a, n, b[r]), 14);
          p = b[r.stream];
          if (r.type === "detection_list") {
            if (p) {
              var C = p.getRectList();
              for (var J = p.getLandmarksList(), G = p.getClassificationsList(), u = [], A = 0; A < C.size(); ++A) {
                var V = Cb(C.get(A), dc, gc);
                V = { T: { X: S(V, 1), Y: S(V, 2), height: S(V, 3), width: S(V, 4), rotation: S(V, 5, 0), W: R(V, 6, 0) }, O: xc(J.get(A)), M: vc(Cb(G.get(A), Sb, Vb)) };
                u.push(V);
              }
              C = u;
            } else
              C = [];
            d[n] = C;
            v.g = 7;
            break;
          }
          if (r.type === "proto_list") {
            if (p) {
              C = Array(p.size());
              for (J = 0; J < p.size(); J++)
                C[J] = p.get(J);
              p.delete();
            } else
              C = [];
            d[n] = C;
            v.g = 7;
            break;
          }
          if (p === void 0) {
            v.g = 3;
            break;
          }
          if (r.type === "float_list") {
            d[n] = p;
            v.g = 7;
            break;
          }
          if (r.type === "proto") {
            d[n] = p;
            v.g = 7;
            break;
          }
          if (r.type !== "texture")
            throw Error("Unknown output config type: '" + r.type + "'");
          m = a.s[n];
          m || (m = new yc(a.h, a.D), a.s[n] = m);
          return F(v, zc(m, p, a.G), 13);
        case 13:
          q = v.h, d[n] = q;
        case 7:
          r.transform && d[n] && (d[n] = r.transform(d[n]));
          v.g = 3;
          break;
        case 14:
          t[w] = v.h;
        case 3:
          f = l.next();
          v.g = 2;
          break;
        case 4:
          return v.return(d);
      }
    });
  }
  function Oc(a, b, c) {
    var d;
    return H(function(e) {
      return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new yc(a.h, a.D), a.s[b] = d), e.return(zc(d, c, a.G))) : e.return(void 0);
    });
  }
  function Lc(a, b) {
    for (var c = b.name || "$", d = [].concat(D(b.wants)), e = new a.h.StringList(), g = B(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(k) {
      for (var h = {}, l = 0; l < b.wants.length; ++l)
        h[d[l]] = k.get(l);
      var n = a.listeners[c];
      n && (a.C = Nc(a, h, b.outs).then(function(r) {
        r = n(r);
        for (var p = 0; p < b.wants.length; ++p) {
          var m = h[d[p]];
          typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
        }
        r && (a.C = r);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  x.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  I("Solution", Hc);
  I("OptionType", { BOOL: 0, NUMBER: 1, Z: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Pc(a) {
    return a.map(Qc);
  }
  function Qc(a) {
    a = Cb(a, kc, mc);
    var b = a.getMesh();
    if (!b)
      return a;
    var c = new Float32Array(b.getVertexBufferList());
    b.getVertexBufferList = function() {
      return c;
    };
    var d = new Uint32Array(b.getIndexBufferList());
    b.getIndexBufferList = function() {
      return d;
    };
    return a;
  }
  function Rc(a) {
    var b = this;
    a = a || {};
    this.g = new Hc({
      locateFile: a.locateFile,
      files: [{ url: "holistic_solution_packed_assets_loader.js" }, { simd: false, url: "holistic_solution_wasm_bin.js" }, { simd: true, url: "holistic_solution_simd_wasm_bin.js" }],
      graph: { url: "holistic.binarypb" },
      inputs: { image: { type: "video", stream: "input_frames_gpu" } },
      listeners: [{ wants: "left_hand_landmarks right_hand_landmarks face_landmarks pose_landmarks world_landmarks segmentation_mask image_transformed multi_face_geometry".split(" "), outs: { image: {
        type: "texture",
        stream: "image_transformed"
      }, leftHandLandmarks: { type: "proto", stream: "left_hand_landmarks", transform: xc }, rightHandLandmarks: { type: "proto", stream: "right_hand_landmarks", transform: xc }, faceLandmarks: { type: "proto", stream: "face_landmarks", transform: xc }, poseLandmarks: { type: "proto", stream: "pose_landmarks", transform: xc }, ea: { type: "proto", stream: "world_landmarks", transform: xc }, segmentationMask: { type: "texture", stream: "segmentation_mask" }, multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: Pc } } }],
      options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: { calculatorName: "EnableFaceGeometryConstant", calculatorType: "ConstantSidePacketCalculator", fieldName: "bool_value" } }, selfieMode: { type: 0, graphOptionXref: {
        calculatorType: "GlScalerCalculator",
        calculatorIndex: 1,
        fieldName: "flip_horizontal"
      } }, modelComplexity: { type: 1, default: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(c) {
        var d, e, g, f;
        return H(function(k) {
          if (k.g == 1) {
            d = "";
            switch (c) {
              case 1:
                d = "pose_landmark_full.tflite";
                break;
              case 2:
                d = "pose_landmark_heavy.tflite";
                break;
              default:
                d = "pose_landmark_lite.tflite";
            }
            e = "third_party/mediapipe/modules/pose_landmark/" + d;
            g = b.g.locateFile(d, "");
            return F(k, fetch(g), 3);
          }
          if (k.g != 2)
            return F(k, k.h.arrayBuffer(), 2);
          f = k.h;
          b.g.overrideFile(e, f);
          return F(k, b.g.reset(), 0);
        });
      } }, smoothLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" } }, enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } }, smoothSegmentation: {
        type: 0,
        graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" }
      }, refineFaceLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineFaceLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: { type: 1, graphOptionXref: {
        calculatorType: "TensorsToDetectionsCalculator",
        calculatorName: "holisticlandmarkgpu__poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
        fieldName: "min_score_thresh"
      } }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "holisticlandmarkgpu__poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "near" } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: {
        type: 1,
        graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" }
      } }
    });
  }
  x = Rc.prototype;
  x.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  x.onResults = function(a) {
    this.g.onResults(a);
  };
  x.initialize = function() {
    var a = this;
    return H(function(b) {
      return F(b, a.g.initialize(), 0);
    });
  };
  x.reset = function() {
    this.g.reset();
  };
  x.send = function(a) {
    var b = this;
    return H(function(c) {
      return F(c, b.g.send(a), 0);
    });
  };
  x.setOptions = function(a) {
    this.g.setOptions(a);
  };
  I("Holistic", Rc);
  I("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } });
  I("FACEMESH_LIPS", nc);
  I("FACEMESH_LEFT_EYE", oc);
  I("FACEMESH_LEFT_EYEBROW", pc);
  I("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]);
  I("FACEMESH_RIGHT_EYE", qc);
  I("FACEMESH_RIGHT_EYEBROW", rc);
  I("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]);
  I("FACEMESH_FACE_OVAL", sc);
  I("FACEMESH_CONTOURS", tc);
  I("FACEMESH_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [
      212,
      214
    ],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [
      92,
      40
    ],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [
      170,
      140
    ],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [
      100,
      36
    ],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [
      170,
      149
    ],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [138, 172],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [
      143,
      111
    ],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [38, 82],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [201, 83],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [
      228,
      24
    ],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [112, 233],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [
      332,
      297
    ],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [
      367,
      416
    ],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [399, 419],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [
      451,
      349
    ],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [
      462,
      328
    ],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [395, 369],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [
      197,
      419
    ],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [
      439,
      455
    ],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [436, 426],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [369, 262],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [
      428,
      262
    ],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [259, 444],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [
      372,
      383
    ],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [
      232,
      120
    ],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [160, 30],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [
      30,
      247
    ],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [91, 146],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [56, 28],
    [
      28,
      157
    ],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [122, 168],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [
      218,
      115
    ],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [
      222,
      52
    ],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [205, 36],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [
      212,
      186
    ],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [112, 232],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [236, 174],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [
      418,
      431
    ],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [
      421,
      18
    ],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [
      382,
      256
    ],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [346, 352],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [
      352,
      366
    ],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [349, 329],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [175, 396],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [
      195,
      248
    ],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [
      420,
      429
    ],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [410, 287],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [
      256,
      341
    ],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [412, 343],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]);
  I("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]);
  I("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]);
  I("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 });
  I("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 });
  I("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 });
  I("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 });
  I("matrixDataToMatrix", function(a) {
    for (var b = a.getCols(), c = a.getRows(), d = a.getPackedDataList(), e = [], g = 0; g < c; g++)
      e.push(Array(b));
    for (g = 0; g < c; g++)
      for (var f = 0; f < b; f++) {
        var k = a.getLayout() === 1 ? g * b + f : f * c + g;
        e[g][f] = d[k];
      }
    return e;
  });
  I("VERSION", "0.5.1635989137");
}).call(VonageHolistic);
const VonageFacedetection = {};
(function() {
  var x;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function B(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  B("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  B("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function C(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function D(a) {
    if (!(a instanceof Array)) {
      a = C(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var ea = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, fa;
  if (typeof Object.setPrototypeOf == "function")
    fa = Object.setPrototypeOf;
  else {
    var ha;
    a: {
      var ia = { a: true }, ja = {};
      try {
        ja.__proto__ = ia;
        ha = ja.a;
        break a;
      } catch (a) {
      }
      ha = false;
    }
    fa = ha ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var ka = fa;
  function E(a, b) {
    a.prototype = ea(b.prototype);
    a.prototype.constructor = a;
    if (ka)
      ka(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.na = b.prototype;
  }
  function la() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.u = this.o = 0;
    this.j = null;
  }
  function ma(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  la.prototype.s = function(a) {
    this.h = a;
  };
  function na(a, b) {
    a.j = { da: b, ea: true };
    a.g = a.o || a.u;
  }
  la.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.u;
  };
  function G(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function oa(a) {
    this.g = new la();
    this.h = a;
  }
  function pa(a, b) {
    ma(a.g);
    var c = a.g.i;
    if (c)
      return qa(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return H(a);
  }
  function qa(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, na(a.g, f), H(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return H(a);
  }
  function H(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, na(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.ea)
        throw b.da;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function ra(a) {
    this.next = function(b) {
      ma(a.g);
      a.g.i ? b = qa(a, a.g.i.next, b, a.g.s) : (a.g.s(b), b = H(a));
      return b;
    };
    this.throw = function(b) {
      ma(a.g);
      a.g.i ? b = qa(a, a.g.i["throw"], b, a.g.s) : (na(a.g, b), b = H(a));
      return b;
    };
    this.return = function(b) {
      return pa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function sa(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, e) {
      function g(f) {
        f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
      }
      g(a.next());
    });
  }
  function J(a) {
    return sa(new ra(new oa(a)));
  }
  B("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.s = false;
      var h = this.j();
      try {
        f(h.resolve, h.reject);
      } catch (k) {
        h.reject(k);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(h) {
        h(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var h = this;
        this.i(function() {
          h.l();
        });
      }
      this.g.push(f);
    };
    var e = y.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var h = 0; h < f.length; ++h) {
          var k = f[h];
          f[h] = null;
          try {
            k();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(m) {
          k || (k = true, l.call(h, m));
        };
      }
      var h = this, k = false;
      return { resolve: f(this.D), reject: f(this.l) };
    };
    b.prototype.D = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.H(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var h = f != null;
              break a;
            case "function":
              h = true;
              break a;
            default:
              h = false;
          }
        h ? this.A(f) : this.o(f);
      }
    };
    b.prototype.A = function(f) {
      var h = void 0;
      try {
        h = f.then;
      } catch (k) {
        this.l(k);
        return;
      }
      typeof h == "function" ? this.I(h, f) : this.o(f);
    };
    b.prototype.l = function(f) {
      this.u(2, f);
    };
    b.prototype.o = function(f) {
      this.u(1, f);
    };
    b.prototype.u = function(f, h) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = h;
      this.h === 2 && this.G();
      this.B();
    };
    b.prototype.G = function() {
      var f = this;
      e(function() {
        if (f.C()) {
          var h = y.console;
          typeof h !== "undefined" && h.error(f.i);
        }
      }, 1);
    };
    b.prototype.C = function() {
      if (this.s)
        return false;
      var f = y.CustomEvent, h = y.Event, k = y.dispatchEvent;
      if (typeof k === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof h === "function" ? f = new h("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return k(f);
    };
    b.prototype.B = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.H = function(f) {
      var h = this.j();
      f.M(h.resolve, h.reject);
    };
    b.prototype.I = function(f, h) {
      var k = this.j();
      try {
        f.call(h, k.resolve, k.reject);
      } catch (l) {
        k.reject(l);
      }
    };
    b.prototype.then = function(f, h) {
      function k(p, n) {
        return typeof p == "function" ? function(r) {
          try {
            l(p(r));
          } catch (t) {
            m(t);
          }
        } : n;
      }
      var l, m, q = new b(function(p, n) {
        l = p;
        m = n;
      });
      this.M(k(f, l), k(h, m));
      return q;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.M = function(f, h) {
      function k() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            h(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(k) : this.g.push(k);
      this.s = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(h, k) {
        k(f);
      });
    };
    b.race = function(f) {
      return new b(function(h, k) {
        for (var l = C(f), m = l.next(); !m.done; m = l.next())
          d(m.value).M(h, k);
      });
    };
    b.all = function(f) {
      var h = C(f), k = h.next();
      return k.done ? d([]) : new b(function(l, m) {
        function q(r) {
          return function(t) {
            p[r] = t;
            n--;
            n == 0 && l(p);
          };
        }
        var p = [], n = 0;
        do
          p.push(void 0), n++, d(k.value).M(q(p.length - 1), m), k = h.next();
        while (!k.done);
      });
    };
    return b;
  });
  function ta(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var ua = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  B("Object.assign", function(a) {
    return a || ua;
  });
  B("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  B("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  B("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  B("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ta(this, function(b) {
        return b;
      });
    };
  });
  var va = this || self;
  function K(a, b) {
    a = a.split(".");
    var c = va;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function L() {
    throw Error("Invalid UTF8");
  }
  function wa(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var xa, ya = typeof TextDecoder !== "undefined", za, Aa = typeof TextEncoder !== "undefined";
  var Ba = {}, M = null;
  function Ca(a) {
    var b;
    b === void 0 && (b = 0);
    Da();
    b = Ba[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | h >> 4];
      h = b[(h & 15) << 2 | k >> 6];
      k = b[k & 63];
      c[g++] = l + f + h + k;
    }
    l = 0;
    k = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], k = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
    }
    return c.join("");
  }
  function Ea(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Fa(a, function(g) {
      d[e++] = g;
    });
    return e !== c ? d.subarray(0, e) : d;
  }
  function Fa(a, b) {
    function c(k) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), m = M[l];
        if (m != null)
          return m;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return k;
    }
    Da();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), h = c(64);
      if (h === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
    }
  }
  function Da() {
    if (!M) {
      M = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Ba[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          M[g] === void 0 && (M[g] = e);
        }
      }
    }
  }
  var Ga = typeof Uint8Array === "function";
  function Ha(a) {
    return Ga && a != null && a instanceof Uint8Array;
  }
  var Ia;
  function Ja(a) {
    this.L = a;
    if (a !== null && a.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var Ka = typeof Uint8Array.prototype.slice === "function", N = 0, O = 0;
  function La(a, b) {
    if (a.constructor === Uint8Array)
      return a;
    if (a.constructor === ArrayBuffer)
      return new Uint8Array(a);
    if (a.constructor === Array)
      return new Uint8Array(a);
    if (a.constructor === String)
      return Ea(a);
    if (a.constructor === Ja) {
      if (!b && (b = a.L) && b.constructor === Uint8Array)
        return b;
      b = a.L;
      b = b == null || Ha(b) ? b : typeof b === "string" ? Ea(b) : null;
      return (a = a.L = b) ? new Uint8Array(a) : Ia || (Ia = new Uint8Array(0));
    }
    if (a instanceof Uint8Array)
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ma(a, b) {
    return Error("Invalid wire type: " + a + " (at position " + b + ")");
  }
  function Na() {
    return Error("Failed to read varint, encoding is invalid.");
  }
  function Oa(a, b) {
    b = b === void 0 ? {} : b;
    b = b.v === void 0 ? false : b.v;
    this.h = null;
    this.g = this.i = this.j = 0;
    this.v = b;
    a && Pa(this, a);
  }
  function Pa(a, b) {
    a.h = La(b, a.v);
    a.j = 0;
    a.i = a.h.length;
    a.g = a.j;
  }
  Oa.prototype.reset = function() {
    this.g = this.j;
  };
  function P(a) {
    if (a.g > a.i)
      throw Error("Tried to read past the end of the data " + a.g + " > " + a.i);
  }
  function Q(a) {
    var b = a.h, c = b[a.g], d = c & 127;
    if (128 > c)
      return a.g += 1, P(a), d;
    c = b[a.g + 1];
    d |= (c & 127) << 7;
    if (128 > c)
      return a.g += 2, P(a), d;
    c = b[a.g + 2];
    d |= (c & 127) << 14;
    if (128 > c)
      return a.g += 3, P(a), d;
    c = b[a.g + 3];
    d |= (c & 127) << 21;
    if (128 > c)
      return a.g += 4, P(a), d;
    c = b[a.g + 4];
    a.g += 5;
    d |= (c & 15) << 28;
    if (128 > c)
      return P(a), d;
    if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++])
      throw Na();
    P(a);
    return d;
  }
  var Qa = [];
  function Ra() {
    this.g = [];
  }
  Ra.prototype.length = function() {
    return this.g.length;
  };
  Ra.prototype.end = function() {
    var a = this.g;
    this.g = [];
    return a;
  };
  function S(a, b) {
    for (; 127 < b; )
      a.g.push(b & 127 | 128), b >>>= 7;
    a.g.push(b);
  }
  function Sa(a) {
    var b = {}, c = b.W === void 0 ? false : b.W;
    this.l = { v: b.v === void 0 ? false : b.v };
    this.W = c;
    b = this.l;
    Qa.length ? (c = Qa.pop(), b && (c.v = b.v), a && Pa(c, a), a = c) : a = new Oa(a, b);
    this.g = a;
    this.j = this.g.g;
    this.h = this.i = -1;
  }
  Sa.prototype.reset = function() {
    this.g.reset();
    this.j = this.g.g;
    this.h = this.i = -1;
  };
  function Ta(a) {
    var b = a.g;
    if (b.g == b.i)
      return false;
    a.j = a.g.g;
    var c = Q(a.g) >>> 0;
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      throw Ma(c, a.j);
    if (1 > b)
      throw Error("Invalid field number: " + b + " (at position " + a.j + ")");
    a.i = b;
    a.h = c;
    return true;
  }
  function Ua(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Ua(a);
        else
          a: {
            a = a.g;
            for (var b = a.g, c = b + 10; b < c; )
              if ((a.h[b++] & 128) === 0) {
                a.g = b;
                P(a);
                break a;
              }
            throw Na();
          }
        break;
      case 1:
        a = a.g;
        a.g += 8;
        P(a);
        break;
      case 2:
        a.h != 2 ? Ua(a) : (b = Q(a.g) >>> 0, a = a.g, a.g += b, P(a));
        break;
      case 5:
        a = a.g;
        a.g += 4;
        P(a);
        break;
      case 3:
        b = a.i;
        do {
          if (!Ta(a))
            throw Error("Unmatched start-group tag: stream EOF");
          if (a.h == 4) {
            if (a.i != b)
              throw Error("Unmatched end-group tag");
            break;
          }
          Ua(a);
        } while (1);
        break;
      default:
        throw Ma(a.h, a.j);
    }
  }
  var Va = [];
  function Wa() {
    this.i = [];
    this.h = 0;
    this.g = new Ra();
  }
  function T(a, b) {
    b.length !== 0 && (a.i.push(b), a.h += b.length);
  }
  function Xa(a, b) {
    if (b = b.ba) {
      T(a, a.g.end());
      for (var c = 0; c < b.length; c++)
        T(a, b[c]);
    }
  }
  var U = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
  function Ya(a, b) {
    Object.isFrozen(a) || (U ? a[U] |= b : a.N !== void 0 ? a.N |= b : Object.defineProperties(a, { N: { value: b, configurable: true, writable: true, enumerable: false } }));
  }
  function Za(a) {
    var b;
    U ? b = a[U] : b = a.N;
    return b == null ? 0 : b;
  }
  function $a(a) {
    Ya(a, 1);
    return a;
  }
  function ab(a) {
    return Array.isArray(a) ? !!(Za(a) & 2) : false;
  }
  function bb(a) {
    if (!Array.isArray(a))
      throw Error("cannot mark non-array as immutable");
    Ya(a, 2);
  }
  function cb(a) {
    return a !== null && typeof a === "object" && !Array.isArray(a) && a.constructor === Object;
  }
  var db = Object.freeze($a([]));
  function eb(a) {
    if (ab(a.m))
      throw Error("Cannot mutate an immutable Message");
  }
  var fb = typeof Symbol != "undefined" && typeof Symbol.hasInstance != "undefined";
  function gb(a) {
    return { value: a, configurable: false, writable: false, enumerable: false };
  }
  function V(a, b, c) {
    return b === -1 ? null : b >= a.i ? a.g ? a.g[b] : void 0 : (c === void 0 ? 0 : c) && a.g && (c = a.g[b], c != null) ? c : a.m[b + a.h];
  }
  function W(a, b, c, d) {
    d = d === void 0 ? false : d;
    eb(a);
    b < a.i && !d ? a.m[b + a.h] = c : (a.g || (a.g = a.m[a.i + a.h] = {}))[b] = c;
  }
  function hb(a, b, c, d) {
    c = c === void 0 ? true : c;
    d = d === void 0 ? false : d;
    var e = V(a, b, d);
    e == null && (e = db);
    if (ab(a.m))
      c && (bb(e), Object.freeze(e));
    else if (e === db || ab(e))
      e = $a(e.slice()), W(a, b, e, d);
    return e;
  }
  function X(a, b, c) {
    a = V(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function ib(a, b, c, d) {
    a.j || (a.j = {});
    var e = ab(a.m), g = a.j[c];
    if (!g) {
      d = hb(a, c, true, d === void 0 ? false : d);
      g = [];
      e = e || ab(d);
      for (var f = 0; f < d.length; f++)
        g[f] = new b(d[f]), e && bb(g[f].m);
      e && (bb(g), Object.freeze(g));
      a.j[c] = g;
    }
    return g;
  }
  function jb(a, b, c, d, e) {
    var g = g === void 0 ? false : g;
    eb(a);
    g = ib(a, c, b, g);
    c = d ? d : new c();
    a = hb(a, b);
    e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.m)) : (g.push(c), a.push(c.m));
    return c;
  }
  function kb(a, b) {
    a = V(a, b);
    return a == null ? 0 : a;
  }
  function lb(a, b) {
    a = V(a, b);
    return a == null ? "" : a;
  }
  function mb(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        if (a && !Array.isArray(a)) {
          if (Ha(a))
            return Ca(a);
          if (a instanceof Ja) {
            var b = a.L;
            b = b == null || typeof b === "string" ? b : Ga && b instanceof Uint8Array ? Ca(b) : null;
            return (a.L = b) || "";
          }
        }
    }
    return a;
  }
  function nb(a) {
    var b = ob;
    b = b === void 0 ? pb : b;
    return qb(a, b);
  }
  function rb(a, b) {
    if (a != null) {
      if (Array.isArray(a))
        a = qb(a, b);
      else if (cb(a)) {
        var c = {}, d;
        for (d in a)
          c[d] = rb(a[d], b);
        a = c;
      } else
        a = b(a);
      return a;
    }
  }
  function qb(a, b) {
    for (var c = a.slice(), d = 0; d < c.length; d++)
      c[d] = rb(c[d], b);
    Array.isArray(a) && Za(a) & 1 && $a(c);
    return c;
  }
  function ob(a) {
    if (a && typeof a == "object" && a.toJSON)
      return a.toJSON();
    a = mb(a);
    return Array.isArray(a) ? nb(a) : a;
  }
  function pb(a) {
    return Ha(a) ? new Uint8Array(a) : a;
  }
  function sb(a, b, c) {
    a || (a = tb);
    tb = null;
    var d = this.constructor.h;
    a || (a = d ? [d] : []);
    this.h = (d ? 0 : -1) - (this.constructor.g || 0);
    this.j = void 0;
    this.m = a;
    a: {
      d = this.m.length;
      a = d - 1;
      if (d && (d = this.m[a], cb(d))) {
        this.i = a - this.h;
        this.g = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.i = Math.max(b, a + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        if (a = c[b], a < this.i)
          a += this.h, (d = this.m[a]) ? Array.isArray(d) && $a(d) : this.m[a] = db;
        else {
          d = this.g || (this.g = this.m[this.i + this.h] = {});
          var e = d[a];
          e ? Array.isArray(e) && $a(e) : d[a] = db;
        }
  }
  sb.prototype.toJSON = function() {
    return nb(this.m);
  };
  sb.prototype.toString = function() {
    return this.m.toString();
  };
  var tb;
  function ub() {
    sb.apply(this, arguments);
  }
  E(ub, sb);
  if (fb) {
    var vb = {};
    Object.defineProperties(ub, (vb[Symbol.hasInstance] = gb(function() {
      throw Error("Cannot perform instanceof checks for MutableMessage");
    }), vb));
  }
  function wb(a, b, c) {
    if (c) {
      var d = {}, e;
      for (e in c) {
        var g = c[e], f = g.ha;
        f || (d.F = g.la || g.fa.P, g.aa ? (d.U = xb(g.aa), f = function(h) {
          return function(k, l, m) {
            return h.F(k, l, m, h.U);
          };
        }(d)) : g.ca ? (d.T = yb(g.X.g, g.ca), f = function(h) {
          return function(k, l, m) {
            return h.F(k, l, m, h.T);
          };
        }(d)) : f = d.F, g.ha = f);
        f(b, a, g.X);
        d = { F: d.F, U: d.U, T: d.T };
      }
    }
    Xa(b, a);
  }
  var zb = Symbol();
  function Ab(a, b, c) {
    return a[zb] || (a[zb] = function(d, e) {
      return b(d, e, c);
    });
  }
  function Bb(a) {
    var b = a[zb];
    if (!b) {
      var c = Cb(a);
      b = function(d, e) {
        return Db(d, e, c);
      };
      a[zb] = b;
    }
    return b;
  }
  function Eb(a) {
    var b = a.aa;
    if (b)
      return Bb(b);
    if (b = a.ka)
      return Ab(a.X.g, b, a.ca);
  }
  function Fb(a) {
    var b = Eb(a), c = a.X, d = a.fa.O;
    return b ? function(e, g) {
      return d(e, g, c, b);
    } : function(e, g) {
      return d(e, g, c);
    };
  }
  function Gb(a, b, c, d, e, g) {
    a = a();
    var f = 0;
    a.length && typeof a[0] !== "number" && (c(b, a[0]), f++);
    for (; f < a.length; ) {
      c = a[f++];
      for (var h = f + 1; h < a.length && typeof a[h] !== "number"; )
        h++;
      var k = a[f++];
      h -= f;
      switch (h) {
        case 0:
          d(b, c, k);
          break;
        case 1:
          d(b, c, k, a[f++]);
          break;
        case 2:
          e(b, c, k, a[f++], a[f++]);
          break;
        case 3:
          h = a[f++];
          var l = a[f++], m = a[f++];
          Array.isArray(m) ? e(b, c, k, h, l, m) : g(b, c, k, h, l, m);
          break;
        case 4:
          g(b, c, k, a[f++], a[f++], a[f++], a[f++]);
          break;
        default:
          throw Error("unexpected number of binary field arguments: " + h);
      }
    }
    return b;
  }
  var Hb = Symbol();
  function xb(a) {
    var b = a[Hb];
    if (!b) {
      var c = Ib(a);
      b = function(d, e) {
        return Jb(d, e, c);
      };
      a[Hb] = b;
    }
    return b;
  }
  function yb(a, b) {
    var c = a[Hb];
    c || (c = function(d, e) {
      return wb(d, e, b);
    }, a[Hb] = c);
    return c;
  }
  var Kb = Symbol();
  function Lb(a, b) {
    a.push(b);
  }
  function Mb(a, b, c) {
    a.push(b, c.P);
  }
  function Nb(a, b, c, d, e) {
    var g = xb(e), f = c.P;
    a.push(b, function(h, k, l) {
      return f(h, k, l, d, g);
    });
  }
  function Ob(a, b, c, d, e, g) {
    var f = yb(d, g), h = c.P;
    a.push(b, function(k, l, m) {
      return h(k, l, m, d, f);
    });
  }
  function Ib(a) {
    var b = a[Kb];
    return b ? b : Gb(a, a[Kb] = [], Lb, Mb, Nb, Ob);
  }
  var Pb = Symbol();
  function Qb(a, b) {
    a[0] = b;
  }
  function Rb(a, b, c, d) {
    var e = c.O;
    a[b] = d ? function(g, f, h) {
      return e(g, f, h, d);
    } : e;
  }
  function Sb(a, b, c, d, e, g) {
    var f = c.O, h = Bb(e);
    a[b] = function(k, l, m) {
      return f(k, l, m, d, h, g);
    };
  }
  function Tb(a, b, c, d, e, g, f) {
    var h = c.O, k = Ab(d, e, g);
    a[b] = function(l, m, q) {
      return h(l, m, q, d, k, f);
    };
  }
  function Cb(a) {
    var b = a[Pb];
    return b ? b : Gb(a, a[Pb] = {}, Qb, Rb, Sb, Tb);
  }
  function Db(a, b, c) {
    for (; Ta(b) && b.h != 4; ) {
      var d = b.i, e = c[d];
      if (!e) {
        var g = c[0];
        g && (g = g[d]) && (e = c[d] = Fb(g));
      }
      if (!e || !e(b, a, d)) {
        if (e = b, d = a, g = e.j, Ua(e), !e.W) {
          var f = e.g.h;
          e = e.g.g;
          e = g === e ? Ia || (Ia = new Uint8Array(0)) : Ka ? f.slice(g, e) : new Uint8Array(f.subarray(g, e));
          (g = d.ba) ? g.push(e) : d.ba = [e];
        }
      }
    }
    return a;
  }
  function Ub(a, b, c) {
    if (Va.length) {
      var d = Va.pop();
      a && (Pa(d.g, a), d.i = -1, d.h = -1);
      a = d;
    } else
      a = new Sa(a);
    try {
      return Db(new b(), a, Cb(c));
    } finally {
      b = a.g, b.h = null, b.j = 0, b.i = 0, b.g = 0, b.v = false, a.i = -1, a.h = -1, 100 > Va.length && Va.push(a);
    }
  }
  function Jb(a, b, c) {
    for (var d = c.length, e = d % 2 == 1, g = e ? 1 : 0; g < d; g += 2)
      (0, c[g + 1])(b, a, c[g]);
    wb(a, b, e ? c[0] : void 0);
  }
  function Vb(a, b) {
    var c = new Wa();
    Jb(a, c, Ib(b));
    T(c, c.g.end());
    a = new Uint8Array(c.h);
    b = c.i;
    for (var d = b.length, e = 0, g = 0; g < d; g++) {
      var f = b[g];
      a.set(f, e);
      e += f.length;
    }
    c.i = [a];
    return a;
  }
  function Wb(a, b) {
    return { O: a, P: b };
  }
  var Y = Wb(function(a, b, c) {
    if (a.h !== 5)
      return false;
    a = a.g;
    var d = a.h[a.g];
    var e = a.h[a.g + 1];
    var g = a.h[a.g + 2], f = a.h[a.g + 3];
    a.g += 4;
    P(a);
    e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
    a = 2 * (e >> 31) + 1;
    d = e >>> 23 & 255;
    e &= 8388607;
    W(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null) {
      S(a.g, 8 * c + 5);
      a = a.g;
      var d = b;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? N = O = 0 : (O = 0, N = 2147483648) : isNaN(d) ? (O = 0, N = 2147483647) : 34028234663852886e22 < d ? (O = 0, N = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), O = 0, N = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, O = 0, N = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = N;
      a.g.push(c >>> 0 & 255);
      a.g.push(c >>> 8 & 255);
      a.g.push(c >>> 16 & 255);
      a.g.push(c >>> 24 & 255);
    }
  }), Xb = Wb(function(a, b, c) {
    if (a.h !== 0)
      return false;
    for (var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)
      e = d.h[d.g++], P(d), g |= (e & 127) << 7 * f;
    128 <= e && (e = d.h[d.g++], P(d), g |= (e & 127) << 28, a |= (e & 127) >> 4);
    if (128 <= e)
      for (f = 0; 5 > f && 128 <= e; f++)
        e = d.h[d.g++], P(d), a |= (e & 127) << 7 * f + 3;
    if (128 > e) {
      d = g >>> 0;
      e = a >>> 0;
      if (a = e & 2147483648)
        d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
      d = 4294967296 * e + (d >>> 0);
    } else
      throw Na();
    W(b, c, a ? -d : d);
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null && b != null) {
      S(a.g, 8 * c);
      a = a.g;
      var d = b;
      c = 0 > d;
      d = Math.abs(d);
      b = d >>> 0;
      d = Math.floor((d - b) / 4294967296);
      d >>>= 0;
      c && (d = ~d >>> 0, b = (~b >>> 0) + 1, 4294967295 < b && (b = 0, d++, 4294967295 < d && (d = 0)));
      N = b;
      O = d;
      c = N;
      for (b = O; 0 < b || 127 < c; )
        a.g.push(c & 127 | 128), c = (c >>> 7 | b << 25) >>> 0, b >>>= 7;
      a.g.push(c);
    }
  }), Yb = Wb(function(a, b, c) {
    if (a.h !== 0)
      return false;
    W(b, c, Q(a.g));
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null && b != null)
      if (S(a.g, 8 * c), a = a.g, c = b, 0 <= c)
        S(a, c);
      else {
        for (b = 0; 9 > b; b++)
          a.g.push(c & 127 | 128), c >>= 7;
        a.g.push(1);
      }
  }), Zb = Wb(function(a, b, c) {
    if (a.h !== 2)
      return false;
    var d = Q(a.g) >>> 0;
    a = a.g;
    var e = a.g;
    a.g += d;
    P(a);
    a = a.h;
    var g;
    if (ya)
      (g = xa) || (g = xa = new TextDecoder("utf-8", { fatal: true })), g = g.decode(a.subarray(e, e + d));
    else {
      d = e + d;
      for (var f = [], h = null, k, l, m; e < d; )
        k = a[e++], 128 > k ? f.push(k) : 224 > k ? e >= d ? L() : (l = a[e++], 194 > k || (l & 192) !== 128 ? (e--, L()) : f.push((k & 31) << 6 | l & 63)) : 240 > k ? e >= d - 1 ? L() : (l = a[e++], (l & 192) !== 128 || k === 224 && 160 > l || k === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, L()) : f.push((k & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= k ? e >= d - 2 ? L() : (l = a[e++], (l & 192) !== 128 || (k << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((m = a[e++]) & 192) !== 128 ? (e--, L()) : (k = (k & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | m & 63, k -= 65536, f.push((k >> 10 & 1023) + 55296, (k & 1023) + 56320))) : L(), 8192 <= f.length && (h = wa(h, f), f.length = 0);
      g = wa(h, f);
    }
    W(b, c, g);
    return true;
  }, function(a, b, c) {
    b = V(b, c);
    if (b != null) {
      var d = false;
      d = d === void 0 ? false : d;
      if (Aa) {
        if (d && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(b))
          throw Error("Found an unpaired surrogate");
        b = (za || (za = new TextEncoder())).encode(b);
      } else {
        for (var e = 0, g = new Uint8Array(3 * b.length), f = 0; f < b.length; f++) {
          var h = b.charCodeAt(f);
          if (128 > h)
            g[e++] = h;
          else {
            if (2048 > h)
              g[e++] = h >> 6 | 192;
            else {
              if (55296 <= h && 57343 >= h) {
                if (56319 >= h && f < b.length) {
                  var k = b.charCodeAt(++f);
                  if (56320 <= k && 57343 >= k) {
                    h = 1024 * (h - 55296) + k - 56320 + 65536;
                    g[e++] = h >> 18 | 240;
                    g[e++] = h >> 12 & 63 | 128;
                    g[e++] = h >> 6 & 63 | 128;
                    g[e++] = h & 63 | 128;
                    continue;
                  } else
                    f--;
                }
                if (d)
                  throw Error("Found an unpaired surrogate");
                h = 65533;
              }
              g[e++] = h >> 12 | 224;
              g[e++] = h >> 6 & 63 | 128;
            }
            g[e++] = h & 63 | 128;
          }
        }
        b = g.subarray(0, e);
      }
      S(a.g, 8 * c + 2);
      S(a.g, b.length);
      T(a, a.g.end());
      T(a, b);
    }
  }), $b = Wb(function(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    b = jb(b, c, d);
    c = a.g.i;
    d = Q(a.g) >>> 0;
    var g = a.g.g + d, f = g - c;
    0 >= f && (a.g.i = g, e(b, a), f = g - a.g.g);
    if (f)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (d + " bytes, instead read " + (d - f) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.g.g = g;
    a.g.i = c;
    return true;
  }, function(a, b, c, d, e) {
    b = ib(b, d, c);
    if (b != null)
      for (d = 0; d < b.length; d++) {
        var g = a;
        S(g.g, 8 * c + 2);
        var f = g.g.end();
        T(g, f);
        f.push(g.h);
        g = f;
        e(b[d], a);
        f = a;
        var h = g.pop();
        for (h = f.h + f.g.length() - h; 127 < h; )
          g.push(h & 127 | 128), h >>>= 7, f.h++;
        g.push(h);
        f.h++;
      }
  });
  function Z() {
    ub.apply(this, arguments);
  }
  E(Z, ub);
  if (fb) {
    var ac = {};
    Object.defineProperties(Z, (ac[Symbol.hasInstance] = gb(Object[Symbol.hasInstance]), ac));
  }
  function bc(a) {
    Z.call(this, a);
  }
  E(bc, Z);
  function cc() {
    return [1, Yb, 2, Y, 3, Zb, 4, Zb];
  }
  function dc(a) {
    Z.call(this, a, -1, ec);
  }
  E(dc, Z);
  dc.prototype.addClassification = function(a, b) {
    jb(this, 1, bc, a, b);
    return this;
  };
  function fc() {
    return [1, $b, bc, cc];
  }
  var ec = [1];
  function gc(a) {
    Z.call(this, a);
  }
  E(gc, Z);
  function hc() {
    return [1, Y, 2, Y, 3, Y, 4, Y, 5, Y];
  }
  function ic(a) {
    Z.call(this, a, -1, jc);
  }
  E(ic, Z);
  function kc() {
    return [1, $b, gc, hc];
  }
  var jc = [1];
  function lc(a) {
    Z.call(this, a);
  }
  E(lc, Z);
  function mc() {
    return [1, Y, 2, Y, 3, Y, 4, Y, 5, Y, 6, Xb];
  }
  var nc = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], oc = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], pc = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], qc = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], rc = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], sc = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], tc = [].concat(D(nc), D(oc), D(pc), D(qc), D(rc), D(sc));
  function uc(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function vc(a) {
    return ib(a, bc, 1).map(function(b) {
      return { index: kb(b, 1), ga: X(b, 2), label: V(b, 3) != null ? lb(b, 3) : void 0, displayName: V(b, 4) != null ? lb(b, 4) : void 0 };
    });
  }
  function wc(a) {
    return { x: X(a, 1), y: X(a, 2), z: X(a, 3), visibility: V(a, 4) != null ? X(a, 4) : void 0 };
  }
  function xc(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function yc(a, b, c) {
    zc(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function zc(a, b) {
    var c = a.g;
    if (a.o === void 0) {
      var d = uc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = uc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.o = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { K: c.getAttribLocation(d, "aVertex"), J: c.getAttribLocation(d, "aTex"), ma: e };
      a.u = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.u);
      c.enableVertexAttribArray(a.j.K);
      c.vertexAttribPointer(a.j.K, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.J);
      c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.o);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.K);
    c.bindBuffer(c.ARRAY_BUFFER, a.u);
    c.vertexAttribPointer(d.K, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.J);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.K);
    c.disableVertexAttribArray(d.J);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function Ac(a) {
    this.g = a;
  }
  var Bc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Cc(a, b) {
    return b + a;
  }
  function Dc(a, b) {
    window[a] = b;
  }
  function Ec(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Fc() {
    return J(function(a) {
      switch (a.g) {
        case 1:
          return a.o = 2, G(a, WebAssembly.instantiate(Bc), 4);
        case 4:
          a.g = 3;
          a.o = 0;
          break;
        case 2:
          return a.o = 0, a.j = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function Gc(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.H = {};
    this.o = {};
    this.u = {};
    this.I = this.s = this.Z = true;
    this.D = Promise.resolve();
    this.Y = "";
    this.C = {};
    this.locateFile = a && a.locateFile || Cc;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.$ = b;
    if (a.options) {
      b = C(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  x = Gc.prototype;
  x.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Hc(a) {
    var b, c, d, e, g, f, h, k, l, m, q;
    return J(function(p) {
      switch (p.g) {
        case 1:
          if (!a.Z)
            return p.return();
          b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
          return G(p, Fc(), 2);
        case 2:
          c = p.h;
          if (typeof window === "object")
            return Dc("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), Dc("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(n) {
              return n.data !== void 0;
            }), h = b.filter(function(n) {
              return n.data === void 0;
            }), k = Promise.all(f.map(function(n) {
              var r = Ic(a, n.url);
              if (n.path !== void 0) {
                var t = n.path;
                r = r.then(function(w) {
                  a.overrideFile(t, w);
                  return Promise.resolve(w);
                });
              }
              return r;
            })), l = Promise.all(h.map(function(n) {
              return n.simd === void 0 || n.simd && c || !n.simd && !c ? Ec(a.locateFile(n.url, a.$)) : Promise.resolve();
            })).then(function() {
              var n, r, t;
              return J(function(w) {
                if (w.g == 1)
                  return n = window.createMediapipeSolutionsWasm, r = window.createMediapipeSolutionsPackedAssets, t = a, G(w, n(r), 2);
                t.h = w.h;
                w.g = 0;
              });
            }), m = function() {
              return J(function(n) {
                a.g.graph && a.g.graph.url ? n = G(n, Ic(a, a.g.graph.url), 0) : (n.g = 0, n = void 0);
                return n;
              });
            }(), G(p, Promise.all([l, k, m]), 7);
          if (typeof importScripts !== "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(n) {
            return n.simd === void 0 || n.simd && c || !n.simd && !c;
          }).map(function(n) {
            return a.locateFile(n.url, a.$);
          });
          importScripts.apply(null, D(d));
          e = a;
          return G(p, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          e.h = p.h;
          a.l = new OffscreenCanvas(1, 1);
          a.h.canvas = a.l;
          g = a.h.GL.createContext(a.l, {
            antialias: false,
            alpha: false,
            ja: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
          });
          a.h.GL.makeContextCurrent(g);
          p.g = 4;
          break;
        case 7:
          a.l = document.createElement("canvas");
          q = a.l.getContext("webgl2", {});
          if (!q && (q = a.l.getContext("webgl", {}), !q))
            return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
          a.G = q;
          a.h.canvas = a.l;
          a.h.createContext(a.l, true, true, {});
        case 4:
          a.i = new a.h.SolutionWasm(), a.Z = false, p.g = 0;
      }
    });
  }
  function Jc(a) {
    var b, c, d, e, g, f, h, k;
    return J(function(l) {
      if (l.g == 1) {
        if (a.g.graph && a.g.graph.url && a.Y === a.g.graph.url)
          return l.return();
        a.s = true;
        if (!a.g.graph || !a.g.graph.url) {
          l.g = 2;
          return;
        }
        a.Y = a.g.graph.url;
        return G(l, Ic(a, a.g.graph.url), 3);
      }
      l.g != 2 && (b = l.h, a.i.loadGraph(b));
      c = C(Object.keys(a.C));
      for (d = c.next(); !d.done; d = c.next())
        e = d.value, a.i.overrideFile(e, a.C[e]);
      a.C = {};
      if (a.g.listeners)
        for (g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())
          h = f.value, Kc(a, h);
      k = a.j;
      a.j = {};
      a.setOptions(k);
      l.g = 0;
    });
  }
  x.reset = function() {
    var a = this;
    return J(function(b) {
      a.i && (a.i.reset(), a.o = {}, a.u = {});
      b.g = 0;
    });
  };
  x.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = C(Object.keys(a)), h = f.next(); !h.done; g = { R: g.R, S: g.S }, h = f.next()) {
        var k = h.value;
        k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.R = h.onChange, g.S = a[k], d.push(function(l) {
          return function() {
            var m;
            return J(function(q) {
              if (q.g == 1)
                return G(q, l.R(l.S), 2);
              m = q.h;
              m === true && (c.s = true);
              q.g = 0;
            });
          };
        }(g))), h.graphOptionXref && (k = { valueNumber: h.type === 1 ? a[k] : 0, valueBoolean: h.type === 0 ? a[k] : false, valueString: h.type === 2 ? a[k] : "" }, h = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), h.graphOptionXref), k), e.push(h))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.s = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
    }
  };
  function Lc(a) {
    var b, c, d, e, g, f, h;
    return J(function(k) {
      switch (k.g) {
        case 1:
          if (!a.s)
            return k.return();
          if (!a.A) {
            k.g = 2;
            break;
          }
          b = C(a.A);
          c = b.next();
        case 3:
          if (c.done) {
            k.g = 5;
            break;
          }
          d = c.value;
          return G(k, d(), 4);
        case 4:
          c = b.next();
          k.g = 3;
          break;
        case 5:
          a.A = void 0;
        case 2:
          if (a.B) {
            e = new a.h.GraphOptionChangeRequestList();
            g = C(a.B);
            for (f = g.next(); !f.done; f = g.next())
              h = f.value, e.push_back(h);
            a.i.changeOptions(e);
            e.delete();
            a.B = void 0;
          }
          a.s = false;
          k.g = 0;
      }
    });
  }
  x.initialize = function() {
    var a = this;
    return J(function(b) {
      return b.g == 1 ? G(b, Hc(a), 2) : b.g != 3 ? G(b, Jc(a), 3) : G(b, Lc(a), 0);
    });
  };
  function Ic(a, b) {
    var c, d;
    return J(function(e) {
      if (b in a.H)
        return e.return(a.H[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.H[b] = d;
      return e.return(d);
    });
  }
  x.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
  };
  x.clearOverriddenFiles = function() {
    this.C = {};
    this.i && this.i.clearOverriddenFiles();
  };
  x.send = function(a, b) {
    var c = this, d, e, g, f, h, k, l, m, q;
    return J(function(p) {
      switch (p.g) {
        case 1:
          if (!c.g.inputs)
            return p.return();
          d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
          return G(p, c.D, 2);
        case 2:
          return G(p, c.initialize(), 3);
        case 3:
          e = new c.h.PacketDataList();
          g = C(Object.keys(a));
          for (f = g.next(); !f.done; f = g.next())
            if (h = f.value, k = c.g.inputs[h]) {
              a: {
                var n = a[h];
                switch (k.type) {
                  case "video":
                    var r = c.o[k.stream];
                    r || (r = new xc(c.h, c.G), c.o[k.stream] = r);
                    r.l === 0 && (r.l = r.h.createTexture());
                    if (typeof HTMLVideoElement !== "undefined" && n instanceof HTMLVideoElement) {
                      var t = n.videoWidth;
                      var w = n.videoHeight;
                    } else
                      typeof HTMLImageElement !== "undefined" && n instanceof HTMLImageElement ? (t = n.naturalWidth, w = n.naturalHeight) : (t = n.width, w = n.height);
                    w = { glName: r.l, width: t, height: w };
                    t = r.g;
                    t.canvas.width = w.width;
                    t.canvas.height = w.height;
                    t.activeTexture(t.TEXTURE0);
                    r.h.bindTexture2d(r.l);
                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n);
                    r.h.bindTexture2d(0);
                    r = w;
                    break a;
                  case "detections":
                    r = c.o[k.stream];
                    r || (r = new Ac(c.h), c.o[k.stream] = r);
                    r.data || (r.data = new r.g.DetectionListData());
                    r.data.reset(n.length);
                    for (w = 0; w < n.length; ++w) {
                      t = n[w];
                      var v = r.data, A = v.setBoundingBox, I = w;
                      var F = t.boundingBox;
                      var u = new lc();
                      W(u, 1, F.xCenter);
                      W(u, 2, F.yCenter);
                      W(u, 3, F.height);
                      W(u, 4, F.width);
                      W(u, 5, F.rotation);
                      W(u, 6, F.rectId);
                      F = Vb(u, mc);
                      A.call(v, I, F);
                      if (t.landmarks)
                        for (v = 0; v < t.landmarks.length; ++v) {
                          u = t.landmarks[v];
                          var z = u.visibility ? true : false;
                          A = r.data;
                          I = A.addNormalizedLandmark;
                          F = w;
                          u = Object.assign(Object.assign({}, u), { visibility: z ? u.visibility : 0 });
                          z = new gc();
                          W(z, 1, u.x);
                          W(z, 2, u.y);
                          W(z, 3, u.z);
                          u.visibility && W(z, 4, u.visibility);
                          u = Vb(z, hc);
                          I.call(A, F, u);
                        }
                      if (t.V)
                        for (v = 0; v < t.V.length; ++v)
                          A = r.data, I = A.addClassification, F = w, u = t.V[v], z = new bc(), W(z, 2, u.ga), u.index && W(z, 1, u.index), u.label && W(z, 3, u.label), u.displayName && W(z, 4, u.displayName), u = Vb(z, cc), I.call(A, F, u);
                    }
                    r = r.data;
                    break a;
                  default:
                    r = {};
                }
              }
              l = r;
              m = k.stream;
              switch (k.type) {
                case "video":
                  e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: m, timestamp: d }));
                  break;
                case "detections":
                  q = l;
                  q.stream = m;
                  q.timestamp = d;
                  e.pushDetectionList(q);
                  break;
                default:
                  throw Error("Unknown input config type: '" + k.type + "'");
              }
            }
          c.i.send(e);
          return G(p, c.D, 4);
        case 4:
          e.delete(), p.g = 0;
      }
    });
  };
  function Mc(a, b, c) {
    var d, e, g, f, h, k, l, m, q, p, n, r, t, w;
    return J(function(v) {
      switch (v.g) {
        case 1:
          if (!c)
            return v.return(b);
          d = {};
          e = 0;
          g = C(Object.keys(c));
          for (f = g.next(); !f.done; f = g.next())
            h = f.value, k = c[h], typeof k !== "string" && k.type === "texture" && b[k.stream] !== void 0 && ++e;
          1 < e && (a.I = false);
          l = C(Object.keys(c));
          f = l.next();
        case 2:
          if (f.done) {
            v.g = 4;
            break;
          }
          m = f.value;
          q = c[m];
          if (typeof q === "string")
            return t = d, w = m, G(v, Nc(a, m, b[q]), 14);
          p = b[q.stream];
          if (q.type === "detection_list") {
            if (p) {
              var A = p.getRectList();
              for (var I = p.getLandmarksList(), F = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z) {
                var R = Ub(A.get(z), lc, mc);
                R = { boundingBox: { xCenter: X(R, 1), yCenter: X(R, 2), height: X(R, 3), width: X(R, 4), rotation: X(R, 5, 0), rectId: kb(R, 6) }, landmarks: ib(Ub(I.get(z), ic, kc), gc, 1).map(wc), V: vc(Ub(F.get(z), dc, fc)) };
                u.push(R);
              }
              A = u;
            } else
              A = [];
            d[m] = A;
            v.g = 7;
            break;
          }
          if (q.type === "proto_list") {
            if (p) {
              A = Array(p.size());
              for (I = 0; I < p.size(); I++)
                A[I] = p.get(I);
              p.delete();
            } else
              A = [];
            d[m] = A;
            v.g = 7;
            break;
          }
          if (p === void 0) {
            v.g = 3;
            break;
          }
          if (q.type === "float_list") {
            d[m] = p;
            v.g = 7;
            break;
          }
          if (q.type === "proto") {
            d[m] = p;
            v.g = 7;
            break;
          }
          if (q.type !== "texture")
            throw Error("Unknown output config type: '" + q.type + "'");
          n = a.u[m];
          n || (n = new xc(a.h, a.G), a.u[m] = n);
          return G(v, yc(n, p, a.I), 13);
        case 13:
          r = v.h, d[m] = r;
        case 7:
          q.transform && d[m] && (d[m] = q.transform(d[m]));
          v.g = 3;
          break;
        case 14:
          t[w] = v.h;
        case 3:
          f = l.next();
          v.g = 2;
          break;
        case 4:
          return v.return(d);
      }
    });
  }
  function Nc(a, b, c) {
    var d;
    return J(function(e) {
      return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.u[b], d || (d = new xc(a.h, a.G), a.u[b] = d), e.return(yc(d, c, a.I))) : e.return(void 0);
    });
  }
  function Kc(a, b) {
    for (var c = b.name || "$", d = [].concat(D(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(h) {
      for (var k = {}, l = 0; l < b.wants.length; ++l)
        k[d[l]] = h.get(l);
      var m = a.listeners[c];
      m && (a.D = Mc(a, k, b.outs).then(function(q) {
        q = m(q);
        for (var p = 0; p < b.wants.length; ++p) {
          var n = k[d[p]];
          typeof n === "object" && n.hasOwnProperty && n.hasOwnProperty("delete") && n.delete();
        }
        q && (a.D = q);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  x.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  K("Solution", Gc);
  K("OptionType", { BOOL: 0, NUMBER: 1, ia: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Oc(a) {
    var b = this;
    a = a || {};
    var c = { url: "face_detection_short.binarypb" }, d = { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } };
    this.g = new Gc({
      locateFile: a.locateFile,
      files: [{ data: true, url: "face_detection_short.binarypb" }, { data: true, url: "face_detection_short_range.tflite" }, { simd: true, url: "face_detection_solution_simd_wasm_bin.js" }, { simd: false, url: "face_detection_solution_wasm_bin.js" }],
      graph: c,
      listeners: [{ wants: ["detections", "image_transformed"], outs: { image: "image_transformed", detections: { type: "detection_list", stream: "detections" } } }],
      inputs: { image: { type: "video", stream: "input_frames_gpu" } },
      options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, model: { type: 0, onChange: function(e) {
        var g, f, h, k, l, m;
        return J(function(q) {
          switch (q.g) {
            case 1:
              g = e === "short" ? ["face_detection_short_range.tflite"] : ["face_detection_full_range_sparse.tflite"], f = C(g), h = f.next();
            case 2:
              if (h.done) {
                q.g = 4;
                break;
              }
              k = h.value;
              l = "third_party/mediapipe/modules/face_detection/" + k;
              return G(q, Ic(b.g, k), 5);
            case 5:
              m = q.h;
              b.g.overrideFile(l, m);
              h = f.next();
              q.g = 2;
              break;
            case 4:
              return c.url = e === "short" ? "face_detection_short.binarypb" : "face_detection_full.binarypb", d.graphOptionXref.calculatorName = e === "short" ? "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator" : "facedetectionfullrangegpu__facedetectionfullrangecommon__TensorsToDetectionsCalculator", q.return(true);
          }
        });
      } }, minDetectionConfidence: d }
    });
  }
  x = Oc.prototype;
  x.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  x.onResults = function(a) {
    this.g.onResults(a);
  };
  x.initialize = function() {
    var a = this;
    return J(function(b) {
      return G(b, a.g.initialize(), 0);
    });
  };
  x.reset = function() {
    this.g.reset();
  };
  x.send = function(a) {
    var b = this;
    return J(function(c) {
      return G(c, b.g.send(a), 0);
    });
  };
  x.setOptions = function(a) {
    this.g.setOptions(a);
  };
  K("FaceDetection", Oc);
  K("FACEDETECTION_LIPS", nc);
  K("FACEDETECTION_LEFT_EYE", oc);
  K("FACEDETECTION_LEFT_EYEBROW", pc);
  K("FACEDETECTION_RIGHT_EYE", qc);
  K("FACEDETECTION_RIGHT_EYEBROW", rc);
  K("FACEDETECTION_FACE_OVAL", sc);
  K("FACEDETECTION_CONTOURS", tc);
  K("FACEDETECTION_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [212, 214],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [92, 40],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [170, 140],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [100, 36],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [170, 149],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [
      138,
      172
    ],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [143, 111],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [
      38,
      82
    ],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [
      201,
      83
    ],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [228, 24],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [
      112,
      233
    ],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [332, 297],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [367, 416],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [
      399,
      419
    ],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [451, 349],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [462, 328],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [
      395,
      369
    ],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [197, 419],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [439, 455],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [
      436,
      426
    ],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [
      369,
      262
    ],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [428, 262],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [
      259,
      444
    ],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [372, 383],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [232, 120],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [
      160,
      30
    ],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [30, 247],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [
      91,
      146
    ],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [
      56,
      28
    ],
    [28, 157],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [
      122,
      168
    ],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [218, 115],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [222, 52],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [
      205,
      36
    ],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [212, 186],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [
      112,
      232
    ],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [
      236,
      174
    ],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [418, 431],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [421, 18],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [382, 256],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [
      346,
      352
    ],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [352, 366],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [
      349,
      329
    ],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [
      175,
      396
    ],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [195, 248],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [420, 429],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [
      410,
      287
    ],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [256, 341],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [
      412,
      343
    ],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]);
  K("VERSION", "0.4.1646425229");
}).call(VonageFacedetection);
const VonageFacemash = {};
(function() {
  var v;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var G = ca(this);
  function J(a, b) {
    if (b)
      a: {
        var c = G;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  J("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  J("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = G[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function K(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function L(a) {
    if (!(a instanceof Array)) {
      a = K(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var ea = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, fa;
  if (typeof Object.setPrototypeOf == "function")
    fa = Object.setPrototypeOf;
  else {
    var ha;
    a: {
      var ia = { a: true }, ja = {};
      try {
        ja.__proto__ = ia;
        ha = ja.a;
        break a;
      } catch (a) {
      }
      ha = false;
    }
    fa = ha ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var ka = fa;
  function M(a, b) {
    a.prototype = ea(b.prototype);
    a.prototype.constructor = a;
    if (ka)
      ka(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.ea = b.prototype;
  }
  function ma() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.s = this.m = 0;
    this.j = null;
  }
  function na(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  ma.prototype.o = function(a) {
    this.h = a;
  };
  function oa(a, b) {
    a.j = { U: b, V: true };
    a.g = a.m || a.s;
  }
  ma.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.s;
  };
  function N(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function pa(a) {
    this.g = new ma();
    this.h = a;
  }
  function qa(a, b) {
    na(a.g);
    var c = a.g.i;
    if (c)
      return ra(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return sa(a);
  }
  function ra(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, oa(a.g, f), sa(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return sa(a);
  }
  function sa(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, oa(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.V)
        throw b.U;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function ta(a) {
    this.next = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = sa(a));
      return b;
    };
    this.throw = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = sa(a));
      return b;
    };
    this.return = function(b) {
      return qa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function O(a, b) {
    b = new ta(new pa(b));
    ka && a.prototype && ka(b, a.prototype);
    return b;
  }
  function ua(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  J("Object.assign", function(a) {
    return a || va;
  });
  J("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.o = false;
      var h = this.j();
      try {
        f(h.resolve, h.reject);
      } catch (k) {
        h.reject(k);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(h) {
        h(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var h = this;
        this.i(function() {
          h.l();
        });
      }
      this.g.push(f);
    };
    var e = G.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var h = 0; h < f.length; ++h) {
          var k = f[h];
          f[h] = null;
          try {
            k();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(n) {
          k || (k = true, l.call(h, n));
        };
      }
      var h = this, k = false;
      return { resolve: f(this.C), reject: f(this.l) };
    };
    b.prototype.C = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.F(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var h = f != null;
              break a;
            case "function":
              h = true;
              break a;
            default:
              h = false;
          }
        h ? this.u(f) : this.m(f);
      }
    };
    b.prototype.u = function(f) {
      var h = void 0;
      try {
        h = f.then;
      } catch (k) {
        this.l(k);
        return;
      }
      typeof h == "function" ? this.G(h, f) : this.m(f);
    };
    b.prototype.l = function(f) {
      this.s(2, f);
    };
    b.prototype.m = function(f) {
      this.s(1, f);
    };
    b.prototype.s = function(f, h) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + h + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = h;
      this.h === 2 && this.D();
      this.A();
    };
    b.prototype.D = function() {
      var f = this;
      e(function() {
        if (f.B()) {
          var h = G.console;
          typeof h !== "undefined" && h.error(f.i);
        }
      }, 1);
    };
    b.prototype.B = function() {
      if (this.o)
        return false;
      var f = G.CustomEvent, h = G.Event, k = G.dispatchEvent;
      if (typeof k === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof h === "function" ? f = new h("unhandledrejection", { cancelable: true }) : (f = G.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return k(f);
    };
    b.prototype.A = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.F = function(f) {
      var h = this.j();
      f.J(h.resolve, h.reject);
    };
    b.prototype.G = function(f, h) {
      var k = this.j();
      try {
        f.call(h, k.resolve, k.reject);
      } catch (l) {
        k.reject(l);
      }
    };
    b.prototype.then = function(f, h) {
      function k(w, r) {
        return typeof w == "function" ? function(y) {
          try {
            l(w(y));
          } catch (m) {
            n(m);
          }
        } : r;
      }
      var l, n, u = new b(function(w, r) {
        l = w;
        n = r;
      });
      this.J(k(f, l), k(h, n));
      return u;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.J = function(f, h) {
      function k() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            h(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(k) : this.g.push(k);
      this.o = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(h, k) {
        k(f);
      });
    };
    b.race = function(f) {
      return new b(function(h, k) {
        for (var l = K(f), n = l.next(); !n.done; n = l.next())
          d(n.value).J(h, k);
      });
    };
    b.all = function(f) {
      var h = K(f), k = h.next();
      return k.done ? d([]) : new b(function(l, n) {
        function u(y) {
          return function(m) {
            w[y] = m;
            r--;
            r == 0 && l(w);
          };
        }
        var w = [], r = 0;
        do
          w.push(void 0), r++, d(k.value).J(u(w.length - 1), n), k = h.next();
        while (!k.done);
      });
    };
    return b;
  });
  J("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  J("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  J("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  J("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ua(this, function(b) {
        return b;
      });
    };
  });
  var wa = this || self;
  function P(a, b) {
    a = a.split(".");
    var c = wa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function xa(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var ya, za = typeof TextDecoder !== "undefined", Aa, Ba = typeof TextEncoder !== "undefined";
  function Ca(a) {
    if (Ba)
      a = (Aa || (Aa = new TextEncoder())).encode(a);
    else {
      var b = void 0;
      b = b === void 0 ? false : b;
      for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
        var g = a.charCodeAt(e);
        if (128 > g)
          d[c++] = g;
        else {
          if (2048 > g)
            d[c++] = g >> 6 | 192;
          else {
            if (55296 <= g && 57343 >= g) {
              if (56319 >= g && e < a.length) {
                var f = a.charCodeAt(++e);
                if (56320 <= f && 57343 >= f) {
                  g = 1024 * (g - 55296) + f - 56320 + 65536;
                  d[c++] = g >> 18 | 240;
                  d[c++] = g >> 12 & 63 | 128;
                  d[c++] = g >> 6 & 63 | 128;
                  d[c++] = g & 63 | 128;
                  continue;
                } else
                  e--;
              }
              if (b)
                throw Error("Found an unpaired surrogate");
              g = 65533;
            }
            d[c++] = g >> 12 | 224;
            d[c++] = g >> 6 & 63 | 128;
          }
          d[c++] = g & 63 | 128;
        }
      }
      a = d.subarray(0, c);
    }
    return a;
  }
  var Da = {}, Ea = null;
  function Fa(a, b) {
    b === void 0 && (b = 0);
    Ga();
    b = Da[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], h = a[e + 1], k = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | h >> 4];
      h = b[(h & 15) << 2 | k >> 6];
      k = b[k & 63];
      c[g++] = l + f + h + k;
    }
    l = 0;
    k = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], k = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + k + d;
    }
    return c.join("");
  }
  function Ha(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Ia(a, function(g) {
      d[e++] = g;
    });
    return d.subarray(0, e);
  }
  function Ia(a, b) {
    function c(k) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), n = Ea[l];
        if (n != null)
          return n;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return k;
    }
    Ga();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), h = c(64);
      if (h === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), h != 64 && b(f << 6 & 192 | h));
    }
  }
  function Ga() {
    if (!Ea) {
      Ea = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Da[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          Ea[g] === void 0 && (Ea[g] = e);
        }
      }
    }
  }
  var Ja = typeof Uint8Array.prototype.slice === "function", Ka;
  function La(a, b, c) {
    return b === c ? Ka || (Ka = new Uint8Array(0)) : Ja ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
  }
  var Q = 0, R = 0;
  function Ma(a, b) {
    b = b === void 0 ? {} : b;
    b = b.v === void 0 ? false : b.v;
    this.h = null;
    this.g = this.j = this.l = 0;
    this.m = false;
    this.v = b;
    a && Na(this, a);
  }
  function Na(a, b) {
    b = b.constructor === Uint8Array ? b : b.constructor === ArrayBuffer ? new Uint8Array(b) : b.constructor === Array ? new Uint8Array(b) : b.constructor === String ? Ha(b) : b instanceof Uint8Array ? new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : new Uint8Array(0);
    a.h = b;
    a.l = 0;
    a.j = a.h.length;
    a.g = a.l;
  }
  Ma.prototype.reset = function() {
    this.g = this.l;
  };
  function Oa(a) {
    for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)
      b = a.h[a.g++], c |= (b & 127) << 7 * e;
    128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b)
      for (e = 0; 5 > e && 128 <= b; e++)
        b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
    if (128 > b) {
      a = c >>> 0;
      b = d >>> 0;
      if (d = b & 2147483648)
        a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
      a = 4294967296 * b + (a >>> 0);
      return d ? -a : a;
    }
    a.m = true;
  }
  Ma.prototype.i = function() {
    var a = this.h, b = a[this.g], c = b & 127;
    if (128 > b)
      return this.g += 1, c;
    b = a[this.g + 1];
    c |= (b & 127) << 7;
    if (128 > b)
      return this.g += 2, c;
    b = a[this.g + 2];
    c |= (b & 127) << 14;
    if (128 > b)
      return this.g += 3, c;
    b = a[this.g + 3];
    c |= (b & 127) << 21;
    if (128 > b)
      return this.g += 4, c;
    b = a[this.g + 4];
    c |= (b & 15) << 28;
    if (128 > b)
      return this.g += 5, c >>> 0;
    this.g += 5;
    128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && 128 <= a[this.g++] && this.g++;
    return c;
  };
  Ma.prototype.o = function() {
    var a = this.h[this.g], b = this.h[this.g + 1];
    var c = this.h[this.g + 2];
    var d = this.h[this.g + 3];
    this.g += 4;
    c = (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
    a = 2 * (c >> 31) + 1;
    b = c >>> 23 & 255;
    c &= 8388607;
    return b == 255 ? c ? NaN : Infinity * a : b == 0 ? a * Math.pow(2, -149) * c : a * Math.pow(2, b - 150) * (c + Math.pow(2, 23));
  };
  var Pa = [];
  function Qa() {
    this.g = new Uint8Array(64);
    this.h = 0;
  }
  Qa.prototype.push = function(a) {
    if (!(this.h + 1 < this.g.length)) {
      var b = this.g;
      this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length));
      this.g.set(b);
    }
    this.g[this.h++] = a;
  };
  Qa.prototype.length = function() {
    return this.h;
  };
  Qa.prototype.end = function() {
    var a = this.g, b = this.h;
    this.h = 0;
    return La(a, 0, b);
  };
  function Ra(a, b) {
    for (; 127 < b; )
      a.push(b & 127 | 128), b >>>= 7;
    a.push(b);
  }
  function Sa(a) {
    var b = {}, c = b.N === void 0 ? false : b.N;
    this.o = { v: b.v === void 0 ? false : b.v };
    this.N = c;
    b = this.o;
    Pa.length ? (c = Pa.pop(), b && (c.v = b.v), a && Na(c, a), a = c) : a = new Ma(a, b);
    this.g = a;
    this.m = this.g.g;
    this.h = this.i = this.l = -1;
    this.j = false;
  }
  Sa.prototype.reset = function() {
    this.g.reset();
    this.h = this.l = -1;
  };
  function S(a) {
    var b = a.g;
    (b = b.g == b.j) || (b = a.j) || (b = a.g, b = b.m || 0 > b.g || b.g > b.j);
    if (b)
      return false;
    a.m = a.g.g;
    b = a.g.i();
    var c = b & 7;
    if (c != 0 && c != 5 && c != 1 && c != 2 && c != 3 && c != 4)
      return a.j = true, false;
    a.i = b;
    a.l = b >>> 3;
    a.h = c;
    return true;
  }
  function Ta(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Ta(a);
        else {
          for (a = a.g; a.h[a.g] & 128; )
            a.g++;
          a.g++;
        }
        break;
      case 1:
        a.h != 1 ? Ta(a) : (a = a.g, a.g += 8);
        break;
      case 2:
        if (a.h != 2)
          Ta(a);
        else {
          var b = a.g.i();
          a = a.g;
          a.g += b;
        }
        break;
      case 5:
        a.h != 5 ? Ta(a) : (a = a.g, a.g += 4);
        break;
      case 3:
        b = a.l;
        do {
          if (!S(a)) {
            a.j = true;
            break;
          }
          if (a.h == 4) {
            a.l != b && (a.j = true);
            break;
          }
          Ta(a);
        } while (1);
        break;
      default:
        a.j = true;
    }
  }
  function Ua(a, b, c) {
    var d = a.g.j, e = a.g.i(), g = a.g.g + e;
    a.g.j = g;
    c(b, a);
    c = g - a.g.g;
    if (c !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length");
    a.g.g = g;
    a.g.j = d;
    return b;
  }
  function T(a) {
    return a.g.o();
  }
  function Va(a) {
    var b = a.g.i();
    a = a.g;
    var c = a.g;
    a.g += b;
    a = a.h;
    var d;
    if (za)
      (d = ya) || (d = ya = new TextDecoder("utf-8", { fatal: false })), d = d.decode(a.subarray(c, c + b));
    else {
      b = c + b;
      for (var e = [], g = null, f, h, k; c < b; )
        f = a[c++], 128 > f ? e.push(f) : 224 > f ? c >= b ? e.push(65533) : (h = a[c++], 194 > f || (h & 192) !== 128 ? (c--, e.push(65533)) : e.push((f & 31) << 6 | h & 63)) : 240 > f ? c >= b - 1 ? e.push(65533) : (h = a[c++], (h & 192) !== 128 || f === 224 && 160 > h || f === 237 && 160 <= h || ((d = a[c++]) & 192) !== 128 ? (c--, e.push(65533)) : e.push((f & 15) << 12 | (h & 63) << 6 | d & 63)) : 244 >= f ? c >= b - 2 ? e.push(65533) : (h = a[c++], (h & 192) !== 128 || (f << 28) + (h - 144) >> 30 !== 0 || ((d = a[c++]) & 192) !== 128 || ((k = a[c++]) & 192) !== 128 ? (c--, e.push(65533)) : (f = (f & 7) << 18 | (h & 63) << 12 | (d & 63) << 6 | k & 63, f -= 65536, e.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320))) : e.push(65533), 8192 <= e.length && (g = xa(g, e), e.length = 0);
      d = xa(g, e);
    }
    return d;
  }
  function Wa(a, b, c) {
    var d = a.g.i();
    for (d = a.g.g + d; a.g.g < d; )
      c.push(b.call(a.g));
  }
  function Xa(a, b) {
    a.h == 2 ? Wa(a, Ma.prototype.o, b) : b.push(T(a));
  }
  function Ya() {
    this.h = [];
    this.i = 0;
    this.g = new Qa();
  }
  function Za(a, b) {
    b.length !== 0 && (a.h.push(b), a.i += b.length);
  }
  function $a(a) {
    var b = a.i + a.g.length();
    if (b === 0)
      return new Uint8Array(0);
    b = new Uint8Array(b);
    for (var c = a.h, d = c.length, e = 0, g = 0; g < d; g++) {
      var f = c[g];
      f.length !== 0 && (b.set(f, e), e += f.length);
    }
    c = a.g;
    d = c.h;
    d !== 0 && (b.set(c.g.subarray(0, d), e), c.h = 0);
    a.h = [b];
    return b;
  }
  function U(a, b, c) {
    if (c != null) {
      Ra(a.g, 8 * b + 5);
      a = a.g;
      var d = c;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? Q = R = 0 : (R = 0, Q = 2147483648) : isNaN(d) ? (R = 0, Q = 2147483647) : 34028234663852886e22 < d ? (R = 0, Q = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), R = 0, Q = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, R = 0, Q = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = Q;
      a.push(c >>> 0 & 255);
      a.push(c >>> 8 & 255);
      a.push(c >>> 16 & 255);
      a.push(c >>> 24 & 255);
    }
  }
  var ab = typeof Uint8Array === "function";
  function bb(a, b, c) {
    if (a != null)
      return typeof a === "object" ? ab && a instanceof Uint8Array ? c(a) : cb(a, b, c) : b(a);
  }
  function cb(a, b, c) {
    if (Array.isArray(a)) {
      for (var d = Array(a.length), e = 0; e < a.length; e++)
        d[e] = bb(a[e], b, c);
      Array.isArray(a) && a.W && db(d);
      return d;
    }
    d = {};
    for (e in a)
      d[e] = bb(a[e], b, c);
    return d;
  }
  function eb(a) {
    return typeof a === "number" ? isFinite(a) ? a : String(a) : a;
  }
  var fb = { W: { value: true, configurable: true } };
  function db(a) {
    Array.isArray(a) && !Object.isFrozen(a) && Object.defineProperties(a, fb);
    return a;
  }
  var gb;
  function V(a, b, c) {
    var d = gb;
    gb = null;
    a || (a = d);
    d = this.constructor.ca;
    a || (a = d ? [d] : []);
    this.j = d ? 0 : -1;
    this.m = this.g = null;
    this.h = a;
    a: {
      d = this.h.length;
      a = d - 1;
      if (d && (d = this.h[a], !(d === null || typeof d != "object" || Array.isArray(d) || ab && d instanceof Uint8Array))) {
        this.l = a - this.j;
        this.i = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        a = c[b], a < this.l ? (a += this.j, (d = this.h[a]) ? db(d) : this.h[a] = hb) : (ib(this), (d = this.i[a]) ? db(d) : this.i[a] = hb);
  }
  var hb = Object.freeze(db([]));
  function ib(a) {
    var b = a.l + a.j;
    a.h[b] || (a.i = a.h[b] = {});
  }
  function W(a, b, c) {
    return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.i ? a.i[b] : void 0 : a.h[b + a.j];
  }
  function jb(a, b) {
    var c = c === void 0 ? false : c;
    var d = W(a, b, c);
    d == null && (d = hb);
    d === hb && (d = db([]), X(a, b, d, c));
    return d;
  }
  function kb(a) {
    var b = jb(a, 3);
    a.m || (a.m = {});
    if (!a.m[3]) {
      for (var c = 0; c < b.length; c++)
        b[c] = +b[c];
      a.m[3] = true;
    }
    return b;
  }
  function lb(a, b, c) {
    a = W(a, b);
    return a == null ? c : a;
  }
  function Y(a, b, c) {
    a = W(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function X(a, b, c, d) {
    (d === void 0 ? 0 : d) || b >= a.l ? (ib(a), a.i[b] = c) : a.h[b + a.j] = c;
  }
  function mb(a, b, c) {
    if (c === -1)
      return null;
    a.g || (a.g = {});
    if (!a.g[c]) {
      var d = W(a, c, false);
      d && (a.g[c] = new b(d));
    }
    return a.g[c];
  }
  function nb(a, b) {
    a.g || (a.g = {});
    var c = a.g[1];
    if (!c) {
      var d = jb(a, 1);
      c = [];
      for (var e = 0; e < d.length; e++)
        c[e] = new b(d[e]);
      a.g[1] = c;
    }
    return c;
  }
  function ob(a, b, c) {
    var d = d === void 0 ? false : d;
    a.g || (a.g = {});
    var e = c ? pb(c) : c;
    a.g[b] = c;
    X(a, b, e, d);
  }
  function qb(a, b, c, d) {
    var e = nb(a, c);
    b = b ? b : new c();
    a = jb(a, 1);
    d != void 0 ? (e.splice(d, 0, b), a.splice(d, 0, pb(b))) : (e.push(b), a.push(pb(b)));
  }
  V.prototype.toJSON = function() {
    var a = pb(this);
    return cb(a, eb, Fa);
  };
  function pb(a, b) {
    if (a.g)
      for (var c in a.g) {
        var d = a.g[c];
        if (Array.isArray(d))
          for (var e = 0; e < d.length; e++)
            d[e] && pb(d[e]);
        else
          d && pb(d);
      }
    return a.h;
  }
  V.prototype.toString = function() {
    return pb(this).toString();
  };
  function rb(a, b) {
    if (a = a.o) {
      Za(b, b.g.end());
      for (var c = 0; c < a.length; c++)
        Za(b, a[c]);
    }
  }
  function sb(a, b) {
    if (b.h == 4)
      return false;
    var c = b.m;
    Ta(b);
    b.N || (b = La(b.g.h, c, b.g.g), (c = a.o) ? c.push(b) : a.o = [b]);
    return true;
  }
  function tb(a) {
    V.call(this, a, -1, ub);
  }
  M(tb, V);
  tb.prototype.getRows = function() {
    return W(this, 1);
  };
  tb.prototype.getCols = function() {
    return W(this, 2);
  };
  tb.prototype.getPackedDataList = function() {
    return kb(this);
  };
  tb.prototype.getLayout = function() {
    return lb(this, 4, 0);
  };
  function vb(a, b) {
    for (; S(b); )
      switch (b.i) {
        case 8:
          var c = b.g.i();
          X(a, 1, c);
          break;
        case 16:
          c = b.g.i();
          X(a, 2, c);
          break;
        case 29:
        case 26:
          Xa(b, a.getPackedDataList());
          break;
        case 32:
          c = Oa(b.g);
          X(a, 4, c);
          break;
        default:
          if (!sb(a, b))
            return a;
      }
    return a;
  }
  var ub = [3];
  function Z(a, b) {
    var c = void 0;
    return new (c || (c = Promise))(function(d, e) {
      function g(k) {
        try {
          h(b.next(k));
        } catch (l) {
          e(l);
        }
      }
      function f(k) {
        try {
          h(b["throw"](k));
        } catch (l) {
          e(l);
        }
      }
      function h(k) {
        k.done ? d(k.value) : new c(function(l) {
          l(k.value);
        }).then(g, f);
      }
      h((b = b.apply(a, void 0)).next());
    });
  }
  function wb(a) {
    V.call(this, a);
  }
  M(wb, V);
  function xb(a, b) {
    for (; S(b); )
      switch (b.i) {
        case 8:
          var c = b.g.i();
          X(a, 1, c);
          break;
        case 21:
          c = T(b);
          X(a, 2, c);
          break;
        case 26:
          c = Va(b);
          X(a, 3, c);
          break;
        case 34:
          c = Va(b);
          X(a, 4, c);
          break;
        default:
          if (!sb(a, b))
            return a;
      }
    return a;
  }
  function yb(a) {
    V.call(this, a, -1, zb);
  }
  M(yb, V);
  yb.prototype.addClassification = function(a, b) {
    qb(this, a, wb, b);
    return this;
  };
  var zb = [1];
  function Ab(a) {
    V.call(this, a);
  }
  M(Ab, V);
  function Bb(a, b) {
    for (; S(b); )
      switch (b.i) {
        case 13:
          var c = T(b);
          X(a, 1, c);
          break;
        case 21:
          c = T(b);
          X(a, 2, c);
          break;
        case 29:
          c = T(b);
          X(a, 3, c);
          break;
        case 37:
          c = T(b);
          X(a, 4, c);
          break;
        case 45:
          c = T(b);
          X(a, 5, c);
          break;
        default:
          if (!sb(a, b))
            return a;
      }
    return a;
  }
  function Cb(a) {
    V.call(this, a, -1, Db);
  }
  M(Cb, V);
  function Eb(a) {
    a: {
      var b = new Cb();
      for (a = new Sa(a); S(a); )
        switch (a.i) {
          case 10:
            var c = Ua(a, new Ab(), Bb);
            qb(b, c, Ab, void 0);
            break;
          default:
            if (!sb(b, a))
              break a;
        }
    }
    return b;
  }
  var Db = [1];
  function Fb(a) {
    V.call(this, a);
  }
  M(Fb, V);
  function Gb(a) {
    V.call(this, a, -1, Hb);
  }
  M(Gb, V);
  Gb.prototype.getVertexType = function() {
    return lb(this, 1, 0);
  };
  Gb.prototype.getPrimitiveType = function() {
    return lb(this, 2, 0);
  };
  Gb.prototype.getVertexBufferList = function() {
    return kb(this);
  };
  Gb.prototype.getIndexBufferList = function() {
    return jb(this, 4);
  };
  function Ib(a, b) {
    for (; S(b); )
      switch (b.i) {
        case 8:
          var c = Oa(b.g);
          X(a, 1, c);
          break;
        case 16:
          c = Oa(b.g);
          X(a, 2, c);
          break;
        case 29:
        case 26:
          Xa(b, a.getVertexBufferList());
          break;
        case 32:
        case 34:
          c = b;
          var d = a.getIndexBufferList();
          c.h == 2 ? Wa(c, Ma.prototype.i, d) : d.push(c.g.i());
          break;
        default:
          if (!sb(a, b))
            return a;
      }
    return a;
  }
  var Hb = [3, 4];
  function Jb(a) {
    V.call(this, a);
  }
  M(Jb, V);
  Jb.prototype.getMesh = function() {
    return mb(this, Gb, 1);
  };
  Jb.prototype.getPoseTransformMatrix = function() {
    return mb(this, tb, 2);
  };
  function Kb(a) {
    a: {
      var b = new Jb();
      for (a = new Sa(a); S(a); )
        switch (a.i) {
          case 10:
            var c = Ua(a, new Gb(), Ib);
            ob(b, 1, c);
            break;
          case 18:
            c = Ua(a, new tb(), vb);
            ob(b, 2, c);
            break;
          default:
            if (!sb(b, a))
              break a;
        }
    }
    return b;
  }
  function Lb(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function Mb(a) {
    return nb(a, wb).map(function(b) {
      return { index: lb(b, 1, 0), Y: Y(b, 2), label: W(b, 3) != null ? lb(b, 3, "") : void 0, displayName: W(b, 4) != null ? lb(b, 4, "") : void 0 };
    });
  }
  function Nb(a) {
    return { x: Y(a, 1), y: Y(a, 2), z: Y(a, 3), visibility: W(a, 4) != null ? Y(a, 4) : void 0 };
  }
  function Ob(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function Pb(a, b, c) {
    Qb(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function Qb(a, b) {
    var c = a.g;
    if (a.m === void 0) {
      var d = Lb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Lb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.m = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { I: c.getAttribLocation(d, "aVertex"), H: c.getAttribLocation(d, "aTex"), da: e };
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.I);
      c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.o = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.o);
      c.enableVertexAttribArray(a.j.H);
      c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.m);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, a.o);
    c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.I);
    c.disableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function Rb(a) {
    this.g = a;
  }
  var Sb = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Tb(a, b) {
    return b + a;
  }
  function Ub(a, b) {
    window[a] = b;
  }
  function Vb(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Wb() {
    return Z(this, function b() {
      return O(b, function(c) {
        switch (c.g) {
          case 1:
            return c.m = 2, N(c, WebAssembly.instantiate(Sb), 4);
          case 4:
            c.g = 3;
            c.m = 0;
            break;
          case 2:
            return c.m = 0, c.j = null, c.return(false);
          case 3:
            return c.return(true);
        }
      });
    });
  }
  function Xb(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.F = {};
    this.m = {};
    this.s = {};
    this.G = this.o = this.R = true;
    this.C = Promise.resolve();
    this.P = "";
    this.B = {};
    this.locateFile = a && a.locateFile || Tb;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.S = b;
    if (a.options) {
      b = K(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  v = Xb.prototype;
  v.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Yb(a, b) {
    return a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(b) : a.g.files;
  }
  function Zb(a) {
    return Z(a, function c() {
      var d = this, e, g, f, h, k, l, n, u, w, r, y;
      return O(c, function(m) {
        switch (m.g) {
          case 1:
            e = d;
            if (!d.R)
              return m.return();
            g = Yb(d, d.j);
            return N(m, Wb(), 2);
          case 2:
            f = m.h;
            if (typeof window === "object")
              return Ub("createMediapipeSolutionsWasm", { locateFile: d.locateFile }), Ub("createMediapipeSolutionsPackedAssets", { locateFile: d.locateFile }), l = g.filter(function(t) {
                return t.data !== void 0;
              }), n = g.filter(function(t) {
                return t.data === void 0;
              }), u = Promise.all(l.map(function(t) {
                var x = $b(e, t.url);
                if (t.path !== void 0) {
                  var z = t.path;
                  x = x.then(function(E) {
                    e.overrideFile(z, E);
                    return Promise.resolve(E);
                  });
                }
                return x;
              })), w = Promise.all(n.map(function(t) {
                return t.simd === void 0 || t.simd && f || !t.simd && !f ? Vb(e.locateFile(t.url, e.S)) : Promise.resolve();
              })).then(function() {
                return Z(e, function x() {
                  var z, E, F = this;
                  return O(x, function(I) {
                    if (I.g == 1)
                      return z = window.createMediapipeSolutionsWasm, E = window.createMediapipeSolutionsPackedAssets, N(I, z(E), 2);
                    F.h = I.h;
                    I.g = 0;
                  });
                });
              }), r = function() {
                return Z(e, function x() {
                  var z = this;
                  return O(x, function(E) {
                    z.g.graph && z.g.graph.url ? E = N(E, $b(z, z.g.graph.url), 0) : (E.g = 0, E = void 0);
                    return E;
                  });
                });
              }(), N(m, Promise.all([w, u, r]), 7);
            if (typeof importScripts !== "function")
              throw Error("solutions can only be loaded on a web page or in a web worker");
            h = g.filter(function(t) {
              return t.simd === void 0 || t.simd && f || !t.simd && !f;
            }).map(function(t) {
              return e.locateFile(t.url, e.S);
            });
            importScripts.apply(null, L(h));
            return N(m, createMediapipeSolutionsWasm(Module), 6);
          case 6:
            d.h = m.h;
            d.l = new OffscreenCanvas(1, 1);
            d.h.canvas = d.l;
            k = d.h.GL.createContext(d.l, { antialias: false, alpha: false, ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1 });
            d.h.GL.makeContextCurrent(k);
            m.g = 4;
            break;
          case 7:
            d.l = document.createElement("canvas");
            y = d.l.getContext("webgl2", {});
            if (!y && (y = d.l.getContext("webgl", {}), !y))
              return alert("Failed to create WebGL canvas context when passing video frame."), m.return();
            d.D = y;
            d.h.canvas = d.l;
            d.h.createContext(d.l, true, true, {});
          case 4:
            d.i = new d.h.SolutionWasm(), d.R = false, m.g = 0;
        }
      });
    });
  }
  function ac(a) {
    return Z(a, function c() {
      var d = this, e, g, f, h, k, l, n, u;
      return O(c, function(w) {
        if (w.g == 1) {
          if (d.g.graph && d.g.graph.url && d.P === d.g.graph.url)
            return w.return();
          d.o = true;
          if (!d.g.graph || !d.g.graph.url) {
            w.g = 2;
            return;
          }
          d.P = d.g.graph.url;
          return N(w, $b(d, d.g.graph.url), 3);
        }
        w.g != 2 && (e = w.h, d.i.loadGraph(e));
        g = K(Object.keys(d.B));
        for (f = g.next(); !f.done; f = g.next())
          h = f.value, d.i.overrideFile(h, d.B[h]);
        d.B = {};
        if (d.g.listeners)
          for (k = K(d.g.listeners), l = k.next(); !l.done; l = k.next())
            n = l.value, bc(d, n);
        u = d.j;
        d.j = {};
        d.setOptions(u);
        w.g = 0;
      });
    });
  }
  v.reset = function() {
    return Z(this, function b() {
      var c = this;
      return O(b, function(d) {
        c.i && (c.i.reset(), c.m = {}, c.s = {});
        d.g = 0;
      });
    });
  };
  v.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = K(Object.keys(a)), h = f.next(); !h.done; g = { K: g.K, L: g.L }, h = f.next()) {
        var k = h.value;
        k in this.j && this.j[k] === a[k] || (this.j[k] = a[k], h = b[k], h !== void 0 && (h.onChange && (g.K = h.onChange, g.L = a[k], d.push(function(l) {
          return function() {
            return Z(c, function u() {
              var w, r = this;
              return O(u, function(y) {
                if (y.g == 1)
                  return N(y, l.K(l.L), 2);
                w = y.h;
                w === true && (r.o = true);
                y.g = 0;
              });
            });
          };
        }(g))), h.graphOptionXref && (k = { valueNumber: h.type === 1 ? a[k] : 0, valueBoolean: h.type === 0 ? a[k] : false, valueString: h.type === 2 ? a[k] : "" }, h = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), h.graphOptionXref), k), e.push(h))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.u = (this.u === void 0 ? [] : this.u).concat(d);
    }
  };
  function cc(a) {
    return Z(a, function c() {
      var d = this, e, g, f, h, k, l, n;
      return O(c, function(u) {
        switch (u.g) {
          case 1:
            if (!d.o)
              return u.return();
            if (!d.u) {
              u.g = 2;
              break;
            }
            e = K(d.u);
            g = e.next();
          case 3:
            if (g.done) {
              u.g = 5;
              break;
            }
            f = g.value;
            return N(u, f(), 4);
          case 4:
            g = e.next();
            u.g = 3;
            break;
          case 5:
            d.u = void 0;
          case 2:
            if (d.A) {
              h = new d.h.GraphOptionChangeRequestList();
              k = K(d.A);
              for (l = k.next(); !l.done; l = k.next())
                n = l.value, h.push_back(n);
              d.i.changeOptions(h);
              h.delete();
              d.A = void 0;
            }
            d.o = false;
            u.g = 0;
        }
      });
    });
  }
  v.initialize = function() {
    return Z(this, function b() {
      var c = this;
      return O(b, function(d) {
        return d.g == 1 ? N(d, Zb(c), 2) : d.g != 3 ? N(d, ac(c), 3) : N(d, cc(c), 0);
      });
    });
  };
  function $b(a, b) {
    return Z(a, function d() {
      var e = this, g, f;
      return O(d, function(h) {
        if (b in e.F)
          return h.return(e.F[b]);
        g = e.locateFile(b, "");
        f = fetch(g).then(function(k) {
          return k.arrayBuffer();
        });
        e.F[b] = f;
        return h.return(f);
      });
    });
  }
  v.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
  };
  v.clearOverriddenFiles = function() {
    this.B = {};
    this.i && this.i.clearOverriddenFiles();
  };
  v.send = function(a, b) {
    return Z(this, function d() {
      var e = this, g, f, h, k, l, n, u, w, r;
      return O(d, function(y) {
        switch (y.g) {
          case 1:
            if (!e.g.inputs)
              return y.return();
            g = 1e3 * (b === void 0 || b === null ? performance.now() : b);
            return N(y, e.C, 2);
          case 2:
            return N(y, e.initialize(), 3);
          case 3:
            f = new e.h.PacketDataList();
            h = K(Object.keys(a));
            for (k = h.next(); !k.done; k = h.next())
              if (l = k.value, n = e.g.inputs[l]) {
                a: {
                  var m = e;
                  var t = a[l];
                  switch (n.type) {
                    case "video":
                      var x = m.m[n.stream];
                      x || (x = new Ob(m.h, m.D), m.m[n.stream] = x);
                      m = x;
                      m.l === 0 && (m.l = m.h.createTexture());
                      if (typeof HTMLVideoElement !== "undefined" && t instanceof HTMLVideoElement) {
                        var z = t.videoWidth;
                        x = t.videoHeight;
                      } else
                        typeof HTMLImageElement !== "undefined" && t instanceof HTMLImageElement ? (z = t.naturalWidth, x = t.naturalHeight) : (z = t.width, x = t.height);
                      x = { glName: m.l, width: z, height: x };
                      z = m.g;
                      z.canvas.width = x.width;
                      z.canvas.height = x.height;
                      z.activeTexture(z.TEXTURE0);
                      m.h.bindTexture2d(m.l);
                      z.texImage2D(z.TEXTURE_2D, 0, z.RGBA, z.RGBA, z.UNSIGNED_BYTE, t);
                      m.h.bindTexture2d(0);
                      m = x;
                      break a;
                    case "detections":
                      x = m.m[n.stream];
                      x || (x = new Rb(m.h), m.m[n.stream] = x);
                      m = x;
                      m.data || (m.data = new m.g.DetectionListData());
                      m.data.reset(t.length);
                      for (x = 0; x < t.length; ++x) {
                        z = t[x];
                        var E = m.data, F = E.setBoundingBox, I = x;
                        var H = z.T;
                        var p = new Fb();
                        X(p, 1, H.Z);
                        X(p, 2, H.$);
                        X(p, 3, H.height);
                        X(p, 4, H.width);
                        X(p, 5, H.rotation);
                        X(p, 6, H.X);
                        var A = H = new Ya();
                        U(A, 1, W(p, 1));
                        U(A, 2, W(p, 2));
                        U(A, 3, W(p, 3));
                        U(A, 4, W(p, 4));
                        U(A, 5, W(p, 5));
                        var C = W(p, 6);
                        if (C != null && C != null) {
                          Ra(A.g, 48);
                          var q = A.g, B = C;
                          C = 0 > B;
                          B = Math.abs(B);
                          var D = B >>> 0;
                          B = Math.floor((B - D) / 4294967296);
                          B >>>= 0;
                          C && (B = ~B >>> 0, D = (~D >>> 0) + 1, 4294967295 < D && (D = 0, B++, 4294967295 < B && (B = 0)));
                          Q = D;
                          R = B;
                          C = Q;
                          for (D = R; 0 < D || 127 < C; )
                            q.push(C & 127 | 128), C = (C >>> 7 | D << 25) >>> 0, D >>>= 7;
                          q.push(C);
                        }
                        rb(p, A);
                        H = $a(H);
                        F.call(E, I, H);
                        if (z.O)
                          for (E = 0; E < z.O.length; ++E)
                            p = z.O[E], A = p.visibility ? true : false, F = m.data, I = F.addNormalizedLandmark, H = x, p = Object.assign(Object.assign({}, p), { visibility: A ? p.visibility : 0 }), A = new Ab(), X(A, 1, p.x), X(A, 2, p.y), X(A, 3, p.z), p.visibility && X(A, 4, p.visibility), q = p = new Ya(), U(q, 1, W(A, 1)), U(q, 2, W(A, 2)), U(q, 3, W(A, 3)), U(q, 4, W(A, 4)), U(q, 5, W(A, 5)), rb(A, q), p = $a(p), I.call(F, H, p);
                        if (z.M)
                          for (E = 0; E < z.M.length; ++E) {
                            F = m.data;
                            I = F.addClassification;
                            H = x;
                            p = z.M[E];
                            A = new wb();
                            X(A, 2, p.Y);
                            p.index && X(A, 1, p.index);
                            p.label && X(A, 3, p.label);
                            p.displayName && X(A, 4, p.displayName);
                            q = p = new Ya();
                            D = W(A, 1);
                            if (D != null && D != null)
                              if (Ra(q.g, 8), C = q.g, 0 <= D)
                                Ra(C, D);
                              else {
                                for (B = 0; 9 > B; B++)
                                  C.push(D & 127 | 128), D >>= 7;
                                C.push(1);
                              }
                            U(q, 2, W(A, 2));
                            C = W(A, 3);
                            C != null && (C = Ca(C), Ra(q.g, 26), Ra(q.g, C.length), Za(q, q.g.end()), Za(q, C));
                            C = W(A, 4);
                            C != null && (C = Ca(C), Ra(q.g, 34), Ra(q.g, C.length), Za(q, q.g.end()), Za(q, C));
                            rb(A, q);
                            p = $a(p);
                            I.call(F, H, p);
                          }
                      }
                      m = m.data;
                      break a;
                    default:
                      m = {};
                  }
                }
                u = m;
                w = n.stream;
                switch (n.type) {
                  case "video":
                    f.pushTexture2d(Object.assign(Object.assign({}, u), { stream: w, timestamp: g }));
                    break;
                  case "detections":
                    r = u;
                    r.stream = w;
                    r.timestamp = g;
                    f.pushDetectionList(r);
                    break;
                  default:
                    throw Error("Unknown input config type: '" + n.type + "'");
                }
              }
            e.i.send(f);
            return N(y, e.C, 4);
          case 4:
            f.delete(), y.g = 0;
        }
      });
    });
  };
  function dc(a, b, c) {
    return Z(a, function e() {
      var g, f, h, k, l, n, u = this, w, r, y, m, t, x, z, E;
      return O(e, function(F) {
        switch (F.g) {
          case 1:
            if (!c)
              return F.return(b);
            g = {};
            f = 0;
            h = K(Object.keys(c));
            for (k = h.next(); !k.done; k = h.next())
              l = k.value, n = c[l], typeof n !== "string" && n.type === "texture" && b[n.stream] !== void 0 && ++f;
            1 < f && (u.G = false);
            w = K(Object.keys(c));
            k = w.next();
          case 2:
            if (k.done) {
              F.g = 4;
              break;
            }
            r = k.value;
            y = c[r];
            if (typeof y === "string")
              return z = g, E = r, N(F, ec(u, r, b[y]), 14);
            m = b[y.stream];
            if (y.type === "detection_list") {
              if (m) {
                var I = m.getRectList();
                for (var H = m.getLandmarksList(), p = m.getClassificationsList(), A = [], C = 0; C < I.size(); ++C) {
                  var q = I.get(C);
                  a: {
                    var B = new Fb();
                    for (q = new Sa(q); S(q); )
                      switch (q.i) {
                        case 13:
                          var D = T(q);
                          X(B, 1, D);
                          break;
                        case 21:
                          D = T(q);
                          X(B, 2, D);
                          break;
                        case 29:
                          D = T(q);
                          X(B, 3, D);
                          break;
                        case 37:
                          D = T(q);
                          X(B, 4, D);
                          break;
                        case 45:
                          D = T(q);
                          X(B, 5, D);
                          break;
                        case 48:
                          D = Oa(q.g);
                          X(B, 6, D);
                          break;
                        default:
                          if (!sb(B, q))
                            break a;
                      }
                  }
                  B = { Z: Y(B, 1), $: Y(B, 2), height: Y(B, 3), width: Y(B, 4), rotation: Y(B, 5, 0), X: lb(B, 6, 0) };
                  q = nb(Eb(H.get(C)), Ab).map(Nb);
                  var la = p.get(C);
                  a:
                    for (D = new yb(), la = new Sa(la); S(la); )
                      switch (la.i) {
                        case 10:
                          D.addClassification(Ua(la, new wb(), xb));
                          break;
                        default:
                          if (!sb(D, la))
                            break a;
                      }
                  B = { T: B, O: q, M: Mb(D) };
                  A.push(B);
                }
                I = A;
              } else
                I = [];
              g[r] = I;
              F.g = 7;
              break;
            }
            if (y.type === "proto_list") {
              if (m) {
                I = Array(m.size());
                for (H = 0; H < m.size(); H++)
                  I[H] = m.get(H);
                m.delete();
              } else
                I = [];
              g[r] = I;
              F.g = 7;
              break;
            }
            if (m === void 0) {
              F.g = 3;
              break;
            }
            if (y.type === "float_list") {
              g[r] = m;
              F.g = 7;
              break;
            }
            if (y.type === "proto") {
              g[r] = m;
              F.g = 7;
              break;
            }
            if (y.type !== "texture")
              throw Error("Unknown output config type: '" + y.type + "'");
            t = u.s[r];
            t || (t = new Ob(u.h, u.D), u.s[r] = t);
            return N(F, Pb(t, m, u.G), 13);
          case 13:
            x = F.h, g[r] = x;
          case 7:
            y.transform && g[r] && (g[r] = y.transform(g[r]));
            F.g = 3;
            break;
          case 14:
            z[E] = F.h;
          case 3:
            k = w.next();
            F.g = 2;
            break;
          case 4:
            return F.return(g);
        }
      });
    });
  }
  function ec(a, b, c) {
    return Z(a, function e() {
      var g = this, f;
      return O(e, function(h) {
        return typeof c === "number" || c instanceof Uint8Array || c instanceof g.h.Uint8BlobList ? h.return(c) : c instanceof g.h.Texture2dDataOut ? (f = g.s[b], f || (f = new Ob(g.h, g.D), g.s[b] = f), h.return(Pb(f, c, g.G))) : h.return(void 0);
      });
    });
  }
  function bc(a, b) {
    for (var c = b.name || "$", d = [].concat(L(b.wants)), e = new a.h.StringList(), g = K(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(h) {
      for (var k = {}, l = 0; l < b.wants.length; ++l)
        k[d[l]] = h.get(l);
      var n = a.listeners[c];
      n && (a.C = dc(a, k, b.outs).then(function(u) {
        u = n(u);
        for (var w = 0; w < b.wants.length; ++w) {
          var r = k[d[w]];
          typeof r === "object" && r.hasOwnProperty && r.hasOwnProperty("delete") && r.delete();
        }
        u && (a.C = u);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  v.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  P("Solution", Xb);
  P("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function fc(a) {
    a = Kb(a);
    var b = a.getMesh();
    if (!b)
      return a;
    var c = new Float32Array(b.getVertexBufferList());
    b.getVertexBufferList = function() {
      return c;
    };
    var d = new Uint32Array(b.getIndexBufferList());
    b.getIndexBufferList = function() {
      return d;
    };
    return a;
  }
  var gc = { files: [{ url: "face_mesh_solution_packed_assets_loader.js" }, { simd: true, url: "face_mesh_solution_simd_wasm_bin.js" }, { simd: false, url: "face_mesh_solution_wasm_bin.js" }], graph: { url: "face_mesh.binarypb" }, listeners: [{ wants: ["multi_face_geometry", "image_transformed", "multi_face_landmarks"], outs: { image: "image_transformed", multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: function(a) {
    return a.map(fc);
  } }, multiFaceLandmarks: { type: "proto_list", stream: "multi_face_landmarks", transform: function(a) {
    return a.map(function(b) {
      return nb(Eb(b), Ab).map(Nb);
    });
  } } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: {
    calculatorName: "EnableFaceGeometryConstant",
    calculatorType: "ConstantSidePacketCalculator",
    fieldName: "bool_value"
  } }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumFaces: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorNumFaces", fieldName: "int_value" } }, refineLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: {
    type: 1,
    graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facelandmarkfrontgpu__facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" }
  }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: {
    calculatorType: "FaceGeometryEnvGeneratorCalculator",
    fieldName: "near"
  } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" } } } };
  var hc = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], ic = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
    386,
    385
  ], [385, 384], [384, 398], [398, 362]], jc = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], kc = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], lc = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], mc = [
    [10, 338],
    [338, 297],
    [297, 332],
    [332, 284],
    [284, 251],
    [251, 389],
    [389, 356],
    [356, 454],
    [454, 323],
    [323, 361],
    [361, 288],
    [288, 397],
    [397, 365],
    [365, 379],
    [379, 378],
    [378, 400],
    [400, 377],
    [377, 152],
    [152, 148],
    [148, 176],
    [176, 149],
    [149, 150],
    [150, 136],
    [136, 172],
    [172, 58],
    [58, 132],
    [132, 93],
    [93, 234],
    [234, 127],
    [127, 162],
    [162, 21],
    [21, 54],
    [54, 103],
    [103, 67],
    [67, 109],
    [109, 10]
  ], nc = [].concat(L(hc), L(ic), L(jc), L(kc), L(lc), L(mc));
  function oc(a) {
    a = a || {};
    a = Object.assign(Object.assign({}, gc), a);
    this.g = new Xb(a);
  }
  v = oc.prototype;
  v.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  v.onResults = function(a) {
    this.g.onResults(a);
  };
  v.initialize = function() {
    return Z(this, function b() {
      var c = this;
      return O(b, function(d) {
        return N(d, c.g.initialize(), 0);
      });
    });
  };
  v.reset = function() {
    this.g.reset();
  };
  v.send = function(a) {
    return Z(this, function c() {
      var d = this;
      return O(c, function(e) {
        return N(e, d.g.send(a), 0);
      });
    });
  };
  v.setOptions = function(a) {
    this.g.setOptions(a);
  };
  P("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } });
  P("FaceMesh", oc);
  P("FACEMESH_LIPS", hc);
  P("FACEMESH_LEFT_EYE", ic);
  P("FACEMESH_LEFT_EYEBROW", jc);
  P("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]);
  P("FACEMESH_RIGHT_EYE", kc);
  P("FACEMESH_RIGHT_EYEBROW", lc);
  P("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]);
  P("FACEMESH_FACE_OVAL", mc);
  P("FACEMESH_CONTOURS", nc);
  P("FACEMESH_TESSELATION", [
    [127, 34],
    [34, 139],
    [139, 127],
    [11, 0],
    [0, 37],
    [37, 11],
    [232, 231],
    [231, 120],
    [120, 232],
    [72, 37],
    [37, 39],
    [39, 72],
    [128, 121],
    [121, 47],
    [47, 128],
    [232, 121],
    [121, 128],
    [128, 232],
    [104, 69],
    [69, 67],
    [67, 104],
    [175, 171],
    [171, 148],
    [148, 175],
    [118, 50],
    [50, 101],
    [101, 118],
    [73, 39],
    [39, 40],
    [40, 73],
    [9, 151],
    [151, 108],
    [108, 9],
    [48, 115],
    [115, 131],
    [131, 48],
    [194, 204],
    [204, 211],
    [211, 194],
    [74, 40],
    [40, 185],
    [185, 74],
    [80, 42],
    [42, 183],
    [183, 80],
    [40, 92],
    [92, 186],
    [186, 40],
    [230, 229],
    [229, 118],
    [118, 230],
    [202, 212],
    [
      212,
      214
    ],
    [214, 202],
    [83, 18],
    [18, 17],
    [17, 83],
    [76, 61],
    [61, 146],
    [146, 76],
    [160, 29],
    [29, 30],
    [30, 160],
    [56, 157],
    [157, 173],
    [173, 56],
    [106, 204],
    [204, 194],
    [194, 106],
    [135, 214],
    [214, 192],
    [192, 135],
    [203, 165],
    [165, 98],
    [98, 203],
    [21, 71],
    [71, 68],
    [68, 21],
    [51, 45],
    [45, 4],
    [4, 51],
    [144, 24],
    [24, 23],
    [23, 144],
    [77, 146],
    [146, 91],
    [91, 77],
    [205, 50],
    [50, 187],
    [187, 205],
    [201, 200],
    [200, 18],
    [18, 201],
    [91, 106],
    [106, 182],
    [182, 91],
    [90, 91],
    [91, 181],
    [181, 90],
    [85, 84],
    [84, 17],
    [17, 85],
    [206, 203],
    [203, 36],
    [36, 206],
    [148, 171],
    [171, 140],
    [140, 148],
    [
      92,
      40
    ],
    [40, 39],
    [39, 92],
    [193, 189],
    [189, 244],
    [244, 193],
    [159, 158],
    [158, 28],
    [28, 159],
    [247, 246],
    [246, 161],
    [161, 247],
    [236, 3],
    [3, 196],
    [196, 236],
    [54, 68],
    [68, 104],
    [104, 54],
    [193, 168],
    [168, 8],
    [8, 193],
    [117, 228],
    [228, 31],
    [31, 117],
    [189, 193],
    [193, 55],
    [55, 189],
    [98, 97],
    [97, 99],
    [99, 98],
    [126, 47],
    [47, 100],
    [100, 126],
    [166, 79],
    [79, 218],
    [218, 166],
    [155, 154],
    [154, 26],
    [26, 155],
    [209, 49],
    [49, 131],
    [131, 209],
    [135, 136],
    [136, 150],
    [150, 135],
    [47, 126],
    [126, 217],
    [217, 47],
    [223, 52],
    [52, 53],
    [53, 223],
    [45, 51],
    [51, 134],
    [134, 45],
    [211, 170],
    [
      170,
      140
    ],
    [140, 211],
    [67, 69],
    [69, 108],
    [108, 67],
    [43, 106],
    [106, 91],
    [91, 43],
    [230, 119],
    [119, 120],
    [120, 230],
    [226, 130],
    [130, 247],
    [247, 226],
    [63, 53],
    [53, 52],
    [52, 63],
    [238, 20],
    [20, 242],
    [242, 238],
    [46, 70],
    [70, 156],
    [156, 46],
    [78, 62],
    [62, 96],
    [96, 78],
    [46, 53],
    [53, 63],
    [63, 46],
    [143, 34],
    [34, 227],
    [227, 143],
    [123, 117],
    [117, 111],
    [111, 123],
    [44, 125],
    [125, 19],
    [19, 44],
    [236, 134],
    [134, 51],
    [51, 236],
    [216, 206],
    [206, 205],
    [205, 216],
    [154, 153],
    [153, 22],
    [22, 154],
    [39, 37],
    [37, 167],
    [167, 39],
    [200, 201],
    [201, 208],
    [208, 200],
    [36, 142],
    [142, 100],
    [
      100,
      36
    ],
    [57, 212],
    [212, 202],
    [202, 57],
    [20, 60],
    [60, 99],
    [99, 20],
    [28, 158],
    [158, 157],
    [157, 28],
    [35, 226],
    [226, 113],
    [113, 35],
    [160, 159],
    [159, 27],
    [27, 160],
    [204, 202],
    [202, 210],
    [210, 204],
    [113, 225],
    [225, 46],
    [46, 113],
    [43, 202],
    [202, 204],
    [204, 43],
    [62, 76],
    [76, 77],
    [77, 62],
    [137, 123],
    [123, 116],
    [116, 137],
    [41, 38],
    [38, 72],
    [72, 41],
    [203, 129],
    [129, 142],
    [142, 203],
    [64, 98],
    [98, 240],
    [240, 64],
    [49, 102],
    [102, 64],
    [64, 49],
    [41, 73],
    [73, 74],
    [74, 41],
    [212, 216],
    [216, 207],
    [207, 212],
    [42, 74],
    [74, 184],
    [184, 42],
    [169, 170],
    [170, 211],
    [211, 169],
    [
      170,
      149
    ],
    [149, 176],
    [176, 170],
    [105, 66],
    [66, 69],
    [69, 105],
    [122, 6],
    [6, 168],
    [168, 122],
    [123, 147],
    [147, 187],
    [187, 123],
    [96, 77],
    [77, 90],
    [90, 96],
    [65, 55],
    [55, 107],
    [107, 65],
    [89, 90],
    [90, 180],
    [180, 89],
    [101, 100],
    [100, 120],
    [120, 101],
    [63, 105],
    [105, 104],
    [104, 63],
    [93, 137],
    [137, 227],
    [227, 93],
    [15, 86],
    [86, 85],
    [85, 15],
    [129, 102],
    [102, 49],
    [49, 129],
    [14, 87],
    [87, 86],
    [86, 14],
    [55, 8],
    [8, 9],
    [9, 55],
    [100, 47],
    [47, 121],
    [121, 100],
    [145, 23],
    [23, 22],
    [22, 145],
    [88, 89],
    [89, 179],
    [179, 88],
    [6, 122],
    [122, 196],
    [196, 6],
    [88, 95],
    [95, 96],
    [96, 88],
    [138, 172],
    [172, 136],
    [136, 138],
    [215, 58],
    [58, 172],
    [172, 215],
    [115, 48],
    [48, 219],
    [219, 115],
    [42, 80],
    [80, 81],
    [81, 42],
    [195, 3],
    [3, 51],
    [51, 195],
    [43, 146],
    [146, 61],
    [61, 43],
    [171, 175],
    [175, 199],
    [199, 171],
    [81, 82],
    [82, 38],
    [38, 81],
    [53, 46],
    [46, 225],
    [225, 53],
    [144, 163],
    [163, 110],
    [110, 144],
    [52, 65],
    [65, 66],
    [66, 52],
    [229, 228],
    [228, 117],
    [117, 229],
    [34, 127],
    [127, 234],
    [234, 34],
    [107, 108],
    [108, 69],
    [69, 107],
    [109, 108],
    [108, 151],
    [151, 109],
    [48, 64],
    [64, 235],
    [235, 48],
    [62, 78],
    [78, 191],
    [191, 62],
    [129, 209],
    [209, 126],
    [126, 129],
    [111, 35],
    [35, 143],
    [
      143,
      111
    ],
    [117, 123],
    [123, 50],
    [50, 117],
    [222, 65],
    [65, 52],
    [52, 222],
    [19, 125],
    [125, 141],
    [141, 19],
    [221, 55],
    [55, 65],
    [65, 221],
    [3, 195],
    [195, 197],
    [197, 3],
    [25, 7],
    [7, 33],
    [33, 25],
    [220, 237],
    [237, 44],
    [44, 220],
    [70, 71],
    [71, 139],
    [139, 70],
    [122, 193],
    [193, 245],
    [245, 122],
    [247, 130],
    [130, 33],
    [33, 247],
    [71, 21],
    [21, 162],
    [162, 71],
    [170, 169],
    [169, 150],
    [150, 170],
    [188, 174],
    [174, 196],
    [196, 188],
    [216, 186],
    [186, 92],
    [92, 216],
    [2, 97],
    [97, 167],
    [167, 2],
    [141, 125],
    [125, 241],
    [241, 141],
    [164, 167],
    [167, 37],
    [37, 164],
    [72, 38],
    [38, 12],
    [12, 72],
    [38, 82],
    [82, 13],
    [13, 38],
    [63, 68],
    [68, 71],
    [71, 63],
    [226, 35],
    [35, 111],
    [111, 226],
    [101, 50],
    [50, 205],
    [205, 101],
    [206, 92],
    [92, 165],
    [165, 206],
    [209, 198],
    [198, 217],
    [217, 209],
    [165, 167],
    [167, 97],
    [97, 165],
    [220, 115],
    [115, 218],
    [218, 220],
    [133, 112],
    [112, 243],
    [243, 133],
    [239, 238],
    [238, 241],
    [241, 239],
    [214, 135],
    [135, 169],
    [169, 214],
    [190, 173],
    [173, 133],
    [133, 190],
    [171, 208],
    [208, 32],
    [32, 171],
    [125, 44],
    [44, 237],
    [237, 125],
    [86, 87],
    [87, 178],
    [178, 86],
    [85, 86],
    [86, 179],
    [179, 85],
    [84, 85],
    [85, 180],
    [180, 84],
    [83, 84],
    [84, 181],
    [181, 83],
    [201, 83],
    [83, 182],
    [182, 201],
    [137, 93],
    [93, 132],
    [132, 137],
    [76, 62],
    [62, 183],
    [183, 76],
    [61, 76],
    [76, 184],
    [184, 61],
    [57, 61],
    [61, 185],
    [185, 57],
    [212, 57],
    [57, 186],
    [186, 212],
    [214, 207],
    [207, 187],
    [187, 214],
    [34, 143],
    [143, 156],
    [156, 34],
    [79, 239],
    [239, 237],
    [237, 79],
    [123, 137],
    [137, 177],
    [177, 123],
    [44, 1],
    [1, 4],
    [4, 44],
    [201, 194],
    [194, 32],
    [32, 201],
    [64, 102],
    [102, 129],
    [129, 64],
    [213, 215],
    [215, 138],
    [138, 213],
    [59, 166],
    [166, 219],
    [219, 59],
    [242, 99],
    [99, 97],
    [97, 242],
    [2, 94],
    [94, 141],
    [141, 2],
    [75, 59],
    [59, 235],
    [235, 75],
    [24, 110],
    [110, 228],
    [
      228,
      24
    ],
    [25, 130],
    [130, 226],
    [226, 25],
    [23, 24],
    [24, 229],
    [229, 23],
    [22, 23],
    [23, 230],
    [230, 22],
    [26, 22],
    [22, 231],
    [231, 26],
    [112, 26],
    [26, 232],
    [232, 112],
    [189, 190],
    [190, 243],
    [243, 189],
    [221, 56],
    [56, 190],
    [190, 221],
    [28, 56],
    [56, 221],
    [221, 28],
    [27, 28],
    [28, 222],
    [222, 27],
    [29, 27],
    [27, 223],
    [223, 29],
    [30, 29],
    [29, 224],
    [224, 30],
    [247, 30],
    [30, 225],
    [225, 247],
    [238, 79],
    [79, 20],
    [20, 238],
    [166, 59],
    [59, 75],
    [75, 166],
    [60, 75],
    [75, 240],
    [240, 60],
    [147, 177],
    [177, 215],
    [215, 147],
    [20, 79],
    [79, 166],
    [166, 20],
    [187, 147],
    [147, 213],
    [213, 187],
    [112, 233],
    [233, 244],
    [244, 112],
    [233, 128],
    [128, 245],
    [245, 233],
    [128, 114],
    [114, 188],
    [188, 128],
    [114, 217],
    [217, 174],
    [174, 114],
    [131, 115],
    [115, 220],
    [220, 131],
    [217, 198],
    [198, 236],
    [236, 217],
    [198, 131],
    [131, 134],
    [134, 198],
    [177, 132],
    [132, 58],
    [58, 177],
    [143, 35],
    [35, 124],
    [124, 143],
    [110, 163],
    [163, 7],
    [7, 110],
    [228, 110],
    [110, 25],
    [25, 228],
    [356, 389],
    [389, 368],
    [368, 356],
    [11, 302],
    [302, 267],
    [267, 11],
    [452, 350],
    [350, 349],
    [349, 452],
    [302, 303],
    [303, 269],
    [269, 302],
    [357, 343],
    [343, 277],
    [277, 357],
    [452, 453],
    [453, 357],
    [357, 452],
    [333, 332],
    [
      332,
      297
    ],
    [297, 333],
    [175, 152],
    [152, 377],
    [377, 175],
    [347, 348],
    [348, 330],
    [330, 347],
    [303, 304],
    [304, 270],
    [270, 303],
    [9, 336],
    [336, 337],
    [337, 9],
    [278, 279],
    [279, 360],
    [360, 278],
    [418, 262],
    [262, 431],
    [431, 418],
    [304, 408],
    [408, 409],
    [409, 304],
    [310, 415],
    [415, 407],
    [407, 310],
    [270, 409],
    [409, 410],
    [410, 270],
    [450, 348],
    [348, 347],
    [347, 450],
    [422, 430],
    [430, 434],
    [434, 422],
    [313, 314],
    [314, 17],
    [17, 313],
    [306, 307],
    [307, 375],
    [375, 306],
    [387, 388],
    [388, 260],
    [260, 387],
    [286, 414],
    [414, 398],
    [398, 286],
    [335, 406],
    [406, 418],
    [418, 335],
    [364, 367],
    [
      367,
      416
    ],
    [416, 364],
    [423, 358],
    [358, 327],
    [327, 423],
    [251, 284],
    [284, 298],
    [298, 251],
    [281, 5],
    [5, 4],
    [4, 281],
    [373, 374],
    [374, 253],
    [253, 373],
    [307, 320],
    [320, 321],
    [321, 307],
    [425, 427],
    [427, 411],
    [411, 425],
    [421, 313],
    [313, 18],
    [18, 421],
    [321, 405],
    [405, 406],
    [406, 321],
    [320, 404],
    [404, 405],
    [405, 320],
    [315, 16],
    [16, 17],
    [17, 315],
    [426, 425],
    [425, 266],
    [266, 426],
    [377, 400],
    [400, 369],
    [369, 377],
    [322, 391],
    [391, 269],
    [269, 322],
    [417, 465],
    [465, 464],
    [464, 417],
    [386, 257],
    [257, 258],
    [258, 386],
    [466, 260],
    [260, 388],
    [388, 466],
    [456, 399],
    [399, 419],
    [419, 456],
    [284, 332],
    [332, 333],
    [333, 284],
    [417, 285],
    [285, 8],
    [8, 417],
    [346, 340],
    [340, 261],
    [261, 346],
    [413, 441],
    [441, 285],
    [285, 413],
    [327, 460],
    [460, 328],
    [328, 327],
    [355, 371],
    [371, 329],
    [329, 355],
    [392, 439],
    [439, 438],
    [438, 392],
    [382, 341],
    [341, 256],
    [256, 382],
    [429, 420],
    [420, 360],
    [360, 429],
    [364, 394],
    [394, 379],
    [379, 364],
    [277, 343],
    [343, 437],
    [437, 277],
    [443, 444],
    [444, 283],
    [283, 443],
    [275, 440],
    [440, 363],
    [363, 275],
    [431, 262],
    [262, 369],
    [369, 431],
    [297, 338],
    [338, 337],
    [337, 297],
    [273, 375],
    [375, 321],
    [321, 273],
    [450, 451],
    [
      451,
      349
    ],
    [349, 450],
    [446, 342],
    [342, 467],
    [467, 446],
    [293, 334],
    [334, 282],
    [282, 293],
    [458, 461],
    [461, 462],
    [462, 458],
    [276, 353],
    [353, 383],
    [383, 276],
    [308, 324],
    [324, 325],
    [325, 308],
    [276, 300],
    [300, 293],
    [293, 276],
    [372, 345],
    [345, 447],
    [447, 372],
    [352, 345],
    [345, 340],
    [340, 352],
    [274, 1],
    [1, 19],
    [19, 274],
    [456, 248],
    [248, 281],
    [281, 456],
    [436, 427],
    [427, 425],
    [425, 436],
    [381, 256],
    [256, 252],
    [252, 381],
    [269, 391],
    [391, 393],
    [393, 269],
    [200, 199],
    [199, 428],
    [428, 200],
    [266, 330],
    [330, 329],
    [329, 266],
    [287, 273],
    [273, 422],
    [422, 287],
    [250, 462],
    [
      462,
      328
    ],
    [328, 250],
    [258, 286],
    [286, 384],
    [384, 258],
    [265, 353],
    [353, 342],
    [342, 265],
    [387, 259],
    [259, 257],
    [257, 387],
    [424, 431],
    [431, 430],
    [430, 424],
    [342, 353],
    [353, 276],
    [276, 342],
    [273, 335],
    [335, 424],
    [424, 273],
    [292, 325],
    [325, 307],
    [307, 292],
    [366, 447],
    [447, 345],
    [345, 366],
    [271, 303],
    [303, 302],
    [302, 271],
    [423, 266],
    [266, 371],
    [371, 423],
    [294, 455],
    [455, 460],
    [460, 294],
    [279, 278],
    [278, 294],
    [294, 279],
    [271, 272],
    [272, 304],
    [304, 271],
    [432, 434],
    [434, 427],
    [427, 432],
    [272, 407],
    [407, 408],
    [408, 272],
    [394, 430],
    [430, 431],
    [431, 394],
    [395, 369],
    [369, 400],
    [400, 395],
    [334, 333],
    [333, 299],
    [299, 334],
    [351, 417],
    [417, 168],
    [168, 351],
    [352, 280],
    [280, 411],
    [411, 352],
    [325, 319],
    [319, 320],
    [320, 325],
    [295, 296],
    [296, 336],
    [336, 295],
    [319, 403],
    [403, 404],
    [404, 319],
    [330, 348],
    [348, 349],
    [349, 330],
    [293, 298],
    [298, 333],
    [333, 293],
    [323, 454],
    [454, 447],
    [447, 323],
    [15, 16],
    [16, 315],
    [315, 15],
    [358, 429],
    [429, 279],
    [279, 358],
    [14, 15],
    [15, 316],
    [316, 14],
    [285, 336],
    [336, 9],
    [9, 285],
    [329, 349],
    [349, 350],
    [350, 329],
    [374, 380],
    [380, 252],
    [252, 374],
    [318, 402],
    [402, 403],
    [403, 318],
    [6, 197],
    [
      197,
      419
    ],
    [419, 6],
    [318, 319],
    [319, 325],
    [325, 318],
    [367, 364],
    [364, 365],
    [365, 367],
    [435, 367],
    [367, 397],
    [397, 435],
    [344, 438],
    [438, 439],
    [439, 344],
    [272, 271],
    [271, 311],
    [311, 272],
    [195, 5],
    [5, 281],
    [281, 195],
    [273, 287],
    [287, 291],
    [291, 273],
    [396, 428],
    [428, 199],
    [199, 396],
    [311, 271],
    [271, 268],
    [268, 311],
    [283, 444],
    [444, 445],
    [445, 283],
    [373, 254],
    [254, 339],
    [339, 373],
    [282, 334],
    [334, 296],
    [296, 282],
    [449, 347],
    [347, 346],
    [346, 449],
    [264, 447],
    [447, 454],
    [454, 264],
    [336, 296],
    [296, 299],
    [299, 336],
    [338, 10],
    [10, 151],
    [151, 338],
    [278, 439],
    [
      439,
      455
    ],
    [455, 278],
    [292, 407],
    [407, 415],
    [415, 292],
    [358, 371],
    [371, 355],
    [355, 358],
    [340, 345],
    [345, 372],
    [372, 340],
    [346, 347],
    [347, 280],
    [280, 346],
    [442, 443],
    [443, 282],
    [282, 442],
    [19, 94],
    [94, 370],
    [370, 19],
    [441, 442],
    [442, 295],
    [295, 441],
    [248, 419],
    [419, 197],
    [197, 248],
    [263, 255],
    [255, 359],
    [359, 263],
    [440, 275],
    [275, 274],
    [274, 440],
    [300, 383],
    [383, 368],
    [368, 300],
    [351, 412],
    [412, 465],
    [465, 351],
    [263, 467],
    [467, 466],
    [466, 263],
    [301, 368],
    [368, 389],
    [389, 301],
    [395, 378],
    [378, 379],
    [379, 395],
    [412, 351],
    [351, 419],
    [419, 412],
    [436, 426],
    [426, 322],
    [322, 436],
    [2, 164],
    [164, 393],
    [393, 2],
    [370, 462],
    [462, 461],
    [461, 370],
    [164, 0],
    [0, 267],
    [267, 164],
    [302, 11],
    [11, 12],
    [12, 302],
    [268, 12],
    [12, 13],
    [13, 268],
    [293, 300],
    [300, 301],
    [301, 293],
    [446, 261],
    [261, 340],
    [340, 446],
    [330, 266],
    [266, 425],
    [425, 330],
    [426, 423],
    [423, 391],
    [391, 426],
    [429, 355],
    [355, 437],
    [437, 429],
    [391, 327],
    [327, 326],
    [326, 391],
    [440, 457],
    [457, 438],
    [438, 440],
    [341, 382],
    [382, 362],
    [362, 341],
    [459, 457],
    [457, 461],
    [461, 459],
    [434, 430],
    [430, 394],
    [394, 434],
    [414, 463],
    [463, 362],
    [362, 414],
    [396, 369],
    [369, 262],
    [262, 396],
    [354, 461],
    [461, 457],
    [457, 354],
    [316, 403],
    [403, 402],
    [402, 316],
    [315, 404],
    [404, 403],
    [403, 315],
    [314, 405],
    [405, 404],
    [404, 314],
    [313, 406],
    [406, 405],
    [405, 313],
    [421, 418],
    [418, 406],
    [406, 421],
    [366, 401],
    [401, 361],
    [361, 366],
    [306, 408],
    [408, 407],
    [407, 306],
    [291, 409],
    [409, 408],
    [408, 291],
    [287, 410],
    [410, 409],
    [409, 287],
    [432, 436],
    [436, 410],
    [410, 432],
    [434, 416],
    [416, 411],
    [411, 434],
    [264, 368],
    [368, 383],
    [383, 264],
    [309, 438],
    [438, 457],
    [457, 309],
    [352, 376],
    [376, 401],
    [401, 352],
    [274, 275],
    [275, 4],
    [4, 274],
    [421, 428],
    [
      428,
      262
    ],
    [262, 421],
    [294, 327],
    [327, 358],
    [358, 294],
    [433, 416],
    [416, 367],
    [367, 433],
    [289, 455],
    [455, 439],
    [439, 289],
    [462, 370],
    [370, 326],
    [326, 462],
    [2, 326],
    [326, 370],
    [370, 2],
    [305, 460],
    [460, 455],
    [455, 305],
    [254, 449],
    [449, 448],
    [448, 254],
    [255, 261],
    [261, 446],
    [446, 255],
    [253, 450],
    [450, 449],
    [449, 253],
    [252, 451],
    [451, 450],
    [450, 252],
    [256, 452],
    [452, 451],
    [451, 256],
    [341, 453],
    [453, 452],
    [452, 341],
    [413, 464],
    [464, 463],
    [463, 413],
    [441, 413],
    [413, 414],
    [414, 441],
    [258, 442],
    [442, 441],
    [441, 258],
    [257, 443],
    [443, 442],
    [442, 257],
    [259, 444],
    [444, 443],
    [443, 259],
    [260, 445],
    [445, 444],
    [444, 260],
    [467, 342],
    [342, 445],
    [445, 467],
    [459, 458],
    [458, 250],
    [250, 459],
    [289, 392],
    [392, 290],
    [290, 289],
    [290, 328],
    [328, 460],
    [460, 290],
    [376, 433],
    [433, 435],
    [435, 376],
    [250, 290],
    [290, 392],
    [392, 250],
    [411, 416],
    [416, 433],
    [433, 411],
    [341, 463],
    [463, 464],
    [464, 341],
    [453, 464],
    [464, 465],
    [465, 453],
    [357, 465],
    [465, 412],
    [412, 357],
    [343, 412],
    [412, 399],
    [399, 343],
    [360, 363],
    [363, 440],
    [440, 360],
    [437, 399],
    [399, 456],
    [456, 437],
    [420, 456],
    [456, 363],
    [363, 420],
    [401, 435],
    [435, 288],
    [288, 401],
    [
      372,
      383
    ],
    [383, 353],
    [353, 372],
    [339, 255],
    [255, 249],
    [249, 339],
    [448, 261],
    [261, 255],
    [255, 448],
    [133, 243],
    [243, 190],
    [190, 133],
    [133, 155],
    [155, 112],
    [112, 133],
    [33, 246],
    [246, 247],
    [247, 33],
    [33, 130],
    [130, 25],
    [25, 33],
    [398, 384],
    [384, 286],
    [286, 398],
    [362, 398],
    [398, 414],
    [414, 362],
    [362, 463],
    [463, 341],
    [341, 362],
    [263, 359],
    [359, 467],
    [467, 263],
    [263, 249],
    [249, 255],
    [255, 263],
    [466, 467],
    [467, 260],
    [260, 466],
    [75, 60],
    [60, 166],
    [166, 75],
    [238, 239],
    [239, 79],
    [79, 238],
    [162, 127],
    [127, 139],
    [139, 162],
    [72, 11],
    [11, 37],
    [37, 72],
    [121, 232],
    [
      232,
      120
    ],
    [120, 121],
    [73, 72],
    [72, 39],
    [39, 73],
    [114, 128],
    [128, 47],
    [47, 114],
    [233, 232],
    [232, 128],
    [128, 233],
    [103, 104],
    [104, 67],
    [67, 103],
    [152, 175],
    [175, 148],
    [148, 152],
    [119, 118],
    [118, 101],
    [101, 119],
    [74, 73],
    [73, 40],
    [40, 74],
    [107, 9],
    [9, 108],
    [108, 107],
    [49, 48],
    [48, 131],
    [131, 49],
    [32, 194],
    [194, 211],
    [211, 32],
    [184, 74],
    [74, 185],
    [185, 184],
    [191, 80],
    [80, 183],
    [183, 191],
    [185, 40],
    [40, 186],
    [186, 185],
    [119, 230],
    [230, 118],
    [118, 119],
    [210, 202],
    [202, 214],
    [214, 210],
    [84, 83],
    [83, 17],
    [17, 84],
    [77, 76],
    [76, 146],
    [146, 77],
    [161, 160],
    [160, 30],
    [30, 161],
    [190, 56],
    [56, 173],
    [173, 190],
    [182, 106],
    [106, 194],
    [194, 182],
    [138, 135],
    [135, 192],
    [192, 138],
    [129, 203],
    [203, 98],
    [98, 129],
    [54, 21],
    [21, 68],
    [68, 54],
    [5, 51],
    [51, 4],
    [4, 5],
    [145, 144],
    [144, 23],
    [23, 145],
    [90, 77],
    [77, 91],
    [91, 90],
    [207, 205],
    [205, 187],
    [187, 207],
    [83, 201],
    [201, 18],
    [18, 83],
    [181, 91],
    [91, 182],
    [182, 181],
    [180, 90],
    [90, 181],
    [181, 180],
    [16, 85],
    [85, 17],
    [17, 16],
    [205, 206],
    [206, 36],
    [36, 205],
    [176, 148],
    [148, 140],
    [140, 176],
    [165, 92],
    [92, 39],
    [39, 165],
    [245, 193],
    [193, 244],
    [244, 245],
    [27, 159],
    [159, 28],
    [28, 27],
    [
      30,
      247
    ],
    [247, 161],
    [161, 30],
    [174, 236],
    [236, 196],
    [196, 174],
    [103, 54],
    [54, 104],
    [104, 103],
    [55, 193],
    [193, 8],
    [8, 55],
    [111, 117],
    [117, 31],
    [31, 111],
    [221, 189],
    [189, 55],
    [55, 221],
    [240, 98],
    [98, 99],
    [99, 240],
    [142, 126],
    [126, 100],
    [100, 142],
    [219, 166],
    [166, 218],
    [218, 219],
    [112, 155],
    [155, 26],
    [26, 112],
    [198, 209],
    [209, 131],
    [131, 198],
    [169, 135],
    [135, 150],
    [150, 169],
    [114, 47],
    [47, 217],
    [217, 114],
    [224, 223],
    [223, 53],
    [53, 224],
    [220, 45],
    [45, 134],
    [134, 220],
    [32, 211],
    [211, 140],
    [140, 32],
    [109, 67],
    [67, 108],
    [108, 109],
    [146, 43],
    [43, 91],
    [91, 146],
    [231, 230],
    [230, 120],
    [120, 231],
    [113, 226],
    [226, 247],
    [247, 113],
    [105, 63],
    [63, 52],
    [52, 105],
    [241, 238],
    [238, 242],
    [242, 241],
    [124, 46],
    [46, 156],
    [156, 124],
    [95, 78],
    [78, 96],
    [96, 95],
    [70, 46],
    [46, 63],
    [63, 70],
    [116, 143],
    [143, 227],
    [227, 116],
    [116, 123],
    [123, 111],
    [111, 116],
    [1, 44],
    [44, 19],
    [19, 1],
    [3, 236],
    [236, 51],
    [51, 3],
    [207, 216],
    [216, 205],
    [205, 207],
    [26, 154],
    [154, 22],
    [22, 26],
    [165, 39],
    [39, 167],
    [167, 165],
    [199, 200],
    [200, 208],
    [208, 199],
    [101, 36],
    [36, 100],
    [100, 101],
    [43, 57],
    [57, 202],
    [202, 43],
    [242, 20],
    [20, 99],
    [99, 242],
    [56, 28],
    [
      28,
      157
    ],
    [157, 56],
    [124, 35],
    [35, 113],
    [113, 124],
    [29, 160],
    [160, 27],
    [27, 29],
    [211, 204],
    [204, 210],
    [210, 211],
    [124, 113],
    [113, 46],
    [46, 124],
    [106, 43],
    [43, 204],
    [204, 106],
    [96, 62],
    [62, 77],
    [77, 96],
    [227, 137],
    [137, 116],
    [116, 227],
    [73, 41],
    [41, 72],
    [72, 73],
    [36, 203],
    [203, 142],
    [142, 36],
    [235, 64],
    [64, 240],
    [240, 235],
    [48, 49],
    [49, 64],
    [64, 48],
    [42, 41],
    [41, 74],
    [74, 42],
    [214, 212],
    [212, 207],
    [207, 214],
    [183, 42],
    [42, 184],
    [184, 183],
    [210, 169],
    [169, 211],
    [211, 210],
    [140, 170],
    [170, 176],
    [176, 140],
    [104, 105],
    [105, 69],
    [69, 104],
    [193, 122],
    [122, 168],
    [168, 193],
    [50, 123],
    [123, 187],
    [187, 50],
    [89, 96],
    [96, 90],
    [90, 89],
    [66, 65],
    [65, 107],
    [107, 66],
    [179, 89],
    [89, 180],
    [180, 179],
    [119, 101],
    [101, 120],
    [120, 119],
    [68, 63],
    [63, 104],
    [104, 68],
    [234, 93],
    [93, 227],
    [227, 234],
    [16, 15],
    [15, 85],
    [85, 16],
    [209, 129],
    [129, 49],
    [49, 209],
    [15, 14],
    [14, 86],
    [86, 15],
    [107, 55],
    [55, 9],
    [9, 107],
    [120, 100],
    [100, 121],
    [121, 120],
    [153, 145],
    [145, 22],
    [22, 153],
    [178, 88],
    [88, 179],
    [179, 178],
    [197, 6],
    [6, 196],
    [196, 197],
    [89, 88],
    [88, 96],
    [96, 89],
    [135, 138],
    [138, 136],
    [136, 135],
    [138, 215],
    [215, 172],
    [172, 138],
    [
      218,
      115
    ],
    [115, 219],
    [219, 218],
    [41, 42],
    [42, 81],
    [81, 41],
    [5, 195],
    [195, 51],
    [51, 5],
    [57, 43],
    [43, 61],
    [61, 57],
    [208, 171],
    [171, 199],
    [199, 208],
    [41, 81],
    [81, 38],
    [38, 41],
    [224, 53],
    [53, 225],
    [225, 224],
    [24, 144],
    [144, 110],
    [110, 24],
    [105, 52],
    [52, 66],
    [66, 105],
    [118, 229],
    [229, 117],
    [117, 118],
    [227, 34],
    [34, 234],
    [234, 227],
    [66, 107],
    [107, 69],
    [69, 66],
    [10, 109],
    [109, 151],
    [151, 10],
    [219, 48],
    [48, 235],
    [235, 219],
    [183, 62],
    [62, 191],
    [191, 183],
    [142, 129],
    [129, 126],
    [126, 142],
    [116, 111],
    [111, 143],
    [143, 116],
    [118, 117],
    [117, 50],
    [50, 118],
    [223, 222],
    [
      222,
      52
    ],
    [52, 223],
    [94, 19],
    [19, 141],
    [141, 94],
    [222, 221],
    [221, 65],
    [65, 222],
    [196, 3],
    [3, 197],
    [197, 196],
    [45, 220],
    [220, 44],
    [44, 45],
    [156, 70],
    [70, 139],
    [139, 156],
    [188, 122],
    [122, 245],
    [245, 188],
    [139, 71],
    [71, 162],
    [162, 139],
    [149, 170],
    [170, 150],
    [150, 149],
    [122, 188],
    [188, 196],
    [196, 122],
    [206, 216],
    [216, 92],
    [92, 206],
    [164, 2],
    [2, 167],
    [167, 164],
    [242, 141],
    [141, 241],
    [241, 242],
    [0, 164],
    [164, 37],
    [37, 0],
    [11, 72],
    [72, 12],
    [12, 11],
    [12, 38],
    [38, 13],
    [13, 12],
    [70, 63],
    [63, 71],
    [71, 70],
    [31, 226],
    [226, 111],
    [111, 31],
    [36, 101],
    [101, 205],
    [205, 36],
    [203, 206],
    [206, 165],
    [165, 203],
    [126, 209],
    [209, 217],
    [217, 126],
    [98, 165],
    [165, 97],
    [97, 98],
    [237, 220],
    [220, 218],
    [218, 237],
    [237, 239],
    [239, 241],
    [241, 237],
    [210, 214],
    [214, 169],
    [169, 210],
    [140, 171],
    [171, 32],
    [32, 140],
    [241, 125],
    [125, 237],
    [237, 241],
    [179, 86],
    [86, 178],
    [178, 179],
    [180, 85],
    [85, 179],
    [179, 180],
    [181, 84],
    [84, 180],
    [180, 181],
    [182, 83],
    [83, 181],
    [181, 182],
    [194, 201],
    [201, 182],
    [182, 194],
    [177, 137],
    [137, 132],
    [132, 177],
    [184, 76],
    [76, 183],
    [183, 184],
    [185, 61],
    [61, 184],
    [184, 185],
    [186, 57],
    [57, 185],
    [185, 186],
    [216, 212],
    [
      212,
      186
    ],
    [186, 216],
    [192, 214],
    [214, 187],
    [187, 192],
    [139, 34],
    [34, 156],
    [156, 139],
    [218, 79],
    [79, 237],
    [237, 218],
    [147, 123],
    [123, 177],
    [177, 147],
    [45, 44],
    [44, 4],
    [4, 45],
    [208, 201],
    [201, 32],
    [32, 208],
    [98, 64],
    [64, 129],
    [129, 98],
    [192, 213],
    [213, 138],
    [138, 192],
    [235, 59],
    [59, 219],
    [219, 235],
    [141, 242],
    [242, 97],
    [97, 141],
    [97, 2],
    [2, 141],
    [141, 97],
    [240, 75],
    [75, 235],
    [235, 240],
    [229, 24],
    [24, 228],
    [228, 229],
    [31, 25],
    [25, 226],
    [226, 31],
    [230, 23],
    [23, 229],
    [229, 230],
    [231, 22],
    [22, 230],
    [230, 231],
    [232, 26],
    [26, 231],
    [231, 232],
    [233, 112],
    [112, 232],
    [232, 233],
    [244, 189],
    [189, 243],
    [243, 244],
    [189, 221],
    [221, 190],
    [190, 189],
    [222, 28],
    [28, 221],
    [221, 222],
    [223, 27],
    [27, 222],
    [222, 223],
    [224, 29],
    [29, 223],
    [223, 224],
    [225, 30],
    [30, 224],
    [224, 225],
    [113, 247],
    [247, 225],
    [225, 113],
    [99, 60],
    [60, 240],
    [240, 99],
    [213, 147],
    [147, 215],
    [215, 213],
    [60, 20],
    [20, 166],
    [166, 60],
    [192, 187],
    [187, 213],
    [213, 192],
    [243, 112],
    [112, 244],
    [244, 243],
    [244, 233],
    [233, 245],
    [245, 244],
    [245, 128],
    [128, 188],
    [188, 245],
    [188, 114],
    [114, 174],
    [174, 188],
    [134, 131],
    [131, 220],
    [220, 134],
    [174, 217],
    [217, 236],
    [236, 174],
    [236, 198],
    [198, 134],
    [134, 236],
    [215, 177],
    [177, 58],
    [58, 215],
    [156, 143],
    [143, 124],
    [124, 156],
    [25, 110],
    [110, 7],
    [7, 25],
    [31, 228],
    [228, 25],
    [25, 31],
    [264, 356],
    [356, 368],
    [368, 264],
    [0, 11],
    [11, 267],
    [267, 0],
    [451, 452],
    [452, 349],
    [349, 451],
    [267, 302],
    [302, 269],
    [269, 267],
    [350, 357],
    [357, 277],
    [277, 350],
    [350, 452],
    [452, 357],
    [357, 350],
    [299, 333],
    [333, 297],
    [297, 299],
    [396, 175],
    [175, 377],
    [377, 396],
    [280, 347],
    [347, 330],
    [330, 280],
    [269, 303],
    [303, 270],
    [270, 269],
    [151, 9],
    [9, 337],
    [337, 151],
    [344, 278],
    [278, 360],
    [360, 344],
    [424, 418],
    [
      418,
      431
    ],
    [431, 424],
    [270, 304],
    [304, 409],
    [409, 270],
    [272, 310],
    [310, 407],
    [407, 272],
    [322, 270],
    [270, 410],
    [410, 322],
    [449, 450],
    [450, 347],
    [347, 449],
    [432, 422],
    [422, 434],
    [434, 432],
    [18, 313],
    [313, 17],
    [17, 18],
    [291, 306],
    [306, 375],
    [375, 291],
    [259, 387],
    [387, 260],
    [260, 259],
    [424, 335],
    [335, 418],
    [418, 424],
    [434, 364],
    [364, 416],
    [416, 434],
    [391, 423],
    [423, 327],
    [327, 391],
    [301, 251],
    [251, 298],
    [298, 301],
    [275, 281],
    [281, 4],
    [4, 275],
    [254, 373],
    [373, 253],
    [253, 254],
    [375, 307],
    [307, 321],
    [321, 375],
    [280, 425],
    [425, 411],
    [411, 280],
    [200, 421],
    [
      421,
      18
    ],
    [18, 200],
    [335, 321],
    [321, 406],
    [406, 335],
    [321, 320],
    [320, 405],
    [405, 321],
    [314, 315],
    [315, 17],
    [17, 314],
    [423, 426],
    [426, 266],
    [266, 423],
    [396, 377],
    [377, 369],
    [369, 396],
    [270, 322],
    [322, 269],
    [269, 270],
    [413, 417],
    [417, 464],
    [464, 413],
    [385, 386],
    [386, 258],
    [258, 385],
    [248, 456],
    [456, 419],
    [419, 248],
    [298, 284],
    [284, 333],
    [333, 298],
    [168, 417],
    [417, 8],
    [8, 168],
    [448, 346],
    [346, 261],
    [261, 448],
    [417, 413],
    [413, 285],
    [285, 417],
    [326, 327],
    [327, 328],
    [328, 326],
    [277, 355],
    [355, 329],
    [329, 277],
    [309, 392],
    [392, 438],
    [438, 309],
    [381, 382],
    [
      382,
      256
    ],
    [256, 381],
    [279, 429],
    [429, 360],
    [360, 279],
    [365, 364],
    [364, 379],
    [379, 365],
    [355, 277],
    [277, 437],
    [437, 355],
    [282, 443],
    [443, 283],
    [283, 282],
    [281, 275],
    [275, 363],
    [363, 281],
    [395, 431],
    [431, 369],
    [369, 395],
    [299, 297],
    [297, 337],
    [337, 299],
    [335, 273],
    [273, 321],
    [321, 335],
    [348, 450],
    [450, 349],
    [349, 348],
    [359, 446],
    [446, 467],
    [467, 359],
    [283, 293],
    [293, 282],
    [282, 283],
    [250, 458],
    [458, 462],
    [462, 250],
    [300, 276],
    [276, 383],
    [383, 300],
    [292, 308],
    [308, 325],
    [325, 292],
    [283, 276],
    [276, 293],
    [293, 283],
    [264, 372],
    [372, 447],
    [447, 264],
    [346, 352],
    [352, 340],
    [340, 346],
    [354, 274],
    [274, 19],
    [19, 354],
    [363, 456],
    [456, 281],
    [281, 363],
    [426, 436],
    [436, 425],
    [425, 426],
    [380, 381],
    [381, 252],
    [252, 380],
    [267, 269],
    [269, 393],
    [393, 267],
    [421, 200],
    [200, 428],
    [428, 421],
    [371, 266],
    [266, 329],
    [329, 371],
    [432, 287],
    [287, 422],
    [422, 432],
    [290, 250],
    [250, 328],
    [328, 290],
    [385, 258],
    [258, 384],
    [384, 385],
    [446, 265],
    [265, 342],
    [342, 446],
    [386, 387],
    [387, 257],
    [257, 386],
    [422, 424],
    [424, 430],
    [430, 422],
    [445, 342],
    [342, 276],
    [276, 445],
    [422, 273],
    [273, 424],
    [424, 422],
    [306, 292],
    [292, 307],
    [307, 306],
    [
      352,
      366
    ],
    [366, 345],
    [345, 352],
    [268, 271],
    [271, 302],
    [302, 268],
    [358, 423],
    [423, 371],
    [371, 358],
    [327, 294],
    [294, 460],
    [460, 327],
    [331, 279],
    [279, 294],
    [294, 331],
    [303, 271],
    [271, 304],
    [304, 303],
    [436, 432],
    [432, 427],
    [427, 436],
    [304, 272],
    [272, 408],
    [408, 304],
    [395, 394],
    [394, 431],
    [431, 395],
    [378, 395],
    [395, 400],
    [400, 378],
    [296, 334],
    [334, 299],
    [299, 296],
    [6, 351],
    [351, 168],
    [168, 6],
    [376, 352],
    [352, 411],
    [411, 376],
    [307, 325],
    [325, 320],
    [320, 307],
    [285, 295],
    [295, 336],
    [336, 285],
    [320, 319],
    [319, 404],
    [404, 320],
    [329, 330],
    [330, 349],
    [349, 329],
    [334, 293],
    [293, 333],
    [333, 334],
    [366, 323],
    [323, 447],
    [447, 366],
    [316, 15],
    [15, 315],
    [315, 316],
    [331, 358],
    [358, 279],
    [279, 331],
    [317, 14],
    [14, 316],
    [316, 317],
    [8, 285],
    [285, 9],
    [9, 8],
    [277, 329],
    [329, 350],
    [350, 277],
    [253, 374],
    [374, 252],
    [252, 253],
    [319, 318],
    [318, 403],
    [403, 319],
    [351, 6],
    [6, 419],
    [419, 351],
    [324, 318],
    [318, 325],
    [325, 324],
    [397, 367],
    [367, 365],
    [365, 397],
    [288, 435],
    [435, 397],
    [397, 288],
    [278, 344],
    [344, 439],
    [439, 278],
    [310, 272],
    [272, 311],
    [311, 310],
    [248, 195],
    [195, 281],
    [281, 248],
    [375, 273],
    [273, 291],
    [291, 375],
    [175, 396],
    [396, 199],
    [199, 175],
    [312, 311],
    [311, 268],
    [268, 312],
    [276, 283],
    [283, 445],
    [445, 276],
    [390, 373],
    [373, 339],
    [339, 390],
    [295, 282],
    [282, 296],
    [296, 295],
    [448, 449],
    [449, 346],
    [346, 448],
    [356, 264],
    [264, 454],
    [454, 356],
    [337, 336],
    [336, 299],
    [299, 337],
    [337, 338],
    [338, 151],
    [151, 337],
    [294, 278],
    [278, 455],
    [455, 294],
    [308, 292],
    [292, 415],
    [415, 308],
    [429, 358],
    [358, 355],
    [355, 429],
    [265, 340],
    [340, 372],
    [372, 265],
    [352, 346],
    [346, 280],
    [280, 352],
    [295, 442],
    [442, 282],
    [282, 295],
    [354, 19],
    [19, 370],
    [370, 354],
    [285, 441],
    [441, 295],
    [295, 285],
    [
      195,
      248
    ],
    [248, 197],
    [197, 195],
    [457, 440],
    [440, 274],
    [274, 457],
    [301, 300],
    [300, 368],
    [368, 301],
    [417, 351],
    [351, 465],
    [465, 417],
    [251, 301],
    [301, 389],
    [389, 251],
    [394, 395],
    [395, 379],
    [379, 394],
    [399, 412],
    [412, 419],
    [419, 399],
    [410, 436],
    [436, 322],
    [322, 410],
    [326, 2],
    [2, 393],
    [393, 326],
    [354, 370],
    [370, 461],
    [461, 354],
    [393, 164],
    [164, 267],
    [267, 393],
    [268, 302],
    [302, 12],
    [12, 268],
    [312, 268],
    [268, 13],
    [13, 312],
    [298, 293],
    [293, 301],
    [301, 298],
    [265, 446],
    [446, 340],
    [340, 265],
    [280, 330],
    [330, 425],
    [425, 280],
    [322, 426],
    [426, 391],
    [391, 322],
    [
      420,
      429
    ],
    [429, 437],
    [437, 420],
    [393, 391],
    [391, 326],
    [326, 393],
    [344, 440],
    [440, 438],
    [438, 344],
    [458, 459],
    [459, 461],
    [461, 458],
    [364, 434],
    [434, 394],
    [394, 364],
    [428, 396],
    [396, 262],
    [262, 428],
    [274, 354],
    [354, 457],
    [457, 274],
    [317, 316],
    [316, 402],
    [402, 317],
    [316, 315],
    [315, 403],
    [403, 316],
    [315, 314],
    [314, 404],
    [404, 315],
    [314, 313],
    [313, 405],
    [405, 314],
    [313, 421],
    [421, 406],
    [406, 313],
    [323, 366],
    [366, 361],
    [361, 323],
    [292, 306],
    [306, 407],
    [407, 292],
    [306, 291],
    [291, 408],
    [408, 306],
    [291, 287],
    [287, 409],
    [409, 291],
    [287, 432],
    [432, 410],
    [410, 287],
    [427, 434],
    [434, 411],
    [411, 427],
    [372, 264],
    [264, 383],
    [383, 372],
    [459, 309],
    [309, 457],
    [457, 459],
    [366, 352],
    [352, 401],
    [401, 366],
    [1, 274],
    [274, 4],
    [4, 1],
    [418, 421],
    [421, 262],
    [262, 418],
    [331, 294],
    [294, 358],
    [358, 331],
    [435, 433],
    [433, 367],
    [367, 435],
    [392, 289],
    [289, 439],
    [439, 392],
    [328, 462],
    [462, 326],
    [326, 328],
    [94, 2],
    [2, 370],
    [370, 94],
    [289, 305],
    [305, 455],
    [455, 289],
    [339, 254],
    [254, 448],
    [448, 339],
    [359, 255],
    [255, 446],
    [446, 359],
    [254, 253],
    [253, 449],
    [449, 254],
    [253, 252],
    [252, 450],
    [450, 253],
    [252, 256],
    [256, 451],
    [451, 252],
    [
      256,
      341
    ],
    [341, 452],
    [452, 256],
    [414, 413],
    [413, 463],
    [463, 414],
    [286, 441],
    [441, 414],
    [414, 286],
    [286, 258],
    [258, 441],
    [441, 286],
    [258, 257],
    [257, 442],
    [442, 258],
    [257, 259],
    [259, 443],
    [443, 257],
    [259, 260],
    [260, 444],
    [444, 259],
    [260, 467],
    [467, 445],
    [445, 260],
    [309, 459],
    [459, 250],
    [250, 309],
    [305, 289],
    [289, 290],
    [290, 305],
    [305, 290],
    [290, 460],
    [460, 305],
    [401, 376],
    [376, 435],
    [435, 401],
    [309, 250],
    [250, 392],
    [392, 309],
    [376, 411],
    [411, 433],
    [433, 376],
    [453, 341],
    [341, 464],
    [464, 453],
    [357, 453],
    [453, 465],
    [465, 357],
    [343, 357],
    [357, 412],
    [412, 343],
    [437, 343],
    [343, 399],
    [399, 437],
    [344, 360],
    [360, 440],
    [440, 344],
    [420, 437],
    [437, 456],
    [456, 420],
    [360, 420],
    [420, 363],
    [363, 360],
    [361, 401],
    [401, 288],
    [288, 361],
    [265, 372],
    [372, 353],
    [353, 265],
    [390, 339],
    [339, 249],
    [249, 390],
    [339, 448],
    [448, 255],
    [255, 339]
  ]);
  P("matrixDataToMatrix", function(a) {
    for (var b = a.getCols(), c = a.getRows(), d = a.getPackedDataList(), e = [], g = 0; g < c; g++)
      e.push(Array(b));
    for (g = 0; g < c; g++)
      for (var f = 0; f < b; f++) {
        var h = a.getLayout() === 1 ? g * b + f : f * c + g;
        e[g][f] = d[h];
      }
    return e;
  });
  P("VERSION", "0.4.1633559619");
}).call(VonageFacemash);
const VonageObjectron = {};
(function() {
  var v;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function z(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  z("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  z("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function A(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function ea(a) {
    if (!(a instanceof Array)) {
      a = A(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var fa = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, ha;
  if (typeof Object.setPrototypeOf == "function")
    ha = Object.setPrototypeOf;
  else {
    var ia;
    a: {
      var ja = { a: true }, ka = {};
      try {
        ka.__proto__ = ja;
        ia = ka.a;
        break a;
      } catch (a) {
      }
      ia = false;
    }
    ha = ia ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var la = ha;
  function C(a, b) {
    a.prototype = fa(b.prototype);
    a.prototype.constructor = a;
    if (la)
      la(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.ka = b.prototype;
  }
  function ma() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.s = this.m = 0;
    this.j = null;
  }
  function na(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  ma.prototype.o = function(a) {
    this.h = a;
  };
  function oa(a, b) {
    a.j = { V: b, X: true };
    a.g = a.m || a.s;
  }
  ma.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.s;
  };
  function E(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function pa(a) {
    this.g = new ma();
    this.h = a;
  }
  function qa(a, b) {
    na(a.g);
    var c = a.g.i;
    if (c)
      return ra(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return F(a);
  }
  function ra(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, oa(a.g, f), F(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return F(a);
  }
  function F(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, oa(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.X)
        throw b.V;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function sa(a) {
    this.next = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = F(a));
      return b;
    };
    this.throw = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = F(a));
      return b;
    };
    this.return = function(b) {
      return qa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ta(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, e) {
      function g(f) {
        f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
      }
      g(a.next());
    });
  }
  function H(a) {
    return ta(new sa(new pa(a)));
  }
  z("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.o = false;
      var k = this.j();
      try {
        f(k.resolve, k.reject);
      } catch (h) {
        k.reject(h);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(k) {
        k(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var k = this;
        this.i(function() {
          k.l();
        });
      }
      this.g.push(f);
    };
    var e = y.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var k = 0; k < f.length; ++k) {
          var h = f[k];
          f[k] = null;
          try {
            h();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(p) {
          h || (h = true, l.call(k, p));
        };
      }
      var k = this, h = false;
      return { resolve: f(this.D), reject: f(this.l) };
    };
    b.prototype.D = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.G(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var k = f != null;
              break a;
            case "function":
              k = true;
              break a;
            default:
              k = false;
          }
        k ? this.A(f) : this.m(f);
      }
    };
    b.prototype.A = function(f) {
      var k = void 0;
      try {
        k = f.then;
      } catch (h) {
        this.l(h);
        return;
      }
      typeof k == "function" ? this.H(k, f) : this.m(f);
    };
    b.prototype.l = function(f) {
      this.s(2, f);
    };
    b.prototype.m = function(f) {
      this.s(1, f);
    };
    b.prototype.s = function(f, k) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = k;
      this.h === 2 && this.F();
      this.B();
    };
    b.prototype.F = function() {
      var f = this;
      e(function() {
        if (f.C()) {
          var k = y.console;
          typeof k !== "undefined" && k.error(f.i);
        }
      }, 1);
    };
    b.prototype.C = function() {
      if (this.o)
        return false;
      var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
      if (typeof h === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof k === "function" ? f = new k("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return h(f);
    };
    b.prototype.B = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.G = function(f) {
      var k = this.j();
      f.K(k.resolve, k.reject);
    };
    b.prototype.H = function(f, k) {
      var h = this.j();
      try {
        f.call(k, h.resolve, h.reject);
      } catch (l) {
        h.reject(l);
      }
    };
    b.prototype.then = function(f, k) {
      function h(q, m) {
        return typeof q == "function" ? function(n) {
          try {
            l(q(n));
          } catch (r) {
            p(r);
          }
        } : m;
      }
      var l, p, t = new b(function(q, m) {
        l = q;
        p = m;
      });
      this.K(h(f, l), h(k, p));
      return t;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.K = function(f, k) {
      function h() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            k(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(h) : this.g.push(h);
      this.o = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(k, h) {
        h(f);
      });
    };
    b.race = function(f) {
      return new b(function(k, h) {
        for (var l = A(f), p = l.next(); !p.done; p = l.next())
          d(p.value).K(k, h);
      });
    };
    b.all = function(f) {
      var k = A(f), h = k.next();
      return h.done ? d([]) : new b(function(l, p) {
        function t(n) {
          return function(r) {
            q[n] = r;
            m--;
            m == 0 && l(q);
          };
        }
        var q = [], m = 0;
        do
          q.push(void 0), m++, d(h.value).K(t(q.length - 1), p), h = k.next();
        while (!h.done);
      });
    };
    return b;
  });
  function ua(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  z("Object.assign", function(a) {
    return a || va;
  });
  z("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  z("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  z("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  z("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ua(this, function(b) {
        return b;
      });
    };
  });
  var wa = this || self;
  function I(a, b) {
    a = a.split(".");
    var c = wa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function J(a) {
    throw a;
  }
  function xa(a, b) {
    J(Error("Invalid wire type: " + a + " (at position " + b + ")"));
  }
  function ya() {
    J(Error("Failed to read varint, encoding is invalid."));
  }
  function za(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var Aa, Ba = typeof TextDecoder !== "undefined", Ca, Da = typeof TextEncoder !== "undefined";
  function Ea(a) {
    if (Da)
      a = (Ca || (Ca = new TextEncoder())).encode(a);
    else {
      var b = void 0;
      b = b === void 0 ? false : b;
      for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
        var g = a.charCodeAt(e);
        if (128 > g)
          d[c++] = g;
        else {
          if (2048 > g)
            d[c++] = g >> 6 | 192;
          else {
            if (55296 <= g && 57343 >= g) {
              if (56319 >= g && e < a.length) {
                var f = a.charCodeAt(++e);
                if (56320 <= f && 57343 >= f) {
                  g = 1024 * (g - 55296) + f - 56320 + 65536;
                  d[c++] = g >> 18 | 240;
                  d[c++] = g >> 12 & 63 | 128;
                  d[c++] = g >> 6 & 63 | 128;
                  d[c++] = g & 63 | 128;
                  continue;
                } else
                  e--;
              }
              if (b)
                throw Error("Found an unpaired surrogate");
              g = 65533;
            }
            d[c++] = g >> 12 | 224;
            d[c++] = g >> 6 & 63 | 128;
          }
          d[c++] = g & 63 | 128;
        }
      }
      a = d.subarray(0, c);
    }
    return a;
  }
  var Fa = {}, Ga = null;
  function Ha(a) {
    var b;
    b === void 0 && (b = 0);
    Ia();
    b = Fa[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | k >> 4];
      k = b[(k & 15) << 2 | h >> 6];
      h = b[h & 63];
      c[g++] = l + f + k + h;
    }
    l = 0;
    h = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], h = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
    }
    return c.join("");
  }
  function Ja(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Ka(a, function(g) {
      d[e++] = g;
    });
    return d.subarray(0, e);
  }
  function Ka(a, b) {
    function c(h) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), p = Ga[l];
        if (p != null)
          return p;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return h;
    }
    Ia();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), k = c(64);
      if (k === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
    }
  }
  function Ia() {
    if (!Ga) {
      Ga = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Fa[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          Ga[g] === void 0 && (Ga[g] = e);
        }
      }
    }
  }
  var La = typeof Uint8Array === "function", Ma;
  function Na(a) {
    this.g = a;
    if (a !== null && a.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  var Oa = typeof Uint8Array.prototype.slice === "function";
  function Pa(a, b, c) {
    return b === c ? Ma || (Ma = new Uint8Array(0)) : Oa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
  }
  var K = 0, M = 0;
  function Qa(a) {
    if (a.constructor === Uint8Array)
      return a;
    if (a.constructor === ArrayBuffer)
      return new Uint8Array(a);
    if (a.constructor === Array)
      return new Uint8Array(a);
    if (a.constructor === String)
      return Ja(a);
    if (a.constructor === Na) {
      if (a.g == null)
        var b = Ma || (Ma = new Uint8Array(0));
      else {
        b = Uint8Array;
        var c = a.g;
        c = c == null || La && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? Ja(c) : null;
        a = a.g = c;
        b = new b(a);
      }
      return b;
    }
    if (a instanceof Uint8Array)
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ra(a, b) {
    b = b === void 0 ? {} : b;
    b = b.v === void 0 ? false : b.v;
    this.h = null;
    this.g = this.i = this.l = 0;
    this.j = false;
    this.v = b;
    a && Sa(this, a);
  }
  function Sa(a, b) {
    a.h = Qa(b);
    a.l = 0;
    a.i = a.h.length;
    a.g = a.l;
  }
  Ra.prototype.reset = function() {
    this.g = this.l;
  };
  function Ta(a) {
    for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)
      b = a.h[a.g++], c |= (b & 127) << 7 * e;
    128 <= b && (b = a.h[a.g++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b)
      for (e = 0; 5 > e && 128 <= b; e++)
        b = a.h[a.g++], d |= (b & 127) << 7 * e + 3;
    if (128 > b) {
      a = c >>> 0;
      b = d >>> 0;
      if (d = b & 2147483648)
        a = ~a + 1 >>> 0, b = ~b >>> 0, a == 0 && (b = b + 1 >>> 0);
      a = 4294967296 * b + (a >>> 0);
      return d ? -a : a;
    }
    a.j = true;
    ya();
  }
  function N(a) {
    a.g > a.i && (a.j = true, J(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
  }
  function O(a) {
    var b = a.h, c = b[a.g], d = c & 127;
    if (128 > c)
      return a.g += 1, N(a), d;
    c = b[a.g + 1];
    d |= (c & 127) << 7;
    if (128 > c)
      return a.g += 2, N(a), d;
    c = b[a.g + 2];
    d |= (c & 127) << 14;
    if (128 > c)
      return a.g += 3, N(a), d;
    c = b[a.g + 3];
    d |= (c & 127) << 21;
    if (128 > c)
      return a.g += 4, N(a), d;
    c = b[a.g + 4];
    d |= (c & 15) << 28;
    if (128 > c)
      return a.g += 5, N(a), d >>> 0;
    a.g += 5;
    if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++])
      return a.j = true, ya(), d;
    N(a);
    return d;
  }
  function Ua(a) {
    var b = a.h[a.g], c = a.h[a.g + 1], d = a.h[a.g + 2], e = a.h[a.g + 3];
    a.g += 4;
    N(a);
    return (b << 0 | c << 8 | d << 16 | e << 24) >>> 0;
  }
  Ra.prototype.m = function() {
    var a = Ua(this), b = 2 * (a >> 31) + 1, c = a >>> 23 & 255;
    a &= 8388607;
    return c == 255 ? a ? NaN : Infinity * b : c == 0 ? b * Math.pow(2, -149) * a : b * Math.pow(2, c - 150) * (a + Math.pow(2, 23));
  };
  var Va = [];
  function Wa() {
    this.g = new Uint8Array(64);
    this.h = 0;
  }
  function P(a, b) {
    if (!(a.h + 1 < a.g.length)) {
      var c = a.g;
      a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
      a.g.set(c);
    }
    a.g[a.h++] = b;
  }
  Wa.prototype.length = function() {
    return this.h;
  };
  Wa.prototype.end = function() {
    var a = this.g, b = this.h;
    this.h = 0;
    return Pa(a, 0, b);
  };
  function Q(a, b) {
    for (; 127 < b; )
      P(a, b & 127 | 128), b >>>= 7;
    P(a, b);
  }
  function Xa(a) {
    var b = {}, c = b.O === void 0 ? false : b.O;
    this.m = { v: b.v === void 0 ? false : b.v };
    this.O = c;
    b = this.m;
    Va.length ? (c = Va.pop(), b && (c.v = b.v), a && Sa(c, a), a = c) : a = new Ra(a, b);
    this.g = a;
    this.l = this.g.g;
    this.h = this.i = -1;
    this.j = false;
  }
  Xa.prototype.reset = function() {
    this.g.reset();
    this.h = this.i = -1;
  };
  function Ya(a) {
    var b = a.g;
    (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.j || 0 > b.g || b.g > b.i);
    if (b)
      return false;
    a.l = a.g.g;
    var c = O(a.g);
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      return a.j = true, xa(c, a.l), false;
    a.i = b;
    a.h = c;
    return true;
  }
  function Za(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Za(a);
        else
          a: {
            a = a.g;
            for (var b = a.g, c = 0; 10 > c; c++) {
              if ((a.h[b] & 128) === 0) {
                a.g = b + 1;
                N(a);
                break a;
              }
              b++;
            }
            a.j = true;
            ya();
          }
        break;
      case 1:
        a = a.g;
        a.g += 8;
        N(a);
        break;
      case 2:
        a.h != 2 ? Za(a) : (b = O(a.g), a = a.g, a.g += b, N(a));
        break;
      case 5:
        a = a.g;
        a.g += 4;
        N(a);
        break;
      case 3:
        b = a.i;
        do {
          if (!Ya(a)) {
            a.j = true;
            J(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (a.h == 4) {
            a.i != b && (a.j = true, J(Error("Unmatched end-group tag")));
            break;
          }
          Za(a);
        } while (1);
        break;
      default:
        a.j = true, xa(a.h, a.l);
    }
  }
  function $a(a, b, c) {
    var d = a.g.i, e = O(a.g), g = a.g.g + e;
    a.g.i = g;
    c(b, a);
    c = g - a.g.g;
    if (c !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (e + " bytes, instead read " + (e - c) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.g.g = g;
    a.g.i = d;
    return b;
  }
  var ab = [];
  function bb() {
    this.h = [];
    this.i = 0;
    this.g = new Wa();
  }
  function cb(a, b) {
    b.length !== 0 && (a.h.push(b), a.i += b.length);
  }
  function db(a, b, c) {
    Q(a.g, 8 * b + 2);
    Q(a.g, c.length);
    cb(a, a.g.end());
    cb(a, c);
  }
  var eb = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
  function fb(a) {
    Object.isFrozen(a) || (eb ? a[eb] |= 1 : a.g !== void 0 ? a.g |= 1 : Object.defineProperties(a, { g: { value: 1, configurable: true, writable: true, enumerable: false } }));
    return a;
  }
  function gb(a) {
    return a !== null && typeof a === "object" && a.constructor === Object;
  }
  function hb(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        if (La && a != null && a instanceof Uint8Array)
          return Ha(a);
        if (a instanceof Na) {
          if (a.g == null)
            a = "";
          else {
            var b = a.g;
            b = b == null || typeof b === "string" ? b : La && b instanceof Uint8Array ? Ha(b) : null;
            a = a.g = b;
          }
          return a;
        }
    }
    return a;
  }
  function ib(a, b) {
    if (a != null)
      return Array.isArray(a) || gb(a) ? jb(a, b) : b(a);
  }
  function jb(a, b) {
    if (Array.isArray(a)) {
      for (var c = Array(a.length), d = 0; d < a.length; d++)
        c[d] = ib(a[d], b);
      if (b = Array.isArray(a)) {
        var e;
        eb ? e = a[eb] : e = a.g;
        b = (e == null ? 0 : e) & 1;
      }
      b && fb(c);
      return c;
    }
    e = {};
    for (c in a)
      e[c] = ib(a[c], b);
    return e;
  }
  function kb(a) {
    a = hb(a);
    return Array.isArray(a) ? jb(a, kb) : a;
  }
  var lb;
  function R(a, b, c) {
    var d = lb;
    lb = null;
    a || (a = d);
    d = this.constructor.ha;
    a || (a = d ? [d] : []);
    this.i = (d ? 0 : -1) - (this.constructor.fa || 0);
    this.l = this.g = null;
    this.u = a;
    a: {
      d = this.u.length;
      a = d - 1;
      if (d && (d = this.u[a], gb(d))) {
        this.j = a - this.i;
        this.h = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.j = Math.max(b, a + 1 - this.i), this.h = null) : this.j = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        a = c[b], a < this.j ? (a += this.i, (d = this.u[a]) ? Array.isArray(d) && fb(d) : this.u[a] = mb) : (nb(this), (d = this.h[a]) ? Array.isArray(d) && fb(d) : this.h[a] = mb);
  }
  var mb = Object.freeze(fb([]));
  function nb(a) {
    var b = a.j + a.i;
    a.u[b] || (a.h = a.u[b] = {});
  }
  function S(a, b, c) {
    return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.j ? a.h ? a.h[b] : void 0 : a.u[b + a.i];
  }
  function ob(a, b, c) {
    c = c === void 0 ? false : c;
    var d = S(a, b, c);
    d == null && (d = mb);
    d === mb && (d = fb(d.slice()), T(a, b, d, c));
    return d;
  }
  function pb(a, b) {
    var c = ob(a, b);
    a.l || (a.l = {});
    if (!a.l[b]) {
      for (var d = 0; d < c.length; d++)
        c[d] = +c[d];
      a.l[b] = true;
    }
    return c;
  }
  function V(a, b, c) {
    a = S(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function T(a, b, c, d) {
    (d === void 0 ? 0 : d) || b >= a.j ? (nb(a), a.h[b] = c) : a.u[b + a.i] = c;
  }
  function qb(a, b, c, d) {
    c !== d ? T(a, b, c) : T(a, b, void 0, false);
  }
  function rb(a, b, c) {
    if (c === -1)
      return null;
    a.g || (a.g = {});
    var d = a.g[c];
    if (d)
      return d;
    var e = S(a, c, false);
    if (e == null)
      return d;
    b = new b(e);
    return a.g[c] = b;
  }
  function sb(a, b, c) {
    a.g || (a.g = {});
    var d = a.g[c];
    if (!d) {
      var e = ob(a, c, false);
      d = [];
      for (var g = 0; g < e.length; g++)
        d[g] = new b(e[g]);
      a.g[c] = d;
    }
    return d;
  }
  function tb(a, b, c, d, e) {
    var g = sb(a, d, b);
    c = c ? c : new d();
    a = ob(a, b);
    e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, c.u)) : (g.push(c), a.push(c.u));
  }
  R.prototype.toJSON = function() {
    return jb(this.u, kb);
  };
  R.prototype.toString = function() {
    return this.u.toString();
  };
  function ub(a, b) {
    a = S(a, b);
    return a == null ? 0 : a;
  }
  function vb(a, b) {
    a = S(a, b);
    return a == null ? "" : a;
  }
  function wb(a, b) {
    if (a = a.m) {
      cb(b, b.g.end());
      for (var c = 0; c < a.length; c++)
        cb(b, a[c]);
    }
  }
  var xb = Symbol();
  function yb(a, b, c) {
    return a[xb] || (a[xb] = function(d, e) {
      return b(d, e, c);
    });
  }
  function zb(a) {
    var b = a[xb];
    if (!b) {
      var c = a[Ab] || (a[Ab] = a());
      b = function(d, e) {
        return Bb(d, e, c);
      };
      a[xb] = b;
    }
    return b;
  }
  function Cb(a) {
    var b = a.da;
    if (b)
      return zb(b);
    if (b = a.ia) {
      var c = a.Y;
      delete a.Y;
      return yb(a.W.g, b, c);
    }
  }
  function Db(a) {
    var b = Cb(a), c = a.W, d = a.ea;
    return b ? function(e, g) {
      return d(e, g, c, b);
    } : function(e, g) {
      return d(e, g, c);
    };
  }
  function Eb(a) {
    var b = a[0];
    switch (a.length) {
      case 2:
        var c = a[1];
        return function(m, n, r) {
          return b(m, n, r, c);
        };
      case 3:
        var d = a[1], e = zb(a[2]);
        return function(m, n, r) {
          return b(m, n, r, d, e);
        };
      case 4:
        var g = a[1], f = a[3], k = zb(a[2]);
        return function(m, n, r) {
          return b(m, n, r, g, k, f);
        };
      case 5:
        var h = a[1], l = yb(h, a[3], a[4]);
        return function(m, n, r) {
          return b(m, n, r, h, l);
        };
      case 6:
        var p = a[1], t = a[5], q = yb(p, a[3], a[4]);
        return function(m, n, r) {
          return b(m, n, r, p, q, t);
        };
      default:
        throw Error("Unsupported number of parameters, expected [2-6], got " + a.length);
    }
  }
  var Ab = Symbol();
  function Bb(a, b, c) {
    for (; Ya(b) && b.h != 4; ) {
      var d = b.i, e = c[d];
      if (e)
        Array.isArray(e) && (e = c[d] = Eb(e));
      else {
        var g = c[0];
        g && (g = g[d]) && (e = c[d] = Db(g));
      }
      e && e(b, a, d) || (e = b, d = a, g = e.l, Za(e), e.O || (e = Pa(e.g.h, g, e.g.g), (g = d.m) ? g.push(e) : d.m = [e]));
    }
    return a;
  }
  function Fb(a, b) {
    var c = new bb();
    b(a, c);
    a = c.i + c.g.length();
    if (a === 0)
      c = new Uint8Array(0);
    else {
      a = new Uint8Array(a);
      for (var d = c.h, e = d.length, g = b = 0; g < e; g++) {
        var f = d[g];
        f.length !== 0 && (a.set(f, b), b += f.length);
      }
      d = c.g;
      e = d.h;
      e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
      c.h = [a];
      c = a;
    }
    return c;
  }
  function Gb(a, b, c) {
    if (ab.length) {
      var d = ab.pop();
      a && (Sa(d.g, a), d.i = -1, d.h = -1);
      a = d;
    } else
      a = new Xa(a);
    try {
      var e = new b();
      return Bb(e, a, c[Ab] || (c[Ab] = c()));
    } finally {
      b = a.g, b.h = null, b.l = 0, b.i = 0, b.g = 0, b.j = false, b.v = false, a.i = -1, a.h = -1, a.j = false, 100 > ab.length && ab.push(a);
    }
  }
  function W(a, b, c) {
    b = S(b, c);
    if (b != null) {
      Q(a.g, 8 * c + 5);
      a = a.g;
      var d = b;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? K = M = 0 : (M = 0, K = 2147483648) : isNaN(d) ? (M = 0, K = 2147483647) : 34028234663852886e22 < d ? (M = 0, K = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), M = 0, K = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, M = 0, K = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = K;
      P(a, c >>> 0 & 255);
      P(a, c >>> 8 & 255);
      P(a, c >>> 16 & 255);
      P(a, c >>> 24 & 255);
    }
  }
  function Hb(a, b, c) {
    if (a.h !== 1)
      return false;
    var d = a.g;
    a = Ua(d);
    var e = Ua(d);
    d = 2 * (e >> 31) + 1;
    var g = e >>> 20 & 2047;
    a = 4294967296 * (e & 1048575) + a;
    qb(b, c, g == 2047 ? a ? NaN : Infinity * d : g == 0 ? d * Math.pow(2, -1074) * a : d * Math.pow(2, g - 1075) * (a + 4503599627370496), 0);
    return true;
  }
  function X(a, b, c) {
    if (a.h !== 5)
      return false;
    T(b, c, a.g.m());
    return true;
  }
  function Y(a, b, c) {
    if (a.h !== 5 && a.h !== 2)
      return false;
    b = ob(b, c);
    if (a.h == 2) {
      c = Ra.prototype.m;
      var d = O(a.g);
      for (d = a.g.g + d; a.g.g < d; )
        b.push(c.call(a.g));
    } else
      b.push(a.g.m());
    return true;
  }
  function Z(a, b, c) {
    if (a.h !== 5)
      return false;
    a = a.g.m();
    qb(b, c, a, 0);
    return true;
  }
  function Ib(a, b, c) {
    if (a.h !== 0)
      return false;
    T(b, c, Ta(a.g));
    return true;
  }
  function Jb(a, b, c) {
    if (a.h !== 0)
      return false;
    T(b, c, O(a.g));
    return true;
  }
  function Kb(a, b, c) {
    if (a.h !== 0)
      return false;
    a = O(a.g);
    qb(b, c, a, 0);
    return true;
  }
  function Lb(a, b, c) {
    if (a.h !== 0)
      return false;
    a = !!O(a.g);
    qb(b, c, a, false);
    return true;
  }
  function Mb(a, b, c) {
    if (a.h !== 2)
      return false;
    var d = O(a.g);
    a = a.g;
    var e = a.g;
    a.g += d;
    N(a);
    a = a.h;
    var g;
    if (Ba)
      (g = Aa) || (g = Aa = new TextDecoder("utf-8", { fatal: false })), g = g.decode(a.subarray(e, e + d));
    else {
      d = e + d;
      for (var f = [], k = null, h, l, p; e < d; )
        h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((p = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | p & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = za(k, f), f.length = 0);
      g = za(k, f);
    }
    T(b, c, g);
    return true;
  }
  function Nb(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    a = $a(a, new d(), e);
    b.g || (b.g = {});
    d = a ? a.u : a;
    b.g[c] = a;
    T(b, c, d, false);
    return true;
  }
  function Ob(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    a = $a(a, new d(), e);
    tb(b, c, a, d, void 0);
    return true;
  }
  function Pb(a, b, c) {
    if (a.h !== 0)
      return false;
    T(b, c, Ta(a.g));
    return true;
  }
  function Qb(a) {
    R.call(this, a);
  }
  C(Qb, R);
  function Rb() {
    return { 1: Jb, 2: X, 3: Mb, 4: Mb };
  }
  function Sb(a, b) {
    var c = S(a, 1);
    if (c != null && c != null) {
      Q(b.g, 8);
      var d = b.g;
      if (0 <= c)
        Q(d, c);
      else {
        for (var e = 0; 9 > e; e++)
          P(d, c & 127 | 128), c >>= 7;
        P(d, 1);
      }
    }
    W(b, a, 2);
    d = S(a, 3);
    d != null && db(b, 3, Ea(d));
    d = S(a, 4);
    d != null && db(b, 4, Ea(d));
    wb(a, b);
  }
  function Tb(a) {
    R.call(this, a, -1, Ub);
  }
  C(Tb, R);
  Tb.prototype.addClassification = function(a, b) {
    tb(this, 1, a, Qb, b);
    return this;
  };
  function Vb() {
    return { 1: [Ob, Qb, Rb] };
  }
  var Ub = [1];
  function Wb(a) {
    R.call(this, a);
  }
  C(Wb, R);
  function Xb() {
    return { 1: X, 2: X, 3: X, 4: X, 5: X };
  }
  function Yb(a, b) {
    W(b, a, 1);
    W(b, a, 2);
    W(b, a, 3);
    W(b, a, 4);
    W(b, a, 5);
    wb(a, b);
  }
  function Zb(a) {
    R.call(this, a, -1, $b);
  }
  C(Zb, R);
  function ac() {
    return { 1: [Ob, Wb, Xb] };
  }
  var $b = [1];
  function bc(a) {
    R.call(this, a);
  }
  C(bc, R);
  function cc() {
    return { 1: X, 2: X, 3: X, 4: X, 5: X, 6: Ib };
  }
  function dc(a, b) {
    W(b, a, 1);
    W(b, a, 2);
    W(b, a, 3);
    W(b, a, 4);
    W(b, a, 5);
    var c = S(a, 6);
    if (c != null && c != null) {
      Q(b.g, 48);
      var d = b.g, e = c;
      c = 0 > e;
      e = Math.abs(e);
      var g = e >>> 0;
      e = Math.floor((e - g) / 4294967296);
      e >>>= 0;
      c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
      K = g;
      M = e;
      c = K;
      for (g = M; 0 < g || 127 < c; )
        P(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
      P(d, c);
    }
    wb(a, b);
  }
  function ec(a) {
    R.call(this, a, -1, fc);
  }
  C(ec, R);
  function gc() {
    return { 1: Pb, 2: Pb, 3: Y, 4: [Nb, hc, ic], 5: Jb, 6: Jb, 7: Y, 8: Y, 9: Y };
  }
  function hc(a) {
    R.call(this, a);
  }
  C(hc, R);
  function ic() {
    return { 1: X, 2: X, 3: X };
  }
  var fc = [3, 7, 8, 9];
  function jc(a) {
    R.call(this, a);
  }
  C(jc, R);
  function kc() {
    return { 1: Z, 2: Z, 3: Z };
  }
  function lc(a) {
    R.call(this, a);
  }
  C(lc, R);
  function mc() {
    return { 1: Z, 2: Z, 3: Z };
  }
  function nc(a) {
    R.call(this, a);
  }
  C(nc, R);
  function oc() {
    return { 1: Kb, 2: [Nb, lc, mc], 3: [Nb, jc, kc], 4: Lb };
  }
  function pc(a) {
    R.call(this, a, -1, qc);
  }
  C(pc, R);
  function rc() {
    return { 1: Kb, 2: [Ob, nc, oc], 3: Z, 4: Y, 5: Y, 6: Y };
  }
  var qc = [2, 4, 5, 6];
  function sc(a) {
    R.call(this, a, -1, tc);
  }
  C(sc, R);
  function uc() {
    return { 1: Kb, 2: [Ob, pc, rc], 3: [Nb, ec, gc], 4: Hb, 5: Y, 6: Y };
  }
  var tc = [2, 5, 6];
  function vc(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function wc(a) {
    return sb(a, Qb, 1).map(function(b) {
      return { index: ub(b, 1), $: V(b, 2), label: S(b, 3) != null ? vb(b, 3) : void 0, displayName: S(b, 4) != null ? vb(b, 4) : void 0 };
    });
  }
  function xc(a) {
    return { x: V(a, 1), y: V(a, 2), z: V(a, 3), visibility: S(a, 4) != null ? V(a, 4) : void 0 };
  }
  function yc(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function zc(a, b, c) {
    Ac(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function Ac(a, b) {
    var c = a.g;
    if (a.m === void 0) {
      var d = vc(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = vc(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.m = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { J: c.getAttribLocation(d, "aVertex"), I: c.getAttribLocation(d, "aTex"), ja: e };
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.J);
      c.vertexAttribPointer(a.j.J, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.o = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.o);
      c.enableVertexAttribArray(a.j.I);
      c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.m);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.J);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.J, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, a.o);
    c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.J);
    c.disableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function Bc(a) {
    this.g = a;
  }
  var Cc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function Dc(a, b) {
    return b + a;
  }
  function Ec(a, b) {
    window[a] = b;
  }
  function Fc(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function Gc() {
    return H(function(a) {
      switch (a.g) {
        case 1:
          return a.m = 2, E(a, WebAssembly.instantiate(Cc), 4);
        case 4:
          a.g = 3;
          a.m = 0;
          break;
        case 2:
          return a.m = 0, a.j = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function Hc(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.G = {};
    this.m = {};
    this.s = {};
    this.H = this.o = this.S = true;
    this.D = Promise.resolve();
    this.R = "";
    this.C = {};
    this.locateFile = a && a.locateFile || Dc;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.T = b;
    if (a.options) {
      b = A(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  v = Hc.prototype;
  v.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function Ic(a) {
    var b, c, d, e, g, f, k, h, l, p, t;
    return H(function(q) {
      switch (q.g) {
        case 1:
          if (!a.S)
            return q.return();
          b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
          return E(q, Gc(), 2);
        case 2:
          c = q.h;
          if (typeof window === "object")
            return Ec("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), Ec("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(m) {
              return m.data !== void 0;
            }), k = b.filter(function(m) {
              return m.data === void 0;
            }), h = Promise.all(f.map(function(m) {
              var n = Jc(a, m.url);
              if (m.path !== void 0) {
                var r = m.path;
                n = n.then(function(x) {
                  a.overrideFile(r, x);
                  return Promise.resolve(x);
                });
              }
              return n;
            })), l = Promise.all(k.map(function(m) {
              return m.simd === void 0 || m.simd && c || !m.simd && !c ? Fc(a.locateFile(m.url, a.T)) : Promise.resolve();
            })).then(function() {
              var m, n, r;
              return H(function(x) {
                if (x.g == 1)
                  return m = window.createMediapipeSolutionsWasm, n = window.createMediapipeSolutionsPackedAssets, r = a, E(x, m(n), 2);
                r.h = x.h;
                x.g = 0;
              });
            }), p = function() {
              return H(function(m) {
                a.g.graph && a.g.graph.url ? m = E(m, Jc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                return m;
              });
            }(), E(q, Promise.all([l, h, p]), 7);
          if (typeof importScripts !== "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(m) {
            return m.simd === void 0 || m.simd && c || !m.simd && !c;
          }).map(function(m) {
            return a.locateFile(m.url, a.T);
          });
          importScripts.apply(null, ea(d));
          e = a;
          return E(q, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          e.h = q.h;
          a.l = new OffscreenCanvas(1, 1);
          a.h.canvas = a.l;
          g = a.h.GL.createContext(a.l, {
            antialias: false,
            alpha: false,
            ga: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
          });
          a.h.GL.makeContextCurrent(g);
          q.g = 4;
          break;
        case 7:
          a.l = document.createElement("canvas");
          t = a.l.getContext("webgl2", {});
          if (!t && (t = a.l.getContext("webgl", {}), !t))
            return alert("Failed to create WebGL canvas context when passing video frame."), q.return();
          a.F = t;
          a.h.canvas = a.l;
          a.h.createContext(a.l, true, true, {});
        case 4:
          a.i = new a.h.SolutionWasm(), a.S = false, q.g = 0;
      }
    });
  }
  function Kc(a) {
    var b, c, d, e, g, f, k, h;
    return H(function(l) {
      if (l.g == 1) {
        if (a.g.graph && a.g.graph.url && a.R === a.g.graph.url)
          return l.return();
        a.o = true;
        if (!a.g.graph || !a.g.graph.url) {
          l.g = 2;
          return;
        }
        a.R = a.g.graph.url;
        return E(l, Jc(a, a.g.graph.url), 3);
      }
      l.g != 2 && (b = l.h, a.i.loadGraph(b));
      c = A(Object.keys(a.C));
      for (d = c.next(); !d.done; d = c.next())
        e = d.value, a.i.overrideFile(e, a.C[e]);
      a.C = {};
      if (a.g.listeners)
        for (g = A(a.g.listeners), f = g.next(); !f.done; f = g.next())
          k = f.value, Lc(a, k);
      h = a.j;
      a.j = {};
      a.setOptions(h);
      l.g = 0;
    });
  }
  v.reset = function() {
    var a = this;
    return H(function(b) {
      a.i && (a.i.reset(), a.m = {}, a.s = {});
      b.g = 0;
    });
  };
  v.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = A(Object.keys(a)), k = f.next(); !k.done; g = { L: g.L, M: g.M }, k = f.next()) {
        var h = k.value;
        h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.L = k.onChange, g.M = a[h], d.push(function(l) {
          return function() {
            var p;
            return H(function(t) {
              if (t.g == 1)
                return E(t, l.L(l.M), 2);
              p = t.h;
              p === true && (c.o = true);
              t.g = 0;
            });
          };
        }(g))), k.graphOptionXref && (h = { valueNumber: k.type === 1 ? a[h] : 0, valueBoolean: k.type === 0 ? a[h] : false, valueString: k.type === 2 ? a[h] : "" }, k = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), k.graphOptionXref), h), e.push(k))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.o = true, this.B = (this.B === void 0 ? [] : this.B).concat(e), this.A = (this.A === void 0 ? [] : this.A).concat(d);
    }
  };
  function Mc(a) {
    var b, c, d, e, g, f, k;
    return H(function(h) {
      switch (h.g) {
        case 1:
          if (!a.o)
            return h.return();
          if (!a.A) {
            h.g = 2;
            break;
          }
          b = A(a.A);
          c = b.next();
        case 3:
          if (c.done) {
            h.g = 5;
            break;
          }
          d = c.value;
          return E(h, d(), 4);
        case 4:
          c = b.next();
          h.g = 3;
          break;
        case 5:
          a.A = void 0;
        case 2:
          if (a.B) {
            e = new a.h.GraphOptionChangeRequestList();
            g = A(a.B);
            for (f = g.next(); !f.done; f = g.next())
              k = f.value, e.push_back(k);
            a.i.changeOptions(e);
            e.delete();
            a.B = void 0;
          }
          a.o = false;
          h.g = 0;
      }
    });
  }
  v.initialize = function() {
    var a = this;
    return H(function(b) {
      return b.g == 1 ? E(b, Ic(a), 2) : b.g != 3 ? E(b, Kc(a), 3) : E(b, Mc(a), 0);
    });
  };
  function Jc(a, b) {
    var c, d;
    return H(function(e) {
      if (b in a.G)
        return e.return(a.G[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.G[b] = d;
      return e.return(d);
    });
  }
  v.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.C[a] = b;
  };
  v.clearOverriddenFiles = function() {
    this.C = {};
    this.i && this.i.clearOverriddenFiles();
  };
  v.send = function(a, b) {
    var c = this, d, e, g, f, k, h, l, p, t;
    return H(function(q) {
      switch (q.g) {
        case 1:
          if (!c.g.inputs)
            return q.return();
          d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
          return E(q, c.D, 2);
        case 2:
          return E(q, c.initialize(), 3);
        case 3:
          e = new c.h.PacketDataList();
          g = A(Object.keys(a));
          for (f = g.next(); !f.done; f = g.next())
            if (k = f.value, h = c.g.inputs[k]) {
              a: {
                var m = a[k];
                switch (h.type) {
                  case "video":
                    var n = c.m[h.stream];
                    n || (n = new yc(c.h, c.F), c.m[h.stream] = n);
                    n.l === 0 && (n.l = n.h.createTexture());
                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                      var r = m.videoWidth;
                      var x = m.videoHeight;
                    } else
                      typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (r = m.naturalWidth, x = m.naturalHeight) : (r = m.width, x = m.height);
                    x = { glName: n.l, width: r, height: x };
                    r = n.g;
                    r.canvas.width = x.width;
                    r.canvas.height = x.height;
                    r.activeTexture(r.TEXTURE0);
                    n.h.bindTexture2d(n.l);
                    r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, m);
                    n.h.bindTexture2d(0);
                    n = x;
                    break a;
                  case "detections":
                    n = c.m[h.stream];
                    n || (n = new Bc(c.h), c.m[h.stream] = n);
                    n.data || (n.data = new n.g.DetectionListData());
                    n.data.reset(m.length);
                    for (x = 0; x < m.length; ++x) {
                      r = m[x];
                      var w = n.data, D = w.setBoundingBox, L = x;
                      var G = r.U;
                      var u = new bc();
                      T(u, 1, G.aa);
                      T(u, 2, G.ba);
                      T(u, 3, G.height);
                      T(u, 4, G.width);
                      T(u, 5, G.rotation);
                      T(u, 6, G.Z);
                      G = Fb(u, dc);
                      D.call(w, L, G);
                      if (r.P)
                        for (w = 0; w < r.P.length; ++w) {
                          u = r.P[w];
                          var B = u.visibility ? true : false;
                          D = n.data;
                          L = D.addNormalizedLandmark;
                          G = x;
                          u = Object.assign(Object.assign({}, u), { visibility: B ? u.visibility : 0 });
                          B = new Wb();
                          T(B, 1, u.x);
                          T(B, 2, u.y);
                          T(B, 3, u.z);
                          u.visibility && T(B, 4, u.visibility);
                          u = Fb(B, Yb);
                          L.call(D, G, u);
                        }
                      if (r.N)
                        for (w = 0; w < r.N.length; ++w)
                          D = n.data, L = D.addClassification, G = x, u = r.N[w], B = new Qb(), T(B, 2, u.$), u.index && T(B, 1, u.index), u.label && T(B, 3, u.label), u.displayName && T(B, 4, u.displayName), u = Fb(B, Sb), L.call(D, G, u);
                    }
                    n = n.data;
                    break a;
                  default:
                    n = {};
                }
              }
              l = n;
              p = h.stream;
              switch (h.type) {
                case "video":
                  e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: p, timestamp: d }));
                  break;
                case "detections":
                  t = l;
                  t.stream = p;
                  t.timestamp = d;
                  e.pushDetectionList(t);
                  break;
                default:
                  throw Error("Unknown input config type: '" + h.type + "'");
              }
            }
          c.i.send(e);
          return E(q, c.D, 4);
        case 4:
          e.delete(), q.g = 0;
      }
    });
  };
  function Nc(a, b, c) {
    var d, e, g, f, k, h, l, p, t, q, m, n, r, x;
    return H(function(w) {
      switch (w.g) {
        case 1:
          if (!c)
            return w.return(b);
          d = {};
          e = 0;
          g = A(Object.keys(c));
          for (f = g.next(); !f.done; f = g.next())
            k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
          1 < e && (a.H = false);
          l = A(Object.keys(c));
          f = l.next();
        case 2:
          if (f.done) {
            w.g = 4;
            break;
          }
          p = f.value;
          t = c[p];
          if (typeof t === "string")
            return r = d, x = p, E(w, Oc(a, p, b[t]), 14);
          q = b[t.stream];
          if (t.type === "detection_list") {
            if (q) {
              var D = q.getRectList();
              for (var L = q.getLandmarksList(), G = q.getClassificationsList(), u = [], B = 0; B < D.size(); ++B) {
                var U = Gb(D.get(B), bc, cc);
                U = { U: { aa: V(U, 1), ba: V(U, 2), height: V(U, 3), width: V(U, 4), rotation: V(U, 5, 0), Z: ub(U, 6) }, P: sb(Gb(L.get(B), Zb, ac), Wb, 1).map(xc), N: wc(Gb(G.get(B), Tb, Vb)) };
                u.push(U);
              }
              D = u;
            } else
              D = [];
            d[p] = D;
            w.g = 7;
            break;
          }
          if (t.type === "proto_list") {
            if (q) {
              D = Array(q.size());
              for (L = 0; L < q.size(); L++)
                D[L] = q.get(L);
              q.delete();
            } else
              D = [];
            d[p] = D;
            w.g = 7;
            break;
          }
          if (q === void 0) {
            w.g = 3;
            break;
          }
          if (t.type === "float_list") {
            d[p] = q;
            w.g = 7;
            break;
          }
          if (t.type === "proto") {
            d[p] = q;
            w.g = 7;
            break;
          }
          if (t.type !== "texture")
            throw Error("Unknown output config type: '" + t.type + "'");
          m = a.s[p];
          m || (m = new yc(a.h, a.F), a.s[p] = m);
          return E(w, zc(m, q, a.H), 13);
        case 13:
          n = w.h, d[p] = n;
        case 7:
          t.transform && d[p] && (d[p] = t.transform(d[p]));
          w.g = 3;
          break;
        case 14:
          r[x] = w.h;
        case 3:
          f = l.next();
          w.g = 2;
          break;
        case 4:
          return w.return(d);
      }
    });
  }
  function Oc(a, b, c) {
    var d;
    return H(function(e) {
      return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new yc(a.h, a.F), a.s[b] = d), e.return(zc(d, c, a.H))) : e.return(void 0);
    });
  }
  function Lc(a, b) {
    for (var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = A(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(k) {
      for (var h = {}, l = 0; l < b.wants.length; ++l)
        h[d[l]] = k.get(l);
      var p = a.listeners[c];
      p && (a.D = Nc(a, h, b.outs).then(function(t) {
        t = p(t);
        for (var q = 0; q < b.wants.length; ++q) {
          var m = h[d[q]];
          typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
        }
        t && (a.D = t);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  v.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  I("Solution", Hc);
  I("OptionType", { BOOL: 0, NUMBER: 1, ca: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function Pc(a) {
    var b = ub(a, 1);
    var c = rb(a, jc, 3);
    c = { x: V(c, 1), y: V(c, 2), depth: V(c, 3) };
    a = rb(a, lc, 2);
    return { id: b, point2d: c, point3d: { x: V(a, 1), y: V(a, 2), z: V(a, 3) } };
  }
  function Qc(a) {
    var b = Gb(a, sc, uc);
    a = [];
    b = sb(b, pc, 2);
    for (var c = 0; c < b.length; c++)
      a.push({ id: ub(b[c], 1), keypoints: sb(b[c], nc, 2).map(Pc), visibility: V(b[c], 3), scale: pb(b[c], 6), translation: pb(b[c], 5), rotation: pb(b[c], 4) });
    return a;
  }
  function Rc(a) {
    switch (a) {
      case "Camera":
        return "object_detection_3d_camera.tflite";
      case "Chair":
        return "object_detection_3d_chair.tflite";
      case "Cup":
        return "object_detection_3d_cup.tflite";
      default:
        return "object_detection_3d_sneakers.tflite";
    }
  }
  function Sc(a) {
    switch (a) {
      case "Camera":
        return "Camera";
      case "Chair":
        return "Chair";
      case "Cup":
        return "Coffee cup, Mug";
      default:
        return "Footwear";
    }
  }
  var Tc = {
    focalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_x" } },
    focalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_y" } },
    principalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_x" } },
    principalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_y" } },
    allowedLabels: { type: 2, graphOptionXref: { calculatorName: "ConstantSidePacketCalculatorAllowedLabels", calculatorType: "ConstantSidePacketCalculator", fieldName: "string_value" } }
  };
  function Uc(a) {
    var b = this;
    a = a || {};
    this.g = new Hc({ locateFile: a.locateFile, files: [{ url: "objectron_solution_packed_assets_loader.js" }, { simd: false, url: "objectron_solution_wasm_bin.js" }, { simd: true, url: "objectron_solution_simd_wasm_bin.js" }], graph: { url: "objectron.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["lifted_objects", "image_transformed"], outs: { image: "image_transformed", objectDetections: { type: "proto", stream: "lifted_objects", transform: Qc } } }], options: {
      useCpuInference: {
        type: 0,
        graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" },
        default: typeof window !== "object" || window.navigator === void 0 ? false : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
      },
      selfieMode: { type: 0, default: false, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
      maxNumObjects: { type: 1, default: 5, graphOptionXref: {
        calculatorType: "ConstantSidePacketCalculator",
        calculatorName: "ConstantSidePacketCalculatorMaxNumObjects",
        fieldName: "int_value"
      } },
      staticImageMode: { type: 0, default: true, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "objectrongpusubgraph__ConstantSidePacketCalculator", fieldName: "bool_value" } },
      minDetectionConfidence: { type: 1, default: 0.5, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "objectrongpusubgraph__objectdetectionoidv4subgraph__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
      minTrackingConfidence: { type: 1, default: 0.99, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "objectrongpusubgraph__boxlandmarksubgraph__ThresholdingCalculator", fieldName: "threshold" } },
      modelName: { default: "Shoe", onChange: function(c) {
        var d, e, g, f;
        return H(function(k) {
          if (k.g == 1)
            return d = c, b.g.setOptions({ allowedLabels: Sc(d) }, Tc), e = Rc(d), g = "object_detection_3d.tflite", E(k, Jc(b.g, e), 2);
          f = k.h;
          b.g.overrideFile(g, f);
          return k.return(true);
        });
      } },
      focalLength: { default: [1, 1], onChange: function(c) {
        var d;
        return H(function(e) {
          d = c;
          b.h = d;
          b.g.setOptions({ focalX: d[0], focalY: d[1] }, Tc);
          return e.return(true);
        });
      } },
      principalPoint: { default: [0, 0], onChange: function(c) {
        var d;
        return H(function(e) {
          d = c;
          b.i = d;
          b.g.setOptions({ principalX: d[0], principalY: d[1] }, Tc);
          return e.return(true);
        });
      } },
      imageSize: { onChange: function(c) {
        var d, e, g, f;
        return H(function(k) {
          if (b.h === void 0 || b.i === void 0)
            return console.error('"focalLength" and "principalPoint" must be set if setting image size'), k.return();
          d = c;
          e = [d[0] / 2, d[1] / 2];
          g = [
            b.h[0] / e[0],
            b.h[1] / e[1]
          ];
          f = [b.i[0] / e[0], b.i[1] / e[1]];
          b.setOptions({ focalLength: g, principalPoint: f });
          k.g = 0;
        });
      } }
    } });
  }
  v = Uc.prototype;
  v.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  v.onResults = function(a) {
    this.g.onResults(a);
  };
  v.initialize = function() {
    var a = this;
    return H(function(b) {
      return E(b, a.g.initialize(), 0);
    });
  };
  v.reset = function() {
    this.g.reset();
  };
  v.send = function(a) {
    var b = this;
    return H(function(c) {
      return E(c, b.g.send(a), 0);
    });
  };
  v.setOptions = function(a) {
    this.g.setOptions(a);
  };
  I("Objectron", Uc);
  I("BOX_CONNECTIONS", [[1, 2], [2, 4], [4, 3], [3, 1], [5, 6], [6, 8], [8, 7], [7, 5], [1, 5], [2, 6], [3, 7], [4, 8]]);
  I("BOX_KEYPOINTS", { CENTER: 0, BACK_BOTTOM_LEFT: 1, FRONT_BOTTOM_LEFT: 2, BACK_TOP_LEFT: 3, FRONT_TOP_LEFT: 4, BACK_BOTTOM_RIGHT: 5, FRONT_BOTTOM_RIGHT: 6, BACK_TOP_RIGHT: 7, FRONT_TOP_RIGHT: 8 });
  I("VERSION", "0.4.1636596145");
}).call(VonageObjectron);
const VonagePose = {};
(function() {
  var x;
  function aa(a) {
    var b = 0;
    return function() {
      return b < a.length ? { done: false, value: a[b++] } : { done: true };
    };
  }
  var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype)
      return a;
    a[b] = c.value;
    return a;
  };
  function ca(a) {
    a = [typeof globalThis == "object" && globalThis, a, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math)
        return c;
    }
    throw Error("Cannot find global object");
  }
  var y = ca(this);
  function B(a, b) {
    if (b)
      a: {
        var c = y;
        a = a.split(".");
        for (var d = 0; d < a.length - 1; d++) {
          var e = a[d];
          if (!(e in c))
            break a;
          c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && b != null && ba(c, a, { configurable: true, writable: true, value: b });
      }
  }
  B("Symbol", function(a) {
    function b(g) {
      if (this instanceof b)
        throw new TypeError("Symbol is not a constructor");
      return new c(d + (g || "") + "_" + e++, g);
    }
    function c(g, f) {
      this.g = g;
      ba(this, "description", { configurable: true, writable: true, value: f });
    }
    if (a)
      return a;
    c.prototype.toString = function() {
      return this.g;
    };
    var d = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", e = 0;
    return b;
  });
  B("Symbol.iterator", function(a) {
    if (a)
      return a;
    a = Symbol("Symbol.iterator");
    for (var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++) {
      var d = y[b[c]];
      typeof d === "function" && typeof d.prototype[a] != "function" && ba(d.prototype, a, { configurable: true, writable: true, value: function() {
        return da(aa(this));
      } });
    }
    return a;
  });
  function da(a) {
    a = { next: a };
    a[Symbol.iterator] = function() {
      return this;
    };
    return a;
  }
  function C(a) {
    var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : { next: aa(a) };
  }
  function ea(a) {
    if (!(a instanceof Array)) {
      a = C(a);
      for (var b, c = []; !(b = a.next()).done; )
        c.push(b.value);
      a = c;
    }
    return a;
  }
  var fa = typeof Object.create == "function" ? Object.create : function(a) {
    function b() {
    }
    b.prototype = a;
    return new b();
  }, ha;
  if (typeof Object.setPrototypeOf == "function")
    ha = Object.setPrototypeOf;
  else {
    var ia;
    a: {
      var ja = { a: true }, ka = {};
      try {
        ka.__proto__ = ja;
        ia = ka.a;
        break a;
      } catch (a) {
      }
      ia = false;
    }
    ha = ia ? function(a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b)
        throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var la = ha;
  function E(a, b) {
    a.prototype = fa(b.prototype);
    a.prototype.constructor = a;
    if (la)
      la(a, b);
    else
      for (var c in b)
        if (c != "prototype")
          if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
          } else
            a[c] = b[c];
    a.ea = b.prototype;
  }
  function ma() {
    this.l = false;
    this.i = null;
    this.h = void 0;
    this.g = 1;
    this.s = this.m = 0;
    this.j = null;
  }
  function na(a) {
    if (a.l)
      throw new TypeError("Generator is already running");
    a.l = true;
  }
  ma.prototype.o = function(a) {
    this.h = a;
  };
  function oa(a, b) {
    a.j = { U: b, V: true };
    a.g = a.m || a.s;
  }
  ma.prototype.return = function(a) {
    this.j = { return: a };
    this.g = this.s;
  };
  function F(a, b, c) {
    a.g = c;
    return { value: b };
  }
  function pa(a) {
    this.g = new ma();
    this.h = a;
  }
  function qa(a, b) {
    na(a.g);
    var c = a.g.i;
    if (c)
      return ra(a, "return" in c ? c["return"] : function(d) {
        return { value: d, done: true };
      }, b, a.g.return);
    a.g.return(b);
    return G(a);
  }
  function ra(a, b, c, d) {
    try {
      var e = b.call(a.g.i, c);
      if (!(e instanceof Object))
        throw new TypeError("Iterator result " + e + " is not an object");
      if (!e.done)
        return a.g.l = false, e;
      var g = e.value;
    } catch (f) {
      return a.g.i = null, oa(a.g, f), G(a);
    }
    a.g.i = null;
    d.call(a.g, g);
    return G(a);
  }
  function G(a) {
    for (; a.g.g; )
      try {
        var b = a.h(a.g);
        if (b)
          return a.g.l = false, { value: b.value, done: false };
      } catch (c) {
        a.g.h = void 0, oa(a.g, c);
      }
    a.g.l = false;
    if (a.g.j) {
      b = a.g.j;
      a.g.j = null;
      if (b.V)
        throw b.U;
      return { value: b.return, done: true };
    }
    return { value: void 0, done: true };
  }
  function sa(a) {
    this.next = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i.next, b, a.g.o) : (a.g.o(b), b = G(a));
      return b;
    };
    this.throw = function(b) {
      na(a.g);
      a.g.i ? b = ra(a, a.g.i["throw"], b, a.g.o) : (oa(a.g, b), b = G(a));
      return b;
    };
    this.return = function(b) {
      return qa(a, b);
    };
    this[Symbol.iterator] = function() {
      return this;
    };
  }
  function ta(a) {
    function b(d) {
      return a.next(d);
    }
    function c(d) {
      return a.throw(d);
    }
    return new Promise(function(d, e) {
      function g(f) {
        f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
      }
      g(a.next());
    });
  }
  function H(a) {
    return ta(new sa(new pa(a)));
  }
  B("Promise", function(a) {
    function b(f) {
      this.h = 0;
      this.i = void 0;
      this.g = [];
      this.o = false;
      var k = this.j();
      try {
        f(k.resolve, k.reject);
      } catch (h) {
        k.reject(h);
      }
    }
    function c() {
      this.g = null;
    }
    function d(f) {
      return f instanceof b ? f : new b(function(k) {
        k(f);
      });
    }
    if (a)
      return a;
    c.prototype.h = function(f) {
      if (this.g == null) {
        this.g = [];
        var k = this;
        this.i(function() {
          k.l();
        });
      }
      this.g.push(f);
    };
    var e = y.setTimeout;
    c.prototype.i = function(f) {
      e(f, 0);
    };
    c.prototype.l = function() {
      for (; this.g && this.g.length; ) {
        var f = this.g;
        this.g = [];
        for (var k = 0; k < f.length; ++k) {
          var h = f[k];
          f[k] = null;
          try {
            h();
          } catch (l) {
            this.j(l);
          }
        }
      }
      this.g = null;
    };
    c.prototype.j = function(f) {
      this.i(function() {
        throw f;
      });
    };
    b.prototype.j = function() {
      function f(l) {
        return function(n) {
          h || (h = true, l.call(k, n));
        };
      }
      var k = this, h = false;
      return { resolve: f(this.C), reject: f(this.l) };
    };
    b.prototype.C = function(f) {
      if (f === this)
        this.l(new TypeError("A Promise cannot resolve to itself"));
      else if (f instanceof b)
        this.F(f);
      else {
        a:
          switch (typeof f) {
            case "object":
              var k = f != null;
              break a;
            case "function":
              k = true;
              break a;
            default:
              k = false;
          }
        k ? this.v(f) : this.m(f);
      }
    };
    b.prototype.v = function(f) {
      var k = void 0;
      try {
        k = f.then;
      } catch (h) {
        this.l(h);
        return;
      }
      typeof k == "function" ? this.G(k, f) : this.m(f);
    };
    b.prototype.l = function(f) {
      this.s(2, f);
    };
    b.prototype.m = function(f) {
      this.s(1, f);
    };
    b.prototype.s = function(f, k) {
      if (this.h != 0)
        throw Error("Cannot settle(" + f + ", " + k + "): Promise already settled in state" + this.h);
      this.h = f;
      this.i = k;
      this.h === 2 && this.D();
      this.A();
    };
    b.prototype.D = function() {
      var f = this;
      e(function() {
        if (f.B()) {
          var k = y.console;
          typeof k !== "undefined" && k.error(f.i);
        }
      }, 1);
    };
    b.prototype.B = function() {
      if (this.o)
        return false;
      var f = y.CustomEvent, k = y.Event, h = y.dispatchEvent;
      if (typeof h === "undefined")
        return true;
      typeof f === "function" ? f = new f("unhandledrejection", { cancelable: true }) : typeof k === "function" ? f = new k("unhandledrejection", { cancelable: true }) : (f = y.document.createEvent("CustomEvent"), f.initCustomEvent("unhandledrejection", false, true, f));
      f.promise = this;
      f.reason = this.i;
      return h(f);
    };
    b.prototype.A = function() {
      if (this.g != null) {
        for (var f = 0; f < this.g.length; ++f)
          g.h(this.g[f]);
        this.g = null;
      }
    };
    var g = new c();
    b.prototype.F = function(f) {
      var k = this.j();
      f.J(k.resolve, k.reject);
    };
    b.prototype.G = function(f, k) {
      var h = this.j();
      try {
        f.call(k, h.resolve, h.reject);
      } catch (l) {
        h.reject(l);
      }
    };
    b.prototype.then = function(f, k) {
      function h(p, m) {
        return typeof p == "function" ? function(q) {
          try {
            l(p(q));
          } catch (t) {
            n(t);
          }
        } : m;
      }
      var l, n, r = new b(function(p, m) {
        l = p;
        n = m;
      });
      this.J(h(f, l), h(k, n));
      return r;
    };
    b.prototype.catch = function(f) {
      return this.then(void 0, f);
    };
    b.prototype.J = function(f, k) {
      function h() {
        switch (l.h) {
          case 1:
            f(l.i);
            break;
          case 2:
            k(l.i);
            break;
          default:
            throw Error("Unexpected state: " + l.h);
        }
      }
      var l = this;
      this.g == null ? g.h(h) : this.g.push(h);
      this.o = true;
    };
    b.resolve = d;
    b.reject = function(f) {
      return new b(function(k, h) {
        h(f);
      });
    };
    b.race = function(f) {
      return new b(function(k, h) {
        for (var l = C(f), n = l.next(); !n.done; n = l.next())
          d(n.value).J(k, h);
      });
    };
    b.all = function(f) {
      var k = C(f), h = k.next();
      return h.done ? d([]) : new b(function(l, n) {
        function r(q) {
          return function(t) {
            p[q] = t;
            m--;
            m == 0 && l(p);
          };
        }
        var p = [], m = 0;
        do
          p.push(void 0), m++, d(h.value).J(r(p.length - 1), n), h = k.next();
        while (!h.done);
      });
    };
    return b;
  });
  function ua(a, b) {
    a instanceof String && (a += "");
    var c = 0, d = false, e = { next: function() {
      if (!d && c < a.length) {
        var g = c++;
        return { value: b(g, a[g]), done: false };
      }
      d = true;
      return { done: true, value: void 0 };
    } };
    e[Symbol.iterator] = function() {
      return e;
    };
    return e;
  }
  var va = typeof Object.assign == "function" ? Object.assign : function(a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (d)
        for (var e in d)
          Object.prototype.hasOwnProperty.call(d, e) && (a[e] = d[e]);
    }
    return a;
  };
  B("Object.assign", function(a) {
    return a || va;
  });
  B("Object.is", function(a) {
    return a ? a : function(b, c) {
      return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
    };
  });
  B("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      var d = this;
      d instanceof String && (d = String(d));
      var e = d.length;
      c = c || 0;
      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var g = d[c];
        if (g === b || Object.is(g, b))
          return true;
      }
      return false;
    };
  });
  B("String.prototype.includes", function(a) {
    return a ? a : function(b, c) {
      if (this == null)
        throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
      if (b instanceof RegExp)
        throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
      return this.indexOf(b, c || 0) !== -1;
    };
  });
  B("Array.prototype.keys", function(a) {
    return a ? a : function() {
      return ua(this, function(b) {
        return b;
      });
    };
  });
  var wa = this || self;
  function J(a, b) {
    a = a.split(".");
    var c = wa;
    a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
    for (var d; a.length && (d = a.shift()); )
      a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
  }
  function xa(a) {
    wa.setTimeout(function() {
      throw a;
    }, 0);
  }
  function K(a) {
    xa(a);
    return;
  }
  function ya(a, b) {
    K(Error("Invalid wire type: " + a + " (at position " + b + ")"));
  }
  function za() {
    K(Error("Failed to read varint, encoding is invalid."));
  }
  function Aa(a, b) {
    b = String.fromCharCode.apply(null, b);
    return a == null ? b : a + b;
  }
  var Ba, Ca = typeof TextDecoder !== "undefined", Da, Ea = typeof TextEncoder !== "undefined";
  function Fa(a) {
    if (Ea)
      a = (Da || (Da = new TextEncoder())).encode(a);
    else {
      var b = void 0;
      b = b === void 0 ? false : b;
      for (var c = 0, d = new Uint8Array(3 * a.length), e = 0; e < a.length; e++) {
        var g = a.charCodeAt(e);
        if (128 > g)
          d[c++] = g;
        else {
          if (2048 > g)
            d[c++] = g >> 6 | 192;
          else {
            if (55296 <= g && 57343 >= g) {
              if (56319 >= g && e < a.length) {
                var f = a.charCodeAt(++e);
                if (56320 <= f && 57343 >= f) {
                  g = 1024 * (g - 55296) + f - 56320 + 65536;
                  d[c++] = g >> 18 | 240;
                  d[c++] = g >> 12 & 63 | 128;
                  d[c++] = g >> 6 & 63 | 128;
                  d[c++] = g & 63 | 128;
                  continue;
                } else
                  e--;
              }
              if (b)
                throw Error("Found an unpaired surrogate");
              g = 65533;
            }
            d[c++] = g >> 12 | 224;
            d[c++] = g >> 6 & 63 | 128;
          }
          d[c++] = g & 63 | 128;
        }
      }
      a = d.subarray(0, c);
    }
    return a;
  }
  var Ga = {}, L = null;
  function Ha(a) {
    var b;
    b === void 0 && (b = 0);
    Ia();
    b = Ga[b];
    for (var c = Array(Math.floor(a.length / 3)), d = b[64] || "", e = 0, g = 0; e < a.length - 2; e += 3) {
      var f = a[e], k = a[e + 1], h = a[e + 2], l = b[f >> 2];
      f = b[(f & 3) << 4 | k >> 4];
      k = b[(k & 15) << 2 | h >> 6];
      h = b[h & 63];
      c[g++] = l + f + k + h;
    }
    l = 0;
    h = d;
    switch (a.length - e) {
      case 2:
        l = a[e + 1], h = b[(l & 15) << 2] || d;
      case 1:
        a = a[e], c[g] = b[a >> 2] + b[(a & 3) << 4 | l >> 4] + h + d;
    }
    return c.join("");
  }
  function Ja(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : "=.".indexOf(a[b - 1]) != -1 && (c = "=.".indexOf(a[b - 2]) != -1 ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    Ka(a, function(g) {
      d[e++] = g;
    });
    return d.subarray(0, e);
  }
  function Ka(a, b) {
    function c(h) {
      for (; d < a.length; ) {
        var l = a.charAt(d++), n = L[l];
        if (n != null)
          return n;
        if (!/^[\s\xa0]*$/.test(l))
          throw Error("Unknown base64 encoding at char: " + l);
      }
      return h;
    }
    Ia();
    for (var d = 0; ; ) {
      var e = c(-1), g = c(0), f = c(64), k = c(64);
      if (k === 64 && e === -1)
        break;
      b(e << 2 | g >> 4);
      f != 64 && (b(g << 4 & 240 | f >> 2), k != 64 && b(f << 6 & 192 | k));
    }
  }
  function Ia() {
    if (!L) {
      L = {};
      for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a.concat(b[c].split(""));
        Ga[c] = d;
        for (var e = 0; e < d.length; e++) {
          var g = d[e];
          L[g] === void 0 && (L[g] = e);
        }
      }
    }
  }
  var La = typeof Uint8Array === "function", Ma;
  function Na(a) {
    this.g = a;
    if (a !== null && a.length === 0)
      throw Error("ByteString should be constructed with non-empty values");
  }
  Na.prototype.toJSON = function() {
    if (this.g == null)
      var a = "";
    else
      a = this.g, a = this.g = a == null || typeof a === "string" ? a : La && a instanceof Uint8Array ? Ha(a) : null;
    return a;
  };
  var Oa = typeof Uint8Array.prototype.slice === "function";
  function Pa(a, b, c) {
    return b === c ? Ma || (Ma = new Uint8Array(0)) : Oa ? a.slice(b, c) : new Uint8Array(a.subarray(b, c));
  }
  var M = 0, N = 0;
  function Qa(a) {
    if (a.constructor === Uint8Array)
      return a;
    if (a.constructor === ArrayBuffer)
      return new Uint8Array(a);
    if (a.constructor === Array)
      return new Uint8Array(a);
    if (a.constructor === String)
      return Ja(a);
    if (a.constructor === Na) {
      if (a.g == null)
        var b = Ma || (Ma = new Uint8Array(0));
      else {
        b = Uint8Array;
        var c = a.g;
        c = c == null || La && c != null && c instanceof Uint8Array ? c : typeof c === "string" ? Ja(c) : null;
        a = a.g = c;
        b = new b(a);
      }
      return b;
    }
    if (a instanceof Uint8Array)
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
  }
  function Ra(a, b) {
    b = b === void 0 ? {} : b;
    b = b.u === void 0 ? false : b.u;
    this.h = null;
    this.g = this.i = this.l = 0;
    this.j = false;
    this.u = b;
    a && Sa(this, a);
  }
  function Sa(a, b) {
    a.h = Qa(b);
    a.l = 0;
    a.i = a.h.length;
    a.g = a.l;
  }
  Ra.prototype.reset = function() {
    this.g = this.l;
  };
  function O(a) {
    a.g > a.i && (a.j = true, K(Error("Tried to read past the end of the data " + a.g + " > " + a.i)));
  }
  function P(a) {
    var b = a.h, c = b[a.g], d = c & 127;
    if (128 > c)
      return a.g += 1, O(a), d;
    c = b[a.g + 1];
    d |= (c & 127) << 7;
    if (128 > c)
      return a.g += 2, O(a), d;
    c = b[a.g + 2];
    d |= (c & 127) << 14;
    if (128 > c)
      return a.g += 3, O(a), d;
    c = b[a.g + 3];
    d |= (c & 127) << 21;
    if (128 > c)
      return a.g += 4, O(a), d;
    c = b[a.g + 4];
    d |= (c & 15) << 28;
    if (128 > c)
      return a.g += 5, O(a), d >>> 0;
    a.g += 5;
    if (128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++] && 128 <= b[a.g++])
      return a.j = true, za(), d;
    O(a);
    return d;
  }
  var Ta = [];
  function Ua() {
    this.g = new Uint8Array(64);
    this.h = 0;
  }
  function Q(a, b) {
    if (!(a.h + 1 < a.g.length)) {
      var c = a.g;
      a.g = new Uint8Array(Math.ceil(1 + 2 * a.g.length));
      a.g.set(c);
    }
    a.g[a.h++] = b;
  }
  Ua.prototype.length = function() {
    return this.h;
  };
  Ua.prototype.end = function() {
    var a = this.g, b = this.h;
    this.h = 0;
    return Pa(a, 0, b);
  };
  function R(a, b) {
    for (; 127 < b; )
      Q(a, b & 127 | 128), b >>>= 7;
    Q(a, b);
  }
  function Va(a) {
    var b = {}, c = b.N === void 0 ? false : b.N;
    this.m = { u: b.u === void 0 ? false : b.u };
    this.N = c;
    b = this.m;
    Ta.length ? (c = Ta.pop(), b && (c.u = b.u), a && Sa(c, a), a = c) : a = new Ra(a, b);
    this.g = a;
    this.l = this.g.g;
    this.h = this.i = -1;
    this.j = false;
  }
  Va.prototype.reset = function() {
    this.g.reset();
    this.h = this.i = -1;
  };
  function Wa(a) {
    var b = a.g;
    (b = b.g == b.i) || (b = a.j) || (b = a.g, b = b.j || 0 > b.g || b.g > b.i);
    if (b)
      return false;
    a.l = a.g.g;
    var c = P(a.g);
    b = c >>> 3;
    c &= 7;
    if (!(0 <= c && 5 >= c))
      return a.j = true, ya(c, a.l), false;
    a.i = b;
    a.h = c;
    return true;
  }
  function Xa(a) {
    switch (a.h) {
      case 0:
        if (a.h != 0)
          Xa(a);
        else
          a: {
            a = a.g;
            for (var b = a.g, c = 0; 10 > c; c++) {
              if ((a.h[b] & 128) === 0) {
                a.g = b + 1;
                O(a);
                break a;
              }
              b++;
            }
            a.j = true;
            za();
          }
        break;
      case 1:
        a = a.g;
        a.g += 8;
        O(a);
        break;
      case 2:
        a.h != 2 ? Xa(a) : (b = P(a.g), a = a.g, a.g += b, O(a));
        break;
      case 5:
        a = a.g;
        a.g += 4;
        O(a);
        break;
      case 3:
        b = a.i;
        do {
          if (!Wa(a)) {
            a.j = true;
            K(Error("Unmatched start-group tag: stream EOF"));
            break;
          }
          if (a.h == 4) {
            a.i != b && (a.j = true, K(Error("Unmatched end-group tag")));
            break;
          }
          Xa(a);
        } while (1);
        break;
      default:
        a.j = true, ya(a.h, a.l);
    }
  }
  function Ya(a, b, c) {
    a.N || (a = Pa(a.g.h, c, a.g.g), (c = b.m) ? c.push(a) : b.m = [a]);
  }
  var Za = [];
  function $a() {
    this.h = [];
    this.i = 0;
    this.g = new Ua();
  }
  function ab(a, b) {
    b.length !== 0 && (a.h.push(b), a.i += b.length);
  }
  function bb(a, b, c) {
    R(a.g, 8 * b + 2);
    R(a.g, c.length);
    ab(a, a.g.end());
    ab(a, c);
  }
  var cb = typeof Symbol === "function" && typeof Symbol() === "symbol" ? Symbol(void 0) : void 0;
  function db(a, b) {
    Object.isFrozen(a) || (cb ? a[cb] |= b : a.g !== void 0 ? a.g |= b : Object.defineProperties(a, { g: { value: b, configurable: true, writable: true, enumerable: false } }));
  }
  function eb(a) {
    if (!a)
      return 0;
    var b;
    cb ? b = a[cb] : b = a.g;
    return b == null ? 0 : b;
  }
  function fb(a) {
    if (!Array.isArray(a))
      return a;
    db(a, 1);
    return a;
  }
  function gb(a) {
    if (!Array.isArray(a))
      throw Error("cannot mark non-array as immutable");
    db(a, 2);
  }
  function hb(a) {
    return a !== null && typeof a === "object" && a.constructor === Object;
  }
  function ib(a) {
    switch (typeof a) {
      case "number":
        return isFinite(a) ? a : String(a);
      case "object":
        return La && a != null && a instanceof Uint8Array ? Ha(a) : a;
      default:
        return a;
    }
  }
  function jb(a, b) {
    if (a != null)
      return Array.isArray(a) || hb(a) ? kb(a, b) : b(a);
  }
  function kb(a, b) {
    if (Array.isArray(a)) {
      for (var c = Array(a.length), d = 0; d < a.length; d++)
        c[d] = jb(a[d], b);
      eb(a) & 1 && fb(c);
      return c;
    }
    c = {};
    for (d in a)
      c[d] = jb(a[d], b);
    return c;
  }
  var lb;
  function T(a, b, c) {
    var d = lb;
    lb = null;
    a || (a = d);
    d = this.constructor.ca;
    a || (a = d ? [d] : []);
    this.j = (d ? 0 : -1) - (this.constructor.aa || 0);
    this.i = null;
    this.g = a;
    a: {
      d = this.g.length;
      a = d - 1;
      if (d && (d = this.g[a], hb(d))) {
        this.l = a - this.j;
        this.h = d;
        break a;
      }
      b !== void 0 && -1 < b ? (this.l = Math.max(b, a + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
    }
    if (c)
      for (b = 0; b < c.length; b++)
        a = c[b], a < this.l ? (a += this.j, (d = this.g[a]) ? fb(d) : this.g[a] = mb) : (nb(this), (d = this.h[a]) ? fb(d) : this.h[a] = mb);
  }
  var mb = Object.freeze(fb([]));
  function nb(a) {
    var b = a.l + a.j;
    a.g[b] || (a.h = a.g[b] = {});
  }
  function U(a, b, c) {
    return b === -1 ? null : (c === void 0 ? 0 : c) || b >= a.l ? a.h ? a.h[b] : void 0 : a.g[b + a.j];
  }
  function ob(a, b, c) {
    c = c === void 0 ? true : c;
    var d = d === void 0 ? false : d;
    var e = U(a, b, d);
    e == null && (e = mb);
    e === mb ? (e = fb([]), V(a, b, e, d)) : c && Array.isArray(e) && eb(e) & 2 && (e = e.slice(), V(a, b, e, d));
    return e;
  }
  function W(a, b, c) {
    a = U(a, b);
    a = a == null ? a : +a;
    return a == null ? c === void 0 ? 0 : c : a;
  }
  function V(a, b, c, d) {
    (d === void 0 ? 0 : d) || b >= a.l ? (nb(a), a.h[b] = c) : a.g[b + a.j] = c;
  }
  function pb(a, b, c) {
    a.i || (a.i = {});
    var d = a.i[c];
    if (!d) {
      var e = ob(a, c, false);
      d = [];
      for (var g = Array.isArray(e) ? !!(eb(e) & 2) : false, f = 0; f < e.length; f++)
        d[f] = new b(e[f]), g && gb(d[f].g);
      g && (gb(d), Object.freeze(d));
      a.i[c] = d;
    }
    return d;
  }
  function qb(a, b, c, d, e) {
    var g = pb(a, d, b);
    c = c ? c : new d();
    a = ob(a, b);
    e != void 0 ? (g.splice(e, 0, c), a.splice(e, 0, X(c))) : (g.push(c), a.push(X(c)));
  }
  T.prototype.toJSON = function() {
    var a = X(this);
    return kb(a, ib);
  };
  function X(a) {
    if (a.i)
      for (var b in a.i) {
        var c = a.i[b];
        if (Array.isArray(c))
          for (var d = 0; d < c.length; d++)
            c[d] && X(c[d]);
        else
          c && X(c);
      }
    return a.g;
  }
  T.prototype.toString = function() {
    return X(this).toString();
  };
  function rb(a, b) {
    a = U(a, b);
    return a == null ? 0 : a;
  }
  function sb(a, b) {
    a = U(a, b);
    return a == null ? "" : a;
  }
  function tb(a, b) {
    if (a = a.m) {
      ab(b, b.g.end());
      for (var c = 0; c < a.length; c++)
        ab(b, a[c]);
    }
  }
  function ub(a) {
    var b = a[0];
    switch (a.length) {
      case 2:
        var c = a[1];
        return function(h, l, n) {
          return b(h, l, n, c);
        };
      case 3:
        var d = a[1], e = a[2];
        return function(h, l, n) {
          return b(h, l, n, d, e);
        };
      case 4:
        var g = a[1], f = a[2], k = a[3];
        return function(h, l, n) {
          return b(h, l, n, g, f, k);
        };
      default:
        throw Error("unsupported number of parameters, expected [2-4], got " + a.length);
    }
  }
  function vb(a, b, c) {
    for (; Wa(b) && b.h != 4; ) {
      var d = b.i, e = c[d];
      if (e) {
        if (Array.isArray(e) && (e = c[d] = ub(e)), !e(b, a, d)) {
          d = b;
          e = a;
          var g = d.l;
          Xa(d);
          Ya(d, e, g);
        }
      } else
        d = b, e = a, g = d.l, Xa(d), Ya(d, e, g);
    }
    return a;
  }
  function wb(a, b) {
    var c = new $a();
    b(a, c);
    a = c.i + c.g.length();
    if (a === 0)
      c = new Uint8Array(0);
    else {
      a = new Uint8Array(a);
      for (var d = c.h, e = d.length, g = b = 0; g < e; g++) {
        var f = d[g];
        f.length !== 0 && (a.set(f, b), b += f.length);
      }
      d = c.g;
      e = d.h;
      e !== 0 && (a.set(d.g.subarray(0, e), b), d.h = 0);
      c.h = [a];
      c = a;
    }
    return c;
  }
  function xb(a, b, c) {
    if (Za.length) {
      var d = Za.pop();
      a && (Sa(d.g, a), d.i = -1, d.h = -1);
      a = d;
    } else
      a = new Va(a);
    try {
      return c(new b(), a);
    } finally {
      b = a.g, b.h = null, b.l = 0, b.i = 0, b.g = 0, b.j = false, b.u = false, a.i = -1, a.h = -1, a.j = false, 100 > Za.length && Za.push(a);
    }
  }
  function Y(a, b, c) {
    b = U(b, c);
    if (b != null) {
      R(a.g, 8 * c + 5);
      a = a.g;
      var d = b;
      d = (c = 0 > d ? 1 : 0) ? -d : d;
      d === 0 ? 0 < 1 / d ? M = N = 0 : (N = 0, M = 2147483648) : isNaN(d) ? (N = 0, M = 2147483647) : 34028234663852886e22 < d ? (N = 0, M = (c << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > d ? (d = Math.round(d / Math.pow(2, -149)), N = 0, M = (c << 31 | d) >>> 0) : (b = Math.floor(Math.log(d) / Math.LN2), d *= Math.pow(2, -b), d = Math.round(8388608 * d), 16777216 <= d && ++b, N = 0, M = (c << 31 | b + 127 << 23 | d & 8388607) >>> 0);
      c = M;
      Q(a, c >>> 0 & 255);
      Q(a, c >>> 8 & 255);
      Q(a, c >>> 16 & 255);
      Q(a, c >>> 24 & 255);
    }
  }
  function Z(a, b, c) {
    if (a.h !== 5)
      return false;
    a = a.g;
    var d = a.h[a.g];
    var e = a.h[a.g + 1];
    var g = a.h[a.g + 2], f = a.h[a.g + 3];
    a.g += 4;
    O(a);
    e = (d << 0 | e << 8 | g << 16 | f << 24) >>> 0;
    a = 2 * (e >> 31) + 1;
    d = e >>> 23 & 255;
    e &= 8388607;
    V(b, c, d == 255 ? e ? NaN : Infinity * a : d == 0 ? a * Math.pow(2, -149) * e : a * Math.pow(2, d - 150) * (e + Math.pow(2, 23)));
    return true;
  }
  function yb(a, b, c) {
    if (a.h !== 0)
      return false;
    for (var d = a.g, e = 128, g = 0, f = a = 0; 4 > f && 128 <= e; f++)
      e = d.h[d.g++], g |= (e & 127) << 7 * f;
    128 <= e && (e = d.h[d.g++], g |= (e & 127) << 28, a |= (e & 127) >> 4);
    if (128 <= e)
      for (f = 0; 5 > f && 128 <= e; f++)
        e = d.h[d.g++], a |= (e & 127) << 7 * f + 3;
    if (128 > e) {
      d = g >>> 0;
      e = a >>> 0;
      if (a = e & 2147483648)
        d = ~d + 1 >>> 0, e = ~e >>> 0, d == 0 && (e = e + 1 >>> 0);
      d = 4294967296 * e + (d >>> 0);
      a = a ? -d : d;
    } else
      d.j = true, za(), a = void 0;
    V(b, c, a);
    return true;
  }
  function zb(a, b, c) {
    if (a.h !== 0)
      return false;
    V(b, c, P(a.g));
    return true;
  }
  function Ab(a, b, c) {
    if (a.h !== 2)
      return false;
    var d = P(a.g);
    a = a.g;
    var e = a.g;
    a.g += d;
    O(a);
    a = a.h;
    var g;
    if (Ca)
      (g = Ba) || (g = Ba = new TextDecoder("utf-8", { fatal: false })), g = g.decode(a.subarray(e, e + d));
    else {
      d = e + d;
      for (var f = [], k = null, h, l, n; e < d; )
        h = a[e++], 128 > h ? f.push(h) : 224 > h ? e >= d ? f.push(65533) : (l = a[e++], 194 > h || (l & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 31) << 6 | l & 63)) : 240 > h ? e >= d - 1 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || h === 224 && 160 > l || h === 237 && 160 <= l || ((g = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : f.push((h & 15) << 12 | (l & 63) << 6 | g & 63)) : 244 >= h ? e >= d - 2 ? f.push(65533) : (l = a[e++], (l & 192) !== 128 || (h << 28) + (l - 144) >> 30 !== 0 || ((g = a[e++]) & 192) !== 128 || ((n = a[e++]) & 192) !== 128 ? (e--, f.push(65533)) : (h = (h & 7) << 18 | (l & 63) << 12 | (g & 63) << 6 | n & 63, h -= 65536, f.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320))) : f.push(65533), 8192 <= f.length && (k = Aa(k, f), f.length = 0);
      g = Aa(k, f);
    }
    V(b, c, g);
    return true;
  }
  function Bb(a, b, c, d, e) {
    if (a.h !== 2)
      return false;
    var g = new d(), f = a.g.i, k = P(a.g), h = a.g.g + k;
    a.g.i = h;
    e(g, a);
    e = h - a.g.g;
    if (e !== 0)
      throw Error("Message parsing ended unexpectedly. Expected to read " + (k + " bytes, instead read " + (k - e) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
    a.g.g = h;
    a.g.i = f;
    qb(b, c, g, d, void 0);
    return true;
  }
  function Cb(a) {
    T.call(this, a);
  }
  var Db;
  E(Cb, T);
  function Eb(a, b) {
    var c = U(a, 1);
    if (c != null && c != null) {
      R(b.g, 8);
      var d = b.g;
      if (0 <= c)
        R(d, c);
      else {
        for (var e = 0; 9 > e; e++)
          Q(d, c & 127 | 128), c >>= 7;
        Q(d, 1);
      }
    }
    Y(b, a, 2);
    d = U(a, 3);
    d != null && bb(b, 3, Fa(d));
    d = U(a, 4);
    d != null && bb(b, 4, Fa(d));
    tb(a, b);
  }
  function Fb(a, b) {
    return vb(a, b, Db || (Db = { 1: zb, 2: Z, 3: Ab, 4: Ab }));
  }
  function Gb(a) {
    T.call(this, a, -1, Hb);
  }
  var Ib;
  E(Gb, T);
  Gb.prototype.addClassification = function(a, b) {
    qb(this, 1, a, Cb, b);
    return this;
  };
  function Jb(a, b) {
    return vb(a, b, Ib || (Ib = { 1: [Bb, Cb, Fb] }));
  }
  var Hb = [1];
  function Kb(a) {
    T.call(this, a);
  }
  var Lb;
  E(Kb, T);
  function Mb(a, b) {
    Y(b, a, 1);
    Y(b, a, 2);
    Y(b, a, 3);
    Y(b, a, 4);
    Y(b, a, 5);
    tb(a, b);
  }
  function Nb(a, b) {
    return vb(a, b, Lb || (Lb = { 1: Z, 2: Z, 3: Z, 4: Z, 5: Z }));
  }
  function Ob(a) {
    T.call(this, a, -1, Pb);
  }
  var Qb;
  E(Ob, T);
  function Rb(a, b) {
    return vb(a, b, Qb || (Qb = { 1: [Bb, Kb, Nb] }));
  }
  var Pb = [1];
  function Sb(a) {
    T.call(this, a);
  }
  var Tb;
  E(Sb, T);
  function Ub(a, b) {
    Y(b, a, 1);
    Y(b, a, 2);
    Y(b, a, 3);
    Y(b, a, 4);
    Y(b, a, 5);
    var c = U(a, 6);
    if (c != null && c != null) {
      R(b.g, 48);
      var d = b.g, e = c;
      c = 0 > e;
      e = Math.abs(e);
      var g = e >>> 0;
      e = Math.floor((e - g) / 4294967296);
      e >>>= 0;
      c && (e = ~e >>> 0, g = (~g >>> 0) + 1, 4294967295 < g && (g = 0, e++, 4294967295 < e && (e = 0)));
      M = g;
      N = e;
      c = M;
      for (g = N; 0 < g || 127 < c; )
        Q(d, c & 127 | 128), c = (c >>> 7 | g << 25) >>> 0, g >>>= 7;
      Q(d, c);
    }
    tb(a, b);
  }
  function Vb(a, b) {
    return vb(a, b, Tb || (Tb = { 1: Z, 2: Z, 3: Z, 4: Z, 5: Z, 6: yb }));
  }
  function Wb(a, b, c) {
    c = a.createShader(c === 0 ? a.VERTEX_SHADER : a.FRAGMENT_SHADER);
    a.shaderSource(c, b);
    a.compileShader(c);
    if (!a.getShaderParameter(c, a.COMPILE_STATUS))
      throw Error("Could not compile WebGL shader.\n\n" + a.getShaderInfoLog(c));
    return c;
  }
  function Xb(a) {
    return pb(a, Cb, 1).map(function(b) {
      return { index: rb(b, 1), X: W(b, 2), label: U(b, 3) != null ? sb(b, 3) : void 0, displayName: U(b, 4) != null ? sb(b, 4) : void 0 };
    });
  }
  function Yb(a) {
    return { x: W(a, 1), y: W(a, 2), z: W(a, 3), visibility: U(a, 4) != null ? W(a, 4) : void 0 };
  }
  function Zb(a) {
    return pb(xb(a, Ob, Rb), Kb, 1).map(Yb);
  }
  function $b(a, b) {
    this.h = a;
    this.g = b;
    this.l = 0;
  }
  function ac(a, b, c) {
    bc(a, b);
    if (typeof a.g.canvas.transferToImageBitmap === "function")
      return Promise.resolve(a.g.canvas.transferToImageBitmap());
    if (c)
      return Promise.resolve(a.g.canvas);
    if (typeof createImageBitmap === "function")
      return createImageBitmap(a.g.canvas);
    a.i === void 0 && (a.i = document.createElement("canvas"));
    return new Promise(function(d) {
      a.i.height = a.g.canvas.height;
      a.i.width = a.g.canvas.width;
      a.i.getContext("2d", {}).drawImage(a.g.canvas, 0, 0, a.g.canvas.width, a.g.canvas.height);
      d(a.i);
    });
  }
  function bc(a, b) {
    var c = a.g;
    if (a.m === void 0) {
      var d = Wb(c, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", 0), e = Wb(c, "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D sampler0;\n  void main(){\n    gl_FragColor = texture2D(sampler0, vTex);\n  }", 1), g = c.createProgram();
      c.attachShader(g, d);
      c.attachShader(g, e);
      c.linkProgram(g);
      if (!c.getProgramParameter(g, c.LINK_STATUS))
        throw Error("Could not compile WebGL program.\n\n" + c.getProgramInfoLog(g));
      d = a.m = g;
      c.useProgram(d);
      e = c.getUniformLocation(d, "sampler0");
      a.j = { I: c.getAttribLocation(d, "aVertex"), H: c.getAttribLocation(d, "aTex"), da: e };
      a.s = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.s);
      c.enableVertexAttribArray(a.j.I);
      c.vertexAttribPointer(a.j.I, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      a.o = c.createBuffer();
      c.bindBuffer(c.ARRAY_BUFFER, a.o);
      c.enableVertexAttribArray(a.j.H);
      c.vertexAttribPointer(a.j.H, 2, c.FLOAT, false, 0, 0);
      c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), c.STATIC_DRAW);
      c.bindBuffer(c.ARRAY_BUFFER, null);
      c.uniform1i(e, 0);
    }
    d = a.j;
    c.useProgram(a.m);
    c.canvas.width = b.width;
    c.canvas.height = b.height;
    c.viewport(0, 0, b.width, b.height);
    c.activeTexture(c.TEXTURE0);
    a.h.bindTexture2d(b.glName);
    c.enableVertexAttribArray(d.I);
    c.bindBuffer(c.ARRAY_BUFFER, a.s);
    c.vertexAttribPointer(d.I, 2, c.FLOAT, false, 0, 0);
    c.enableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, a.o);
    c.vertexAttribPointer(d.H, 2, c.FLOAT, false, 0, 0);
    c.bindFramebuffer(c.DRAW_FRAMEBUFFER ? c.DRAW_FRAMEBUFFER : c.FRAMEBUFFER, null);
    c.clearColor(0, 0, 0, 0);
    c.clear(c.COLOR_BUFFER_BIT);
    c.colorMask(true, true, true, true);
    c.drawArrays(c.TRIANGLE_FAN, 0, 4);
    c.disableVertexAttribArray(d.I);
    c.disableVertexAttribArray(d.H);
    c.bindBuffer(c.ARRAY_BUFFER, null);
    a.h.bindTexture2d(0);
  }
  function cc(a) {
    this.g = a;
  }
  var dc = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
  function ec(a, b) {
    return b + a;
  }
  function fc(a, b) {
    window[a] = b;
  }
  function gc(a) {
    var b = document.createElement("script");
    b.setAttribute("src", a);
    b.setAttribute("crossorigin", "anonymous");
    return new Promise(function(c) {
      b.addEventListener("load", function() {
        c();
      }, false);
      b.addEventListener("error", function() {
        c();
      }, false);
      document.body.appendChild(b);
    });
  }
  function hc() {
    return H(function(a) {
      switch (a.g) {
        case 1:
          return a.m = 2, F(a, WebAssembly.instantiate(dc), 4);
        case 4:
          a.g = 3;
          a.m = 0;
          break;
        case 2:
          return a.m = 0, a.j = null, a.return(false);
        case 3:
          return a.return(true);
      }
    });
  }
  function ic(a) {
    this.g = a;
    this.listeners = {};
    this.j = {};
    this.F = {};
    this.m = {};
    this.s = {};
    this.G = this.o = this.R = true;
    this.C = Promise.resolve();
    this.P = "";
    this.B = {};
    this.locateFile = a && a.locateFile || ec;
    if (typeof window === "object")
      var b = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
    else if (typeof location !== "undefined")
      b = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
    else
      throw Error("solutions can only be loaded on a web page or in a web worker");
    this.S = b;
    if (a.options) {
      b = C(Object.keys(a.options));
      for (var c = b.next(); !c.done; c = b.next()) {
        c = c.value;
        var d = a.options[c].default;
        d !== void 0 && (this.j[c] = typeof d === "function" ? d() : d);
      }
    }
  }
  x = ic.prototype;
  x.close = function() {
    this.i && this.i.delete();
    return Promise.resolve();
  };
  function jc(a) {
    var b, c, d, e, g, f, k, h, l, n, r;
    return H(function(p) {
      switch (p.g) {
        case 1:
          if (!a.R)
            return p.return();
          b = a.g.files === void 0 ? [] : typeof a.g.files === "function" ? a.g.files(a.j) : a.g.files;
          return F(p, hc(), 2);
        case 2:
          c = p.h;
          if (typeof window === "object")
            return fc("createMediapipeSolutionsWasm", { locateFile: a.locateFile }), fc("createMediapipeSolutionsPackedAssets", { locateFile: a.locateFile }), f = b.filter(function(m) {
              return m.data !== void 0;
            }), k = b.filter(function(m) {
              return m.data === void 0;
            }), h = Promise.all(f.map(function(m) {
              var q = kc(a, m.url);
              if (m.path !== void 0) {
                var t = m.path;
                q = q.then(function(w) {
                  a.overrideFile(t, w);
                  return Promise.resolve(w);
                });
              }
              return q;
            })), l = Promise.all(k.map(function(m) {
              return m.simd === void 0 || m.simd && c || !m.simd && !c ? gc(a.locateFile(m.url, a.S)) : Promise.resolve();
            })).then(function() {
              var m, q, t;
              return H(function(w) {
                if (w.g == 1)
                  return m = window.createMediapipeSolutionsWasm, q = window.createMediapipeSolutionsPackedAssets, t = a, F(w, m(q), 2);
                t.h = w.h;
                w.g = 0;
              });
            }), n = function() {
              return H(function(m) {
                a.g.graph && a.g.graph.url ? m = F(m, kc(a, a.g.graph.url), 0) : (m.g = 0, m = void 0);
                return m;
              });
            }(), F(p, Promise.all([l, h, n]), 7);
          if (typeof importScripts !== "function")
            throw Error("solutions can only be loaded on a web page or in a web worker");
          d = b.filter(function(m) {
            return m.simd === void 0 || m.simd && c || !m.simd && !c;
          }).map(function(m) {
            return a.locateFile(m.url, a.S);
          });
          importScripts.apply(null, ea(d));
          e = a;
          return F(p, createMediapipeSolutionsWasm(Module), 6);
        case 6:
          e.h = p.h;
          a.l = new OffscreenCanvas(1, 1);
          a.h.canvas = a.l;
          g = a.h.GL.createContext(a.l, {
            antialias: false,
            alpha: false,
            ba: typeof WebGL2RenderingContext !== "undefined" ? 2 : 1
          });
          a.h.GL.makeContextCurrent(g);
          p.g = 4;
          break;
        case 7:
          a.l = document.createElement("canvas");
          r = a.l.getContext("webgl2", {});
          if (!r && (r = a.l.getContext("webgl", {}), !r))
            return alert("Failed to create WebGL canvas context when passing video frame."), p.return();
          a.D = r;
          a.h.canvas = a.l;
          a.h.createContext(a.l, true, true, {});
        case 4:
          a.i = new a.h.SolutionWasm(), a.R = false, p.g = 0;
      }
    });
  }
  function lc(a) {
    var b, c, d, e, g, f, k, h;
    return H(function(l) {
      if (l.g == 1) {
        if (a.g.graph && a.g.graph.url && a.P === a.g.graph.url)
          return l.return();
        a.o = true;
        if (!a.g.graph || !a.g.graph.url) {
          l.g = 2;
          return;
        }
        a.P = a.g.graph.url;
        return F(l, kc(a, a.g.graph.url), 3);
      }
      l.g != 2 && (b = l.h, a.i.loadGraph(b));
      c = C(Object.keys(a.B));
      for (d = c.next(); !d.done; d = c.next())
        e = d.value, a.i.overrideFile(e, a.B[e]);
      a.B = {};
      if (a.g.listeners)
        for (g = C(a.g.listeners), f = g.next(); !f.done; f = g.next())
          k = f.value, mc(a, k);
      h = a.j;
      a.j = {};
      a.setOptions(h);
      l.g = 0;
    });
  }
  x.reset = function() {
    var a = this;
    return H(function(b) {
      a.i && (a.i.reset(), a.m = {}, a.s = {});
      b.g = 0;
    });
  };
  x.setOptions = function(a, b) {
    var c = this;
    if (b = b || this.g.options) {
      for (var d = [], e = [], g = {}, f = C(Object.keys(a)), k = f.next(); !k.done; g = { K: g.K, L: g.L }, k = f.next()) {
        var h = k.value;
        h in this.j && this.j[h] === a[h] || (this.j[h] = a[h], k = b[h], k !== void 0 && (k.onChange && (g.K = k.onChange, g.L = a[h], d.push(function(l) {
          return function() {
            var n;
            return H(function(r) {
              if (r.g == 1)
                return F(r, l.K(l.L), 2);
              n = r.h;
              n === true && (c.o = true);
              r.g = 0;
            });
          };
        }(g))), k.graphOptionXref && (h = { valueNumber: k.type === 1 ? a[h] : 0, valueBoolean: k.type === 0 ? a[h] : false, valueString: k.type === 2 ? a[h] : "" }, k = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), k.graphOptionXref), h), e.push(k))));
      }
      if (d.length !== 0 || e.length !== 0)
        this.o = true, this.A = (this.A === void 0 ? [] : this.A).concat(e), this.v = (this.v === void 0 ? [] : this.v).concat(d);
    }
  };
  function nc(a) {
    var b, c, d, e, g, f, k;
    return H(function(h) {
      switch (h.g) {
        case 1:
          if (!a.o)
            return h.return();
          if (!a.v) {
            h.g = 2;
            break;
          }
          b = C(a.v);
          c = b.next();
        case 3:
          if (c.done) {
            h.g = 5;
            break;
          }
          d = c.value;
          return F(h, d(), 4);
        case 4:
          c = b.next();
          h.g = 3;
          break;
        case 5:
          a.v = void 0;
        case 2:
          if (a.A) {
            e = new a.h.GraphOptionChangeRequestList();
            g = C(a.A);
            for (f = g.next(); !f.done; f = g.next())
              k = f.value, e.push_back(k);
            a.i.changeOptions(e);
            e.delete();
            a.A = void 0;
          }
          a.o = false;
          h.g = 0;
      }
    });
  }
  x.initialize = function() {
    var a = this;
    return H(function(b) {
      return b.g == 1 ? F(b, jc(a), 2) : b.g != 3 ? F(b, lc(a), 3) : F(b, nc(a), 0);
    });
  };
  function kc(a, b) {
    var c, d;
    return H(function(e) {
      if (b in a.F)
        return e.return(a.F[b]);
      c = a.locateFile(b, "");
      d = fetch(c).then(function(g) {
        return g.arrayBuffer();
      });
      a.F[b] = d;
      return e.return(d);
    });
  }
  x.overrideFile = function(a, b) {
    this.i ? this.i.overrideFile(a, b) : this.B[a] = b;
  };
  x.clearOverriddenFiles = function() {
    this.B = {};
    this.i && this.i.clearOverriddenFiles();
  };
  x.send = function(a, b) {
    var c = this, d, e, g, f, k, h, l, n, r;
    return H(function(p) {
      switch (p.g) {
        case 1:
          if (!c.g.inputs)
            return p.return();
          d = 1e3 * (b === void 0 || b === null ? performance.now() : b);
          return F(p, c.C, 2);
        case 2:
          return F(p, c.initialize(), 3);
        case 3:
          e = new c.h.PacketDataList();
          g = C(Object.keys(a));
          for (f = g.next(); !f.done; f = g.next())
            if (k = f.value, h = c.g.inputs[k]) {
              a: {
                var m = a[k];
                switch (h.type) {
                  case "video":
                    var q = c.m[h.stream];
                    q || (q = new $b(c.h, c.D), c.m[h.stream] = q);
                    q.l === 0 && (q.l = q.h.createTexture());
                    if (typeof HTMLVideoElement !== "undefined" && m instanceof HTMLVideoElement) {
                      var t = m.videoWidth;
                      var w = m.videoHeight;
                    } else
                      typeof HTMLImageElement !== "undefined" && m instanceof HTMLImageElement ? (t = m.naturalWidth, w = m.naturalHeight) : (t = m.width, w = m.height);
                    w = { glName: q.l, width: t, height: w };
                    t = q.g;
                    t.canvas.width = w.width;
                    t.canvas.height = w.height;
                    t.activeTexture(t.TEXTURE0);
                    q.h.bindTexture2d(q.l);
                    t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, m);
                    q.h.bindTexture2d(0);
                    q = w;
                    break a;
                  case "detections":
                    q = c.m[h.stream];
                    q || (q = new cc(c.h), c.m[h.stream] = q);
                    q.data || (q.data = new q.g.DetectionListData());
                    q.data.reset(m.length);
                    for (w = 0; w < m.length; ++w) {
                      t = m[w];
                      var v = q.data, A = v.setBoundingBox, I = w;
                      var D = t.T;
                      var u = new Sb();
                      V(u, 1, D.Y);
                      V(u, 2, D.Z);
                      V(u, 3, D.height);
                      V(u, 4, D.width);
                      V(u, 5, D.rotation);
                      V(u, 6, D.W);
                      D = wb(u, Ub);
                      A.call(v, I, D);
                      if (t.O)
                        for (v = 0; v < t.O.length; ++v) {
                          u = t.O[v];
                          var z = u.visibility ? true : false;
                          A = q.data;
                          I = A.addNormalizedLandmark;
                          D = w;
                          u = Object.assign(Object.assign({}, u), { visibility: z ? u.visibility : 0 });
                          z = new Kb();
                          V(z, 1, u.x);
                          V(z, 2, u.y);
                          V(z, 3, u.z);
                          u.visibility && V(z, 4, u.visibility);
                          u = wb(z, Mb);
                          I.call(A, D, u);
                        }
                      if (t.M)
                        for (v = 0; v < t.M.length; ++v)
                          A = q.data, I = A.addClassification, D = w, u = t.M[v], z = new Cb(), V(z, 2, u.X), u.index && V(z, 1, u.index), u.label && V(z, 3, u.label), u.displayName && V(z, 4, u.displayName), u = wb(z, Eb), I.call(A, D, u);
                    }
                    q = q.data;
                    break a;
                  default:
                    q = {};
                }
              }
              l = q;
              n = h.stream;
              switch (h.type) {
                case "video":
                  e.pushTexture2d(Object.assign(Object.assign({}, l), { stream: n, timestamp: d }));
                  break;
                case "detections":
                  r = l;
                  r.stream = n;
                  r.timestamp = d;
                  e.pushDetectionList(r);
                  break;
                default:
                  throw Error("Unknown input config type: '" + h.type + "'");
              }
            }
          c.i.send(e);
          return F(p, c.C, 4);
        case 4:
          e.delete(), p.g = 0;
      }
    });
  };
  function oc(a, b, c) {
    var d, e, g, f, k, h, l, n, r, p, m, q, t, w;
    return H(function(v) {
      switch (v.g) {
        case 1:
          if (!c)
            return v.return(b);
          d = {};
          e = 0;
          g = C(Object.keys(c));
          for (f = g.next(); !f.done; f = g.next())
            k = f.value, h = c[k], typeof h !== "string" && h.type === "texture" && b[h.stream] !== void 0 && ++e;
          1 < e && (a.G = false);
          l = C(Object.keys(c));
          f = l.next();
        case 2:
          if (f.done) {
            v.g = 4;
            break;
          }
          n = f.value;
          r = c[n];
          if (typeof r === "string")
            return t = d, w = n, F(v, pc(a, n, b[r]), 14);
          p = b[r.stream];
          if (r.type === "detection_list") {
            if (p) {
              var A = p.getRectList();
              for (var I = p.getLandmarksList(), D = p.getClassificationsList(), u = [], z = 0; z < A.size(); ++z) {
                var S = xb(A.get(z), Sb, Vb);
                S = { T: { Y: W(S, 1), Z: W(S, 2), height: W(S, 3), width: W(S, 4), rotation: W(S, 5, 0), W: rb(S, 6) }, O: Zb(I.get(z)), M: Xb(xb(D.get(z), Gb, Jb)) };
                u.push(S);
              }
              A = u;
            } else
              A = [];
            d[n] = A;
            v.g = 7;
            break;
          }
          if (r.type === "proto_list") {
            if (p) {
              A = Array(p.size());
              for (I = 0; I < p.size(); I++)
                A[I] = p.get(I);
              p.delete();
            } else
              A = [];
            d[n] = A;
            v.g = 7;
            break;
          }
          if (p === void 0) {
            v.g = 3;
            break;
          }
          if (r.type === "float_list") {
            d[n] = p;
            v.g = 7;
            break;
          }
          if (r.type === "proto") {
            d[n] = p;
            v.g = 7;
            break;
          }
          if (r.type !== "texture")
            throw Error("Unknown output config type: '" + r.type + "'");
          m = a.s[n];
          m || (m = new $b(a.h, a.D), a.s[n] = m);
          return F(v, ac(m, p, a.G), 13);
        case 13:
          q = v.h, d[n] = q;
        case 7:
          r.transform && d[n] && (d[n] = r.transform(d[n]));
          v.g = 3;
          break;
        case 14:
          t[w] = v.h;
        case 3:
          f = l.next();
          v.g = 2;
          break;
        case 4:
          return v.return(d);
      }
    });
  }
  function pc(a, b, c) {
    var d;
    return H(function(e) {
      return typeof c === "number" || c instanceof Uint8Array || c instanceof a.h.Uint8BlobList ? e.return(c) : c instanceof a.h.Texture2dDataOut ? (d = a.s[b], d || (d = new $b(a.h, a.D), a.s[b] = d), e.return(ac(d, c, a.G))) : e.return(void 0);
    });
  }
  function mc(a, b) {
    for (var c = b.name || "$", d = [].concat(ea(b.wants)), e = new a.h.StringList(), g = C(b.wants), f = g.next(); !f.done; f = g.next())
      e.push_back(f.value);
    g = a.h.PacketListener.implement({ onResults: function(k) {
      for (var h = {}, l = 0; l < b.wants.length; ++l)
        h[d[l]] = k.get(l);
      var n = a.listeners[c];
      n && (a.C = oc(a, h, b.outs).then(function(r) {
        r = n(r);
        for (var p = 0; p < b.wants.length; ++p) {
          var m = h[d[p]];
          typeof m === "object" && m.hasOwnProperty && m.hasOwnProperty("delete") && m.delete();
        }
        r && (a.C = r);
      }));
    } });
    a.i.attachMultiListener(e, g);
    e.delete();
  }
  x.onResults = function(a, b) {
    this.listeners[b || "$"] = a;
  };
  J("Solution", ic);
  J("OptionType", { BOOL: 0, NUMBER: 1, $: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
  function qc(a) {
    a === void 0 && (a = 0);
    switch (a) {
      case 1:
        return "pose_landmark_full.tflite";
      case 2:
        return "pose_landmark_heavy.tflite";
      default:
        return "pose_landmark_lite.tflite";
    }
  }
  function rc(a) {
    var b = this;
    a = a || {};
    this.g = new ic({ locateFile: a.locateFile, files: function(c) {
      return [{ url: "pose_solution_packed_assets_loader.js" }, { simd: false, url: "pose_solution_wasm_bin.js" }, { simd: true, url: "pose_solution_simd_wasm_bin.js" }, { data: true, url: qc(c.modelComplexity) }];
    }, graph: { url: "pose_web.binarypb" }, listeners: [{ wants: ["pose_landmarks", "world_landmarks", "segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, poseLandmarks: {
      type: "proto",
      stream: "pose_landmarks",
      transform: Zb
    }, poseWorldLandmarks: { type: "proto", stream: "world_landmarks", transform: Zb }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: {
      useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document },
      selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
      modelComplexity: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(c) {
        var d, e, g;
        return H(function(f) {
          if (f.g == 1)
            return d = qc(c), e = "third_party/mediapipe/modules/pose_landmark/" + d, F(f, kc(b.g, d), 2);
          g = f.h;
          b.g.overrideFile(e, g);
          return f.return(true);
        });
      } },
      smoothLandmarks: {
        type: 0,
        graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" }
      },
      enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } },
      smoothSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" } },
      minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
      minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }
    } });
  }
  x = rc.prototype;
  x.reset = function() {
    this.g.reset();
  };
  x.close = function() {
    this.g.close();
    return Promise.resolve();
  };
  x.onResults = function(a) {
    this.g.onResults(a);
  };
  x.initialize = function() {
    var a = this;
    return H(function(b) {
      return F(b, a.g.initialize(), 0);
    });
  };
  x.send = function(a, b) {
    var c = this;
    return H(function(d) {
      return F(d, c.g.send(a, b), 0);
    });
  };
  x.setOptions = function(a) {
    this.g.setOptions(a);
  };
  J("Pose", rc);
  J("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]);
  J("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 });
  J("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 });
  J("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 });
  J("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 });
  J("VERSION", "0.5.1635988162");
}).call(VonagePose);
const _MediapipeHelper = class {
  constructor() {
    this.mediapipeMap_ = /* @__PURE__ */ new Map();
  }
  getVersion(modelType) {
    switch (modelType) {
      case "face_detection":
        return VonageFacedetection.VERSION;
      case "face_mesh":
        return VonageFacemash.VERSION;
      case "hands":
        return VonageHands.VERSION;
      case "holistic":
        return VonageHolistic.VERSION;
      case "objectron":
        return VonageObjectron.VERSION;
      case "selfie_segmentation":
        return VonageSelfiesegmentation.VERSION;
      case "pose":
        return VonagePose.VERSION;
      default:
        return "";
    }
  }
  initialize(config) {
    return new Promise(async (resolve, reject) => {
      if (config.mediaPipeModelConfigArray.length == 0) {
        reject("no model was selected");
        return;
      }
      for (let index = 0; index < config.mediaPipeModelConfigArray.length; index++) {
        const mediaPipeModelConfig = config.mediaPipeModelConfigArray[index];
        if (this.mediapipeMap_.has(mediaPipeModelConfig.modelType)) {
          reject("setting same type is not supported");
          return;
        }
        if (typeof mediaPipeModelConfig.listener != "function") {
          reject(`[${mediaPipeModelConfig.modelType}] ResultsListener must be provided`);
          return;
        }
        let tempMediaPipe;
        switch (mediaPipeModelConfig.modelType) {
          case "face_mesh":
            tempMediaPipe = new VonageFacemash.FaceMesh({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "face_mesh/" + this.getVersion("face_mesh");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "face_detection":
            tempMediaPipe = new VonageFacedetection.FaceDetection({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "face_detection/" + this.getVersion("face_detection");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "hands":
            tempMediaPipe = new VonageHands.Hands({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "hands/" + this.getVersion("hands");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "holistic":
            tempMediaPipe = new VonageHolistic.Holistic({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "holistic/" + this.getVersion("holistic");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "objectron":
            tempMediaPipe = new VonageObjectron.Objectron({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "objectron/" + this.getVersion("objectron");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "selfie_segmentation":
            tempMediaPipe = new VonageSelfiesegmentation.SelfieSegmentation({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "selfie_segmentation/" + this.getVersion("selfie_segmentation");
                return baseUrl + "/" + path;
              }
            });
            break;
          case "pose":
            tempMediaPipe = new VonagePose.Pose({
              locateFile: (path, prefix) => {
                let baseUrl = mediaPipeModelConfig.assetsUri || _MediapipeHelper.defaultAssetsBaseUrl + "pose/" + this.getVersion("pose");
                return baseUrl + "/" + path;
              }
            });
            break;
          default:
            reject("unknown model type");
            return;
        }
        tempMediaPipe.onResults(mediaPipeModelConfig.listener);
        if (mediaPipeModelConfig.options) {
          tempMediaPipe.setOptions(mediaPipeModelConfig.options);
        }
        try {
          await tempMediaPipe.initialize();
          this.mediapipeMap_.set(mediaPipeModelConfig.modelType, tempMediaPipe);
        } catch (e) {
          reject(e);
          return;
        }
      }
      resolve();
    });
  }
  close(modelType) {
    return new Promise((resolve, reject) => {
      let promises = [];
      if (modelType) {
        let tempMediaPipe = this.mediapipeMap_.get(modelType);
        if (tempMediaPipe) {
          this.mediapipeMap_.delete(modelType);
          promises.push(tempMediaPipe.close());
        } else {
          reject("model not exit");
          return;
        }
      } else {
        for (const [key, tempMediaPipe] of this.mediapipeMap_.entries()) {
          promises.push(tempMediaPipe.close());
        }
        this.mediapipeMap_.clear();
      }
      Promise.all(promises).then(() => {
        resolve();
      }).catch((e) => {
        reject(e);
      });
    });
  }
  send(image, modelType) {
    return new Promise((resolve, reject) => {
      let promises = [];
      if (modelType) {
        let tempMediaPipe = this.mediapipeMap_.get(modelType);
        if (tempMediaPipe) {
          promises.push(tempMediaPipe.send({ image }));
        } else {
          reject("model not exit");
          return;
        }
      } else {
        for (const [key, tempMediaPipe] of this.mediapipeMap_.entries()) {
          promises.push(tempMediaPipe.send({ image }));
        }
      }
      Promise.all(promises).then(() => {
        resolve();
      }).catch((e) => {
        reject(e);
      });
    });
  }
  reset(modelType) {
    if (modelType) {
      let tempMediaPipe = this.mediapipeMap_.get(modelType);
      if (tempMediaPipe && typeof tempMediaPipe.reset === "function") {
        tempMediaPipe.reset();
      }
    } else {
      for (const [key, tempMediaPipe] of this.mediapipeMap_.entries()) {
        if (tempMediaPipe && typeof tempMediaPipe.reset === "function") {
          tempMediaPipe.reset();
        }
      }
    }
  }
};
let MediapipeHelper = _MediapipeHelper;
MediapipeHelper.defaultAssetsBaseUrl = "https://d3opqjmqzxf057.cloudfront.net/ml/mediapipe/";
const anyMap = /* @__PURE__ */ new WeakMap();
const eventsMap = /* @__PURE__ */ new WeakMap();
const producersMap = /* @__PURE__ */ new WeakMap();
const anyProducer = Symbol("anyProducer");
const resolvedPromise = Promise.resolve();
const listenerAdded = Symbol("listenerAdded");
const listenerRemoved = Symbol("listenerRemoved");
let isGlobalDebugEnabled = false;
function assertEventName(eventName) {
  if (typeof eventName !== "string" && typeof eventName !== "symbol") {
    throw new TypeError("eventName must be a string or a symbol");
  }
}
function assertListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError("listener must be a function");
  }
}
function getListeners(instance, eventName) {
  const events = eventsMap.get(instance);
  if (!events.has(eventName)) {
    events.set(eventName, /* @__PURE__ */ new Set());
  }
  return events.get(eventName);
}
function getEventProducers(instance, eventName) {
  const key = typeof eventName === "string" || typeof eventName === "symbol" ? eventName : anyProducer;
  const producers = producersMap.get(instance);
  if (!producers.has(key)) {
    producers.set(key, /* @__PURE__ */ new Set());
  }
  return producers.get(key);
}
function enqueueProducers(instance, eventName, eventData) {
  const producers = producersMap.get(instance);
  if (producers.has(eventName)) {
    for (const producer of producers.get(eventName)) {
      producer.enqueue(eventData);
    }
  }
  if (producers.has(anyProducer)) {
    const item = Promise.all([eventName, eventData]);
    for (const producer of producers.get(anyProducer)) {
      producer.enqueue(item);
    }
  }
}
function iterator(instance, eventNames) {
  eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
  let isFinished = false;
  let flush = () => {
  };
  let queue = [];
  const producer = {
    enqueue(item) {
      queue.push(item);
      flush();
    },
    finish() {
      isFinished = true;
      flush();
    }
  };
  for (const eventName of eventNames) {
    getEventProducers(instance, eventName).add(producer);
  }
  return {
    async next() {
      if (!queue) {
        return { done: true };
      }
      if (queue.length === 0) {
        if (isFinished) {
          queue = void 0;
          return this.next();
        }
        await new Promise((resolve) => {
          flush = resolve;
        });
        return this.next();
      }
      return {
        done: false,
        value: await queue.shift()
      };
    },
    async return(value) {
      queue = void 0;
      for (const eventName of eventNames) {
        getEventProducers(instance, eventName).delete(producer);
      }
      flush();
      return arguments.length > 0 ? { done: true, value: await value } : { done: true };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function defaultMethodNamesOrAssert(methodNames) {
  if (methodNames === void 0) {
    return allEmitteryMethods;
  }
  if (!Array.isArray(methodNames)) {
    throw new TypeError("`methodNames` must be an array of strings");
  }
  for (const methodName of methodNames) {
    if (!allEmitteryMethods.includes(methodName)) {
      if (typeof methodName !== "string") {
        throw new TypeError("`methodNames` element must be a string");
      }
      throw new Error(`${methodName} is not Emittery method`);
    }
  }
  return methodNames;
}
const isListenerSymbol = (symbol) => symbol === listenerAdded || symbol === listenerRemoved;
class Emittery {
  static mixin(emitteryPropertyName, methodNames) {
    methodNames = defaultMethodNamesOrAssert(methodNames);
    return (target) => {
      if (typeof target !== "function") {
        throw new TypeError("`target` must be function");
      }
      for (const methodName of methodNames) {
        if (target.prototype[methodName] !== void 0) {
          throw new Error(`The property \`${methodName}\` already exists on \`target\``);
        }
      }
      function getEmitteryProperty() {
        Object.defineProperty(this, emitteryPropertyName, {
          enumerable: false,
          value: new Emittery()
        });
        return this[emitteryPropertyName];
      }
      Object.defineProperty(target.prototype, emitteryPropertyName, {
        enumerable: false,
        get: getEmitteryProperty
      });
      const emitteryMethodCaller = (methodName) => function(...args) {
        return this[emitteryPropertyName][methodName](...args);
      };
      for (const methodName of methodNames) {
        Object.defineProperty(target.prototype, methodName, {
          enumerable: false,
          value: emitteryMethodCaller(methodName)
        });
      }
      return target;
    };
  }
  static get isDebugEnabled() {
    if (typeof process !== "object") {
      return isGlobalDebugEnabled;
    }
    const { env } = process || { env: {} };
    return env.DEBUG === "emittery" || env.DEBUG === "*" || isGlobalDebugEnabled;
  }
  static set isDebugEnabled(newValue) {
    isGlobalDebugEnabled = newValue;
  }
  constructor(options = {}) {
    anyMap.set(this, /* @__PURE__ */ new Set());
    eventsMap.set(this, /* @__PURE__ */ new Map());
    producersMap.set(this, /* @__PURE__ */ new Map());
    this.debug = options.debug || {};
    if (this.debug.enabled === void 0) {
      this.debug.enabled = false;
    }
    if (!this.debug.logger) {
      this.debug.logger = (type, debugName, eventName, eventData) => {
        try {
          eventData = JSON.stringify(eventData);
        } catch {
          eventData = `Object with the following keys failed to stringify: ${Object.keys(eventData).join(",")}`;
        }
        if (typeof eventName === "symbol") {
          eventName = eventName.toString();
        }
        const currentTime = new Date();
        const logTime = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}.${currentTime.getMilliseconds()}`;
        console.log(`[${logTime}][emittery:${type}][${debugName}] Event Name: ${eventName}
	data: ${eventData}`);
      };
    }
  }
  logIfDebugEnabled(type, eventName, eventData) {
    if (Emittery.isDebugEnabled || this.debug.enabled) {
      this.debug.logger(type, this.debug.name, eventName, eventData);
    }
  }
  on(eventNames, listener) {
    assertListener(listener);
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName(eventName);
      getListeners(this, eventName).add(listener);
      this.logIfDebugEnabled("subscribe", eventName, void 0);
      if (!isListenerSymbol(eventName)) {
        this.emit(listenerAdded, { eventName, listener });
      }
    }
    return this.off.bind(this, eventNames, listener);
  }
  off(eventNames, listener) {
    assertListener(listener);
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName(eventName);
      getListeners(this, eventName).delete(listener);
      this.logIfDebugEnabled("unsubscribe", eventName, void 0);
      if (!isListenerSymbol(eventName)) {
        this.emit(listenerRemoved, { eventName, listener });
      }
    }
  }
  once(eventNames) {
    return new Promise((resolve) => {
      const off = this.on(eventNames, (data2) => {
        off();
        resolve(data2);
      });
    });
  }
  events(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      assertEventName(eventName);
    }
    return iterator(this, eventNames);
  }
  async emit(eventName, eventData) {
    assertEventName(eventName);
    this.logIfDebugEnabled("emit", eventName, eventData);
    enqueueProducers(this, eventName, eventData);
    const listeners = getListeners(this, eventName);
    const anyListeners = anyMap.get(this);
    const staticListeners = [...listeners];
    const staticAnyListeners = isListenerSymbol(eventName) ? [] : [...anyListeners];
    await resolvedPromise;
    await Promise.all([
      ...staticListeners.map(async (listener) => {
        if (listeners.has(listener)) {
          return listener(eventData);
        }
      }),
      ...staticAnyListeners.map(async (listener) => {
        if (anyListeners.has(listener)) {
          return listener(eventName, eventData);
        }
      })
    ]);
  }
  async emitSerial(eventName, eventData) {
    assertEventName(eventName);
    this.logIfDebugEnabled("emitSerial", eventName, eventData);
    const listeners = getListeners(this, eventName);
    const anyListeners = anyMap.get(this);
    const staticListeners = [...listeners];
    const staticAnyListeners = [...anyListeners];
    await resolvedPromise;
    for (const listener of staticListeners) {
      if (listeners.has(listener)) {
        await listener(eventData);
      }
    }
    for (const listener of staticAnyListeners) {
      if (anyListeners.has(listener)) {
        await listener(eventName, eventData);
      }
    }
  }
  onAny(listener) {
    assertListener(listener);
    this.logIfDebugEnabled("subscribeAny", void 0, void 0);
    anyMap.get(this).add(listener);
    this.emit(listenerAdded, { listener });
    return this.offAny.bind(this, listener);
  }
  anyEvent() {
    return iterator(this);
  }
  offAny(listener) {
    assertListener(listener);
    this.logIfDebugEnabled("unsubscribeAny", void 0, void 0);
    this.emit(listenerRemoved, { listener });
    anyMap.get(this).delete(listener);
  }
  clearListeners(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    for (const eventName of eventNames) {
      this.logIfDebugEnabled("clear", eventName, void 0);
      if (typeof eventName === "string" || typeof eventName === "symbol") {
        getListeners(this, eventName).clear();
        const producers = getEventProducers(this, eventName);
        for (const producer of producers) {
          producer.finish();
        }
        producers.clear();
      } else {
        anyMap.get(this).clear();
        for (const listeners of eventsMap.get(this).values()) {
          listeners.clear();
        }
        for (const producers of producersMap.get(this).values()) {
          for (const producer of producers) {
            producer.finish();
          }
          producers.clear();
        }
      }
    }
  }
  listenerCount(eventNames) {
    eventNames = Array.isArray(eventNames) ? eventNames : [eventNames];
    let count = 0;
    for (const eventName of eventNames) {
      if (typeof eventName === "string") {
        count += anyMap.get(this).size + getListeners(this, eventName).size + getEventProducers(this, eventName).size + getEventProducers(this).size;
        continue;
      }
      if (typeof eventName !== "undefined") {
        assertEventName(eventName);
      }
      count += anyMap.get(this).size;
      for (const value of eventsMap.get(this).values()) {
        count += value.size;
      }
      for (const value of producersMap.get(this).values()) {
        count += value.size;
      }
    }
    return count;
  }
  bindMethods(target, methodNames) {
    if (typeof target !== "object" || target === null) {
      throw new TypeError("`target` must be an object");
    }
    methodNames = defaultMethodNamesOrAssert(methodNames);
    for (const methodName of methodNames) {
      if (target[methodName] !== void 0) {
        throw new Error(`The property \`${methodName}\` already exists on \`target\``);
      }
      Object.defineProperty(target, methodName, {
        enumerable: false,
        value: this[methodName].bind(this)
      });
    }
  }
}
const allEmitteryMethods = Object.getOwnPropertyNames(Emittery.prototype).filter((v) => v !== "constructor");
Object.defineProperty(Emittery, "listenerAdded", {
  value: listenerAdded,
  writable: false,
  enumerable: true,
  configurable: false
});
Object.defineProperty(Emittery, "listenerRemoved", {
  value: listenerRemoved,
  writable: false,
  enumerable: true,
  configurable: false
});
var emittery = Emittery;
const encodedJs = "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";
const blob = typeof window !== "undefined" && window.Blob && new Blob([atob(encodedJs)], { type: "text/javascript;charset=utf-8" });
function WorkerWrapper() {
  const objURL = blob && (window.URL || window.webkitURL).createObjectURL(blob);
  try {
    return objURL ? new Worker(objURL, {}) : new Worker("data:application/javascript;base64," + encodedJs, { type: "module" });
  } finally {
    objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
  }
}
class VonageAssetsLoaderHelper {
  static createVideoReadable(videoUri) {
    return new Promise((resolve, reject) => {
      const bgvideo = document.createElement("video");
      let errorAbortSignal = new AbortController();
      let canplayAbortSignal = new AbortController();
      bgvideo.addEventListener("canplay", () => {
        errorAbortSignal.abort();
        bgvideo.muted = true;
        bgvideo.loop = true;
        bgvideo.play().then(() => {
          try {
            const bgMediaStream = bgvideo.captureStream();
            const processor = new MediaStreamTrackProcessor(bgMediaStream.getVideoTracks()[0]);
            resolve(processor.readable);
          } catch (e) {
            reject(e);
          }
        });
      }, { once: true, signal: canplayAbortSignal.signal });
      bgvideo.addEventListener("error", (e) => {
        canplayAbortSignal.abort();
        reject("loading error:" + e);
      }, { once: true, signal: errorAbortSignal.signal });
      bgvideo.crossOrigin = "anonymous";
      bgvideo.src = videoUri;
    });
  }
  static createImageCanvas(imageUri) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.onload = function() {
        createImageBitmap(img).then((image) => {
          img.remove();
          resolve(image);
        }).catch((e) => {
          reject(e);
        });
      };
      img.onerror = function(e) {
        reject(e);
      };
      img.crossOrigin = "anonymous";
      img.src = imageUri;
    });
  }
}
class VonageMediaProcessorWorker extends emittery {
  constructor() {
    super();
    this.worker_ = new WorkerWrapper();
    this.trackExpectedRate_ = -1;
    this.workerInited_ = false;
    this.mediapipeHelper_ = new MediapipeHelper();
    this.innerEmitty_ = new emittery();
    this.worker_.addEventListener("message", (msg) => {
      if (msg.data instanceof ImageBitmap) {
        this.mediapipeHelper_.send(msg.data).then(() => {
          msg.data.close();
        }).catch((e) => {
          let error = {
            error: e,
            eventMetaData: {
              transformerIndex: -1
            },
            function: "transform"
          };
          this.emit("error", error);
        });
      } else {
        let inputData = JSON.parse(msg.data);
        if (inputData.callbackType === "success" || inputData.callbackType === "error") {
          if (inputData.message === "init") {
            this.innerEmitty_.emit("initResults", msg.data);
          } else if (inputData.message === "transform") {
            this.innerEmitty_.emit("transformResults", msg.data);
          } else if (inputData.message === "destroy") {
            this.innerEmitty_.emit("destroyResults", msg.data);
          } else if (inputData.message === "setBackgroundOptions") {
            this.innerEmitty_.emit("setBackgroundOptionsResults", msg.data);
          } else if (inputData.message === "setVideoBGReadable") {
            this.innerEmitty_.emit("setVideoBGReadableResults", msg.data);
          } else if (inputData.message === "setVirtualBGImage") {
            this.innerEmitty_.emit("setVirtualBGImageResults", msg.data);
          }
        } else if (inputData.callbackType === "media_processor_error_event") {
          this.emit("error", inputData.message);
        } else if (inputData.callbackType === "media_processor_warn_event") {
          this.emit("warn", inputData.message);
        } else if (inputData.callbackType === "media_processor_pipeline_event") {
          this.emit("pipelineInfo", inputData.message);
          let msg2 = inputData.message;
          if (msg2.message === "pipeline_ended" || msg2.message === "pipeline_ended_with_error") {
            this.mediapipeHelper_.close().finally(() => {
              if (this.worker_) {
                this.cleanInnerEmitty();
                this.worker_.terminate();
                this.workerInited_ = false;
                this.worker_ = void 0;
              }
            });
          }
        }
      }
    });
  }
  cleanInnerEmitty() {
    let error = "Worker ended";
    if (this.innerEmitty_.listenerCount("initResults")) {
      this.innerEmitty_.emit("initResults", JSON.stringify({ error }));
    }
    if (this.innerEmitty_.listenerCount("destroyResults")) {
      this.innerEmitty_.emit("destroyResults", JSON.stringify({ error }));
    }
    if (this.innerEmitty_.listenerCount("setBackgroundOptionsResults")) {
      this.innerEmitty_.emit("setBackgroundOptionsResults", JSON.stringify({ error }));
    }
    if (this.innerEmitty_.listenerCount("setVideoBGReadableResults")) {
      this.innerEmitty_.emit("setVideoBGReadableResults", JSON.stringify({ error }));
    }
    if (this.innerEmitty_.listenerCount("setVirtualBGImageResults")) {
      this.innerEmitty_.emit("setVirtualBGImageResults", JSON.stringify({ error }));
    }
    if (this.innerEmitty_.listenerCount("transformResults")) {
      this.innerEmitty_.emit("transformResults", JSON.stringify({ error }));
    }
  }
  init(config) {
    return new Promise((resolve, reject) => {
      if (!this.worker_) {
        reject("worker is off");
        return;
      }
      let modelOptions = {
        modelSelection: 1,
        selfieMode: false
      };
      this.mediapipeHelper_.initialize({
        mediaPipeModelConfigArray: [
          {
            assetsUri: config.mediapipeBaseAssetsUri,
            modelType: "selfie_segmentation",
            options: modelOptions,
            listener: (results) => {
              let result = results;
              if (this.worker_) {
                this.worker_.postMessage(result.segmentationMask, [result.segmentationMask]);
              }
            }
          }
        ]
      }).then(() => {
        let metaDataStr = JSON.stringify(getVonageMetadata());
        if (typeof metaDataStr != "string") {
          metaDataStr = JSON.stringify({});
        }
        if (!this.worker_) {
          reject("worker is off");
          return;
        }
        this.worker_.postMessage({
          operation: "init",
          metaData: metaDataStr
        });
        this.innerEmitty_.once("initResults").then((eventData) => {
          let inputData = JSON.parse(eventData);
          if (inputData.callbackType === "success") {
            this.workerInited_ = true;
            if (this.trackExpectedRate_ != -1) {
              this.postTrackExpectedRate();
            }
            this.setBackgroundOptions(config).then(() => {
              resolve();
            }).catch((e) => {
              reject(e);
            });
          } else {
            reject(inputData.error);
          }
        }).catch((e) => {
          reject(e);
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }
  transform(readable, writable) {
    return new Promise(async (resolve, reject) => {
      if (!this.worker_) {
        reject("worker is off");
        return;
      }
      this.worker_.postMessage({
        operation: "transform",
        readable,
        writable
      }, [readable, writable]);
      this.innerEmitty_.once("transformResults").then((eventData) => {
        let inputData = JSON.parse(eventData);
        if (inputData.callbackType === "success") {
          resolve();
        } else {
          reject(inputData.error);
        }
      }).catch((e) => {
        reject(e);
      });
    });
  }
  destroy() {
    return new Promise(async (resolve, reject) => {
      if (!this.worker_) {
        resolve();
        return;
      }
      this.worker_.postMessage({
        operation: "destroy"
      });
      this.innerEmitty_.once("destroyResults").then((eventData) => {
        let inputData = JSON.parse(eventData);
        if (inputData.callbackType === "success") {
          this.mediapipeHelper_.close().then(() => {
            resolve();
          }).catch((e) => {
            reject(e);
          });
        } else {
          reject(inputData.error);
        }
      }).catch((e) => {
        reject(e);
      });
    });
  }
  setTrackExpectedRate(trackExpectedRate) {
    this.trackExpectedRate_ = trackExpectedRate;
    this.postTrackExpectedRate();
  }
  postTrackExpectedRate() {
    if (this.workerInited_) {
      this.worker_.postMessage({
        operation: "setTrackExpectedRate",
        rate: this.trackExpectedRate_
      });
    }
  }
  setBackgroundOptions(backgroundOptions) {
    return new Promise((resolve, reject) => {
      if (!this.worker_) {
        reject("worker is off");
        return;
      }
      this.worker_.postMessage({
        operation: "setBackgroundOptions",
        backgroundOptions: JSON.stringify(backgroundOptions)
      });
      this.innerEmitty_.once("setBackgroundOptionsResults").then((eventData) => {
        let inputData = JSON.parse(eventData);
        if (inputData.callbackType === "success") {
          if (backgroundOptions.transformerType === "VideoBackground") {
            VonageAssetsLoaderHelper.createVideoReadable(backgroundOptions.backgroundAssetUri).then((res) => {
              if (!this.worker_) {
                reject("worker is off");
                return;
              }
              this.worker_.postMessage({
                operation: "setVideoBGReadable",
                readable: res
              }, [res]);
              this.innerEmitty_.once("setVideoBGReadableResults").then((eventData2) => {
                let inputData2 = JSON.parse(eventData2);
                if (inputData2.callbackType === "success") {
                  resolve();
                } else {
                  reject(inputData2.error);
                }
              }).catch((e) => {
                reject(e);
              });
            }).catch((e) => {
              reject(e);
            });
          } else if (backgroundOptions.transformerType === "VirtualBackground") {
            VonageAssetsLoaderHelper.createImageCanvas(backgroundOptions.backgroundAssetUri).then((res) => {
              if (!this.worker_) {
                reject("worker is off");
                return;
              }
              this.worker_.postMessage({
                operation: "setVirtualBGImage",
                image: res
              }, [res]);
              this.innerEmitty_.once("setVirtualBGImageResults").then((eventData2) => {
                let inputData2 = JSON.parse(eventData2);
                if (inputData2.callbackType === "success") {
                  resolve();
                } else {
                  reject(inputData2.error);
                }
              }).catch((e) => {
                reject(e);
              });
            }).catch((e) => {
              reject(e);
            });
          } else {
            resolve();
          }
        } else {
          reject(inputData.error);
        }
      }).catch((e) => {
        reject(e);
      });
    });
  }
}
class VonageMediaProcessor extends emittery {
  constructor() {
    super();
    this.worker = new VonageMediaProcessorWorker();
    this.connector = new MediaProcessorConnector(this.worker);
  }
  async init(config) {
    await this.worker.init(config);
    this.worker.onAny((name, data2) => this.emit(name, data2));
  }
  async setBackgroundOptions(options) {
    await this.worker.setBackgroundOptions(options);
  }
  setTrackExpectedRate(rate) {
    this.worker.setTrackExpectedRate(rate);
  }
  getConnector() {
    return this.connector;
  }
  static async create(config) {
    const result = new this();
    await result.init(config);
    return result;
  }
}
let vonageMediaProcessor;
async function createVonageMediaProcessor(config) {
  return await VonageMediaProcessor.create(config);
}
function getVonageEventEmitter() {
  return vonageMediaProcessor;
}
function setTrackExpectedRate(trackExpectedRate2) {
  trackExpectedRate2 = trackExpectedRate2;
  vonageMediaProcessor.setTrackExpectedRate(trackExpectedRate2);
}
function createVonageMediaProcessorConnector(config) {
  return new Promise(async (resolve, reject) => {
    vonageMediaProcessor = await VonageMediaProcessor.create(config);
    resolve(vonageMediaProcessor.getConnector());
  });
}
function setBackgroundOptions(backgroundOptions) {
  return new Promise((resolve, reject) => {
    if (vonageMediaProcessor) {
      vonageMediaProcessor.setBackgroundOptions(backgroundOptions).then(() => {
        resolve();
      }).catch((e) => {
        reject(e);
      });
    } else {
      reject("media processor is not set");
    }
  });
}
export { BlurRadius, MediapipeHelper, VonageFacedetection, VonageFacemash, VonageHands, VonageHolistic, VonageMediaProcessor, VonageObjectron, VonagePose, VonageSelfiesegmentation, createVonageMediaProcessor, createVonageMediaProcessorConnector, getVonageEventEmitter, isSupported, setBackgroundOptions, setTrackExpectedRate };
